import gql from 'graphql-tag';
import * as React from 'react';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactComponents from '@apollo/client/react/components';
import * as ApolloReactHoc from '@apollo/client/react/hoc';
import * as ApolloReactHooks from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: any }> = { [K in keyof T]: T[K] };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /**
   * The `ID` scalar type represents a unique MongoDB identifier in collection.
   * MongoDB by default use 12-byte ObjectId value
   * (https://docs.mongodb.com/manual/reference/bson-types/#objectid). But MongoDB
   * also may accepts string or integer as correct values for _id field.
   */
  MongoID: any;
};

export type Addon = {
  __typename?: 'Addon';
  active: Scalars['Boolean'];
  oAuthToken: Scalars['String'];
};

export type Addons = {
  __typename?: 'Addons';
  mall?: Maybe<Addon>;
  amazon?: Maybe<Addon>;
  alza?: Maybe<Addon>;
  kaufland?: Maybe<Addon>;
};

export type AddonsEndpoints = {
  __typename?: 'AddonsEndpoints';
  mall?: Maybe<Array<Maybe<Endpoints>>>;
  alza?: Maybe<Array<Maybe<Endpoints>>>;
  amazon?: Maybe<Array<Maybe<Endpoints>>>;
  kaufland?: Maybe<Array<Maybe<Endpoints>>>;
};

export enum AdvancedSearchableFields {
  marketplaceOrderId = 'marketplaceOrderId',
  buyer_email = 'buyer_email',
  buyer_name = 'buyer_name',
  buyer_addressLine = 'buyer_addressLine',
  items_name = 'items_name',
  items_sku = 'items_sku'
}

export enum AlzaCarrierName {
  ALZABOX = 'ALZABOX',
  ALZABRANCH = 'ALZABRANCH',
  COURIER = 'COURIER',
  CZPOSTD = 'CZPOSTD',
  CZPOSTP = 'CZPOSTP',
  CZPOSTB = 'CZPOSTB',
  DHL = 'DHL',
  DPD = 'DPD',
  ALZA = 'ALZA',
  DPDALZABOX = 'DPDALZABOX',
  DPDBOX = 'DPDBOX',
  DPDPARCELSHOP = 'DPDPARCELSHOP',
  FOFRSTD = 'FOFRSTD',
  GebruderWeissStandard = 'GebruderWeissStandard',
  GEIS = 'GEIS',
  GEISPOINT = 'GEISPOINT',
  GEISCARGO = 'GEISCARGO',
  GLS = 'GLS',
  GO = 'GO',
  HELICARSTD = 'HELICARSTD',
  HELICARUP = 'HELICARUP',
  MagyarPOSTHD = 'MagyarPOSTHD',
  MagyarPOSTPO = 'MagyarPOSTPO',
  MagyarPOSTPP = 'MagyarPOSTPP',
  MagyarPOSTPT = 'MagyarPOSTPT',
  PPL = 'PPL',
  PPLPARCELSHOP = 'PPLPARCELSHOP',
  RHENUS = 'RHENUS',
  SKPOSTD = 'SKPOSTD',
  SKPOSTP = 'SKPOSTP',
  SKYNET = 'SKYNET',
  TOPTRANS = 'TOPTRANS',
  UPS = 'UPS',
  WEDOHD = 'WEDOHD',
  ZASILKOVNA = 'ZASILKOVNA',
  ZavolejSiKuryra = 'ZavolejSiKuryra',
  Supplier = 'Supplier'
}

export type AlzaCredentials = {
  __typename?: 'AlzaCredentials';
  marketplace?: Maybe<AlzaMarketplace>;
  secretKey?: Maybe<Scalars['String']>;
  apiBaseUrl?: Maybe<Scalars['String']>;
  buyerId?: Maybe<Scalars['Int']>;
  supplierId?: Maybe<Scalars['Int']>;
  supplierBranchId?: Maybe<Scalars['Int']>;
};

export type AlzaFullSync = {
  __typename?: 'AlzaFullSync';
  message: Scalars['String'];
  willRunAt: Scalars['Date'];
};

export enum AlzaMarketplace {
  alza_cz = 'alza_cz'
}

export enum AmazonCarrierName {
  ThreeHundredSixtylion = 'ThreeHundredSixtylion',
  FourPX = 'FourPX',
  A1 = 'A1',
  AAACooper = 'AAACooper',
  ABF = 'ABF',
  AFLFedex = 'AFLFedex',
  ALLJOY = 'ALLJOY',
  AMAUK = 'AMAUK',
  AMAZONHORIZON = 'AMAZONHORIZON',
  AmazonShipping = 'AmazonShipping',
  AMZL = 'AMZL',
  AMZLUK = 'AMZLUK',
  Andere = 'Andere',
  Anjun = 'Anjun',
  AO = 'AO',
  AODeutschland = 'AODeutschland',
  APC = 'APC',
  APCOvernight = 'APCOvernight',
  APCPOSTALLOGISTICS = 'APCPOSTALLOGISTICS',
  APGeCommerce = 'APGeCommerce',
  Aramex = 'Aramex',
  ARAS = 'ARAS',
  ArasKargo = 'ArasKargo',
  ArcoSpedizioni = 'ArcoSpedizioni',
  Arkas = 'Arkas',
  ArrowXL = 'ArrowXL',
  Asendia = 'Asendia',
  Asgard = 'Asgard',
  Assett = 'Assett',
  ATPOST = 'ATPOST',
  ATS = 'ATS',
  AUSSIEPOST = 'AUSSIEPOST',
  AustraliaPost = 'AustraliaPost',
  AustraliaPostArticleID = 'AustraliaPostArticleID',
  AustraliaPostConsignment = 'AustraliaPostConsignment',
  B2C = 'B2C',
  B2CEurope = 'B2CEurope',
  B2CShip = 'B2CShip',
  Balnak = 'Balnak',
  Bartolini = 'Bartolini',
  BeijingQuanfengExpress = 'BeijingQuanfengExpress',
  BestBuy = 'BestBuy',
  BestExpress = 'BestExpress',
  BetterTrucks = 'BetterTrucks',
  BJS = 'BJS',
  Blowhorn = 'Blowhorn',
  BluePackage = 'BluePackage',
  BlueDart = 'BlueDart',
  Bombax = 'Bombax',
  BombinoExpress = 'BombinoExpress',
  BPOST = 'BPOST',
  BR1Express = 'BR1Express',
  BRT = 'BRT',
  Buylogic = 'Buylogic',
  Cainiao = 'Cainiao',
  CanadaPost = 'CanadaPost',
  Canpar = 'Canpar',
  CargoLine = 'CargoLine',
  Caribou = 'Caribou',
  Cart2India = 'Cart2India',
  CBHub = 'CBHub',
  CBL = 'CBL',
  CDC = 'CDC',
  CELERITAS = 'CELERITAS',
  Centex = 'Centex',
  CEVA = 'CEVA',
  CevaLojistik = 'CevaLojistik',
  ChinaPost = 'ChinaPost',
  ChronoExpress = 'ChronoExpress',
  Chronopost = 'Chronopost',
  Chukou1 = 'Chukou1',
  Cititrans = 'Cititrans',
  CityLink = 'CityLink',
  CityPost = 'CityPost',
  CNE = 'CNE',
  Coliposte = 'Coliposte',
  Colissimo = 'Colissimo',
  ConsegnaMezziPropri = 'ConsegnaMezziPropri',
  Conway = 'Conway',
  Correios = 'Correios',
  Correos = 'Correos',
  CorreosExpress = 'CorreosExpress',
  COSCO = 'COSCO',
  CouriersPlease = 'CouriersPlease',
  CTTExpress = 'CTTExpress',
  Cubyn = 'Cubyn',
  CyberSavings = 'CyberSavings',
  DACHSER = 'DACHSER',
  DAIPOST = 'DAIPOST',
  DBSchenker = 'DBSchenker',
  DELDeliveries = 'DELDeliveries',
  Delhivery = 'Delhivery',
  Delivengo = 'Delivengo',
  DeliveryGroup = 'DeliveryGroup',
  DerKurier = 'DerKurier',
  DeutschePost = 'DeutschePost',
  DFL = 'DFL',
  DHL = 'DHL',
  DHLeCommerce = 'DHLeCommerce',
  DHLExpress = 'DHLExpress',
  DHLFreight = 'DHLFreight',
  DHLGlobalMail = 'DHLGlobalMail',
  DHLHomeDelivery = 'DHLHomeDelivery',
  DHLKargo = 'DHLKargo',
  DHLPaket = 'DHLPaket',
  DHLParcelUK = 'DHLParcelUK',
  DHLPL = 'DHLPL',
  DigitalDelivery = 'DigitalDelivery',
  DirectLog = 'DirectLog',
  Dotzot = 'Dotzot',
  DPB = 'DPB',
  DPD = 'DPD',
  DPDLocal = 'DPDLocal',
  DSV = 'DSV',
  DTDC = 'DTDC',
  DX = 'DX',
  DXExpress = 'DXExpress',
  DXFreight = 'DXFreight',
  DXSecure = 'DXSecure',
  DYNAMICEXPRESS = 'DYNAMICEXPRESS',
  ECMS = 'ECMS',
  ECMSexpress = 'ECMSexpress',
  EcomExpress = 'EcomExpress',
  EcomShippingSolutionsPVTltd = 'EcomShippingSolutionsPVTltd',
  EINSASOURCING = 'EINSASOURCING',
  EKITrans = 'EKITrans',
  EmiratesPost = 'EmiratesPost',
  Emons = 'Emons',
  Endopack = 'Endopack',
  Energo = 'Energo',
  Envialia = 'Envialia',
  ePostGlobal = 'ePostGlobal',
  Equick = 'Equick',
  ESNAD = 'ESNAD',
  Estafeta = 'Estafeta',
  Estes = 'Estes',
  EUB = 'EUB',
  Europaczka = 'Europaczka',
  Exapaq = 'Exapaq',
  FASTEST = 'FASTEST',
  Fastway = 'Fastway',
  FedEx = 'FedEx',
  FedexFreight = 'FedexFreight',
  FEDEXJP = 'FEDEXJP',
  FedExSmartPost = 'FedExSmartPost',
  FERCAM = 'FERCAM',
  FilloKargo = 'FilloKargo',
  FirstFlight = 'FirstFlight',
  FirstFlightChina = 'FirstFlightChina',
  FirstMile = 'FirstMile',
  Fleetan = 'Fleetan',
  Flyt = 'Flyt',
  FRACHTPOST = 'FRACHTPOST',
  FRANCEEXPRESS = 'FRANCEEXPRESS',
  Gati = 'Gati',
  GEL = 'GEL',
  GELExpress = 'GELExpress',
  geodis = 'geodis',
  GeodisCalberson = 'GeodisCalberson',
  GeopostKargo = 'GeopostKargo',
  GFS = 'GFS',
  GLS = 'GLS',
  GLSCanada = 'GLSCanada',
  GO = 'GO',
  Gojavas = 'Gojavas',
  GRUPOLOGISTIC = 'GRUPOLOGISTIC',
  Hellmann = 'Hellmann',
  Heppner = 'Heppner',
  Hermes = 'Hermes',
  HermesCorporate = 'HermesCorporate',
  HermesEinrichtungsservice = 'HermesEinrichtungsservice',
  HermesLogistikGruppe = 'HermesLogistikGruppe',
  HermesUK = 'HermesUK',
  Hlog = 'Hlog',
  HNC = 'HNC',
  HomeLogistics = 'HomeLogistics',
  honesteye = 'honesteye',
  HongkongPost = 'HongkongPost',
  HorozLojistik = 'HorozLojistik',
  HotpointLogistics = 'HotpointLogistics',
  HRP = 'HRP',
  HScode = 'HScode',
  HUAHANLogistics = 'HUAHANLogistics',
  HubEurope = 'HubEurope',
  HunterExpress = 'HunterExpress',
  HunterLogistics = 'HunterLogistics',
  Huxloe = 'Huxloe',
  HuxloeLogistics = 'HuxloeLogistics',
  ICCWorldwide = 'ICCWorldwide',
  IDS = 'IDS',
  IDSNetzwerk = 'IDSNetzwerk',
  iMile = 'iMile',
  IndiaPost = 'IndiaPost',
  InPost = 'InPost',
  Interlink = 'Interlink',
  Interno = 'Interno',
  Intersoft = 'Intersoft',
  iParcel = 'iParcel',
  ITDGlobal = 'ITDGlobal',
  JampTExpress = 'JampTExpress',
  JapanPost = 'JapanPost',
  JCEX = 'JCEX',
  JerseyPost = 'JerseyPost',
  Jiufang = 'Jiufang',
  JPEXPRESS = 'JPEXPRESS',
  JPLUPU = 'JPLUPU',
  JSExpress = 'JSExpress',
  JT = 'JT',
  JTExpress = 'JTExpress',
  JYExpress = 'JYExpress',
  Kargokar = 'Kargokar',
  KEAVO = 'KEAVO',
  Kerry = 'Kerry',
  KuehneNagel = 'KuehneNagel',
  Kybotech = 'Kybotech',
  LaPoste = 'LaPoste',
  Landmark = 'Landmark',
  LandmarkGlobal = 'LandmarkGlobal',
  Lasership = 'Lasership',
  Lemonmode = 'Lemonmode',
  Letian = 'Letian',
  LFLogistic = 'LFLogistic',
  Liccardi = 'Liccardi',
  LiccardiTrasporti = 'LiccardiTrasporti',
  LogistikGruppe = 'LogistikGruppe',
  Loomis = 'Loomis',
  MailAlliance = 'MailAlliance',
  MailAmericas = 'MailAmericas',
  Mainpost = 'Mainpost',
  MBE = 'MBE',
  MetroKargo = 'MetroKargo',
  Mezzipropri = 'Mezzipropri',
  MHI = 'MHI',
  Milkman = 'Milkman',
  MNGKargo = 'MNGKargo',
  MondialRelay = 'MondialRelay',
  MRW = 'MRW',
  MZZBriefdienst = 'MZZBriefdienst',
  Nacex = 'Nacex',
  NAQELEXPRESS = 'NAQELEXPRESS',
  NarpostKargo = 'NarpostKargo',
  NewZealandPost = 'NewZealandPost',
  Newgistics = 'Newgistics',
  Nexive = 'Nexive',
  Ninjavan = 'Ninjavan',
  NipponExpress = 'NipponExpress',
  NITTSU = 'NITTSU',
  NOVEO = 'NOVEO',
  NowBikes = 'NowBikes',
  NTL = 'NTL',
  OCSWorldwide = 'OCSWorldwide',
  OldDominion = 'OldDominion',
  OneWorldExpress = 'OneWorldExpress',
  ONTIME = 'ONTIME',
  OnTrac = 'OnTrac',
  OSM = 'OSM',
  OSMWorldwide = 'OSMWorldwide',
  Other = 'Other',
  Otro = 'Otro',
  OverniteExpress = 'OverniteExpress',
  Palletline = 'Palletline',
  Palletways = 'Palletways',
  Panther = 'Panther',
  ParcelHub = 'ParcelHub',
  ParcelMonkey = 'ParcelMonkey',
  ParcelStation = 'ParcelStation',
  Parcel2go = 'Parcel2go',
  ParcelDenOnline = 'ParcelDenOnline',
  Parcelforce = 'Parcelforce',
  Parcelhub = 'Parcelhub',
  ParcelinkLogistics = 'ParcelinkLogistics',
  Parcelnet = 'Parcelnet',
  ParcelOne = 'ParcelOne',
  Paquetexpress = 'Paquetexpress',
  PDCLogistics = 'PDCLogistics',
  Pilot = 'Pilot',
  PilotFreight = 'PilotFreight',
  PIN = 'PIN',
  PolishPost = 'PolishPost',
  PosLaju = 'PosLaju',
  PostModern = 'PostModern',
  PosteItaliane = 'PosteItaliane',
  PostNL = 'PostNL',
  PostNord = 'PostNord',
  Professional = 'Professional',
  PTTKargo = 'PTTKargo',
  PUROLATOR = 'PUROLATOR',
  Quantium = 'Quantium',
  Qxpress = 'Qxpress',
  RL = 'RL',
  RabenGroup = 'RabenGroup',
  RBNA = 'RBNA',
  REDUR = 'REDUR',
  Redpack = 'Redpack',
  Rhenus = 'Rhenus',
  Rieck = 'Rieck',
  Rivigo = 'Rivigo',
  RMLGB = 'RMLGB',
  Roadrunner = 'Roadrunner',
  RoyalMail = 'RoyalMail',
  RRDonnelley = 'RRDonnelley',
  Safexpress = 'Safexpress',
  SAGAWA = 'SAGAWA',
  SagawaExpress = 'SagawaExpress',
  Saia = 'Saia',
  Sailpost = 'Sailpost',
  SchweizerPost = 'SchweizerPost',
  SDA = 'SDA',
  Seino = 'Seino',
  SEINOTRANSPORTATION = 'SEINOTRANSPORTATION',
  SekoLogistics = 'SekoLogistics',
  SelemKargo = 'SelemKargo',
  SelfDelivery = 'SelfDelivery',
  Sendcloud = 'Sendcloud',
  Sending = 'Sending',
  SENDLE = 'SENDLE',
  Seur = 'Seur',
  SevenSenders = 'SevenSenders',
  SFExpress = 'SFExpress',
  SFC = 'SFC',
  ShipDelight = 'ShipDelight',
  ShipGlobalUS = 'ShipGlobalUS',
  SHIPA = 'SHIPA',
  ShipEconomy = 'ShipEconomy',
  ShipEntegra = 'ShipEntegra',
  ShipGlobal = 'ShipGlobal',
  Shipmate = 'Shipmate',
  Shippit = 'Shippit',
  ShopiniWorld = 'ShopiniWorld',
  ShreeMarutiCourier = 'ShreeMarutiCourier',
  ShreeTirupatiCourier = 'ShreeTirupatiCourier',
  ShunfengExpress = 'ShunfengExpress',
  Sinerlog = 'Sinerlog',
  SingaporePost = 'SingaporePost',
  Sinotrans = 'Sinotrans',
  Skypostal = 'Skypostal',
  Smartmail = 'Smartmail',
  Smartrlogistics = 'Smartrlogistics',
  SMSA = 'SMSA',
  SMSAExpress = 'SMSAExpress',
  Soarmall = 'Soarmall',
  Sonstige = 'Sonstige',
  SouthEasternFreightLines = 'SouthEasternFreightLines',
  Speedaf = 'Speedaf',
  Speedex = 'Speedex',
  Spoton = 'Spoton',
  Spring = 'Spring',
  springGDS = 'springGDS',
  Sprint = 'Sprint',
  StahlmannandSachs = 'StahlmannandSachs',
  Stampit = 'Stampit',
  Staples = 'Staples',
  StarTrackArticleID = 'StarTrackArticleID',
  StarTrackConsignment = 'StarTrackConsignment',
  STG = 'STG',
  STOExpress = 'STOExpress',
  Streamlite = 'Streamlite',
  Sunyou = 'Sunyou',
  Susa = 'Susa',
  Swisspost = 'Swisspost',
  Szendex = 'Szendex',
  Target = 'Target',
  TATAExpress = 'TATAExpress',
  TDN = 'TDN',
  TeamExpress = 'TeamExpress',
  TezelLojistik = 'TezelLojistik',
  TheDeliveryGroup = 'TheDeliveryGroup',
  TheProfessionalCouriers = 'TheProfessionalCouriers',
  TIPSA = 'TIPSA',
  TNT = 'TNT',
  TNTKargo = 'TNTKargo',
  TNTIT = 'TNTIT',
  Toll = 'Toll',
  TollGlobalExpress = 'TollGlobalExpress',
  TongdaGlobal = 'TongdaGlobal',
  Topyou = 'Topyou',
  TotalExpress = 'TotalExpress',
  Tourline = 'Tourline',
  Trackon = 'Trackon',
  Trakpak = 'Trakpak',
  Transaher = 'Transaher',
  TransFolha = 'TransFolha',
  Translink = 'Translink',
  TransoFlex = 'TransoFlex',
  Truline = 'Truline',
  TSB = 'TSB',
  Tuffnells = 'Tuffnells',
  TWS = 'TWS',
  TXT = 'TXT',
  TyD = 'TyD',
  UBI = 'UBI',
  UKMail = 'UKMail',
  UniUni = 'UniUni',
  UPakWeShip = 'UPakWeShip',
  UPS = 'UPS',
  UPSFreight = 'UPSFreight',
  UPSMailInnovations = 'UPSMailInnovations',
  Upsilon = 'Upsilon',
  UPSMI = 'UPSMI',
  UrbanExpress = 'UrbanExpress',
  Uship = 'Uship',
  USPS = 'USPS',
  VerageShipping = 'VerageShipping',
  ViaXpress = 'ViaXpress',
  VIR = 'VIR',
  VNLIN = 'VNLIN',
  WanbExpress = 'WanbExpress',
  WatkinsandShepard = 'WatkinsandShepard',
  Wefast = 'Wefast',
  WeWorldExpress = 'WeWorldExpress',
  Whistl = 'Whistl',
  Whizzard = 'Whizzard',
  WINIT = 'WINIT',
  WPX = 'WPX',
  XDP = 'XDP',
  XPO = 'XPO',
  XPOFreight = 'XPOFreight',
  Xpressbees = 'Xpressbees',
  YAMATO = 'YAMATO',
  YamatoTransport = 'YamatoTransport',
  YANWEN = 'YANWEN',
  YDH = 'YDH',
  YellowFreight = 'YellowFreight',
  YFLogistics = 'YFLogistics',
  YFHEX = 'YFHEX',
  YHT = 'YHT',
  Yodel = 'Yodel',
  YTOExpress = 'YTOExpress',
  YunExpress = 'YunExpress',
  YundaExpress = 'YundaExpress',
  ZADExpress = 'ZADExpress',
  Zeleris = 'Zeleris',
  ZTOExpress = 'ZTOExpress',
  ZustAmbrosetti = 'ZustAmbrosetti'
}

export type AmazonErrorRate = {
  __typename?: 'AmazonErrorRate';
  code?: Maybe<Scalars['String']>;
  marketplace?: Maybe<MarketplaceName>;
  message?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
};

export type ApiToken = {
  __typename?: 'ApiToken';
  companyId: Scalars['MongoID'];
  token: Scalars['String'];
  type: EnumApiTokenType;
  access?: Maybe<Scalars['JSON']>;
  _id: Scalars['MongoID'];
};

export type Asins = {
  __typename?: 'Asins';
  alza_cz?: Maybe<Scalars['String']>;
  amazon_mx?: Maybe<Scalars['String']>;
  amazon_us?: Maybe<Scalars['String']>;
  amazon_ca?: Maybe<Scalars['String']>;
  amazon_br?: Maybe<Scalars['String']>;
  amazon_de?: Maybe<Scalars['String']>;
  amazon_uk?: Maybe<Scalars['String']>;
  amazon_fr?: Maybe<Scalars['String']>;
  amazon_it?: Maybe<Scalars['String']>;
  amazon_es?: Maybe<Scalars['String']>;
  amazon_nl?: Maybe<Scalars['String']>;
  amazon_se?: Maybe<Scalars['String']>;
  amazon_tr?: Maybe<Scalars['String']>;
  amazon_pl?: Maybe<Scalars['String']>;
  amazon_be?: Maybe<Scalars['String']>;
  amazon_ie?: Maybe<Scalars['String']>;
  amazon_sg?: Maybe<Scalars['String']>;
  amazon_au?: Maybe<Scalars['String']>;
  amazon_jp?: Maybe<Scalars['String']>;
  emag_bg?: Maybe<Scalars['String']>;
  emag_hu?: Maybe<Scalars['String']>;
  emag_pl?: Maybe<Scalars['String']>;
  emag_ro?: Maybe<Scalars['String']>;
  mall_cz?: Maybe<Scalars['String']>;
  mall_hu?: Maybe<Scalars['String']>;
  mall_pl?: Maybe<Scalars['String']>;
  mall_si?: Maybe<Scalars['String']>;
  mall_sk?: Maybe<Scalars['String']>;
  real_de?: Maybe<Scalars['String']>;
  kaufland_de?: Maybe<Scalars['String']>;
  kaufland_cz?: Maybe<Scalars['String']>;
  kaufland_sk?: Maybe<Scalars['String']>;
  kaufland_at?: Maybe<Scalars['String']>;
  kaufland_pl?: Maybe<Scalars['String']>;
  kaufland_nl?: Maybe<Scalars['String']>;
  kaufland_es?: Maybe<Scalars['String']>;
  kaufland_fr?: Maybe<Scalars['String']>;
  kaufland_it?: Maybe<Scalars['String']>;
  glami_cz?: Maybe<Scalars['String']>;
  cdiscount_fr?: Maybe<Scalars['String']>;
  ebay_at?: Maybe<Scalars['String']>;
  ebay_cz?: Maybe<Scalars['String']>;
  ebay_fr?: Maybe<Scalars['String']>;
  ebay_pl?: Maybe<Scalars['String']>;
  ebay_de?: Maybe<Scalars['String']>;
  ebay_us?: Maybe<Scalars['String']>;
  ebay_uk?: Maybe<Scalars['String']>;
  allegro_cz?: Maybe<Scalars['String']>;
  allegro_pl?: Maybe<Scalars['String']>;
  allegro_sk?: Maybe<Scalars['String']>;
  baskedo_bg?: Maybe<Scalars['String']>;
  baskedo_hu?: Maybe<Scalars['String']>;
  bol_nl?: Maybe<Scalars['String']>;
  expando_shop_ro?: Maybe<Scalars['String']>;
  limetka_cz?: Maybe<Scalars['String']>;
  limetka_gr?: Maybe<Scalars['String']>;
  limetka_sk?: Maybe<Scalars['String']>;
};

export type AsinsInput = {
  alza_cz?: Maybe<Scalars['String']>;
  amazon_mx?: Maybe<Scalars['String']>;
  amazon_us?: Maybe<Scalars['String']>;
  amazon_ca?: Maybe<Scalars['String']>;
  amazon_br?: Maybe<Scalars['String']>;
  amazon_de?: Maybe<Scalars['String']>;
  amazon_uk?: Maybe<Scalars['String']>;
  amazon_fr?: Maybe<Scalars['String']>;
  amazon_it?: Maybe<Scalars['String']>;
  amazon_es?: Maybe<Scalars['String']>;
  amazon_nl?: Maybe<Scalars['String']>;
  amazon_se?: Maybe<Scalars['String']>;
  amazon_tr?: Maybe<Scalars['String']>;
  amazon_pl?: Maybe<Scalars['String']>;
  amazon_be?: Maybe<Scalars['String']>;
  amazon_ie?: Maybe<Scalars['String']>;
  amazon_sg?: Maybe<Scalars['String']>;
  amazon_au?: Maybe<Scalars['String']>;
  amazon_jp?: Maybe<Scalars['String']>;
  emag_bg?: Maybe<Scalars['String']>;
  emag_hu?: Maybe<Scalars['String']>;
  emag_pl?: Maybe<Scalars['String']>;
  emag_ro?: Maybe<Scalars['String']>;
  mall_cz?: Maybe<Scalars['String']>;
  mall_hu?: Maybe<Scalars['String']>;
  mall_pl?: Maybe<Scalars['String']>;
  mall_si?: Maybe<Scalars['String']>;
  mall_sk?: Maybe<Scalars['String']>;
  real_de?: Maybe<Scalars['String']>;
  kaufland_de?: Maybe<Scalars['String']>;
  kaufland_cz?: Maybe<Scalars['String']>;
  kaufland_sk?: Maybe<Scalars['String']>;
  kaufland_at?: Maybe<Scalars['String']>;
  kaufland_pl?: Maybe<Scalars['String']>;
  kaufland_nl?: Maybe<Scalars['String']>;
  kaufland_es?: Maybe<Scalars['String']>;
  kaufland_fr?: Maybe<Scalars['String']>;
  kaufland_it?: Maybe<Scalars['String']>;
  glami_cz?: Maybe<Scalars['String']>;
  cdiscount_fr?: Maybe<Scalars['String']>;
  ebay_at?: Maybe<Scalars['String']>;
  ebay_cz?: Maybe<Scalars['String']>;
  ebay_fr?: Maybe<Scalars['String']>;
  ebay_pl?: Maybe<Scalars['String']>;
  ebay_de?: Maybe<Scalars['String']>;
  ebay_us?: Maybe<Scalars['String']>;
  ebay_uk?: Maybe<Scalars['String']>;
  allegro_cz?: Maybe<Scalars['String']>;
  allegro_pl?: Maybe<Scalars['String']>;
  allegro_sk?: Maybe<Scalars['String']>;
  baskedo_bg?: Maybe<Scalars['String']>;
  baskedo_hu?: Maybe<Scalars['String']>;
  bol_nl?: Maybe<Scalars['String']>;
  expando_shop_ro?: Maybe<Scalars['String']>;
  limetka_cz?: Maybe<Scalars['String']>;
  limetka_gr?: Maybe<Scalars['String']>;
  limetka_sk?: Maybe<Scalars['String']>;
};

export type Autopricing = {
  __typename?: 'Autopricing';
  marketplace?: Maybe<MarketplaceName>;
  autoprice?: Maybe<Scalars['Float']>;
  buybox?: Maybe<Scalars['Boolean']>;
  selling?: Maybe<Scalars['Float']>;
  active?: Maybe<Scalars['Boolean']>;
  topCap?: Maybe<Scalars['Float']>;
  bottomCap?: Maybe<Scalars['Float']>;
  topCapAbsolute?: Maybe<Scalars['Float']>;
  bottomCapAbsolute?: Maybe<Scalars['Float']>;
  salesRank?: Maybe<PricingSalesRank>;
};

export type AutopricingInput = {
  marketplace?: Maybe<MarketplaceName>;
  autoprice?: Maybe<Scalars['Float']>;
  buybox?: Maybe<Scalars['Boolean']>;
  selling?: Maybe<Scalars['Float']>;
  active?: Maybe<Scalars['Boolean']>;
  topCap?: Maybe<Scalars['Float']>;
  bottomCap?: Maybe<Scalars['Float']>;
  topCapAbsolute?: Maybe<Scalars['Float']>;
  bottomCapAbsolute?: Maybe<Scalars['Float']>;
  salesRank?: Maybe<PricingSalesRankInput>;
};

export type AutopricingReport = {
  __typename?: 'AutopricingReport';
  companyId?: Maybe<Scalars['String']>;
  state?: Maybe<AutopricingReportState>;
  createdAt?: Maybe<Scalars['Date']>;
  options?: Maybe<AutopricingReportOptions>;
  progress?: Maybe<Scalars['Float']>;
  finishedAt?: Maybe<Scalars['Date']>;
  resultItems?: Maybe<Array<Maybe<AutopricingReportResultItem>>>;
};

export type AutopricingReportFieldWeightsOptions = {
  __typename?: 'AutopricingReportFieldWeightsOptions';
  rank?: Maybe<Scalars['Int']>;
  stock?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Int']>;
};

export type AutopricingReportFieldWeightsOptionsInput = {
  rank?: Maybe<Scalars['Int']>;
  stock?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Int']>;
};

export type AutopricingReportFilterOptions = {
  __typename?: 'AutopricingReportFilterOptions';
  marketplaces?: Maybe<Array<Maybe<MarketplaceName>>>;
  resultCount?: Maybe<Scalars['Int']>;
  stockAtLeast?: Maybe<Scalars['Int']>;
  maxBottomCapShift?: Maybe<Scalars['Float']>;
  maxTopCapShift?: Maybe<Scalars['Float']>;
};

export type AutopricingReportFilterOptionsInput = {
  marketplaces?: Maybe<Array<Maybe<MarketplaceName>>>;
  resultCount?: Maybe<Scalars['Int']>;
  stockAtLeast?: Maybe<Scalars['Int']>;
  maxBottomCapShift?: Maybe<Scalars['Float']>;
  maxTopCapShift?: Maybe<Scalars['Float']>;
};

export type AutopricingReportOptions = {
  __typename?: 'AutopricingReportOptions';
  filters?: Maybe<AutopricingReportFilterOptions>;
  relevantRanges?: Maybe<AutopricingReportRelevantRangesOptions>;
  fieldWeights?: Maybe<AutopricingReportFieldWeightsOptions>;
};

export type AutopricingReportRecommendation = {
  __typename?: 'AutopricingReportRecommendation';
  bottomLimitShift?: Maybe<Scalars['Float']>;
  topLimitShift?: Maybe<Scalars['Float']>;
};

export type AutopricingReportRelevantRangesOptions = {
  __typename?: 'AutopricingReportRelevantRangesOptions';
  rank?: Maybe<Scalars['Int']>;
  stock?: Maybe<Scalars['Int']>;
};

export type AutopricingReportRelevantRangesOptionsInput = {
  rank?: Maybe<Scalars['Int']>;
  stock?: Maybe<Scalars['Int']>;
};

export type AutopricingReportResultItem = {
  __typename?: 'AutopricingReportResultItem';
  autopricing?: Maybe<Autopricing>;
  variant?: Maybe<ProductVariant>;
  recommendation?: Maybe<AutopricingReportRecommendation>;
};

export enum AutopricingReportState {
  created = 'created',
  processing = 'processing',
  finished = 'finished',
  error = 'error',
  none = 'none'
}

export type AutopricingStatistics = {
  __typename?: 'AutopricingStatistics';
  count: Scalars['Int'];
  addedCount: Scalars['Int'];
  reducedCount: Scalars['Int'];
  addedMoney?: Maybe<Money>;
  reducedMoney?: Maybe<Money>;
};

export type Barcode = {
  __typename?: 'Barcode';
  code?: Maybe<Scalars['String']>;
  type?: Maybe<BarcodeType>;
};

export type BarcodeInput = {
  code?: Maybe<Scalars['String']>;
  type?: Maybe<BarcodeType>;
};

export enum BarcodeType {
  wtf = 'wtf',
  EAN_8 = 'EAN_8',
  EAN_13 = 'EAN_13',
  UPC = 'UPC',
  ASIN = 'ASIN'
}

export type BlockProductVariant = {
  __typename?: 'BlockProductVariant';
  sku?: Maybe<Scalars['String']>;
  productStatus?: Maybe<Array<Maybe<ProductStatus>>>;
};

export enum BolCarrierName {
  DHL = 'DHL',
  GLS = 'GLS',
  UPS = 'UPS',
  PostNL = 'PostNL',
  DHLGlobalMail = 'DHLGlobalMail',
  AMPERE = 'AMPERE',
  DHLFORYOU = 'DHLFORYOU',
  Ampere = 'Ampere',
  Anders = 'Anders',
  Bezorgafspraak = 'Bezorgafspraak',
  BpostBelgie = 'BpostBelgie',
  BpostBriefpost = 'BpostBriefpost',
  Briefpost = 'Briefpost',
  Cycloon = 'Cycloon',
  DHLGermany = 'DHLGermany',
  DHLSameDay = 'DHLSameDay',
  DPDBelgie = 'DPDBelgie',
  DPDNederland = 'DPDNederland',
  Dynalogic = 'Dynalogic',
  FedExBelgie = 'FedExBelgie',
  FedExNederland = 'FedExNederland',
  Packs = 'Packs',
  ParcelNl = 'ParcelNl',
  PartsExpress = 'PartsExpress',
  PostNLBriefpost = 'PostNLBriefpost',
  PostNLExtraAtHome = 'PostNLExtraAtHome',
  TNTExpress = 'TNTExpress',
  TransMission = 'TransMission',
  TransportserviceNederlands = 'TransportserviceNederlands',
  Trunkrs = 'Trunkrs'
}

export type BuyBoxPriceInfo = {
  __typename?: 'BuyBoxPriceInfo';
  landed?: Maybe<Scalars['Float']>;
  listing?: Maybe<Scalars['Float']>;
  shipping?: Maybe<Scalars['Float']>;
};

export type BuyBoxPriceInfoInput = {
  landed?: Maybe<Scalars['Float']>;
  listing?: Maybe<Scalars['Float']>;
  shipping?: Maybe<Scalars['Float']>;
};

export type BuyBoxStats = {
  __typename?: 'BuyBoxStats';
  isInBuyBoxCount?: Maybe<Scalars['Int']>;
  notInBuyBoxCount?: Maybe<Scalars['Int']>;
};

export enum CarrierName {
  ALZABOX = 'ALZABOX',
  ALZABRANCH = 'ALZABRANCH',
  COURIER = 'COURIER',
  CZPOSTD = 'CZPOSTD',
  CZPOSTP = 'CZPOSTP',
  CZPOSTB = 'CZPOSTB',
  DHL = 'DHL',
  DPD = 'DPD',
  ALZA = 'ALZA',
  DPDALZABOX = 'DPDALZABOX',
  DPDBOX = 'DPDBOX',
  DPDPARCELSHOP = 'DPDPARCELSHOP',
  FOFRSTD = 'FOFRSTD',
  GebruderWeissStandard = 'GebruderWeissStandard',
  GEIS = 'GEIS',
  GEISPOINT = 'GEISPOINT',
  GEISCARGO = 'GEISCARGO',
  GLS = 'GLS',
  GO = 'GO',
  HELICARSTD = 'HELICARSTD',
  HELICARUP = 'HELICARUP',
  MagyarPOSTHD = 'MagyarPOSTHD',
  MagyarPOSTPO = 'MagyarPOSTPO',
  MagyarPOSTPP = 'MagyarPOSTPP',
  MagyarPOSTPT = 'MagyarPOSTPT',
  PPL = 'PPL',
  PPLPARCELSHOP = 'PPLPARCELSHOP',
  RHENUS = 'RHENUS',
  SKPOSTD = 'SKPOSTD',
  SKPOSTP = 'SKPOSTP',
  SKYNET = 'SKYNET',
  TOPTRANS = 'TOPTRANS',
  UPS = 'UPS',
  WEDOHD = 'WEDOHD',
  ZASILKOVNA = 'ZASILKOVNA',
  ZavolejSiKuryra = 'ZavolejSiKuryra',
  Supplier = 'Supplier',
  ThreeHundredSixtylion = 'ThreeHundredSixtylion',
  FourPX = 'FourPX',
  A1 = 'A1',
  AAACooper = 'AAACooper',
  ABF = 'ABF',
  AFLFedex = 'AFLFedex',
  ALLJOY = 'ALLJOY',
  AMAUK = 'AMAUK',
  AMAZONHORIZON = 'AMAZONHORIZON',
  AmazonShipping = 'AmazonShipping',
  AMZL = 'AMZL',
  AMZLUK = 'AMZLUK',
  Andere = 'Andere',
  Anjun = 'Anjun',
  AO = 'AO',
  AODeutschland = 'AODeutschland',
  APC = 'APC',
  APCOvernight = 'APCOvernight',
  APCPOSTALLOGISTICS = 'APCPOSTALLOGISTICS',
  APGeCommerce = 'APGeCommerce',
  Aramex = 'Aramex',
  ARAS = 'ARAS',
  ArasKargo = 'ArasKargo',
  ArcoSpedizioni = 'ArcoSpedizioni',
  Arkas = 'Arkas',
  ArrowXL = 'ArrowXL',
  Asendia = 'Asendia',
  Asgard = 'Asgard',
  Assett = 'Assett',
  ATPOST = 'ATPOST',
  ATS = 'ATS',
  AUSSIEPOST = 'AUSSIEPOST',
  AustraliaPost = 'AustraliaPost',
  AustraliaPostArticleID = 'AustraliaPostArticleID',
  AustraliaPostConsignment = 'AustraliaPostConsignment',
  B2C = 'B2C',
  B2CEurope = 'B2CEurope',
  B2CShip = 'B2CShip',
  Balnak = 'Balnak',
  Bartolini = 'Bartolini',
  BeijingQuanfengExpress = 'BeijingQuanfengExpress',
  BestBuy = 'BestBuy',
  BestExpress = 'BestExpress',
  BetterTrucks = 'BetterTrucks',
  BJS = 'BJS',
  Blowhorn = 'Blowhorn',
  BluePackage = 'BluePackage',
  BlueDart = 'BlueDart',
  Bombax = 'Bombax',
  BombinoExpress = 'BombinoExpress',
  BPOST = 'BPOST',
  BR1Express = 'BR1Express',
  BRT = 'BRT',
  Buylogic = 'Buylogic',
  Cainiao = 'Cainiao',
  CanadaPost = 'CanadaPost',
  Canpar = 'Canpar',
  CargoLine = 'CargoLine',
  Caribou = 'Caribou',
  Cart2India = 'Cart2India',
  CBHub = 'CBHub',
  CBL = 'CBL',
  CDC = 'CDC',
  CELERITAS = 'CELERITAS',
  Centex = 'Centex',
  CEVA = 'CEVA',
  CevaLojistik = 'CevaLojistik',
  ChinaPost = 'ChinaPost',
  ChronoExpress = 'ChronoExpress',
  Chronopost = 'Chronopost',
  Chukou1 = 'Chukou1',
  Cititrans = 'Cititrans',
  CityLink = 'CityLink',
  CityPost = 'CityPost',
  CNE = 'CNE',
  Coliposte = 'Coliposte',
  Colissimo = 'Colissimo',
  ConsegnaMezziPropri = 'ConsegnaMezziPropri',
  Conway = 'Conway',
  Correios = 'Correios',
  Correos = 'Correos',
  CorreosExpress = 'CorreosExpress',
  COSCO = 'COSCO',
  CouriersPlease = 'CouriersPlease',
  CTTExpress = 'CTTExpress',
  Cubyn = 'Cubyn',
  CyberSavings = 'CyberSavings',
  DACHSER = 'DACHSER',
  DAIPOST = 'DAIPOST',
  DBSchenker = 'DBSchenker',
  DELDeliveries = 'DELDeliveries',
  Delhivery = 'Delhivery',
  Delivengo = 'Delivengo',
  DeliveryGroup = 'DeliveryGroup',
  DerKurier = 'DerKurier',
  DeutschePost = 'DeutschePost',
  DFL = 'DFL',
  DHLeCommerce = 'DHLeCommerce',
  DHLExpress = 'DHLExpress',
  DHLFreight = 'DHLFreight',
  DHLGlobalMail = 'DHLGlobalMail',
  DHLHomeDelivery = 'DHLHomeDelivery',
  DHLKargo = 'DHLKargo',
  DHLPaket = 'DHLPaket',
  DHLParcelUK = 'DHLParcelUK',
  DHLPL = 'DHLPL',
  DigitalDelivery = 'DigitalDelivery',
  DirectLog = 'DirectLog',
  Dotzot = 'Dotzot',
  DPB = 'DPB',
  DPDLocal = 'DPDLocal',
  DSV = 'DSV',
  DTDC = 'DTDC',
  DX = 'DX',
  DXExpress = 'DXExpress',
  DXFreight = 'DXFreight',
  DXSecure = 'DXSecure',
  DYNAMICEXPRESS = 'DYNAMICEXPRESS',
  ECMS = 'ECMS',
  ECMSexpress = 'ECMSexpress',
  EcomExpress = 'EcomExpress',
  EcomShippingSolutionsPVTltd = 'EcomShippingSolutionsPVTltd',
  EINSASOURCING = 'EINSASOURCING',
  EKITrans = 'EKITrans',
  EmiratesPost = 'EmiratesPost',
  Emons = 'Emons',
  Endopack = 'Endopack',
  Energo = 'Energo',
  Envialia = 'Envialia',
  ePostGlobal = 'ePostGlobal',
  Equick = 'Equick',
  ESNAD = 'ESNAD',
  Estafeta = 'Estafeta',
  Estes = 'Estes',
  EUB = 'EUB',
  Europaczka = 'Europaczka',
  Exapaq = 'Exapaq',
  FASTEST = 'FASTEST',
  Fastway = 'Fastway',
  FedEx = 'FedEx',
  FedexFreight = 'FedexFreight',
  FEDEXJP = 'FEDEXJP',
  FedExSmartPost = 'FedExSmartPost',
  FERCAM = 'FERCAM',
  FilloKargo = 'FilloKargo',
  FirstFlight = 'FirstFlight',
  FirstFlightChina = 'FirstFlightChina',
  FirstMile = 'FirstMile',
  Fleetan = 'Fleetan',
  Flyt = 'Flyt',
  FRACHTPOST = 'FRACHTPOST',
  FRANCEEXPRESS = 'FRANCEEXPRESS',
  Gati = 'Gati',
  GEL = 'GEL',
  GELExpress = 'GELExpress',
  geodis = 'geodis',
  GeodisCalberson = 'GeodisCalberson',
  GeopostKargo = 'GeopostKargo',
  GFS = 'GFS',
  GLSCanada = 'GLSCanada',
  Gojavas = 'Gojavas',
  GRUPOLOGISTIC = 'GRUPOLOGISTIC',
  Hellmann = 'Hellmann',
  Heppner = 'Heppner',
  Hermes = 'Hermes',
  HermesCorporate = 'HermesCorporate',
  HermesEinrichtungsservice = 'HermesEinrichtungsservice',
  HermesLogistikGruppe = 'HermesLogistikGruppe',
  HermesUK = 'HermesUK',
  Hlog = 'Hlog',
  HNC = 'HNC',
  HomeLogistics = 'HomeLogistics',
  honesteye = 'honesteye',
  HongkongPost = 'HongkongPost',
  HorozLojistik = 'HorozLojistik',
  HotpointLogistics = 'HotpointLogistics',
  HRP = 'HRP',
  HScode = 'HScode',
  HUAHANLogistics = 'HUAHANLogistics',
  HubEurope = 'HubEurope',
  HunterExpress = 'HunterExpress',
  HunterLogistics = 'HunterLogistics',
  Huxloe = 'Huxloe',
  HuxloeLogistics = 'HuxloeLogistics',
  ICCWorldwide = 'ICCWorldwide',
  IDS = 'IDS',
  IDSNetzwerk = 'IDSNetzwerk',
  iMile = 'iMile',
  IndiaPost = 'IndiaPost',
  InPost = 'InPost',
  Interlink = 'Interlink',
  Interno = 'Interno',
  Intersoft = 'Intersoft',
  iParcel = 'iParcel',
  ITDGlobal = 'ITDGlobal',
  JampTExpress = 'JampTExpress',
  JapanPost = 'JapanPost',
  JCEX = 'JCEX',
  JerseyPost = 'JerseyPost',
  Jiufang = 'Jiufang',
  JPEXPRESS = 'JPEXPRESS',
  JPLUPU = 'JPLUPU',
  JSExpress = 'JSExpress',
  JT = 'JT',
  JTExpress = 'JTExpress',
  JYExpress = 'JYExpress',
  Kargokar = 'Kargokar',
  KEAVO = 'KEAVO',
  Kerry = 'Kerry',
  KuehneNagel = 'KuehneNagel',
  Kybotech = 'Kybotech',
  LaPoste = 'LaPoste',
  Landmark = 'Landmark',
  LandmarkGlobal = 'LandmarkGlobal',
  Lasership = 'Lasership',
  Lemonmode = 'Lemonmode',
  Letian = 'Letian',
  LFLogistic = 'LFLogistic',
  Liccardi = 'Liccardi',
  LiccardiTrasporti = 'LiccardiTrasporti',
  LogistikGruppe = 'LogistikGruppe',
  Loomis = 'Loomis',
  MailAlliance = 'MailAlliance',
  MailAmericas = 'MailAmericas',
  Mainpost = 'Mainpost',
  MBE = 'MBE',
  MetroKargo = 'MetroKargo',
  Mezzipropri = 'Mezzipropri',
  MHI = 'MHI',
  Milkman = 'Milkman',
  MNGKargo = 'MNGKargo',
  MondialRelay = 'MondialRelay',
  MRW = 'MRW',
  MZZBriefdienst = 'MZZBriefdienst',
  Nacex = 'Nacex',
  NAQELEXPRESS = 'NAQELEXPRESS',
  NarpostKargo = 'NarpostKargo',
  NewZealandPost = 'NewZealandPost',
  Newgistics = 'Newgistics',
  Nexive = 'Nexive',
  Ninjavan = 'Ninjavan',
  NipponExpress = 'NipponExpress',
  NITTSU = 'NITTSU',
  NOVEO = 'NOVEO',
  NowBikes = 'NowBikes',
  NTL = 'NTL',
  OCSWorldwide = 'OCSWorldwide',
  OldDominion = 'OldDominion',
  OneWorldExpress = 'OneWorldExpress',
  ONTIME = 'ONTIME',
  OnTrac = 'OnTrac',
  OSM = 'OSM',
  OSMWorldwide = 'OSMWorldwide',
  Other = 'Other',
  Otro = 'Otro',
  OverniteExpress = 'OverniteExpress',
  Palletline = 'Palletline',
  Palletways = 'Palletways',
  Panther = 'Panther',
  ParcelHub = 'ParcelHub',
  ParcelMonkey = 'ParcelMonkey',
  ParcelStation = 'ParcelStation',
  Parcel2go = 'Parcel2go',
  ParcelDenOnline = 'ParcelDenOnline',
  Parcelforce = 'Parcelforce',
  Parcelhub = 'Parcelhub',
  ParcelinkLogistics = 'ParcelinkLogistics',
  Parcelnet = 'Parcelnet',
  ParcelOne = 'ParcelOne',
  Paquetexpress = 'Paquetexpress',
  PDCLogistics = 'PDCLogistics',
  Pilot = 'Pilot',
  PilotFreight = 'PilotFreight',
  PIN = 'PIN',
  PolishPost = 'PolishPost',
  PosLaju = 'PosLaju',
  PostModern = 'PostModern',
  PosteItaliane = 'PosteItaliane',
  PostNL = 'PostNL',
  PostNord = 'PostNord',
  Professional = 'Professional',
  PTTKargo = 'PTTKargo',
  PUROLATOR = 'PUROLATOR',
  Quantium = 'Quantium',
  Qxpress = 'Qxpress',
  RL = 'RL',
  RabenGroup = 'RabenGroup',
  RBNA = 'RBNA',
  REDUR = 'REDUR',
  Redpack = 'Redpack',
  Rhenus = 'Rhenus',
  Rieck = 'Rieck',
  Rivigo = 'Rivigo',
  RMLGB = 'RMLGB',
  Roadrunner = 'Roadrunner',
  RoyalMail = 'RoyalMail',
  RRDonnelley = 'RRDonnelley',
  Safexpress = 'Safexpress',
  SAGAWA = 'SAGAWA',
  SagawaExpress = 'SagawaExpress',
  Saia = 'Saia',
  Sailpost = 'Sailpost',
  SchweizerPost = 'SchweizerPost',
  SDA = 'SDA',
  Seino = 'Seino',
  SEINOTRANSPORTATION = 'SEINOTRANSPORTATION',
  SekoLogistics = 'SekoLogistics',
  SelemKargo = 'SelemKargo',
  SelfDelivery = 'SelfDelivery',
  Sendcloud = 'Sendcloud',
  Sending = 'Sending',
  SENDLE = 'SENDLE',
  Seur = 'Seur',
  SevenSenders = 'SevenSenders',
  SFExpress = 'SFExpress',
  SFC = 'SFC',
  ShipDelight = 'ShipDelight',
  ShipGlobalUS = 'ShipGlobalUS',
  SHIPA = 'SHIPA',
  ShipEconomy = 'ShipEconomy',
  ShipEntegra = 'ShipEntegra',
  ShipGlobal = 'ShipGlobal',
  Shipmate = 'Shipmate',
  Shippit = 'Shippit',
  ShopiniWorld = 'ShopiniWorld',
  ShreeMarutiCourier = 'ShreeMarutiCourier',
  ShreeTirupatiCourier = 'ShreeTirupatiCourier',
  ShunfengExpress = 'ShunfengExpress',
  Sinerlog = 'Sinerlog',
  SingaporePost = 'SingaporePost',
  Sinotrans = 'Sinotrans',
  Skypostal = 'Skypostal',
  Smartmail = 'Smartmail',
  Smartrlogistics = 'Smartrlogistics',
  SMSA = 'SMSA',
  SMSAExpress = 'SMSAExpress',
  Soarmall = 'Soarmall',
  Sonstige = 'Sonstige',
  SouthEasternFreightLines = 'SouthEasternFreightLines',
  Speedaf = 'Speedaf',
  Speedex = 'Speedex',
  Spoton = 'Spoton',
  Spring = 'Spring',
  springGDS = 'springGDS',
  Sprint = 'Sprint',
  StahlmannandSachs = 'StahlmannandSachs',
  Stampit = 'Stampit',
  Staples = 'Staples',
  StarTrackArticleID = 'StarTrackArticleID',
  StarTrackConsignment = 'StarTrackConsignment',
  STG = 'STG',
  STOExpress = 'STOExpress',
  Streamlite = 'Streamlite',
  Sunyou = 'Sunyou',
  Susa = 'Susa',
  Swisspost = 'Swisspost',
  Szendex = 'Szendex',
  Target = 'Target',
  TATAExpress = 'TATAExpress',
  TDN = 'TDN',
  TeamExpress = 'TeamExpress',
  TezelLojistik = 'TezelLojistik',
  TheDeliveryGroup = 'TheDeliveryGroup',
  TheProfessionalCouriers = 'TheProfessionalCouriers',
  TIPSA = 'TIPSA',
  TNT = 'TNT',
  TNTKargo = 'TNTKargo',
  TNTIT = 'TNTIT',
  Toll = 'Toll',
  TollGlobalExpress = 'TollGlobalExpress',
  TongdaGlobal = 'TongdaGlobal',
  Topyou = 'Topyou',
  TotalExpress = 'TotalExpress',
  Tourline = 'Tourline',
  Trackon = 'Trackon',
  Trakpak = 'Trakpak',
  Transaher = 'Transaher',
  TransFolha = 'TransFolha',
  Translink = 'Translink',
  TransoFlex = 'TransoFlex',
  Truline = 'Truline',
  TSB = 'TSB',
  Tuffnells = 'Tuffnells',
  TWS = 'TWS',
  TXT = 'TXT',
  TyD = 'TyD',
  UBI = 'UBI',
  UKMail = 'UKMail',
  UniUni = 'UniUni',
  UPakWeShip = 'UPakWeShip',
  UPSFreight = 'UPSFreight',
  UPSMailInnovations = 'UPSMailInnovations',
  Upsilon = 'Upsilon',
  UPSMI = 'UPSMI',
  UrbanExpress = 'UrbanExpress',
  Uship = 'Uship',
  USPS = 'USPS',
  VerageShipping = 'VerageShipping',
  ViaXpress = 'ViaXpress',
  VIR = 'VIR',
  VNLIN = 'VNLIN',
  WanbExpress = 'WanbExpress',
  WatkinsandShepard = 'WatkinsandShepard',
  Wefast = 'Wefast',
  WeWorldExpress = 'WeWorldExpress',
  Whistl = 'Whistl',
  Whizzard = 'Whizzard',
  WINIT = 'WINIT',
  WPX = 'WPX',
  XDP = 'XDP',
  XPO = 'XPO',
  XPOFreight = 'XPOFreight',
  Xpressbees = 'Xpressbees',
  YAMATO = 'YAMATO',
  YamatoTransport = 'YamatoTransport',
  YANWEN = 'YANWEN',
  YDH = 'YDH',
  YellowFreight = 'YellowFreight',
  YFLogistics = 'YFLogistics',
  YFHEX = 'YFHEX',
  YHT = 'YHT',
  Yodel = 'Yodel',
  YTOExpress = 'YTOExpress',
  YunExpress = 'YunExpress',
  YundaExpress = 'YundaExpress',
  ZADExpress = 'ZADExpress',
  Zeleris = 'Zeleris',
  ZTOExpress = 'ZTOExpress',
  ZustAmbrosetti = 'ZustAmbrosetti',
  WEDOLOGISTICS = 'WEDOLOGISTICS',
  SPS = 'SPS',
  CZECHPOST = 'CZECHPOST',
  Packeta = 'Packeta',
  OTHER = 'OTHER',
  AsendiaHK = 'AsendiaHK',
  Bpost = 'Bpost',
  ChinaEMS_ePacket = 'ChinaEMS_ePacket',
  Chronofresh = 'Chronofresh',
  CNEExpress = 'CNEExpress',
  ColisPrive = 'ColisPrive',
  DHLDeutschePost = 'DHLDeutschePost',
  DHLEcommerceAsia = 'DHLEcommerceAsia',
  FastWL = 'FastWL',
  GEODIS = 'GEODIS',
  LaPosteCourrier = 'LaPosteCourrier',
  MalaysiaPost = 'MalaysiaPost',
  RelaisColis = 'RelaisColis',
  SFCService = 'SFCService',
  WishPost = 'WishPost',
  Yanwen = 'Yanwen'
}

export enum CdiscountCarrierName {
  FourPX = 'FourPX',
  AsendiaHK = 'AsendiaHK',
  Bpost = 'Bpost',
  ChinaEMS_ePacket = 'ChinaEMS_ePacket',
  ChinaPost = 'ChinaPost',
  Chronofresh = 'Chronofresh',
  Chronopost = 'Chronopost',
  CNEExpress = 'CNEExpress',
  ColisPrive = 'ColisPrive',
  Colissimo = 'Colissimo',
  DBSchenker = 'DBSchenker',
  DHLDeutschePost = 'DHLDeutschePost',
  DHLEcommerceAsia = 'DHLEcommerceAsia',
  DHLExpress = 'DHLExpress',
  DPD = 'DPD',
  FastWL = 'FastWL',
  FedEx = 'FedEx',
  GEODIS = 'GEODIS',
  GLS = 'GLS',
  Hermes = 'Hermes',
  LaPosteCourrier = 'LaPosteCourrier',
  MalaysiaPost = 'MalaysiaPost',
  MondialRelay = 'MondialRelay',
  PostNL = 'PostNL',
  RelaisColis = 'RelaisColis',
  SFExpress = 'SFExpress',
  SFCService = 'SFCService',
  SingaporePost = 'SingaporePost',
  Spring = 'Spring',
  TNT = 'TNT',
  UPS = 'UPS',
  WanbExpress = 'WanbExpress',
  WishPost = 'WishPost',
  Yanwen = 'Yanwen',
  YunExpress = 'YunExpress',
  Other = 'Other'
}

export type ChannelHighestPriceInfo = {
  __typename?: 'ChannelHighestPriceInfo';
  channel?: Maybe<Scalars['String']>;
  landed?: Maybe<Scalars['Float']>;
  listing?: Maybe<Scalars['Float']>;
  shipping?: Maybe<Scalars['Float']>;
};

export type ChannelHighestPriceInfoInput = {
  channel?: Maybe<Scalars['String']>;
  landed?: Maybe<Scalars['Float']>;
  listing?: Maybe<Scalars['Float']>;
  shipping?: Maybe<Scalars['Float']>;
};

export type ChannelLowestPriceInfo = {
  __typename?: 'ChannelLowestPriceInfo';
  channel?: Maybe<Scalars['String']>;
  landed?: Maybe<Scalars['Float']>;
  listing?: Maybe<Scalars['Float']>;
  shipping?: Maybe<Scalars['Float']>;
};

export type ChannelLowestPriceInfoInput = {
  channel?: Maybe<Scalars['String']>;
  landed?: Maybe<Scalars['Float']>;
  listing?: Maybe<Scalars['Float']>;
  shipping?: Maybe<Scalars['Float']>;
};

export type CompanyError = {
  __typename?: 'CompanyError';
  companyId: Scalars['MongoID'];
  code?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['Date']>;
  timestamp?: Maybe<Scalars['Date']>;
  count?: Maybe<Scalars['Float']>;
  message?: Maybe<Scalars['String']>;
  devMessage?: Maybe<Scalars['String']>;
  _id: Scalars['MongoID'];
};

export type CompanyQuery = {
  __typename?: 'CompanyQuery';
  active?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  internalName?: Maybe<Scalars['String']>;
  feedType?: Maybe<EnumCompanyFeedType>;
  onboardingState?: Maybe<EnumCompanyOnboardingState>;
  googleDataStudioUrl?: Maybe<Scalars['String']>;
  returnAddress?: Maybe<CompanyReturnAddress>;
  _id: Scalars['MongoID'];
  isOnboarding?: Maybe<Scalars['Boolean']>;
  subscription?: Maybe<SubscriptionSchema>;
};

export type CompanyReturnAddress = {
  __typename?: 'CompanyReturnAddress';
  companyName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
};

export type CompanyReturnAddressDoc = {
  __typename?: 'CompanyReturnAddressDoc';
  returnAddress?: Maybe<CompanyReturnAddress>;
  _id: Scalars['MongoID'];
};

export type CompleteShoptetLoginResult = {
  __typename?: 'CompleteShoptetLoginResult';
  user?: Maybe<UserQuery>;
  redirectUrl?: Maybe<Scalars['String']>;
};

export type CreatePasswordResetEmailResult = {
  __typename?: 'CreatePasswordResetEmailResult';
  success: Scalars['Boolean'];
  email: Scalars['String'];
  invalidEmail?: Maybe<Scalars['Boolean']>;
};

export type CreateShipment = {
  __typename?: 'CreateShipment';
  success: Scalars['Boolean'];
  message?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
};

export type CustomFeedMapping = {
  __typename?: 'CustomFeedMapping';
  g__id?: Maybe<Scalars['String']>;
  g__gtin?: Maybe<Scalars['String']>;
  g__price?: Maybe<Scalars['String']>;
  g__title?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['String']>;
  g__image_link?: Maybe<Scalars['String']>;
  eco_fee?: Maybe<Scalars['String']>;
  shipping_template?: Maybe<Scalars['String']>;
  handling_time?: Maybe<Scalars['String']>;
  vat_rate?: Maybe<Scalars['String']>;
  condition?: Maybe<Scalars['String']>;
  prices_alza_cz?: Maybe<Scalars['String']>;
  prices_amazon_mx?: Maybe<Scalars['String']>;
  prices_amazon_us?: Maybe<Scalars['String']>;
  prices_amazon_ca?: Maybe<Scalars['String']>;
  prices_amazon_br?: Maybe<Scalars['String']>;
  prices_amazon_de?: Maybe<Scalars['String']>;
  prices_amazon_uk?: Maybe<Scalars['String']>;
  prices_amazon_fr?: Maybe<Scalars['String']>;
  prices_amazon_it?: Maybe<Scalars['String']>;
  prices_amazon_es?: Maybe<Scalars['String']>;
  prices_amazon_nl?: Maybe<Scalars['String']>;
  prices_amazon_se?: Maybe<Scalars['String']>;
  prices_amazon_tr?: Maybe<Scalars['String']>;
  prices_amazon_pl?: Maybe<Scalars['String']>;
  prices_amazon_be?: Maybe<Scalars['String']>;
  prices_amazon_ie?: Maybe<Scalars['String']>;
  prices_amazon_sg?: Maybe<Scalars['String']>;
  prices_amazon_au?: Maybe<Scalars['String']>;
  prices_amazon_jp?: Maybe<Scalars['String']>;
  prices_emag_bg?: Maybe<Scalars['String']>;
  prices_emag_hu?: Maybe<Scalars['String']>;
  prices_emag_pl?: Maybe<Scalars['String']>;
  prices_emag_ro?: Maybe<Scalars['String']>;
  prices_mall_cz?: Maybe<Scalars['String']>;
  prices_mall_hu?: Maybe<Scalars['String']>;
  prices_mall_pl?: Maybe<Scalars['String']>;
  prices_mall_si?: Maybe<Scalars['String']>;
  prices_mall_sk?: Maybe<Scalars['String']>;
  prices_shoptet_alza?: Maybe<Scalars['String']>;
  prices_shoptet_amazon?: Maybe<Scalars['String']>;
  prices_shoptet_mall?: Maybe<Scalars['String']>;
  prices_real_de?: Maybe<Scalars['String']>;
  prices_kaufland_de?: Maybe<Scalars['String']>;
  prices_kaufland_cz?: Maybe<Scalars['String']>;
  prices_kaufland_sk?: Maybe<Scalars['String']>;
  prices_kaufland_at?: Maybe<Scalars['String']>;
  prices_kaufland_pl?: Maybe<Scalars['String']>;
  prices_kaufland_nl?: Maybe<Scalars['String']>;
  prices_kaufland_es?: Maybe<Scalars['String']>;
  prices_kaufland_fr?: Maybe<Scalars['String']>;
  prices_kaufland_it?: Maybe<Scalars['String']>;
  prices_glami_cz?: Maybe<Scalars['String']>;
  prices_cdiscount_fr?: Maybe<Scalars['String']>;
  prices_ebay_at?: Maybe<Scalars['String']>;
  prices_ebay_cz?: Maybe<Scalars['String']>;
  prices_ebay_fr?: Maybe<Scalars['String']>;
  prices_ebay_pl?: Maybe<Scalars['String']>;
  prices_ebay_de?: Maybe<Scalars['String']>;
  prices_ebay_us?: Maybe<Scalars['String']>;
  prices_ebay_uk?: Maybe<Scalars['String']>;
  prices_allegro_cz?: Maybe<Scalars['String']>;
  prices_allegro_pl?: Maybe<Scalars['String']>;
  prices_allegro_sk?: Maybe<Scalars['String']>;
  prices_baskedo_bg?: Maybe<Scalars['String']>;
  prices_baskedo_hu?: Maybe<Scalars['String']>;
  prices_bol_nl?: Maybe<Scalars['String']>;
  prices_expando_shop_ro?: Maybe<Scalars['String']>;
  prices_limetka_cz?: Maybe<Scalars['String']>;
  prices_limetka_gr?: Maybe<Scalars['String']>;
  prices_limetka_sk?: Maybe<Scalars['String']>;
  autopricing_amazon_mx_status?: Maybe<Scalars['String']>;
  autopricing_amazon_mx_min_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_mx_max_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_mx_min_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_mx_max_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_us_status?: Maybe<Scalars['String']>;
  autopricing_amazon_us_min_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_us_max_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_us_min_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_us_max_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_ca_status?: Maybe<Scalars['String']>;
  autopricing_amazon_ca_min_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_ca_max_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_ca_min_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_ca_max_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_br_status?: Maybe<Scalars['String']>;
  autopricing_amazon_br_min_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_br_max_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_br_min_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_br_max_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_de_status?: Maybe<Scalars['String']>;
  autopricing_amazon_de_min_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_de_max_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_de_min_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_de_max_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_uk_status?: Maybe<Scalars['String']>;
  autopricing_amazon_uk_min_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_uk_max_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_uk_min_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_uk_max_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_fr_status?: Maybe<Scalars['String']>;
  autopricing_amazon_fr_min_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_fr_max_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_fr_min_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_fr_max_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_it_status?: Maybe<Scalars['String']>;
  autopricing_amazon_it_min_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_it_max_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_it_min_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_it_max_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_es_status?: Maybe<Scalars['String']>;
  autopricing_amazon_es_min_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_es_max_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_es_min_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_es_max_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_nl_status?: Maybe<Scalars['String']>;
  autopricing_amazon_nl_min_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_nl_max_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_nl_min_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_nl_max_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_se_status?: Maybe<Scalars['String']>;
  autopricing_amazon_se_min_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_se_max_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_se_min_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_se_max_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_tr_status?: Maybe<Scalars['String']>;
  autopricing_amazon_tr_min_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_tr_max_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_tr_min_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_tr_max_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_pl_status?: Maybe<Scalars['String']>;
  autopricing_amazon_pl_min_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_pl_max_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_pl_min_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_pl_max_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_be_status?: Maybe<Scalars['String']>;
  autopricing_amazon_be_min_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_be_max_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_be_min_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_be_max_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_ie_status?: Maybe<Scalars['String']>;
  autopricing_amazon_ie_min_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_ie_max_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_ie_min_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_ie_max_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_sg_status?: Maybe<Scalars['String']>;
  autopricing_amazon_sg_min_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_sg_max_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_sg_min_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_sg_max_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_au_status?: Maybe<Scalars['String']>;
  autopricing_amazon_au_min_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_au_max_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_au_min_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_au_max_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_jp_status?: Maybe<Scalars['String']>;
  autopricing_amazon_jp_min_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_jp_max_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_jp_min_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_jp_max_absolute?: Maybe<Scalars['String']>;
};

export type CustomProductFeed = {
  __typename?: 'CustomProductFeed';
  setupState?: Maybe<EFeedSetupState>;
  status?: Maybe<EFeedStatus>;
  feedUrl?: Maybe<Scalars['String']>;
  item?: Maybe<Scalars['String']>;
  feedSample?: Maybe<Scalars['String']>;
  elementNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  encoding?: Maybe<Scalars['String']>;
  mapping?: Maybe<CustomFeedMapping>;
  pathValues?: Maybe<Array<Maybe<FeedPathValues>>>;
};

export type CustomProductFeedInput = {
  feedUrl: Scalars['String'];
  feedType?: Maybe<ProductFeedTypeEnum>;
  decompress?: Maybe<Scalars['Boolean']>;
  encoding?: Maybe<Scalars['String']>;
  item?: Maybe<Scalars['String']>;
  mapping?: Maybe<CustomProductFeedMappingInput>;
  auth?: Maybe<Scalars['String']>;
  js?: Maybe<Scalars['String']>;
  useCommaDelimiter?: Maybe<Scalars['Boolean']>;
  anyDecimal?: Maybe<Scalars['Boolean']>;
  handlingTime?: Maybe<Scalars['Int']>;
};

export type CustomProductFeedMappingInput = {
  g__id?: Maybe<Scalars['String']>;
  g__gtin?: Maybe<Scalars['String']>;
  g__price?: Maybe<Scalars['String']>;
  g__title?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['String']>;
  g__image_link?: Maybe<Scalars['String']>;
  eco_fee?: Maybe<Scalars['String']>;
  shipping_template?: Maybe<Scalars['String']>;
  handling_time?: Maybe<Scalars['String']>;
  vat_rate?: Maybe<Scalars['String']>;
  condition?: Maybe<Scalars['String']>;
  prices_alza_cz?: Maybe<Scalars['String']>;
  prices_amazon_mx?: Maybe<Scalars['String']>;
  prices_amazon_us?: Maybe<Scalars['String']>;
  prices_amazon_ca?: Maybe<Scalars['String']>;
  prices_amazon_br?: Maybe<Scalars['String']>;
  prices_amazon_de?: Maybe<Scalars['String']>;
  prices_amazon_uk?: Maybe<Scalars['String']>;
  prices_amazon_fr?: Maybe<Scalars['String']>;
  prices_amazon_it?: Maybe<Scalars['String']>;
  prices_amazon_es?: Maybe<Scalars['String']>;
  prices_amazon_nl?: Maybe<Scalars['String']>;
  prices_amazon_se?: Maybe<Scalars['String']>;
  prices_amazon_tr?: Maybe<Scalars['String']>;
  prices_amazon_pl?: Maybe<Scalars['String']>;
  prices_amazon_be?: Maybe<Scalars['String']>;
  prices_amazon_ie?: Maybe<Scalars['String']>;
  prices_amazon_sg?: Maybe<Scalars['String']>;
  prices_amazon_au?: Maybe<Scalars['String']>;
  prices_amazon_jp?: Maybe<Scalars['String']>;
  prices_emag_bg?: Maybe<Scalars['String']>;
  prices_emag_hu?: Maybe<Scalars['String']>;
  prices_emag_pl?: Maybe<Scalars['String']>;
  prices_emag_ro?: Maybe<Scalars['String']>;
  prices_mall_cz?: Maybe<Scalars['String']>;
  prices_mall_hu?: Maybe<Scalars['String']>;
  prices_mall_pl?: Maybe<Scalars['String']>;
  prices_mall_si?: Maybe<Scalars['String']>;
  prices_mall_sk?: Maybe<Scalars['String']>;
  prices_shoptet_alza?: Maybe<Scalars['String']>;
  prices_shoptet_amazon?: Maybe<Scalars['String']>;
  prices_shoptet_mall?: Maybe<Scalars['String']>;
  prices_real_de?: Maybe<Scalars['String']>;
  prices_kaufland_de?: Maybe<Scalars['String']>;
  prices_kaufland_cz?: Maybe<Scalars['String']>;
  prices_kaufland_sk?: Maybe<Scalars['String']>;
  prices_kaufland_at?: Maybe<Scalars['String']>;
  prices_kaufland_pl?: Maybe<Scalars['String']>;
  prices_kaufland_nl?: Maybe<Scalars['String']>;
  prices_kaufland_es?: Maybe<Scalars['String']>;
  prices_kaufland_fr?: Maybe<Scalars['String']>;
  prices_kaufland_it?: Maybe<Scalars['String']>;
  prices_glami_cz?: Maybe<Scalars['String']>;
  prices_cdiscount_fr?: Maybe<Scalars['String']>;
  prices_ebay_at?: Maybe<Scalars['String']>;
  prices_ebay_cz?: Maybe<Scalars['String']>;
  prices_ebay_fr?: Maybe<Scalars['String']>;
  prices_ebay_pl?: Maybe<Scalars['String']>;
  prices_ebay_de?: Maybe<Scalars['String']>;
  prices_ebay_us?: Maybe<Scalars['String']>;
  prices_ebay_uk?: Maybe<Scalars['String']>;
  prices_allegro_cz?: Maybe<Scalars['String']>;
  prices_allegro_pl?: Maybe<Scalars['String']>;
  prices_allegro_sk?: Maybe<Scalars['String']>;
  prices_baskedo_bg?: Maybe<Scalars['String']>;
  prices_baskedo_hu?: Maybe<Scalars['String']>;
  prices_bol_nl?: Maybe<Scalars['String']>;
  prices_expando_shop_ro?: Maybe<Scalars['String']>;
  prices_limetka_cz?: Maybe<Scalars['String']>;
  prices_limetka_gr?: Maybe<Scalars['String']>;
  prices_limetka_sk?: Maybe<Scalars['String']>;
  autopricing_amazon_mx_status?: Maybe<Scalars['String']>;
  autopricing_amazon_mx_min_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_mx_max_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_mx_min_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_mx_max_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_us_status?: Maybe<Scalars['String']>;
  autopricing_amazon_us_min_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_us_max_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_us_min_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_us_max_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_ca_status?: Maybe<Scalars['String']>;
  autopricing_amazon_ca_min_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_ca_max_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_ca_min_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_ca_max_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_br_status?: Maybe<Scalars['String']>;
  autopricing_amazon_br_min_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_br_max_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_br_min_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_br_max_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_de_status?: Maybe<Scalars['String']>;
  autopricing_amazon_de_min_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_de_max_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_de_min_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_de_max_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_uk_status?: Maybe<Scalars['String']>;
  autopricing_amazon_uk_min_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_uk_max_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_uk_min_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_uk_max_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_fr_status?: Maybe<Scalars['String']>;
  autopricing_amazon_fr_min_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_fr_max_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_fr_min_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_fr_max_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_it_status?: Maybe<Scalars['String']>;
  autopricing_amazon_it_min_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_it_max_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_it_min_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_it_max_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_es_status?: Maybe<Scalars['String']>;
  autopricing_amazon_es_min_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_es_max_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_es_min_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_es_max_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_nl_status?: Maybe<Scalars['String']>;
  autopricing_amazon_nl_min_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_nl_max_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_nl_min_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_nl_max_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_se_status?: Maybe<Scalars['String']>;
  autopricing_amazon_se_min_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_se_max_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_se_min_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_se_max_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_tr_status?: Maybe<Scalars['String']>;
  autopricing_amazon_tr_min_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_tr_max_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_tr_min_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_tr_max_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_pl_status?: Maybe<Scalars['String']>;
  autopricing_amazon_pl_min_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_pl_max_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_pl_min_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_pl_max_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_be_status?: Maybe<Scalars['String']>;
  autopricing_amazon_be_min_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_be_max_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_be_min_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_be_max_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_ie_status?: Maybe<Scalars['String']>;
  autopricing_amazon_ie_min_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_ie_max_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_ie_min_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_ie_max_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_sg_status?: Maybe<Scalars['String']>;
  autopricing_amazon_sg_min_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_sg_max_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_sg_min_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_sg_max_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_au_status?: Maybe<Scalars['String']>;
  autopricing_amazon_au_min_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_au_max_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_au_min_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_au_max_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_jp_status?: Maybe<Scalars['String']>;
  autopricing_amazon_jp_min_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_jp_max_percentage?: Maybe<Scalars['String']>;
  autopricing_amazon_jp_min_absolute?: Maybe<Scalars['String']>;
  autopricing_amazon_jp_max_absolute?: Maybe<Scalars['String']>;
};


export type DiscardTrialDeadlineResult = {
  __typename?: 'DiscardTrialDeadlineResult';
  success: Scalars['Boolean'];
};

export enum EFeatureName {
  bulk_confirm_orders = 'bulk_confirm_orders',
  default_ship_method = 'default_ship_method',
  delete_company_enabled = 'delete_company_enabled',
  glami_enabled = 'glami_enabled',
  group_pickup_lists = 'group_pickup_lists',
  mall_new_product_sync = 'mall_new_product_sync',
  handling_time_enabled = 'handling_time_enabled',
  autopricing_suggestions = 'autopricing_suggestions',
  storno_status_enabled = 'storno_status_enabled',
  alza_v5_shipment_departure = 'alza_v5_shipment_departure',
  show_automatch_toggle = 'show_automatch_toggle',
  alza_fullnumber = 'alza_fullnumber',
  kaufland_products = 'kaufland_products',
  new_kaufland = 'new_kaufland',
  orders_500 = 'orders_500',
  ebay_orders = 'ebay_orders',
  show_return_label_button = 'show_return_label_button',
  block_kaufland_products_disabled = 'block_kaufland_products_disabled',
  v5_ai_matching_enabled = 'v5_ai_matching_enabled',
  partner_marketplaces = 'partner_marketplaces',
  pause_closes_amazon_offer = 'pause_closes_amazon_offer'
}

export enum EFeedSetupState {
  NoFeed = 'NoFeed',
  ItemSelection = 'ItemSelection',
  Mapping = 'Mapping',
  Done = 'Done'
}

export enum EFeedStatus {
  Ok = 'Ok',
  NoData = 'NoData',
  UrlUnreachable = 'UrlUnreachable',
  BadMapping = 'BadMapping',
  BadItem = 'BadItem',
  PossibleBadItem = 'PossibleBadItem',
  Timeout = 'Timeout',
  Unauthorized = 'Unauthorized',
  NoProducts = 'NoProducts',
  IncorrectData = 'IncorrectData',
  ErrorWhileDownloading = 'ErrorWhileDownloading'
}

export type EmailNotificationSettings = {
  __typename?: 'EmailNotificationSettings';
  platform?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
};

export type EmailVerification = {
  __typename?: 'EmailVerification';
  email: Scalars['String'];
  code: Scalars['String'];
  verified: Scalars['Boolean'];
  expireAt: Scalars['Date'];
  createdAt: Scalars['Date'];
  _id: Scalars['MongoID'];
  hasExpired: Scalars['Boolean'];
};

export type Endpoints = {
  __typename?: 'Endpoints';
  endpoint: Scalars['String'];
  description: Scalars['String'];
  access: Scalars['String'];
};

export enum EnumApiTokenType {
  Primary = 'Primary',
  Alternative = 'Alternative'
}

export enum EnumCompanyFeedType {
  GOOGLE_PRODUCT = 'GOOGLE_PRODUCT',
  SHOPIFY = 'SHOPIFY',
  SHOPTET = 'SHOPTET',
  NONE = 'NONE',
  CUSTOM = 'CUSTOM',
  DATABASE = 'DATABASE',
  FEED = 'FEED'
}

export enum EnumCompanyOnboardingState {
  SOURCE_SELECTION = 'SOURCE_SELECTION',
  MARKETPLACES_CONNECTION = 'MARKETPLACES_CONNECTION',
  DONE = 'DONE'
}

export enum EnumFulfillmentCarrier {
  ALZABOX = 'ALZABOX',
  ALZABRANCH = 'ALZABRANCH',
  COURIER = 'COURIER',
  CZPOSTD = 'CZPOSTD',
  CZPOSTP = 'CZPOSTP',
  CZPOSTB = 'CZPOSTB',
  DHL = 'DHL',
  DPD = 'DPD',
  ALZA = 'ALZA',
  DPDALZABOX = 'DPDALZABOX',
  DPDBOX = 'DPDBOX',
  DPDPARCELSHOP = 'DPDPARCELSHOP',
  FOFRSTD = 'FOFRSTD',
  GebruderWeissStandard = 'GebruderWeissStandard',
  GEIS = 'GEIS',
  GEISPOINT = 'GEISPOINT',
  GEISCARGO = 'GEISCARGO',
  GLS = 'GLS',
  GO = 'GO',
  HELICARSTD = 'HELICARSTD',
  HELICARUP = 'HELICARUP',
  MagyarPOSTHD = 'MagyarPOSTHD',
  MagyarPOSTPO = 'MagyarPOSTPO',
  MagyarPOSTPP = 'MagyarPOSTPP',
  MagyarPOSTPT = 'MagyarPOSTPT',
  PPL = 'PPL',
  PPLPARCELSHOP = 'PPLPARCELSHOP',
  RHENUS = 'RHENUS',
  SKPOSTD = 'SKPOSTD',
  SKPOSTP = 'SKPOSTP',
  SKYNET = 'SKYNET',
  TOPTRANS = 'TOPTRANS',
  UPS = 'UPS',
  WEDOHD = 'WEDOHD',
  ZASILKOVNA = 'ZASILKOVNA',
  ZavolejSiKuryra = 'ZavolejSiKuryra',
  Supplier = 'Supplier',
  ThreeHundredSixtylion = 'ThreeHundredSixtylion',
  FourPX = 'FourPX',
  A1 = 'A1',
  AAACooper = 'AAACooper',
  ABF = 'ABF',
  AFLFedex = 'AFLFedex',
  ALLJOY = 'ALLJOY',
  AMAUK = 'AMAUK',
  AMAZONHORIZON = 'AMAZONHORIZON',
  AmazonShipping = 'AmazonShipping',
  AMZL = 'AMZL',
  AMZLUK = 'AMZLUK',
  Andere = 'Andere',
  Anjun = 'Anjun',
  AO = 'AO',
  AODeutschland = 'AODeutschland',
  APC = 'APC',
  APCOvernight = 'APCOvernight',
  APCPOSTALLOGISTICS = 'APCPOSTALLOGISTICS',
  APGeCommerce = 'APGeCommerce',
  Aramex = 'Aramex',
  ARAS = 'ARAS',
  ArasKargo = 'ArasKargo',
  ArcoSpedizioni = 'ArcoSpedizioni',
  Arkas = 'Arkas',
  ArrowXL = 'ArrowXL',
  Asendia = 'Asendia',
  Asgard = 'Asgard',
  Assett = 'Assett',
  ATPOST = 'ATPOST',
  ATS = 'ATS',
  AUSSIEPOST = 'AUSSIEPOST',
  AustraliaPost = 'AustraliaPost',
  AustraliaPostArticleID = 'AustraliaPostArticleID',
  AustraliaPostConsignment = 'AustraliaPostConsignment',
  B2C = 'B2C',
  B2CEurope = 'B2CEurope',
  B2CShip = 'B2CShip',
  Balnak = 'Balnak',
  Bartolini = 'Bartolini',
  BeijingQuanfengExpress = 'BeijingQuanfengExpress',
  BestBuy = 'BestBuy',
  BestExpress = 'BestExpress',
  BetterTrucks = 'BetterTrucks',
  BJS = 'BJS',
  Blowhorn = 'Blowhorn',
  BluePackage = 'BluePackage',
  BlueDart = 'BlueDart',
  Bombax = 'Bombax',
  BombinoExpress = 'BombinoExpress',
  BPOST = 'BPOST',
  BR1Express = 'BR1Express',
  BRT = 'BRT',
  Buylogic = 'Buylogic',
  Cainiao = 'Cainiao',
  CanadaPost = 'CanadaPost',
  Canpar = 'Canpar',
  CargoLine = 'CargoLine',
  Caribou = 'Caribou',
  Cart2India = 'Cart2India',
  CBHub = 'CBHub',
  CBL = 'CBL',
  CDC = 'CDC',
  CELERITAS = 'CELERITAS',
  Centex = 'Centex',
  CEVA = 'CEVA',
  CevaLojistik = 'CevaLojistik',
  ChinaPost = 'ChinaPost',
  ChronoExpress = 'ChronoExpress',
  Chronopost = 'Chronopost',
  Chukou1 = 'Chukou1',
  Cititrans = 'Cititrans',
  CityLink = 'CityLink',
  CityPost = 'CityPost',
  CNE = 'CNE',
  Coliposte = 'Coliposte',
  Colissimo = 'Colissimo',
  ConsegnaMezziPropri = 'ConsegnaMezziPropri',
  Conway = 'Conway',
  Correios = 'Correios',
  Correos = 'Correos',
  CorreosExpress = 'CorreosExpress',
  COSCO = 'COSCO',
  CouriersPlease = 'CouriersPlease',
  CTTExpress = 'CTTExpress',
  Cubyn = 'Cubyn',
  CyberSavings = 'CyberSavings',
  DACHSER = 'DACHSER',
  DAIPOST = 'DAIPOST',
  DBSchenker = 'DBSchenker',
  DELDeliveries = 'DELDeliveries',
  Delhivery = 'Delhivery',
  Delivengo = 'Delivengo',
  DeliveryGroup = 'DeliveryGroup',
  DerKurier = 'DerKurier',
  DeutschePost = 'DeutschePost',
  DFL = 'DFL',
  DHLeCommerce = 'DHLeCommerce',
  DHLExpress = 'DHLExpress',
  DHLFreight = 'DHLFreight',
  DHLGlobalMail = 'DHLGlobalMail',
  DHLHomeDelivery = 'DHLHomeDelivery',
  DHLKargo = 'DHLKargo',
  DHLPaket = 'DHLPaket',
  DHLParcelUK = 'DHLParcelUK',
  DHLPL = 'DHLPL',
  DigitalDelivery = 'DigitalDelivery',
  DirectLog = 'DirectLog',
  Dotzot = 'Dotzot',
  DPB = 'DPB',
  DPDLocal = 'DPDLocal',
  DSV = 'DSV',
  DTDC = 'DTDC',
  DX = 'DX',
  DXExpress = 'DXExpress',
  DXFreight = 'DXFreight',
  DXSecure = 'DXSecure',
  DYNAMICEXPRESS = 'DYNAMICEXPRESS',
  ECMS = 'ECMS',
  ECMSexpress = 'ECMSexpress',
  EcomExpress = 'EcomExpress',
  EcomShippingSolutionsPVTltd = 'EcomShippingSolutionsPVTltd',
  EINSASOURCING = 'EINSASOURCING',
  EKITrans = 'EKITrans',
  EmiratesPost = 'EmiratesPost',
  Emons = 'Emons',
  Endopack = 'Endopack',
  Energo = 'Energo',
  Envialia = 'Envialia',
  ePostGlobal = 'ePostGlobal',
  Equick = 'Equick',
  ESNAD = 'ESNAD',
  Estafeta = 'Estafeta',
  Estes = 'Estes',
  EUB = 'EUB',
  Europaczka = 'Europaczka',
  Exapaq = 'Exapaq',
  FASTEST = 'FASTEST',
  Fastway = 'Fastway',
  FedEx = 'FedEx',
  FedexFreight = 'FedexFreight',
  FEDEXJP = 'FEDEXJP',
  FedExSmartPost = 'FedExSmartPost',
  FERCAM = 'FERCAM',
  FilloKargo = 'FilloKargo',
  FirstFlight = 'FirstFlight',
  FirstFlightChina = 'FirstFlightChina',
  FirstMile = 'FirstMile',
  Fleetan = 'Fleetan',
  Flyt = 'Flyt',
  FRACHTPOST = 'FRACHTPOST',
  FRANCEEXPRESS = 'FRANCEEXPRESS',
  Gati = 'Gati',
  GEL = 'GEL',
  GELExpress = 'GELExpress',
  geodis = 'geodis',
  GeodisCalberson = 'GeodisCalberson',
  GeopostKargo = 'GeopostKargo',
  GFS = 'GFS',
  GLSCanada = 'GLSCanada',
  Gojavas = 'Gojavas',
  GRUPOLOGISTIC = 'GRUPOLOGISTIC',
  Hellmann = 'Hellmann',
  Heppner = 'Heppner',
  Hermes = 'Hermes',
  HermesCorporate = 'HermesCorporate',
  HermesEinrichtungsservice = 'HermesEinrichtungsservice',
  HermesLogistikGruppe = 'HermesLogistikGruppe',
  HermesUK = 'HermesUK',
  Hlog = 'Hlog',
  HNC = 'HNC',
  HomeLogistics = 'HomeLogistics',
  honesteye = 'honesteye',
  HongkongPost = 'HongkongPost',
  HorozLojistik = 'HorozLojistik',
  HotpointLogistics = 'HotpointLogistics',
  HRP = 'HRP',
  HScode = 'HScode',
  HUAHANLogistics = 'HUAHANLogistics',
  HubEurope = 'HubEurope',
  HunterExpress = 'HunterExpress',
  HunterLogistics = 'HunterLogistics',
  Huxloe = 'Huxloe',
  HuxloeLogistics = 'HuxloeLogistics',
  ICCWorldwide = 'ICCWorldwide',
  IDS = 'IDS',
  IDSNetzwerk = 'IDSNetzwerk',
  iMile = 'iMile',
  IndiaPost = 'IndiaPost',
  InPost = 'InPost',
  Interlink = 'Interlink',
  Interno = 'Interno',
  Intersoft = 'Intersoft',
  iParcel = 'iParcel',
  ITDGlobal = 'ITDGlobal',
  JampTExpress = 'JampTExpress',
  JapanPost = 'JapanPost',
  JCEX = 'JCEX',
  JerseyPost = 'JerseyPost',
  Jiufang = 'Jiufang',
  JPEXPRESS = 'JPEXPRESS',
  JPLUPU = 'JPLUPU',
  JSExpress = 'JSExpress',
  JT = 'JT',
  JTExpress = 'JTExpress',
  JYExpress = 'JYExpress',
  Kargokar = 'Kargokar',
  KEAVO = 'KEAVO',
  Kerry = 'Kerry',
  KuehneNagel = 'KuehneNagel',
  Kybotech = 'Kybotech',
  LaPoste = 'LaPoste',
  Landmark = 'Landmark',
  LandmarkGlobal = 'LandmarkGlobal',
  Lasership = 'Lasership',
  Lemonmode = 'Lemonmode',
  Letian = 'Letian',
  LFLogistic = 'LFLogistic',
  Liccardi = 'Liccardi',
  LiccardiTrasporti = 'LiccardiTrasporti',
  LogistikGruppe = 'LogistikGruppe',
  Loomis = 'Loomis',
  MailAlliance = 'MailAlliance',
  MailAmericas = 'MailAmericas',
  Mainpost = 'Mainpost',
  MBE = 'MBE',
  MetroKargo = 'MetroKargo',
  Mezzipropri = 'Mezzipropri',
  MHI = 'MHI',
  Milkman = 'Milkman',
  MNGKargo = 'MNGKargo',
  MondialRelay = 'MondialRelay',
  MRW = 'MRW',
  MZZBriefdienst = 'MZZBriefdienst',
  Nacex = 'Nacex',
  NAQELEXPRESS = 'NAQELEXPRESS',
  NarpostKargo = 'NarpostKargo',
  NewZealandPost = 'NewZealandPost',
  Newgistics = 'Newgistics',
  Nexive = 'Nexive',
  Ninjavan = 'Ninjavan',
  NipponExpress = 'NipponExpress',
  NITTSU = 'NITTSU',
  NOVEO = 'NOVEO',
  NowBikes = 'NowBikes',
  NTL = 'NTL',
  OCSWorldwide = 'OCSWorldwide',
  OldDominion = 'OldDominion',
  OneWorldExpress = 'OneWorldExpress',
  ONTIME = 'ONTIME',
  OnTrac = 'OnTrac',
  OSM = 'OSM',
  OSMWorldwide = 'OSMWorldwide',
  Other = 'Other',
  Otro = 'Otro',
  OverniteExpress = 'OverniteExpress',
  Palletline = 'Palletline',
  Palletways = 'Palletways',
  Panther = 'Panther',
  ParcelHub = 'ParcelHub',
  ParcelMonkey = 'ParcelMonkey',
  ParcelStation = 'ParcelStation',
  Parcel2go = 'Parcel2go',
  ParcelDenOnline = 'ParcelDenOnline',
  Parcelforce = 'Parcelforce',
  Parcelhub = 'Parcelhub',
  ParcelinkLogistics = 'ParcelinkLogistics',
  Parcelnet = 'Parcelnet',
  ParcelOne = 'ParcelOne',
  Paquetexpress = 'Paquetexpress',
  PDCLogistics = 'PDCLogistics',
  Pilot = 'Pilot',
  PilotFreight = 'PilotFreight',
  PIN = 'PIN',
  PolishPost = 'PolishPost',
  PosLaju = 'PosLaju',
  PostModern = 'PostModern',
  PosteItaliane = 'PosteItaliane',
  PostNL = 'PostNL',
  PostNord = 'PostNord',
  Professional = 'Professional',
  PTTKargo = 'PTTKargo',
  PUROLATOR = 'PUROLATOR',
  Quantium = 'Quantium',
  Qxpress = 'Qxpress',
  RL = 'RL',
  RabenGroup = 'RabenGroup',
  RBNA = 'RBNA',
  REDUR = 'REDUR',
  Redpack = 'Redpack',
  Rhenus = 'Rhenus',
  Rieck = 'Rieck',
  Rivigo = 'Rivigo',
  RMLGB = 'RMLGB',
  Roadrunner = 'Roadrunner',
  RoyalMail = 'RoyalMail',
  RRDonnelley = 'RRDonnelley',
  Safexpress = 'Safexpress',
  SAGAWA = 'SAGAWA',
  SagawaExpress = 'SagawaExpress',
  Saia = 'Saia',
  Sailpost = 'Sailpost',
  SchweizerPost = 'SchweizerPost',
  SDA = 'SDA',
  Seino = 'Seino',
  SEINOTRANSPORTATION = 'SEINOTRANSPORTATION',
  SekoLogistics = 'SekoLogistics',
  SelemKargo = 'SelemKargo',
  SelfDelivery = 'SelfDelivery',
  Sendcloud = 'Sendcloud',
  Sending = 'Sending',
  SENDLE = 'SENDLE',
  Seur = 'Seur',
  SevenSenders = 'SevenSenders',
  SFExpress = 'SFExpress',
  SFC = 'SFC',
  ShipDelight = 'ShipDelight',
  ShipGlobalUS = 'ShipGlobalUS',
  SHIPA = 'SHIPA',
  ShipEconomy = 'ShipEconomy',
  ShipEntegra = 'ShipEntegra',
  ShipGlobal = 'ShipGlobal',
  Shipmate = 'Shipmate',
  Shippit = 'Shippit',
  ShopiniWorld = 'ShopiniWorld',
  ShreeMarutiCourier = 'ShreeMarutiCourier',
  ShreeTirupatiCourier = 'ShreeTirupatiCourier',
  ShunfengExpress = 'ShunfengExpress',
  Sinerlog = 'Sinerlog',
  SingaporePost = 'SingaporePost',
  Sinotrans = 'Sinotrans',
  Skypostal = 'Skypostal',
  Smartmail = 'Smartmail',
  Smartrlogistics = 'Smartrlogistics',
  SMSA = 'SMSA',
  SMSAExpress = 'SMSAExpress',
  Soarmall = 'Soarmall',
  Sonstige = 'Sonstige',
  SouthEasternFreightLines = 'SouthEasternFreightLines',
  Speedaf = 'Speedaf',
  Speedex = 'Speedex',
  Spoton = 'Spoton',
  Spring = 'Spring',
  springGDS = 'springGDS',
  Sprint = 'Sprint',
  StahlmannandSachs = 'StahlmannandSachs',
  Stampit = 'Stampit',
  Staples = 'Staples',
  StarTrackArticleID = 'StarTrackArticleID',
  StarTrackConsignment = 'StarTrackConsignment',
  STG = 'STG',
  STOExpress = 'STOExpress',
  Streamlite = 'Streamlite',
  Sunyou = 'Sunyou',
  Susa = 'Susa',
  Swisspost = 'Swisspost',
  Szendex = 'Szendex',
  Target = 'Target',
  TATAExpress = 'TATAExpress',
  TDN = 'TDN',
  TeamExpress = 'TeamExpress',
  TezelLojistik = 'TezelLojistik',
  TheDeliveryGroup = 'TheDeliveryGroup',
  TheProfessionalCouriers = 'TheProfessionalCouriers',
  TIPSA = 'TIPSA',
  TNT = 'TNT',
  TNTKargo = 'TNTKargo',
  TNTIT = 'TNTIT',
  Toll = 'Toll',
  TollGlobalExpress = 'TollGlobalExpress',
  TongdaGlobal = 'TongdaGlobal',
  Topyou = 'Topyou',
  TotalExpress = 'TotalExpress',
  Tourline = 'Tourline',
  Trackon = 'Trackon',
  Trakpak = 'Trakpak',
  Transaher = 'Transaher',
  TransFolha = 'TransFolha',
  Translink = 'Translink',
  TransoFlex = 'TransoFlex',
  Truline = 'Truline',
  TSB = 'TSB',
  Tuffnells = 'Tuffnells',
  TWS = 'TWS',
  TXT = 'TXT',
  TyD = 'TyD',
  UBI = 'UBI',
  UKMail = 'UKMail',
  UniUni = 'UniUni',
  UPakWeShip = 'UPakWeShip',
  UPSFreight = 'UPSFreight',
  UPSMailInnovations = 'UPSMailInnovations',
  Upsilon = 'Upsilon',
  UPSMI = 'UPSMI',
  UrbanExpress = 'UrbanExpress',
  Uship = 'Uship',
  USPS = 'USPS',
  VerageShipping = 'VerageShipping',
  ViaXpress = 'ViaXpress',
  VIR = 'VIR',
  VNLIN = 'VNLIN',
  WanbExpress = 'WanbExpress',
  WatkinsandShepard = 'WatkinsandShepard',
  Wefast = 'Wefast',
  WeWorldExpress = 'WeWorldExpress',
  Whistl = 'Whistl',
  Whizzard = 'Whizzard',
  WINIT = 'WINIT',
  WPX = 'WPX',
  XDP = 'XDP',
  XPO = 'XPO',
  XPOFreight = 'XPOFreight',
  Xpressbees = 'Xpressbees',
  YAMATO = 'YAMATO',
  YamatoTransport = 'YamatoTransport',
  YANWEN = 'YANWEN',
  YDH = 'YDH',
  YellowFreight = 'YellowFreight',
  YFLogistics = 'YFLogistics',
  YFHEX = 'YFHEX',
  YHT = 'YHT',
  Yodel = 'Yodel',
  YTOExpress = 'YTOExpress',
  YunExpress = 'YunExpress',
  YundaExpress = 'YundaExpress',
  ZADExpress = 'ZADExpress',
  Zeleris = 'Zeleris',
  ZTOExpress = 'ZTOExpress',
  ZustAmbrosetti = 'ZustAmbrosetti',
  WEDOLOGISTICS = 'WEDOLOGISTICS',
  SPS = 'SPS',
  CZECHPOST = 'CZECHPOST',
  Packeta = 'Packeta',
  OTHER = 'OTHER',
  AsendiaHK = 'AsendiaHK',
  Bpost = 'Bpost',
  ChinaEMS_ePacket = 'ChinaEMS_ePacket',
  Chronofresh = 'Chronofresh',
  CNEExpress = 'CNEExpress',
  ColisPrive = 'ColisPrive',
  DHLDeutschePost = 'DHLDeutschePost',
  DHLEcommerceAsia = 'DHLEcommerceAsia',
  FastWL = 'FastWL',
  GEODIS = 'GEODIS',
  LaPosteCourrier = 'LaPosteCourrier',
  MalaysiaPost = 'MalaysiaPost',
  RelaisColis = 'RelaisColis',
  SFCService = 'SFCService',
  WishPost = 'WishPost',
  Yanwen = 'Yanwen'
}

export enum EnumFulfillmentStatus {
  Registered = 'Registered',
  Shipped = 'Shipped',
  AtDepot = 'AtDepot',
  OutForDelivery = 'OutForDelivery',
  Delivered = 'Delivered',
  Canceled = 'Canceled',
  Failed = 'Failed'
}

export enum EnumImportSettingsCarrier {
  ALZABOX = 'ALZABOX',
  ALZABRANCH = 'ALZABRANCH',
  COURIER = 'COURIER',
  CZPOSTD = 'CZPOSTD',
  CZPOSTP = 'CZPOSTP',
  CZPOSTB = 'CZPOSTB',
  DHL = 'DHL',
  DPD = 'DPD',
  ALZA = 'ALZA',
  DPDALZABOX = 'DPDALZABOX',
  DPDBOX = 'DPDBOX',
  DPDPARCELSHOP = 'DPDPARCELSHOP',
  FOFRSTD = 'FOFRSTD',
  GebruderWeissStandard = 'GebruderWeissStandard',
  GEIS = 'GEIS',
  GEISPOINT = 'GEISPOINT',
  GEISCARGO = 'GEISCARGO',
  GLS = 'GLS',
  GO = 'GO',
  HELICARSTD = 'HELICARSTD',
  HELICARUP = 'HELICARUP',
  MagyarPOSTHD = 'MagyarPOSTHD',
  MagyarPOSTPO = 'MagyarPOSTPO',
  MagyarPOSTPP = 'MagyarPOSTPP',
  MagyarPOSTPT = 'MagyarPOSTPT',
  PPL = 'PPL',
  PPLPARCELSHOP = 'PPLPARCELSHOP',
  RHENUS = 'RHENUS',
  SKPOSTD = 'SKPOSTD',
  SKPOSTP = 'SKPOSTP',
  SKYNET = 'SKYNET',
  TOPTRANS = 'TOPTRANS',
  UPS = 'UPS',
  WEDOHD = 'WEDOHD',
  ZASILKOVNA = 'ZASILKOVNA',
  ZavolejSiKuryra = 'ZavolejSiKuryra',
  Supplier = 'Supplier',
  ThreeHundredSixtylion = 'ThreeHundredSixtylion',
  FourPX = 'FourPX',
  A1 = 'A1',
  AAACooper = 'AAACooper',
  ABF = 'ABF',
  AFLFedex = 'AFLFedex',
  ALLJOY = 'ALLJOY',
  AMAUK = 'AMAUK',
  AMAZONHORIZON = 'AMAZONHORIZON',
  AmazonShipping = 'AmazonShipping',
  AMZL = 'AMZL',
  AMZLUK = 'AMZLUK',
  Andere = 'Andere',
  Anjun = 'Anjun',
  AO = 'AO',
  AODeutschland = 'AODeutschland',
  APC = 'APC',
  APCOvernight = 'APCOvernight',
  APCPOSTALLOGISTICS = 'APCPOSTALLOGISTICS',
  APGeCommerce = 'APGeCommerce',
  Aramex = 'Aramex',
  ARAS = 'ARAS',
  ArasKargo = 'ArasKargo',
  ArcoSpedizioni = 'ArcoSpedizioni',
  Arkas = 'Arkas',
  ArrowXL = 'ArrowXL',
  Asendia = 'Asendia',
  Asgard = 'Asgard',
  Assett = 'Assett',
  ATPOST = 'ATPOST',
  ATS = 'ATS',
  AUSSIEPOST = 'AUSSIEPOST',
  AustraliaPost = 'AustraliaPost',
  AustraliaPostArticleID = 'AustraliaPostArticleID',
  AustraliaPostConsignment = 'AustraliaPostConsignment',
  B2C = 'B2C',
  B2CEurope = 'B2CEurope',
  B2CShip = 'B2CShip',
  Balnak = 'Balnak',
  Bartolini = 'Bartolini',
  BeijingQuanfengExpress = 'BeijingQuanfengExpress',
  BestBuy = 'BestBuy',
  BestExpress = 'BestExpress',
  BetterTrucks = 'BetterTrucks',
  BJS = 'BJS',
  Blowhorn = 'Blowhorn',
  BluePackage = 'BluePackage',
  BlueDart = 'BlueDart',
  Bombax = 'Bombax',
  BombinoExpress = 'BombinoExpress',
  BPOST = 'BPOST',
  BR1Express = 'BR1Express',
  BRT = 'BRT',
  Buylogic = 'Buylogic',
  Cainiao = 'Cainiao',
  CanadaPost = 'CanadaPost',
  Canpar = 'Canpar',
  CargoLine = 'CargoLine',
  Caribou = 'Caribou',
  Cart2India = 'Cart2India',
  CBHub = 'CBHub',
  CBL = 'CBL',
  CDC = 'CDC',
  CELERITAS = 'CELERITAS',
  Centex = 'Centex',
  CEVA = 'CEVA',
  CevaLojistik = 'CevaLojistik',
  ChinaPost = 'ChinaPost',
  ChronoExpress = 'ChronoExpress',
  Chronopost = 'Chronopost',
  Chukou1 = 'Chukou1',
  Cititrans = 'Cititrans',
  CityLink = 'CityLink',
  CityPost = 'CityPost',
  CNE = 'CNE',
  Coliposte = 'Coliposte',
  Colissimo = 'Colissimo',
  ConsegnaMezziPropri = 'ConsegnaMezziPropri',
  Conway = 'Conway',
  Correios = 'Correios',
  Correos = 'Correos',
  CorreosExpress = 'CorreosExpress',
  COSCO = 'COSCO',
  CouriersPlease = 'CouriersPlease',
  CTTExpress = 'CTTExpress',
  Cubyn = 'Cubyn',
  CyberSavings = 'CyberSavings',
  DACHSER = 'DACHSER',
  DAIPOST = 'DAIPOST',
  DBSchenker = 'DBSchenker',
  DELDeliveries = 'DELDeliveries',
  Delhivery = 'Delhivery',
  Delivengo = 'Delivengo',
  DeliveryGroup = 'DeliveryGroup',
  DerKurier = 'DerKurier',
  DeutschePost = 'DeutschePost',
  DFL = 'DFL',
  DHLeCommerce = 'DHLeCommerce',
  DHLExpress = 'DHLExpress',
  DHLFreight = 'DHLFreight',
  DHLGlobalMail = 'DHLGlobalMail',
  DHLHomeDelivery = 'DHLHomeDelivery',
  DHLKargo = 'DHLKargo',
  DHLPaket = 'DHLPaket',
  DHLParcelUK = 'DHLParcelUK',
  DHLPL = 'DHLPL',
  DigitalDelivery = 'DigitalDelivery',
  DirectLog = 'DirectLog',
  Dotzot = 'Dotzot',
  DPB = 'DPB',
  DPDLocal = 'DPDLocal',
  DSV = 'DSV',
  DTDC = 'DTDC',
  DX = 'DX',
  DXExpress = 'DXExpress',
  DXFreight = 'DXFreight',
  DXSecure = 'DXSecure',
  DYNAMICEXPRESS = 'DYNAMICEXPRESS',
  ECMS = 'ECMS',
  ECMSexpress = 'ECMSexpress',
  EcomExpress = 'EcomExpress',
  EcomShippingSolutionsPVTltd = 'EcomShippingSolutionsPVTltd',
  EINSASOURCING = 'EINSASOURCING',
  EKITrans = 'EKITrans',
  EmiratesPost = 'EmiratesPost',
  Emons = 'Emons',
  Endopack = 'Endopack',
  Energo = 'Energo',
  Envialia = 'Envialia',
  ePostGlobal = 'ePostGlobal',
  Equick = 'Equick',
  ESNAD = 'ESNAD',
  Estafeta = 'Estafeta',
  Estes = 'Estes',
  EUB = 'EUB',
  Europaczka = 'Europaczka',
  Exapaq = 'Exapaq',
  FASTEST = 'FASTEST',
  Fastway = 'Fastway',
  FedEx = 'FedEx',
  FedexFreight = 'FedexFreight',
  FEDEXJP = 'FEDEXJP',
  FedExSmartPost = 'FedExSmartPost',
  FERCAM = 'FERCAM',
  FilloKargo = 'FilloKargo',
  FirstFlight = 'FirstFlight',
  FirstFlightChina = 'FirstFlightChina',
  FirstMile = 'FirstMile',
  Fleetan = 'Fleetan',
  Flyt = 'Flyt',
  FRACHTPOST = 'FRACHTPOST',
  FRANCEEXPRESS = 'FRANCEEXPRESS',
  Gati = 'Gati',
  GEL = 'GEL',
  GELExpress = 'GELExpress',
  geodis = 'geodis',
  GeodisCalberson = 'GeodisCalberson',
  GeopostKargo = 'GeopostKargo',
  GFS = 'GFS',
  GLSCanada = 'GLSCanada',
  Gojavas = 'Gojavas',
  GRUPOLOGISTIC = 'GRUPOLOGISTIC',
  Hellmann = 'Hellmann',
  Heppner = 'Heppner',
  Hermes = 'Hermes',
  HermesCorporate = 'HermesCorporate',
  HermesEinrichtungsservice = 'HermesEinrichtungsservice',
  HermesLogistikGruppe = 'HermesLogistikGruppe',
  HermesUK = 'HermesUK',
  Hlog = 'Hlog',
  HNC = 'HNC',
  HomeLogistics = 'HomeLogistics',
  honesteye = 'honesteye',
  HongkongPost = 'HongkongPost',
  HorozLojistik = 'HorozLojistik',
  HotpointLogistics = 'HotpointLogistics',
  HRP = 'HRP',
  HScode = 'HScode',
  HUAHANLogistics = 'HUAHANLogistics',
  HubEurope = 'HubEurope',
  HunterExpress = 'HunterExpress',
  HunterLogistics = 'HunterLogistics',
  Huxloe = 'Huxloe',
  HuxloeLogistics = 'HuxloeLogistics',
  ICCWorldwide = 'ICCWorldwide',
  IDS = 'IDS',
  IDSNetzwerk = 'IDSNetzwerk',
  iMile = 'iMile',
  IndiaPost = 'IndiaPost',
  InPost = 'InPost',
  Interlink = 'Interlink',
  Interno = 'Interno',
  Intersoft = 'Intersoft',
  iParcel = 'iParcel',
  ITDGlobal = 'ITDGlobal',
  JampTExpress = 'JampTExpress',
  JapanPost = 'JapanPost',
  JCEX = 'JCEX',
  JerseyPost = 'JerseyPost',
  Jiufang = 'Jiufang',
  JPEXPRESS = 'JPEXPRESS',
  JPLUPU = 'JPLUPU',
  JSExpress = 'JSExpress',
  JT = 'JT',
  JTExpress = 'JTExpress',
  JYExpress = 'JYExpress',
  Kargokar = 'Kargokar',
  KEAVO = 'KEAVO',
  Kerry = 'Kerry',
  KuehneNagel = 'KuehneNagel',
  Kybotech = 'Kybotech',
  LaPoste = 'LaPoste',
  Landmark = 'Landmark',
  LandmarkGlobal = 'LandmarkGlobal',
  Lasership = 'Lasership',
  Lemonmode = 'Lemonmode',
  Letian = 'Letian',
  LFLogistic = 'LFLogistic',
  Liccardi = 'Liccardi',
  LiccardiTrasporti = 'LiccardiTrasporti',
  LogistikGruppe = 'LogistikGruppe',
  Loomis = 'Loomis',
  MailAlliance = 'MailAlliance',
  MailAmericas = 'MailAmericas',
  Mainpost = 'Mainpost',
  MBE = 'MBE',
  MetroKargo = 'MetroKargo',
  Mezzipropri = 'Mezzipropri',
  MHI = 'MHI',
  Milkman = 'Milkman',
  MNGKargo = 'MNGKargo',
  MondialRelay = 'MondialRelay',
  MRW = 'MRW',
  MZZBriefdienst = 'MZZBriefdienst',
  Nacex = 'Nacex',
  NAQELEXPRESS = 'NAQELEXPRESS',
  NarpostKargo = 'NarpostKargo',
  NewZealandPost = 'NewZealandPost',
  Newgistics = 'Newgistics',
  Nexive = 'Nexive',
  Ninjavan = 'Ninjavan',
  NipponExpress = 'NipponExpress',
  NITTSU = 'NITTSU',
  NOVEO = 'NOVEO',
  NowBikes = 'NowBikes',
  NTL = 'NTL',
  OCSWorldwide = 'OCSWorldwide',
  OldDominion = 'OldDominion',
  OneWorldExpress = 'OneWorldExpress',
  ONTIME = 'ONTIME',
  OnTrac = 'OnTrac',
  OSM = 'OSM',
  OSMWorldwide = 'OSMWorldwide',
  Other = 'Other',
  Otro = 'Otro',
  OverniteExpress = 'OverniteExpress',
  Palletline = 'Palletline',
  Palletways = 'Palletways',
  Panther = 'Panther',
  ParcelHub = 'ParcelHub',
  ParcelMonkey = 'ParcelMonkey',
  ParcelStation = 'ParcelStation',
  Parcel2go = 'Parcel2go',
  ParcelDenOnline = 'ParcelDenOnline',
  Parcelforce = 'Parcelforce',
  Parcelhub = 'Parcelhub',
  ParcelinkLogistics = 'ParcelinkLogistics',
  Parcelnet = 'Parcelnet',
  ParcelOne = 'ParcelOne',
  Paquetexpress = 'Paquetexpress',
  PDCLogistics = 'PDCLogistics',
  Pilot = 'Pilot',
  PilotFreight = 'PilotFreight',
  PIN = 'PIN',
  PolishPost = 'PolishPost',
  PosLaju = 'PosLaju',
  PostModern = 'PostModern',
  PosteItaliane = 'PosteItaliane',
  PostNL = 'PostNL',
  PostNord = 'PostNord',
  Professional = 'Professional',
  PTTKargo = 'PTTKargo',
  PUROLATOR = 'PUROLATOR',
  Quantium = 'Quantium',
  Qxpress = 'Qxpress',
  RL = 'RL',
  RabenGroup = 'RabenGroup',
  RBNA = 'RBNA',
  REDUR = 'REDUR',
  Redpack = 'Redpack',
  Rhenus = 'Rhenus',
  Rieck = 'Rieck',
  Rivigo = 'Rivigo',
  RMLGB = 'RMLGB',
  Roadrunner = 'Roadrunner',
  RoyalMail = 'RoyalMail',
  RRDonnelley = 'RRDonnelley',
  Safexpress = 'Safexpress',
  SAGAWA = 'SAGAWA',
  SagawaExpress = 'SagawaExpress',
  Saia = 'Saia',
  Sailpost = 'Sailpost',
  SchweizerPost = 'SchweizerPost',
  SDA = 'SDA',
  Seino = 'Seino',
  SEINOTRANSPORTATION = 'SEINOTRANSPORTATION',
  SekoLogistics = 'SekoLogistics',
  SelemKargo = 'SelemKargo',
  SelfDelivery = 'SelfDelivery',
  Sendcloud = 'Sendcloud',
  Sending = 'Sending',
  SENDLE = 'SENDLE',
  Seur = 'Seur',
  SevenSenders = 'SevenSenders',
  SFExpress = 'SFExpress',
  SFC = 'SFC',
  ShipDelight = 'ShipDelight',
  ShipGlobalUS = 'ShipGlobalUS',
  SHIPA = 'SHIPA',
  ShipEconomy = 'ShipEconomy',
  ShipEntegra = 'ShipEntegra',
  ShipGlobal = 'ShipGlobal',
  Shipmate = 'Shipmate',
  Shippit = 'Shippit',
  ShopiniWorld = 'ShopiniWorld',
  ShreeMarutiCourier = 'ShreeMarutiCourier',
  ShreeTirupatiCourier = 'ShreeTirupatiCourier',
  ShunfengExpress = 'ShunfengExpress',
  Sinerlog = 'Sinerlog',
  SingaporePost = 'SingaporePost',
  Sinotrans = 'Sinotrans',
  Skypostal = 'Skypostal',
  Smartmail = 'Smartmail',
  Smartrlogistics = 'Smartrlogistics',
  SMSA = 'SMSA',
  SMSAExpress = 'SMSAExpress',
  Soarmall = 'Soarmall',
  Sonstige = 'Sonstige',
  SouthEasternFreightLines = 'SouthEasternFreightLines',
  Speedaf = 'Speedaf',
  Speedex = 'Speedex',
  Spoton = 'Spoton',
  Spring = 'Spring',
  springGDS = 'springGDS',
  Sprint = 'Sprint',
  StahlmannandSachs = 'StahlmannandSachs',
  Stampit = 'Stampit',
  Staples = 'Staples',
  StarTrackArticleID = 'StarTrackArticleID',
  StarTrackConsignment = 'StarTrackConsignment',
  STG = 'STG',
  STOExpress = 'STOExpress',
  Streamlite = 'Streamlite',
  Sunyou = 'Sunyou',
  Susa = 'Susa',
  Swisspost = 'Swisspost',
  Szendex = 'Szendex',
  Target = 'Target',
  TATAExpress = 'TATAExpress',
  TDN = 'TDN',
  TeamExpress = 'TeamExpress',
  TezelLojistik = 'TezelLojistik',
  TheDeliveryGroup = 'TheDeliveryGroup',
  TheProfessionalCouriers = 'TheProfessionalCouriers',
  TIPSA = 'TIPSA',
  TNT = 'TNT',
  TNTKargo = 'TNTKargo',
  TNTIT = 'TNTIT',
  Toll = 'Toll',
  TollGlobalExpress = 'TollGlobalExpress',
  TongdaGlobal = 'TongdaGlobal',
  Topyou = 'Topyou',
  TotalExpress = 'TotalExpress',
  Tourline = 'Tourline',
  Trackon = 'Trackon',
  Trakpak = 'Trakpak',
  Transaher = 'Transaher',
  TransFolha = 'TransFolha',
  Translink = 'Translink',
  TransoFlex = 'TransoFlex',
  Truline = 'Truline',
  TSB = 'TSB',
  Tuffnells = 'Tuffnells',
  TWS = 'TWS',
  TXT = 'TXT',
  TyD = 'TyD',
  UBI = 'UBI',
  UKMail = 'UKMail',
  UniUni = 'UniUni',
  UPakWeShip = 'UPakWeShip',
  UPSFreight = 'UPSFreight',
  UPSMailInnovations = 'UPSMailInnovations',
  Upsilon = 'Upsilon',
  UPSMI = 'UPSMI',
  UrbanExpress = 'UrbanExpress',
  Uship = 'Uship',
  USPS = 'USPS',
  VerageShipping = 'VerageShipping',
  ViaXpress = 'ViaXpress',
  VIR = 'VIR',
  VNLIN = 'VNLIN',
  WanbExpress = 'WanbExpress',
  WatkinsandShepard = 'WatkinsandShepard',
  Wefast = 'Wefast',
  WeWorldExpress = 'WeWorldExpress',
  Whistl = 'Whistl',
  Whizzard = 'Whizzard',
  WINIT = 'WINIT',
  WPX = 'WPX',
  XDP = 'XDP',
  XPO = 'XPO',
  XPOFreight = 'XPOFreight',
  Xpressbees = 'Xpressbees',
  YAMATO = 'YAMATO',
  YamatoTransport = 'YamatoTransport',
  YANWEN = 'YANWEN',
  YDH = 'YDH',
  YellowFreight = 'YellowFreight',
  YFLogistics = 'YFLogistics',
  YFHEX = 'YFHEX',
  YHT = 'YHT',
  Yodel = 'Yodel',
  YTOExpress = 'YTOExpress',
  YunExpress = 'YunExpress',
  YundaExpress = 'YundaExpress',
  ZADExpress = 'ZADExpress',
  Zeleris = 'Zeleris',
  ZTOExpress = 'ZTOExpress',
  ZustAmbrosetti = 'ZustAmbrosetti',
  WEDOLOGISTICS = 'WEDOLOGISTICS',
  SPS = 'SPS',
  CZECHPOST = 'CZECHPOST',
  Packeta = 'Packeta',
  OTHER = 'OTHER',
  AsendiaHK = 'AsendiaHK',
  Bpost = 'Bpost',
  ChinaEMS_ePacket = 'ChinaEMS_ePacket',
  Chronofresh = 'Chronofresh',
  CNEExpress = 'CNEExpress',
  ColisPrive = 'ColisPrive',
  DHLDeutschePost = 'DHLDeutschePost',
  DHLEcommerceAsia = 'DHLEcommerceAsia',
  FastWL = 'FastWL',
  GEODIS = 'GEODIS',
  LaPosteCourrier = 'LaPosteCourrier',
  MalaysiaPost = 'MalaysiaPost',
  RelaisColis = 'RelaisColis',
  SFCService = 'SFCService',
  WishPost = 'WishPost',
  Yanwen = 'Yanwen'
}

export enum EnumImportSettingsDeliveryMethodsMappingMarketplace {
  alza_cz = 'alza_cz',
  amazon_mx = 'amazon_mx',
  amazon_us = 'amazon_us',
  amazon_ca = 'amazon_ca',
  amazon_br = 'amazon_br',
  amazon_de = 'amazon_de',
  amazon_uk = 'amazon_uk',
  amazon_fr = 'amazon_fr',
  amazon_it = 'amazon_it',
  amazon_es = 'amazon_es',
  amazon_nl = 'amazon_nl',
  amazon_se = 'amazon_se',
  amazon_tr = 'amazon_tr',
  amazon_pl = 'amazon_pl',
  amazon_be = 'amazon_be',
  amazon_ie = 'amazon_ie',
  amazon_sg = 'amazon_sg',
  amazon_au = 'amazon_au',
  amazon_jp = 'amazon_jp',
  emag_bg = 'emag_bg',
  emag_hu = 'emag_hu',
  emag_pl = 'emag_pl',
  emag_ro = 'emag_ro',
  mall_cz = 'mall_cz',
  mall_hu = 'mall_hu',
  mall_pl = 'mall_pl',
  mall_si = 'mall_si',
  mall_sk = 'mall_sk',
  real_de = 'real_de',
  kaufland_de = 'kaufland_de',
  kaufland_cz = 'kaufland_cz',
  kaufland_sk = 'kaufland_sk',
  kaufland_at = 'kaufland_at',
  kaufland_pl = 'kaufland_pl',
  kaufland_nl = 'kaufland_nl',
  kaufland_es = 'kaufland_es',
  kaufland_fr = 'kaufland_fr',
  kaufland_it = 'kaufland_it',
  glami_cz = 'glami_cz',
  cdiscount_fr = 'cdiscount_fr',
  ebay_at = 'ebay_at',
  ebay_cz = 'ebay_cz',
  ebay_fr = 'ebay_fr',
  ebay_pl = 'ebay_pl',
  ebay_de = 'ebay_de',
  ebay_us = 'ebay_us',
  ebay_uk = 'ebay_uk',
  allegro_cz = 'allegro_cz',
  allegro_pl = 'allegro_pl',
  allegro_sk = 'allegro_sk',
  baskedo_bg = 'baskedo_bg',
  baskedo_hu = 'baskedo_hu',
  bol_nl = 'bol_nl',
  bol_be = 'bol_be',
  expando_shop_ro = 'expando_shop_ro',
  limetka_cz = 'limetka_cz',
  limetka_gr = 'limetka_gr',
  limetka_sk = 'limetka_sk'
}

export enum EnumImportSettingsMarketplaceType {
  alza = 'alza',
  amazon = 'amazon',
  emag = 'emag',
  mall = 'mall',
  real = 'real',
  kaufland = 'kaufland',
  glami = 'glami',
  cdiscount = 'cdiscount',
  ebay = 'ebay',
  allegro = 'allegro',
  baskedo = 'baskedo',
  bol = 'bol',
  expando_shop = 'expando_shop',
  limetka = 'limetka'
}

export enum EnumImportSettingsPaymentMethodsMappingMethod {
  online = 'online',
  cashOnDelivery = 'cashOnDelivery'
}

export enum EnumImportSettingsService {
  shoptet = 'shoptet'
}

export enum EnumJobQueueName {
  CRON_AUTOMATIC_SYNC = 'CRON_AUTOMATIC_SYNC',
  PRODUCT_FEED = 'PRODUCT_FEED',
  PRODUCT_LISTING = 'PRODUCT_LISTING',
  SUBMISSION_RESOLVING = 'SUBMISSION_RESOLVING',
  SYNC = 'SYNC'
}

export enum EnumJobState {
  completed = 'completed',
  failed = 'failed',
  delayed = 'delayed',
  active = 'active',
  waiting = 'waiting',
  paused = 'paused',
  stuck = 'stuck',
  stalled = 'stalled'
}

export enum EnumMarketplaceStatus {
  online = 'online',
  offline = 'offline',
  error = 'error'
}

export enum EnumOrderAutopricingStatus {
  None = 'None',
  Pending = 'Pending',
  PendingTax = 'PendingTax',
  Done = 'Done'
}

export enum EnumOrderCurrencyCode {
  EUR = 'EUR',
  GBP = 'GBP',
  USD = 'USD',
  CAD = 'CAD',
  CZK = 'CZK',
  MXN = 'MXN',
  BRL = 'BRL',
  INR = 'INR',
  CNY = 'CNY',
  JPY = 'JPY',
  AUD = 'AUD',
  SGD = 'SGD',
  PLN = 'PLN',
  RON = 'RON',
  HUF = 'HUF',
  HKD = 'HKD',
  ISK = 'ISK',
  PHP = 'PHP',
  DKK = 'DKK',
  SEK = 'SEK',
  IDR = 'IDR',
  RUB = 'RUB',
  HRK = 'HRK',
  THB = 'THB',
  CHF = 'CHF',
  BGN = 'BGN',
  TRY = 'TRY',
  NOK = 'NOK',
  NZD = 'NZD',
  ZAR = 'ZAR',
  ILS = 'ILS',
  KRW = 'KRW',
  MYR = 'MYR'
}

export enum EnumOrderPaymentPaymentMethod {
  CreditCard = 'CreditCard',
  CashOnDelivery = 'CashOnDelivery'
}

export enum EnumOrderStatus {
  Unshipped = 'Unshipped',
  Pending = 'Pending',
  Shipped = 'Shipped',
  Canceled = 'Canceled',
  Delivered = 'Delivered'
}

export enum EnumPdfsProcess {
  Merge = 'Merge',
  BarcodeBatch = 'BarcodeBatch',
  BarcodeWithEanBatch = 'BarcodeWithEanBatch'
}

export enum EnumPdfsStatus {
  Processing = 'Processing',
  Failed = 'Failed',
  Done = 'Done'
}

export enum EnumSubscriptionSchemaName {
  EXPANDO_APP_SERVICE = 'EXPANDO_APP_SERVICE'
}

export enum EnumUserLanguage {
  cs = 'cs',
  en = 'en'
}

export enum EnumUserRolesType {
  user = 'user',
  superadmin = 'superadmin'
}

export type FeatureToggle = {
  __typename?: 'FeatureToggle';
  enabled: Scalars['Boolean'];
};

export type FeatureToggleList = {
  __typename?: 'FeatureToggleList';
  pass?: Maybe<Array<Scalars['String']>>;
  block?: Maybe<Array<Scalars['String']>>;
};

export type FeatureToggleResult = {
  __typename?: 'FeatureToggleResult';
  allowed: Scalars['Boolean'];
};

export type FeedConvertReport = {
  __typename?: 'FeedConvertReport';
  id?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['String']>;
  state?: Maybe<FeedConvertReportState>;
  createdAt?: Maybe<Scalars['Date']>;
  settings?: Maybe<FeedConvertReportSettings>;
  progress?: Maybe<Scalars['Float']>;
  finishedAt?: Maybe<Scalars['Date']>;
  result?: Maybe<FeedConvertResultItem>;
};

export type FeedConvertReportSettings = {
  __typename?: 'FeedConvertReportSettings';
  version?: Maybe<Scalars['Int']>;
  sourceFormat?: Maybe<Scalars['String']>;
  resultFormat?: Maybe<Scalars['String']>;
};

export enum FeedConvertReportState {
  created = 'created',
  processing = 'processing',
  finished = 'finished',
  error = 'error',
  none = 'none'
}

export type FeedConvertResultItem = {
  __typename?: 'FeedConvertResultItem';
  downloadUrl?: Maybe<Scalars['String']>;
};

export type FeedPathValues = {
  __typename?: 'FeedPathValues';
  path?: Maybe<Scalars['String']>;
  values?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Feedback = {
  __typename?: 'Feedback';
  count?: Maybe<Scalars['Float']>;
  rating?: Maybe<Scalars['Float']>;
};

export type FeedbackInput = {
  count?: Maybe<Scalars['Float']>;
  rating?: Maybe<Scalars['Float']>;
};

export type FilterInputProducts = {
  search?: Maybe<Scalars['String']>;
  marketplace?: Maybe<MarketplaceName>;
  buyBox?: Maybe<Scalars['Boolean']>;
  isBuyBoxWinner?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Array<Maybe<Scalars['String']>>>;
  hasStock?: Maybe<Scalars['Boolean']>;
  locks?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type FilterInputStatistics = {
  from?: Maybe<Scalars['Date']>;
  to?: Maybe<Scalars['Date']>;
  marketplace?: Maybe<MarketplaceName>;
  period?: Maybe<Period>;
};

export type FilterOrdersInput = {
  search?: Maybe<Scalars['String']>;
  marketplace?: Maybe<MarketplaceName>;
  flag?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<Scalars['String']>;
  deliveryBranchId?: Maybe<Scalars['Int']>;
  selectedShipDate?: Maybe<Scalars['Date']>;
  companyId?: Maybe<Scalars['String']>;
  repricing?: Maybe<Scalars['Boolean']>;
  advancedSearch?: Maybe<Array<Maybe<Scalars['String']>>>;
  returnLabelStatus?: Maybe<Scalars['String']>;
};

export type FinancialEvents = {
  __typename?: 'FinancialEvents';
  isRefunded: Scalars['Boolean'];
  shippingPrice?: Maybe<Scalars['Float']>;
};

export type ForbidListingsInput = {
  amazon_mx?: Maybe<Scalars['Boolean']>;
  amazon_us?: Maybe<Scalars['Boolean']>;
  amazon_ca?: Maybe<Scalars['Boolean']>;
  amazon_br?: Maybe<Scalars['Boolean']>;
  amazon_de?: Maybe<Scalars['Boolean']>;
  amazon_uk?: Maybe<Scalars['Boolean']>;
  amazon_fr?: Maybe<Scalars['Boolean']>;
  amazon_it?: Maybe<Scalars['Boolean']>;
  amazon_es?: Maybe<Scalars['Boolean']>;
  amazon_nl?: Maybe<Scalars['Boolean']>;
  amazon_se?: Maybe<Scalars['Boolean']>;
  amazon_tr?: Maybe<Scalars['Boolean']>;
  amazon_pl?: Maybe<Scalars['Boolean']>;
  amazon_be?: Maybe<Scalars['Boolean']>;
  amazon_ie?: Maybe<Scalars['Boolean']>;
  amazon_sg?: Maybe<Scalars['Boolean']>;
  amazon_au?: Maybe<Scalars['Boolean']>;
  amazon_jp?: Maybe<Scalars['Boolean']>;
  real_de?: Maybe<Scalars['Boolean']>;
  kaufland_de?: Maybe<Scalars['Boolean']>;
  kaufland_cz?: Maybe<Scalars['Boolean']>;
  kaufland_sk?: Maybe<Scalars['Boolean']>;
  kaufland_at?: Maybe<Scalars['Boolean']>;
  kaufland_pl?: Maybe<Scalars['Boolean']>;
  kaufland_nl?: Maybe<Scalars['Boolean']>;
  kaufland_es?: Maybe<Scalars['Boolean']>;
  kaufland_fr?: Maybe<Scalars['Boolean']>;
  kaufland_it?: Maybe<Scalars['Boolean']>;
  cdiscount_fr?: Maybe<Scalars['Boolean']>;
  emag_bg?: Maybe<Scalars['Boolean']>;
  emag_hu?: Maybe<Scalars['Boolean']>;
  emag_pl?: Maybe<Scalars['Boolean']>;
  emag_ro?: Maybe<Scalars['Boolean']>;
  alza_cz?: Maybe<Scalars['Boolean']>;
};

export type Formula = {
  __typename?: 'Formula';
  multiply?: Maybe<Scalars['Float']>;
  add?: Maybe<Scalars['Float']>;
};

export type FormulaInput = {
  multiply?: Maybe<Scalars['Float']>;
  add?: Maybe<Scalars['Float']>;
};

export type Fulfillment = {
  __typename?: 'Fulfillment';
  nextRetryAt?: Maybe<Scalars['Date']>;
  labelGenerationStopped?: Maybe<Scalars['Boolean']>;
  labelGenerationContactAlza?: Maybe<Scalars['Boolean']>;
  labelGenerationRetryRunId?: Maybe<Scalars['String']>;
  companyId: Scalars['MongoID'];
  fulfillmentId?: Maybe<Scalars['String']>;
  marketplaceOrderIds: Array<Maybe<Scalars['String']>>;
  status?: Maybe<EnumFulfillmentStatus>;
  carrier?: Maybe<EnumFulfillmentCarrier>;
  carrierName?: Maybe<Scalars['String']>;
  shipDate?: Maybe<Scalars['Date']>;
  lastChanged?: Maybe<Scalars['Date']>;
  lastConfirmed?: Maybe<Scalars['Date']>;
  shipMethod?: Maybe<Scalars['String']>;
  trackingNumber?: Maybe<Scalars['String']>;
  trackingUrl?: Maybe<Scalars['String']>;
  cashOnDelivery?: Maybe<FulfillmentCashOnDelivery>;
  shipmentValue?: Maybe<FulfillmentCashOnDelivery>;
  parcelShop?: Maybe<FulfillmentParcelShop>;
  packages?: Maybe<Array<Maybe<FulfillmentPackages>>>;
  syncError?: Maybe<Scalars['String']>;
  syncWarning?: Maybe<Scalars['String']>;
  cancelReason?: Maybe<Scalars['String']>;
  _id: Scalars['MongoID'];
  marketplace: MarketplaceName;
  marketplaceOrderId?: Maybe<Scalars['String']>;
};

export type FulfillmentCashOnDelivery = {
  __typename?: 'FulfillmentCashOnDelivery';
  value?: Maybe<Scalars['Float']>;
  currency?: Maybe<Scalars['String']>;
};

export type FulfillmentCashOnDeliveryInput = {
  value?: Maybe<Scalars['Float']>;
  currency?: Maybe<Scalars['String']>;
};

export type FulfillmentInput = {
  fulfillmentId?: Maybe<Scalars['String']>;
  status: EnumFulfillmentStatus;
  carrier?: Maybe<EnumFulfillmentCarrier>;
  carrierName?: Maybe<Scalars['String']>;
  shipDate: Scalars['Date'];
  shipMethod?: Maybe<Scalars['String']>;
  trackingNumber?: Maybe<Scalars['String']>;
  trackingUrl?: Maybe<Scalars['String']>;
  cashOnDelivery?: Maybe<FulfillmentCashOnDeliveryInput>;
  shipmentValue?: Maybe<FulfillmentCashOnDeliveryInput>;
  parcelShop?: Maybe<FulfillmentParcelShopInput>;
  packages?: Maybe<Array<Maybe<FulfillmentPackagesInput>>>;
  syncError?: Maybe<Scalars['String']>;
  syncWarning?: Maybe<Scalars['String']>;
  cancelReason?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['MongoID']>;
  marketplace: MarketplaceName;
  marketplaceOrderId: Scalars['String'];
};

export type FulfillmentPackages = {
  __typename?: 'FulfillmentPackages';
  number?: Maybe<Scalars['String']>;
  fullNumber?: Maybe<Scalars['String']>;
  weight?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Maybe<FulfillmentPackagesItems>>>;
};

export type FulfillmentPackagesInput = {
  number?: Maybe<Scalars['String']>;
  fullNumber?: Maybe<Scalars['String']>;
  weight?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Maybe<FulfillmentPackagesItemsInput>>>;
};

export type FulfillmentPackagesItems = {
  __typename?: 'FulfillmentPackagesItems';
  marketplaceItemId?: Maybe<Scalars['String']>;
  marketplaceOrderId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  serials?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type FulfillmentPackagesItemsInput = {
  marketplaceItemId?: Maybe<Scalars['String']>;
  marketplaceOrderId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  serials?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type FulfillmentParcelShop = {
  __typename?: 'FulfillmentParcelShop';
  parcelShopIdentification?: Maybe<Scalars['String']>;
  parcelShopBranchCode?: Maybe<Scalars['String']>;
};

export type FulfillmentParcelShopInput = {
  parcelShopIdentification?: Maybe<Scalars['String']>;
  parcelShopBranchCode?: Maybe<Scalars['String']>;
};

export type GeneratePackages = {
  __typename?: 'GeneratePackages';
  success: Scalars['Boolean'];
  packagesSummaryPdfUrl?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
};

export type GlamiDeliveryMethod = {
  __typename?: 'GlamiDeliveryMethod';
  code: Scalars['String'];
  title: Scalars['String'];
};

export type ImportSettings = {
  __typename?: 'ImportSettings';
  marketplaceType: EnumImportSettingsMarketplaceType;
  service: EnumImportSettingsService;
  defaultOrderStatus?: Maybe<Scalars['String']>;
  orderDeliveredOnStatus?: Maybe<Scalars['String']>;
  orderShippingOnStatus?: Maybe<Scalars['String']>;
  importOrderJustOnce?: Maybe<Scalars['Boolean']>;
  lowerStockOnOrder?: Maybe<Scalars['Boolean']>;
  synchronizeOrders?: Maybe<Scalars['Boolean']>;
  shipmentMethod?: Maybe<Scalars['String']>;
  synchronizeFbaOrders?: Maybe<Scalars['Boolean']>;
  carrier?: Maybe<EnumImportSettingsCarrier>;
  carrierName?: Maybe<Scalars['String']>;
  deliveryMethodsMapping?: Maybe<Array<Maybe<ImportSettingsDeliveryMethodsMapping>>>;
  autoconfirmOrderOnStatus?: Maybe<Scalars['String']>;
  paymentMethodsMapping?: Maybe<Array<Maybe<ImportSettingsPaymentMethodsMapping>>>;
  importFromPurchaseDate?: Maybe<Scalars['Date']>;
  importShoptetCancelOrderStatus?: Maybe<Scalars['Boolean']>;
  shoptetCancelOrderStatus?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['MongoID']>;
};

export type ImportSettingsDeliveryMethodsMapping = {
  __typename?: 'ImportSettingsDeliveryMethodsMapping';
  marketplace?: Maybe<EnumImportSettingsDeliveryMethodsMappingMarketplace>;
  method?: Maybe<Scalars['String']>;
  serviceMethod?: Maybe<Scalars['String']>;
};

export type ImportSettingsDeliveryMethodsMappingInput = {
  marketplace?: Maybe<EnumImportSettingsDeliveryMethodsMappingMarketplace>;
  method?: Maybe<Scalars['String']>;
  serviceMethod?: Maybe<Scalars['String']>;
};

export type ImportSettingsInput = {
  marketplaceType: EnumImportSettingsMarketplaceType;
  service: EnumImportSettingsService;
  defaultOrderStatus?: Maybe<Scalars['String']>;
  orderDeliveredOnStatus?: Maybe<Scalars['String']>;
  orderShippingOnStatus?: Maybe<Scalars['String']>;
  importOrderJustOnce?: Maybe<Scalars['Boolean']>;
  lowerStockOnOrder?: Maybe<Scalars['Boolean']>;
  synchronizeOrders?: Maybe<Scalars['Boolean']>;
  shipmentMethod?: Maybe<Scalars['String']>;
  synchronizeFbaOrders?: Maybe<Scalars['Boolean']>;
  carrier?: Maybe<EnumImportSettingsCarrier>;
  carrierName?: Maybe<Scalars['String']>;
  deliveryMethodsMapping?: Maybe<Array<Maybe<ImportSettingsDeliveryMethodsMappingInput>>>;
  autoconfirmOrderOnStatus?: Maybe<Scalars['String']>;
  paymentMethodsMapping?: Maybe<Array<Maybe<ImportSettingsPaymentMethodsMappingInput>>>;
  importFromPurchaseDate?: Maybe<Scalars['Date']>;
  importShoptetCancelOrderStatus?: Maybe<Scalars['Boolean']>;
  shoptetCancelOrderStatus?: Maybe<Scalars['String']>;
};

export type ImportSettingsPaymentMethodsMapping = {
  __typename?: 'ImportSettingsPaymentMethodsMapping';
  method?: Maybe<EnumImportSettingsPaymentMethodsMappingMethod>;
  serviceMethod?: Maybe<Scalars['String']>;
};

export type ImportSettingsPaymentMethodsMappingInput = {
  method?: Maybe<EnumImportSettingsPaymentMethodsMappingMethod>;
  serviceMethod?: Maybe<Scalars['String']>;
};

export type ItemCondition = {
  __typename?: 'ItemCondition';
  isDefault?: Maybe<Scalars['Boolean']>;
  itemCondition?: Maybe<Scalars['String']>;
  itemConditionCode?: Maybe<Scalars['String']>;
  itemNote?: Maybe<Scalars['String']>;
};


export type Job = {
  __typename?: 'Job';
  queueName?: Maybe<EnumJobQueueName>;
  state?: Maybe<EnumJobState>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  createdAt?: Maybe<Scalars['Date']>;
};

export type JobInterface = {
  job?: Maybe<Job>;
};

export type ListingError = {
  __typename?: 'ListingError';
  code?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type ListingErrorInput = {
  code?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type ListingStatistics = {
  __typename?: 'ListingStatistics';
  ok: Scalars['Int'];
  error: Scalars['Int'];
};

export enum ListingStatus {
  ok = 'ok',
  error = 'error'
}

export type MallCredentials = {
  __typename?: 'MallCredentials';
  marketplace?: Maybe<MallMarketplace>;
  authorizationKey?: Maybe<Scalars['String']>;
  webhookId?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
};

export type MallDeliveryMethod = {
  __typename?: 'MallDeliveryMethod';
  code: Scalars['String'];
  title: Scalars['String'];
  marketplace: MallMarketplaceName;
};

export enum MallMarketplace {
  mall_cz = 'mall_cz',
  mall_hu = 'mall_hu',
  mall_pl = 'mall_pl',
  mall_si = 'mall_si',
  mall_sk = 'mall_sk'
}

export enum MallMarketplaceName {
  mall_cz = 'mall_cz',
  mall_hu = 'mall_hu',
  mall_pl = 'mall_pl',
  mall_si = 'mall_si',
  mall_sk = 'mall_sk'
}

export type ManualShipmentDeparture = {
  __typename?: 'ManualShipmentDeparture';
  success: Scalars['Boolean'];
  message?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
};

export type MarketplaceActivity = {
  __typename?: 'MarketplaceActivity';
  marketplace?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export enum MarketplaceName {
  alza_cz = 'alza_cz',
  amazon_mx = 'amazon_mx',
  amazon_us = 'amazon_us',
  amazon_ca = 'amazon_ca',
  amazon_br = 'amazon_br',
  amazon_de = 'amazon_de',
  amazon_uk = 'amazon_uk',
  amazon_fr = 'amazon_fr',
  amazon_it = 'amazon_it',
  amazon_es = 'amazon_es',
  amazon_nl = 'amazon_nl',
  amazon_se = 'amazon_se',
  amazon_tr = 'amazon_tr',
  amazon_pl = 'amazon_pl',
  amazon_be = 'amazon_be',
  amazon_ie = 'amazon_ie',
  amazon_sg = 'amazon_sg',
  amazon_au = 'amazon_au',
  amazon_jp = 'amazon_jp',
  emag_bg = 'emag_bg',
  emag_hu = 'emag_hu',
  emag_pl = 'emag_pl',
  emag_ro = 'emag_ro',
  mall_cz = 'mall_cz',
  mall_hu = 'mall_hu',
  mall_pl = 'mall_pl',
  mall_si = 'mall_si',
  mall_sk = 'mall_sk',
  real_de = 'real_de',
  kaufland_de = 'kaufland_de',
  kaufland_cz = 'kaufland_cz',
  kaufland_sk = 'kaufland_sk',
  kaufland_at = 'kaufland_at',
  kaufland_pl = 'kaufland_pl',
  kaufland_nl = 'kaufland_nl',
  kaufland_es = 'kaufland_es',
  kaufland_fr = 'kaufland_fr',
  kaufland_it = 'kaufland_it',
  glami_cz = 'glami_cz',
  cdiscount_fr = 'cdiscount_fr',
  ebay_at = 'ebay_at',
  ebay_cz = 'ebay_cz',
  ebay_fr = 'ebay_fr',
  ebay_pl = 'ebay_pl',
  ebay_de = 'ebay_de',
  ebay_us = 'ebay_us',
  ebay_uk = 'ebay_uk',
  allegro_cz = 'allegro_cz',
  allegro_pl = 'allegro_pl',
  allegro_sk = 'allegro_sk',
  baskedo_bg = 'baskedo_bg',
  baskedo_hu = 'baskedo_hu',
  bol_nl = 'bol_nl',
  bol_be = 'bol_be',
  expando_shop_ro = 'expando_shop_ro',
  limetka_cz = 'limetka_cz',
  limetka_gr = 'limetka_gr',
  limetka_sk = 'limetka_sk'
}

export type MarketplaceOfferDetails = {
  __typename?: 'MarketplaceOfferDetails';
  isBuyBoxWinner?: Maybe<Scalars['Boolean']>;
  isFeaturedMerchant?: Maybe<Scalars['Boolean']>;
  isFulfilledByAmazon?: Maybe<Scalars['Boolean']>;
};

export type MarketplaceOfferDetailsInput = {
  isBuyBoxWinner?: Maybe<Scalars['Boolean']>;
  isFeaturedMerchant?: Maybe<Scalars['Boolean']>;
  isFulfilledByAmazon?: Maybe<Scalars['Boolean']>;
};

export enum MarketplaceRegion {
  alza_cz = 'alza_cz',
  amazon_america = 'amazon_america',
  amazon_europe = 'amazon_europe',
  amazon_far_east_sg = 'amazon_far_east_sg',
  amazon_far_east_au = 'amazon_far_east_au',
  amazon_far_east_jp = 'amazon_far_east_jp',
  emag_bg = 'emag_bg',
  emag_hu = 'emag_hu',
  emag_pl = 'emag_pl',
  emag_ro = 'emag_ro',
  mall_cz = 'mall_cz',
  mall_hu = 'mall_hu',
  mall_pl = 'mall_pl',
  mall_si = 'mall_si',
  mall_sk = 'mall_sk',
  shoptet_alza = 'shoptet_alza',
  shoptet_amazon = 'shoptet_amazon',
  shoptet_mall = 'shoptet_mall',
  real_de = 'real_de',
  kaufland_de = 'kaufland_de',
  kaufland_cz = 'kaufland_cz',
  kaufland_sk = 'kaufland_sk',
  kaufland_at = 'kaufland_at',
  kaufland_pl = 'kaufland_pl',
  kaufland_nl = 'kaufland_nl',
  kaufland_es = 'kaufland_es',
  kaufland_fr = 'kaufland_fr',
  kaufland_it = 'kaufland_it',
  glami_cz = 'glami_cz',
  cdiscount_fr = 'cdiscount_fr',
  ebay_at = 'ebay_at',
  ebay_cz = 'ebay_cz',
  ebay_fr = 'ebay_fr',
  ebay_pl = 'ebay_pl',
  ebay_de = 'ebay_de',
  ebay_us = 'ebay_us',
  ebay_uk = 'ebay_uk',
  allegro_cz = 'allegro_cz',
  allegro_pl = 'allegro_pl',
  allegro_sk = 'allegro_sk',
  baskedo_bg = 'baskedo_bg',
  baskedo_hu = 'baskedo_hu',
  bol_nl = 'bol_nl',
  bol_be = 'bol_be',
  expando_shop_ro = 'expando_shop_ro',
  limetka_cz = 'limetka_cz',
  limetka_gr = 'limetka_gr',
  limetka_sk = 'limetka_sk'
}

export type MarketplaceSkus = {
  __typename?: 'MarketplaceSkus';
  emag?: Maybe<Scalars['String']>;
};

export type MarketplaceSkusInput = {
  emag?: Maybe<Scalars['String']>;
};

export type MarketplaceStatus = {
  __typename?: 'MarketplaceStatus';
  marketplace?: Maybe<MarketplaceName>;
  status?: Maybe<EnumMarketplaceStatus>;
  error?: Maybe<Scalars['String']>;
  hidden?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  formula?: Maybe<Formula>;
  currency?: Maybe<Scalars['String']>;
  region?: Maybe<MarketplaceRegion>;
  errorRates?: Maybe<Array<Maybe<AmazonErrorRate>>>;
  currentListingStatistics?: Maybe<ListingStatistics>;
};

export type Money = {
  __typename?: 'Money';
  value: Scalars['Float'];
  currency: Scalars['String'];
};


export type Mutation = {
  __typename?: 'Mutation';
  exportProducts?: Maybe<ProductExport>;
  amazonReconnect?: Maybe<MarketplaceStatus>;
  formula?: Maybe<MarketplaceStatus>;
  updateMarketplaceStatus?: Maybe<Array<Maybe<MarketplaceStatus>>>;
  sync?: Maybe<ProductSync>;
  forceSync?: Maybe<Sync>;
  setSyncSettings?: Maybe<SyncSettings>;
  setImportSettings?: Maybe<Array<Maybe<ImportSettings>>>;
  updateFulfillment?: Maybe<Fulfillment>;
  updateFulfillmentAsync?: Maybe<Fulfillment>;
  userRegistration?: Maybe<UserRegistrationRes>;
  completeRegistration?: Maybe<EmailVerification>;
  updateUser?: Maybe<UserQuery>;
  updateOnboardingState?: Maybe<CompanyQuery>;
  updateGoogleDataStudioUrl?: Maybe<CompanyQuery>;
  updateInternalCompanyName?: Maybe<CompanyQuery>;
  updateReturnAddressDoc?: Maybe<CompanyQuery>;
  updateReturnAddress?: Maybe<CompanyQuery>;
  thanos?: Maybe<Scalars['String']>;
  startShoptetLogin?: Maybe<StartShoptetLoginResult>;
  completeShoptetLogin?: Maybe<CompleteShoptetLoginResult>;
  updateProductAutopricingActiveState?: Maybe<Scalars['JSON']>;
  updateProductAutopricingLimits?: Maybe<Scalars['JSON']>;
  updateProductAutopricingLimitsBulk?: Maybe<Scalars['JSON']>;
  deleteProduct?: Maybe<SuccessMessage>;
  generatePackages?: Maybe<GeneratePackages>;
  createShipment?: Maybe<CreateShipment>;
  shipmentDeparture?: Maybe<ShipmentDeparture>;
  manualShipmentDeparture?: Maybe<ManualShipmentDeparture>;
  cancelAlzaOrder?: Maybe<SuccessMessage>;
  retryAlzaShipment?: Maybe<SuccessMessage>;
  cancelAlzaShippingLabels?: Maybe<SuccessMessage>;
  saveAlzaCredentials?: Maybe<SuccessMessage>;
  saveCredentials?: Maybe<Scalars['JSON']>;
  setMallMarketplaceConnection?: Maybe<SuccessMessage>;
  deleteMarketplaceConnection?: Maybe<SuccessMessage>;
  saveEmailNotificationSettings?: Maybe<SuccessMessage>;
  triggerAlzaSync?: Maybe<AlzaFullSync>;
  shoptetFullSync?: Maybe<SuccessMessage>;
  setCustomProductFeed?: Maybe<CustomProductFeed>;
  validateProductFeedField?: Maybe<Array<Maybe<ValidateProductFeedField>>>;
  mergePdfs?: Maybe<Pdfs>;
  generateBarcodes?: Maybe<Pdfs>;
  generateBarcodesWithEan?: Maybe<Pdfs>;
  requestAutopricingReport?: Maybe<AutopricingReport>;
  requestPricingReport?: Maybe<PricingReport>;
  requestFeedConvertReport?: Maybe<FeedConvertReport>;
  createReturnPackageLabel?: Maybe<Order>;
  createReturnPackageLabelAsAdmin?: Maybe<Order>;
  sendPasswordResetEmail: CreatePasswordResetEmailResult;
  resetPassword?: Maybe<ResetPasswordResult>;
  superLogin: SuperloginResult;
  updateProductVariant?: Maybe<Array<Maybe<ProductVariant>>>;
  uploadProductVariants?: Maybe<Scalars['JSON']>;
  countProductVariants?: Maybe<Scalars['Int']>;
  blockProducts?: Maybe<Array<Maybe<BlockProductVariant>>>;
  updateForbidListings?: Maybe<UpdateForbidListingsResult>;
  setSubscription?: Maybe<SubscriptionSchema>;
  verifyEmail: VerifyEmailResult;
  discardTrialDeadline: DiscardTrialDeadlineResult;
};


export type MutationexportProductsArgs = {
  filter?: Maybe<FilterInputProducts>;
  sort?: Maybe<Array<Maybe<ProductsSortInput>>>;
};


export type MutationamazonReconnectArgs = {
  marketplace: MarketplaceName;
};


export type MutationformulaArgs = {
  formula?: Maybe<FormulaInput>;
  marketplace: Scalars['String'];
};


export type MutationupdateMarketplaceStatusArgs = {
  status?: Maybe<UpdateMwsMarketplaceInputStatus>;
  marketplace: MarketplaceName;
};


export type MutationforceSyncArgs = {
  companyId?: Maybe<Scalars['String']>;
};


export type MutationsetSyncSettingsArgs = {
  settings?: Maybe<SyncSettingsInput>;
};


export type MutationsetImportSettingsArgs = {
  importSettings?: Maybe<ImportSettingsInput>;
};


export type MutationupdateFulfillmentArgs = {
  fulfillment?: Maybe<FulfillmentInput>;
  fulfillmentChannel?: Maybe<Scalars['String']>;
};


export type MutationupdateFulfillmentAsyncArgs = {
  fulfillment?: Maybe<FulfillmentInput>;
};


export type MutationuserRegistrationArgs = {
  dto: UserRegistrationDto;
};


export type MutationcompleteRegistrationArgs = {
  verificationCode: Scalars['String'];
};


export type MutationupdateUserArgs = {
  user?: Maybe<UserInput>;
};


export type MutationupdateOnboardingStateArgs = {
  onboardingState?: Maybe<EnumCompanyOnboardingState>;
};


export type MutationupdateGoogleDataStudioUrlArgs = {
  googleDataStudioUrl?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['String']>;
};


export type MutationupdateInternalCompanyNameArgs = {
  internalName?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['String']>;
};


export type MutationupdateReturnAddressDocArgs = {
  companyId?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  countryCode: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  street: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  zipCode: Scalars['String'];
  city: Scalars['String'];
};


export type MutationupdateReturnAddressArgs = {
  companyName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  countryCode: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  street: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  zipCode: Scalars['String'];
  city: Scalars['String'];
};


export type MutationthanosArgs = {
  companyId?: Maybe<Scalars['String']>;
};


export type MutationstartShoptetLoginArgs = {
  shopId?: Maybe<Scalars['String']>;
  shopHostname?: Maybe<Scalars['String']>;
  redirectUrl?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
};


export type MutationcompleteShoptetLoginArgs = {
  state: Scalars['String'];
  code: Scalars['String'];
};


export type MutationupdateProductAutopricingActiveStateArgs = {
  sku: Scalars['String'];
  marketplace?: Maybe<MarketplaceName>;
  active: Scalars['Boolean'];
};


export type MutationupdateProductAutopricingLimitsArgs = {
  sku: Scalars['String'];
  marketplace?: Maybe<MarketplaceName>;
  topCap?: Maybe<Scalars['Float']>;
  bottomCap?: Maybe<Scalars['Float']>;
  topCapAbsolute?: Maybe<Scalars['Float']>;
  bottomCapAbsolute?: Maybe<Scalars['Float']>;
};


export type MutationupdateProductAutopricingLimitsBulkArgs = {
  newSettings?: Maybe<newSettings>;
};


export type MutationdeleteProductArgs = {
  skus?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type MutationgeneratePackagesArgs = {
  carrier: Scalars['String'];
  packages?: Maybe<Array<Maybe<PackagesInput>>>;
  orderId: Scalars['String'];
};


export type MutationcreateShipmentArgs = {
  carrier?: Maybe<Scalars['String']>;
  packages?: Maybe<Array<Maybe<PackagesInput>>>;
  orderIds: Array<Maybe<Scalars['String']>>;
};


export type MutationshipmentDepartureArgs = {
  orderId: Scalars['String'];
};


export type MutationmanualShipmentDepartureArgs = {
  carrier: Scalars['String'];
  packages?: Maybe<Array<Maybe<PackagesInput>>>;
  orderId: Scalars['String'];
};


export type MutationcancelAlzaOrderArgs = {
  orderId: Scalars['String'];
  deliveryResultStatus: Scalars['String'];
};


export type MutationretryAlzaShipmentArgs = {
  fulfillmentId: Scalars['String'];
  expectedRunId: Scalars['String'];
};


export type MutationcancelAlzaShippingLabelsArgs = {
  fulfillmentId: Scalars['String'];
};


export type MutationsaveAlzaCredentialsArgs = {
  marketplace?: Maybe<AlzaMarketplace>;
  apiBaseUrl: Scalars['String'];
  buyerId: Scalars['Int'];
  supplierId: Scalars['Int'];
  supplierBranchId: Scalars['Int'];
  secretKey: Scalars['String'];
  active?: Maybe<Scalars['Boolean']>;
};


export type MutationsaveCredentialsArgs = {
  serviceScope?: Maybe<MarketplaceRegion>;
  apiBaseUrl?: Maybe<Scalars['String']>;
  buyerId?: Maybe<Scalars['String']>;
  supplierId?: Maybe<Scalars['String']>;
  supplierBranchId?: Maybe<Scalars['String']>;
  sellerId?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  clientId?: Maybe<Scalars['String']>;
  webhookId?: Maybe<Scalars['String']>;
  webhookUrl?: Maybe<Scalars['String']>;
  clientKey?: Maybe<Scalars['String']>;
  secretKey?: Maybe<Scalars['String']>;
};


export type MutationsetMallMarketplaceConnectionArgs = {
  marketplace?: Maybe<MallMarketplace>;
  authorizationKey: Scalars['String'];
  active?: Maybe<Scalars['Boolean']>;
};


export type MutationdeleteMarketplaceConnectionArgs = {
  serviceScope?: Maybe<MarketplaceRegion>;
};


export type MutationsaveEmailNotificationSettingsArgs = {
  platform?: Maybe<Platform>;
  active: Scalars['Boolean'];
};


export type MutationsetCustomProductFeedArgs = {
  feed?: Maybe<CustomProductFeedInput>;
  step?: Maybe<EFeedSetupState>;
};


export type MutationvalidateProductFeedFieldArgs = {
  type?: Maybe<ValidationFieldTypeEnum>;
  values: Array<Maybe<Scalars['String']>>;
};


export type MutationmergePdfsArgs = {
  links?: Maybe<Array<Scalars['String']>>;
};


export type MutationgenerateBarcodesArgs = {
  marketplaceOrderIds?: Maybe<Array<Scalars['String']>>;
};


export type MutationgenerateBarcodesWithEanArgs = {
  marketplaceOrderIds?: Maybe<Array<Scalars['String']>>;
};


export type MutationrequestAutopricingReportArgs = {
  filters?: Maybe<AutopricingReportFilterOptionsInput>;
  relevantRanges?: Maybe<AutopricingReportRelevantRangesOptionsInput>;
  fieldWeights?: Maybe<AutopricingReportFieldWeightsOptionsInput>;
};


export type MutationrequestPricingReportArgs = {
  service?: Maybe<MarketplaceName>;
};


export type MutationrequestFeedConvertReportArgs = {
  url?: Maybe<Scalars['String']>;
};


export type MutationcreateReturnPackageLabelArgs = {
  marketplace?: Maybe<Scalars['String']>;
  marketplaceOrderId?: Maybe<Scalars['String']>;
};


export type MutationcreateReturnPackageLabelAsAdminArgs = {
  companyId?: Maybe<Scalars['String']>;
  marketplace?: Maybe<Scalars['String']>;
  marketplaceOrderId?: Maybe<Scalars['String']>;
};


export type MutationsendPasswordResetEmailArgs = {
  email: Scalars['String'];
};


export type MutationresetPasswordArgs = {
  code: Scalars['String'];
  password: Scalars['String'];
};


export type MutationsuperLoginArgs = {
  email: Scalars['String'];
};


export type MutationupdateProductVariantArgs = {
  products?: Maybe<Array<Maybe<ProductVariantInput>>>;
};


export type MutationuploadProductVariantsArgs = {
  products?: Maybe<Array<Maybe<ProductVariantInput>>>;
};


export type MutationblockProductsArgs = {
  products?: Maybe<Array<Maybe<ProductVariantInput>>>;
};


export type MutationupdateForbidListingsArgs = {
  productVariants?: Maybe<Array<Maybe<ProductVariantInput>>>;
};


export type MutationsetSubscriptionArgs = {
  settings?: Maybe<SubscriptionSchemaInput>;
};


export type MutationverifyEmailArgs = {
  email: Scalars['String'];
};


export type MutationdiscardTrialDeadlineArgs = {
  email: Scalars['String'];
  companyId: Scalars['String'];
};

export type Offer = {
  __typename?: 'Offer';
  sellerId?: Maybe<Scalars['String']>;
  listingPrice?: Maybe<Scalars['Float']>;
  shippingPrice?: Maybe<Scalars['Float']>;
  feedback?: Maybe<Feedback>;
  shippingTime?: Maybe<ShippingTime>;
  marketplaceDetails?: Maybe<MarketplaceOfferDetails>;
};

export type OfferInput = {
  sellerId?: Maybe<Scalars['String']>;
  listingPrice?: Maybe<Scalars['Float']>;
  shippingPrice?: Maybe<Scalars['Float']>;
  feedback?: Maybe<FeedbackInput>;
  shippingTime?: Maybe<ShippingTimeInput>;
  marketplaceDetails?: Maybe<MarketplaceOfferDetailsInput>;
};

export type Order = {
  __typename?: 'Order';
  companyId: Scalars['MongoID'];
  marketplaceOrderId: Scalars['String'];
  status?: Maybe<EnumOrderStatus>;
  marketplace?: Maybe<MarketplaceName>;
  fulfillmentId?: Maybe<Scalars['MongoID']>;
  fulfillmentChannel?: Maybe<Scalars['String']>;
  totalPrice?: Maybe<Scalars['Float']>;
  totalItemTax?: Maybe<Scalars['Float']>;
  shippingPrice?: Maybe<Scalars['Float']>;
  totalDiscount?: Maybe<Scalars['Float']>;
  currencyCode?: Maybe<EnumOrderCurrencyCode>;
  shipServiceLevel?: Maybe<Scalars['String']>;
  delivery?: Maybe<OrderDelivery>;
  paymentMethod?: Maybe<Scalars['String']>;
  invoices?: Maybe<Array<Maybe<OrderInvoices>>>;
  buyer?: Maybe<OrderBuyer>;
  billingAddress?: Maybe<OrderBillingAddress>;
  deliveryAddress?: Maybe<OrderBillingAddress>;
  items?: Maybe<Array<Maybe<OrderItems>>>;
  lastChanged?: Maybe<Scalars['Date']>;
  latestShipDate?: Maybe<Scalars['Date']>;
  latestDeliveryDate?: Maybe<Scalars['Date']>;
  selectedShipDate?: Maybe<Scalars['Date']>;
  demandedExpeditionDate?: Maybe<Scalars['Date']>;
  marketplaceLastChanged?: Maybe<Scalars['Date']>;
  packageLabels?: Maybe<Scalars['String']>;
  purchaseDate?: Maybe<Scalars['Date']>;
  isPremiumOrder?: Maybe<Scalars['Boolean']>;
  isPrime?: Maybe<Scalars['Boolean']>;
  isBusinessOrder?: Maybe<Scalars['Boolean']>;
  isComplete?: Maybe<Scalars['Boolean']>;
  isRefunded?: Maybe<Scalars['Boolean']>;
  isUnshipped?: Maybe<Scalars['Boolean']>;
  pendingDate?: Maybe<Scalars['Date']>;
  unshippedDate?: Maybe<Scalars['Date']>;
  shippedDate?: Maybe<Scalars['Date']>;
  canceledDate?: Maybe<Scalars['Date']>;
  deliveredDate?: Maybe<Scalars['Date']>;
  autopricing?: Maybe<Array<Maybe<OrderAutopricing>>>;
  autopricingHistory?: Maybe<Array<Maybe<OrderAutopricing>>>;
  autopricingTotal?: Maybe<Scalars['Float']>;
  autopricingTotalUp?: Maybe<Scalars['Float']>;
  autopricingTotalDown?: Maybe<Scalars['Float']>;
  autopricingStatus?: Maybe<EnumOrderAutopricingStatus>;
  autopricingTaxReports?: Maybe<Array<Maybe<OrderAutopricingTaxReports>>>;
  price: OrderPrice;
  mallDeliveryMethod?: Maybe<Scalars['String']>;
  marketplaceDeliveryMethod?: Maybe<OrderMarketplaceDeliveryMethod>;
  shippingCarrierIdentification?: Maybe<Scalars['String']>;
  parcelShop?: Maybe<OrderParcelShop>;
  payment?: Maybe<OrderPayment>;
  cashOnDelivery?: Maybe<OrderCashOnDelivery>;
  deliveryBranchId?: Maybe<Scalars['Float']>;
  shipmentValue?: Maybe<Scalars['Float']>;
  shipmentValueCurrency?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  returnLabels?: Maybe<Array<Maybe<OrderReturnLabels>>>;
  piiPurgedAt?: Maybe<Scalars['Date']>;
  _id: Scalars['MongoID'];
  financialEvents?: Maybe<FinancialEvents>;
  user?: Maybe<UserQuery>;
  users?: Maybe<Array<Maybe<UserQuery>>>;
  fulfillment?: Maybe<Fulfillment>;
  pickupList?: Maybe<PickupList>;
};

export type OrderAutopricing = {
  __typename?: 'OrderAutopricing';
  sku?: Maybe<Scalars['String']>;
  delta?: Maybe<Scalars['Float']>;
  base?: Maybe<Scalars['Float']>;
  autoprice?: Maybe<Scalars['Float']>;
  date?: Maybe<Scalars['Date']>;
};

export type OrderAutopricingTaxReports = {
  __typename?: 'OrderAutopricingTaxReports';
  sku?: Maybe<Scalars['String']>;
  taxReportingScheme?: Maybe<Scalars['String']>;
  sellerTaxCountry?: Maybe<Scalars['String']>;
  price?: Maybe<OrderItemsLineItemPrice>;
  discount?: Maybe<OrderItemsLineItemPrice>;
};

export type OrderBillingAddress = {
  __typename?: 'OrderBillingAddress';
  companyName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  addressLine: Array<Maybe<Scalars['String']>>;
  city: Scalars['String'];
  province?: Maybe<Scalars['String']>;
  zip: Scalars['String'];
  countryCode: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  taxId?: Maybe<Scalars['String']>;
  taxCountry?: Maybe<Scalars['String']>;
  vatNo?: Maybe<Scalars['String']>;
};

export type OrderBuyer = {
  __typename?: 'OrderBuyer';
  name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  addressLine?: Maybe<Array<Maybe<Scalars['String']>>>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  district?: Maybe<Scalars['String']>;
  stateOrRegion?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  taxId?: Maybe<Scalars['String']>;
  taxCountry?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  regNo?: Maybe<Scalars['String']>;
  vatNo?: Maybe<Scalars['String']>;
};

export type OrderCashOnDelivery = {
  __typename?: 'OrderCashOnDelivery';
  value?: Maybe<Scalars['Float']>;
  currency?: Maybe<Scalars['String']>;
  variableSymbol?: Maybe<Scalars['String']>;
};

export type OrderDelivery = {
  __typename?: 'OrderDelivery';
  shippingCarrier?: Maybe<Scalars['String']>;
  shippingCarrierService?: Maybe<Scalars['String']>;
};

export type OrderInvoices = {
  __typename?: 'OrderInvoices';
  id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
};

export type OrderItems = {
  __typename?: 'OrderItems';
  sku: Scalars['String'];
  asin?: Maybe<Scalars['String']>;
  marketplaceItemId?: Maybe<Scalars['String']>;
  marketplaceSku?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  price: Scalars['Float'];
  itemPrice?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  tax?: Maybe<Scalars['Float']>;
  promotionDiscount?: Maybe<Scalars['Float']>;
  promotionDiscountTax?: Maybe<Scalars['Float']>;
  shippingDiscount?: Maybe<Scalars['Float']>;
  shippingDiscountTax?: Maybe<Scalars['Float']>;
  shippingTax?: Maybe<Scalars['Float']>;
  shippingPrice?: Maybe<Scalars['Float']>;
  deliveryItemIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  lineItemPrice?: Maybe<OrderItemsLineItemPrice>;
  lineItemDiscount?: Maybe<OrderItemsLineItemPrice>;
  deliveryPrice?: Maybe<OrderItemsLineItemPrice>;
  deliveryDiscount?: Maybe<OrderItemsLineItemPrice>;
  marketplaceCommission?: Maybe<OrderItemsLineItemPrice>;
  serialNumbersRequired?: Maybe<Scalars['Boolean']>;
  orderItemIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  buyerCustomInfo?: Maybe<Array<Maybe<OrderItemsBuyerCustomInfo>>>;
};

export type OrderItemsBuyerCustomInfo = {
  __typename?: 'OrderItemsBuyerCustomInfo';
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type OrderItemsLineItemPrice = {
  __typename?: 'OrderItemsLineItemPrice';
  withTax?: Maybe<Scalars['Float']>;
  withoutTax?: Maybe<Scalars['Float']>;
  tax?: Maybe<Scalars['Float']>;
  taxRatePercent?: Maybe<Scalars['Float']>;
  taxRatePercentDecimal?: Maybe<Scalars['Float']>;
};

export type OrderMarketplaceDeliveryMethod = {
  __typename?: 'OrderMarketplaceDeliveryMethod';
  code?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** List of items with pagination. */
export type OrderPagination = {
  __typename?: 'OrderPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<Order>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type OrderParcelShop = {
  __typename?: 'OrderParcelShop';
  parcelShopIdentification?: Maybe<Scalars['String']>;
  parcelShopBranchCode?: Maybe<Scalars['String']>;
};

export type OrderPayment = {
  __typename?: 'OrderPayment';
  cashOnDelivery?: Maybe<OrderPaymentCashOnDelivery>;
  paymentMethod: EnumOrderPaymentPaymentMethod;
};

export type OrderPaymentCashOnDelivery = {
  __typename?: 'OrderPaymentCashOnDelivery';
  toPay?: Maybe<Scalars['Float']>;
  servicePrice?: Maybe<Scalars['Float']>;
};

export type OrderPrice = {
  __typename?: 'OrderPrice';
  items?: Maybe<OrderItemsLineItemPrice>;
  delivery?: Maybe<OrderItemsLineItemPrice>;
  payment?: Maybe<OrderItemsLineItemPrice>;
  totalDiscount?: Maybe<OrderItemsLineItemPrice>;
  total: OrderItemsLineItemPrice;
};

export type OrderReturnLabels = {
  __typename?: 'OrderReturnLabels';
  status?: Maybe<Scalars['String']>;
  requestCreatedAt?: Maybe<Scalars['Date']>;
  packageLabelUrls?: Maybe<Array<Maybe<Scalars['String']>>>;
  errorMessage?: Maybe<Scalars['String']>;
  shipmentNumber?: Maybe<Scalars['String']>;
  labelNumber?: Maybe<Scalars['Float']>;
};

export type OrderStatistics = {
  __typename?: 'OrderStatistics';
  from?: Maybe<Scalars['Date']>;
  to?: Maybe<Scalars['Date']>;
  gmv?: Maybe<Scalars['Float']>;
  count?: Maybe<Scalars['Int']>;
};

export type OrderStatisticsPerCountry = {
  __typename?: 'OrderStatisticsPerCountry';
  buyerCountryCode?: Maybe<Scalars['String']>;
  gmv?: Maybe<Scalars['Float']>;
  count?: Maybe<Scalars['Int']>;
};

export enum OrderStatisticsTimeRange {
  today = 'today',
  lastThirtyDays = 'lastThirtyDays',
  lastSevenDays = 'lastSevenDays'
}

export type OrdersSortInput = {
  isUnshipped?: Maybe<Sort>;
  purchaseDate?: Maybe<Sort>;
};

export type OrderstatisticsPerMarketplace = {
  __typename?: 'OrderstatisticsPerMarketplace';
  marketplace?: Maybe<Scalars['String']>;
  gmv?: Maybe<Scalars['Float']>;
  count?: Maybe<Scalars['Int']>;
};

export type PackageItemsInput = {
  marketplaceItemId: Scalars['String'];
  marketplaceOrderId: Scalars['String'];
  quantity: Scalars['Int'];
};

export type PackagesInput = {
  number?: Maybe<Scalars['String']>;
  weight: Scalars['Float'];
  items?: Maybe<Array<Maybe<PackageItemsInput>>>;
};

export type PaginationInfo = {
  __typename?: 'PaginationInfo';
  currentPage: Scalars['Int'];
  perPage: Scalars['Int'];
  pageCount?: Maybe<Scalars['Int']>;
  itemCount?: Maybe<Scalars['Int']>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']>;
};

export type Pdfs = {
  __typename?: 'Pdfs';
  input?: Maybe<Scalars['JSON']>;
  process: EnumPdfsProcess;
  status: EnumPdfsStatus;
  downloadLink?: Maybe<Scalars['String']>;
  downloadLinkToFailedFile?: Maybe<Scalars['String']>;
  requestedAt?: Maybe<Scalars['Date']>;
  doneAt?: Maybe<Scalars['Date']>;
  failedAt?: Maybe<Scalars['Date']>;
  failReason?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['MongoID']>;
};

export enum Period {
  DAY = 'DAY',
  WEEK = 'WEEK'
}

export type PickupList = {
  __typename?: 'PickupList';
  companyId: Scalars['MongoID'];
  carrier: Scalars['String'];
  orderIds: Array<Maybe<Scalars['MongoID']>>;
  carrierPickupListId?: Maybe<Scalars['Float']>;
  carrierPickupListGroupId?: Maybe<Scalars['Float']>;
  pickupTime?: Maybe<Scalars['Date']>;
  lastChanged?: Maybe<Scalars['Date']>;
  pickupList?: Maybe<Scalars['String']>;
  pickupListGroup?: Maybe<Scalars['String']>;
};

export type PickupListsAggregation = {
  __typename?: 'PickupListsAggregation';
  collectionTime?: Maybe<Scalars['Date']>;
  pickupTime: Scalars['Date'];
  count: Scalars['Int'];
  pickupLists?: Maybe<Array<Scalars['String']>>;
  pickupListGroups?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export enum Platform {
  alza = 'alza',
  amazon = 'amazon',
  emag = 'emag',
  mall = 'mall',
  shoptet = 'shoptet',
  real = 'real',
  kaufland = 'kaufland',
  glami = 'glami',
  cdiscount = 'cdiscount',
  ebay = 'ebay',
  allegro = 'allegro',
  baskedo = 'baskedo',
  bol = 'bol',
  expando_shop = 'expando_shop',
  limetka = 'limetka'
}

export type PlatformStatus = {
  __typename?: 'PlatformStatus';
  active?: Maybe<Scalars['Boolean']>;
  connected?: Maybe<Scalars['Boolean']>;
  hidden?: Maybe<Scalars['Boolean']>;
};

export type PlatformStatuses = {
  __typename?: 'PlatformStatuses';
  alza?: Maybe<PlatformStatus>;
  amazon?: Maybe<PlatformStatus>;
  emag?: Maybe<PlatformStatus>;
  mall?: Maybe<PlatformStatus>;
  real?: Maybe<PlatformStatus>;
  kaufland?: Maybe<PlatformStatus>;
  glami?: Maybe<PlatformStatus>;
  cdiscount?: Maybe<PlatformStatus>;
  ebay?: Maybe<PlatformStatus>;
  allegro?: Maybe<PlatformStatus>;
  baskedo?: Maybe<PlatformStatus>;
  bol?: Maybe<PlatformStatus>;
  expando_shop?: Maybe<PlatformStatus>;
  limetka?: Maybe<PlatformStatus>;
};

export type Price = {
  __typename?: 'Price';
  base?: Maybe<Scalars['Float']>;
  selling?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  max?: Maybe<Scalars['Float']>;
};

export type PriceInput = {
  base?: Maybe<Scalars['Float']>;
  selling?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  max?: Maybe<Scalars['Float']>;
};

export type Prices = {
  __typename?: 'Prices';
  alza_cz?: Maybe<Price>;
  amazon_mx?: Maybe<Price>;
  amazon_us?: Maybe<Price>;
  amazon_ca?: Maybe<Price>;
  amazon_br?: Maybe<Price>;
  amazon_de?: Maybe<Price>;
  amazon_uk?: Maybe<Price>;
  amazon_fr?: Maybe<Price>;
  amazon_it?: Maybe<Price>;
  amazon_es?: Maybe<Price>;
  amazon_nl?: Maybe<Price>;
  amazon_se?: Maybe<Price>;
  amazon_tr?: Maybe<Price>;
  amazon_pl?: Maybe<Price>;
  amazon_be?: Maybe<Price>;
  amazon_ie?: Maybe<Price>;
  amazon_sg?: Maybe<Price>;
  amazon_au?: Maybe<Price>;
  amazon_jp?: Maybe<Price>;
  emag_bg?: Maybe<Price>;
  emag_hu?: Maybe<Price>;
  emag_pl?: Maybe<Price>;
  emag_ro?: Maybe<Price>;
  mall_cz?: Maybe<Price>;
  mall_hu?: Maybe<Price>;
  mall_pl?: Maybe<Price>;
  mall_si?: Maybe<Price>;
  mall_sk?: Maybe<Price>;
  real_de?: Maybe<Price>;
  kaufland_de?: Maybe<Price>;
  kaufland_cz?: Maybe<Price>;
  kaufland_sk?: Maybe<Price>;
  kaufland_at?: Maybe<Price>;
  kaufland_pl?: Maybe<Price>;
  kaufland_nl?: Maybe<Price>;
  kaufland_es?: Maybe<Price>;
  kaufland_fr?: Maybe<Price>;
  kaufland_it?: Maybe<Price>;
  glami_cz?: Maybe<Price>;
  cdiscount_fr?: Maybe<Price>;
  ebay_at?: Maybe<Price>;
  ebay_cz?: Maybe<Price>;
  ebay_fr?: Maybe<Price>;
  ebay_pl?: Maybe<Price>;
  ebay_de?: Maybe<Price>;
  ebay_us?: Maybe<Price>;
  ebay_uk?: Maybe<Price>;
  allegro_cz?: Maybe<Price>;
  allegro_pl?: Maybe<Price>;
  allegro_sk?: Maybe<Price>;
  baskedo_bg?: Maybe<Price>;
  baskedo_hu?: Maybe<Price>;
  bol_nl?: Maybe<Price>;
  expando_shop_ro?: Maybe<Price>;
  limetka_cz?: Maybe<Price>;
  limetka_gr?: Maybe<Price>;
  limetka_sk?: Maybe<Price>;
};

export type PricesInput = {
  alza_cz?: Maybe<PriceInput>;
  amazon_mx?: Maybe<PriceInput>;
  amazon_us?: Maybe<PriceInput>;
  amazon_ca?: Maybe<PriceInput>;
  amazon_br?: Maybe<PriceInput>;
  amazon_de?: Maybe<PriceInput>;
  amazon_uk?: Maybe<PriceInput>;
  amazon_fr?: Maybe<PriceInput>;
  amazon_it?: Maybe<PriceInput>;
  amazon_es?: Maybe<PriceInput>;
  amazon_nl?: Maybe<PriceInput>;
  amazon_se?: Maybe<PriceInput>;
  amazon_tr?: Maybe<PriceInput>;
  amazon_pl?: Maybe<PriceInput>;
  amazon_be?: Maybe<PriceInput>;
  amazon_ie?: Maybe<PriceInput>;
  amazon_sg?: Maybe<PriceInput>;
  amazon_au?: Maybe<PriceInput>;
  amazon_jp?: Maybe<PriceInput>;
  emag_bg?: Maybe<PriceInput>;
  emag_hu?: Maybe<PriceInput>;
  emag_pl?: Maybe<PriceInput>;
  emag_ro?: Maybe<PriceInput>;
  mall_cz?: Maybe<PriceInput>;
  mall_hu?: Maybe<PriceInput>;
  mall_pl?: Maybe<PriceInput>;
  mall_si?: Maybe<PriceInput>;
  mall_sk?: Maybe<PriceInput>;
  real_de?: Maybe<PriceInput>;
  kaufland_de?: Maybe<PriceInput>;
  kaufland_cz?: Maybe<PriceInput>;
  kaufland_sk?: Maybe<PriceInput>;
  kaufland_at?: Maybe<PriceInput>;
  kaufland_pl?: Maybe<PriceInput>;
  kaufland_nl?: Maybe<PriceInput>;
  kaufland_es?: Maybe<PriceInput>;
  kaufland_fr?: Maybe<PriceInput>;
  kaufland_it?: Maybe<PriceInput>;
  glami_cz?: Maybe<PriceInput>;
  cdiscount_fr?: Maybe<PriceInput>;
  ebay_at?: Maybe<PriceInput>;
  ebay_cz?: Maybe<PriceInput>;
  ebay_fr?: Maybe<PriceInput>;
  ebay_pl?: Maybe<PriceInput>;
  ebay_de?: Maybe<PriceInput>;
  ebay_us?: Maybe<PriceInput>;
  ebay_uk?: Maybe<PriceInput>;
  allegro_cz?: Maybe<PriceInput>;
  allegro_pl?: Maybe<PriceInput>;
  allegro_sk?: Maybe<PriceInput>;
  baskedo_bg?: Maybe<PriceInput>;
  baskedo_hu?: Maybe<PriceInput>;
  bol_nl?: Maybe<PriceInput>;
  expando_shop_ro?: Maybe<PriceInput>;
  limetka_cz?: Maybe<PriceInput>;
  limetka_gr?: Maybe<PriceInput>;
  limetka_sk?: Maybe<PriceInput>;
};

export type Pricing = {
  __typename?: 'Pricing';
  summary?: Maybe<Summary>;
  offer?: Maybe<Offer>;
};

export type PricingInput = {
  summary?: Maybe<SummaryInput>;
  offer?: Maybe<OfferInput>;
};

export type PricingReport = {
  __typename?: 'PricingReport';
  id?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['String']>;
  state?: Maybe<PricingReportState>;
  createdAt?: Maybe<Scalars['Date']>;
  settings?: Maybe<PricingReportSettings>;
  progress?: Maybe<Scalars['Float']>;
  finishedAt?: Maybe<Scalars['Date']>;
  result?: Maybe<PricingReportResultItem>;
};

export type PricingReportResultItem = {
  __typename?: 'PricingReportResultItem';
  reportPath?: Maybe<Scalars['String']>;
  reportLink?: Maybe<Scalars['String']>;
};

export type PricingReportSettings = {
  __typename?: 'PricingReportSettings';
  service?: Maybe<MarketplaceName>;
  version?: Maybe<Scalars['Int']>;
  format?: Maybe<Scalars['String']>;
};

export enum PricingReportState {
  created = 'created',
  processing = 'processing',
  finished = 'finished',
  error = 'error',
  none = 'none'
}

export type PricingSalesRank = {
  __typename?: 'PricingSalesRank';
  categoryId?: Maybe<Scalars['String']>;
  rank?: Maybe<Scalars['Int']>;
};

export type PricingSalesRankInput = {
  categoryId?: Maybe<Scalars['String']>;
  rank?: Maybe<Scalars['Int']>;
};

export type ProductExport = {
  __typename?: 'ProductExport';
  _id: Scalars['String'];
  status: Scalars['String'];
  requestedAt: Scalars['String'];
  doneAt?: Maybe<Scalars['String']>;
  failedAt?: Maybe<Scalars['String']>;
  failReason?: Maybe<Scalars['String']>;
  downloadLink?: Maybe<Scalars['String']>;
};

export type ProductFeedResult = {
  __typename?: 'ProductFeedResult';
  companyId?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  feedType?: Maybe<ProductFeedTypeEnum>;
  feedUrl?: Maybe<Scalars['String']>;
  productsAll?: Maybe<Scalars['Int']>;
  productsInStock?: Maybe<Scalars['Int']>;
  productsToBeListed?: Maybe<Scalars['Int']>;
  productsWithEAN?: Maybe<Scalars['Int']>;
  isConnected: Scalars['Boolean'];
};

export enum ProductFeedTypeEnum {
  GOOGLE_PRODUCT = 'GOOGLE_PRODUCT',
  SHOPIFY = 'SHOPIFY',
  SHOPTET = 'SHOPTET',
  NONE = 'NONE',
  CUSTOM = 'CUSTOM',
  DATABASE = 'DATABASE',
  FEED = 'FEED'
}

export type ProductLookup = {
  __typename?: 'ProductLookup';
  error?: Maybe<Scalars['String']>;
  quotaRemaining?: Maybe<Scalars['Int']>;
  quotaMax?: Maybe<Scalars['Int']>;
  quotaResetIn?: Maybe<Scalars['String']>;
  products?: Maybe<Array<Maybe<ProductLookupItem>>>;
};

export type ProductLookupItem = {
  __typename?: 'ProductLookupItem';
  image?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  asin?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  group?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  currency?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
  categoryId?: Maybe<Scalars['String']>;
  rank?: Maybe<Scalars['String']>;
};

export type ProductStats = {
  __typename?: 'ProductStats';
  companyId?: Maybe<Scalars['String']>;
  marketplaces?: Maybe<Array<Maybe<MarketplaceName>>>;
  ok?: Maybe<Scalars['Int']>;
  paused?: Maybe<Scalars['Int']>;
  notFound?: Maybe<Scalars['Int']>;
  error?: Maybe<Scalars['Int']>;
  missingBarcode?: Maybe<Scalars['Int']>;
  buyBox?: Maybe<BuyBoxStats>;
};

export type ProductStatus = {
  __typename?: 'ProductStatus';
  companyId?: Maybe<Scalars['String']>;
  marketplace?: Maybe<MarketplaceName>;
  sku?: Maybe<Scalars['String']>;
  hasAsin?: Maybe<Scalars['Boolean']>;
  hasStock?: Maybe<Scalars['Boolean']>;
  hasValidBarcode?: Maybe<Scalars['Boolean']>;
  isBuyBoxWinner?: Maybe<Scalars['Boolean']>;
  listingStatus?: Maybe<ListingStatus>;
  listingErrors?: Maybe<Array<Maybe<ListingError>>>;
  status?: Maybe<Status>;
  forbidListing?: Maybe<Scalars['Boolean']>;
};

export type ProductStatusInput = {
  companyId?: Maybe<Scalars['String']>;
  marketplace?: Maybe<MarketplaceName>;
  sku?: Maybe<Scalars['String']>;
  hasAsin?: Maybe<Scalars['Boolean']>;
  hasStock?: Maybe<Scalars['Boolean']>;
  hasValidBarcode?: Maybe<Scalars['Boolean']>;
  isBuyBoxWinner?: Maybe<Scalars['Boolean']>;
  listingStatus?: Maybe<ListingStatus>;
  listingErrors?: Maybe<Array<Maybe<ListingErrorInput>>>;
  status?: Maybe<Status>;
  forbidListing?: Maybe<Scalars['Boolean']>;
};

export type ProductSync = {
  __typename?: 'ProductSync';
  _id?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['String']>;
  interval?: Maybe<Scalars['Int']>;
  startedOn?: Maybe<Scalars['Date']>;
  finishedOn?: Maybe<Scalars['Date']>;
  isSyncing?: Maybe<Scalars['Boolean']>;
  feedDownloadStartedOn?: Maybe<Scalars['Date']>;
  feedDownloadFinishedOn?: Maybe<Scalars['Date']>;
  isFeedSyncing?: Maybe<Scalars['Boolean']>;
  isFeedSyncIncoming?: Maybe<Scalars['Boolean']>;
  nextSyncOn?: Maybe<Scalars['Date']>;
};

export type ProductVariant = {
  __typename?: 'ProductVariant';
  _id?: Maybe<Scalars['MongoID']>;
  companyId?: Maybe<Scalars['String']>;
  sku?: Maybe<Scalars['String']>;
  barcode?: Maybe<Barcode>;
  image?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  stock?: Maybe<Scalars['Int']>;
  prices?: Maybe<Prices>;
  removedAt?: Maybe<Scalars['Date']>;
  asins?: Maybe<Asins>;
  shippingTemplate?: Maybe<Scalars['String']>;
  locks?: Maybe<Array<Maybe<Scalars['String']>>>;
  parent?: Maybe<Scalars['String']>;
  ecoFee?: Maybe<Scalars['Float']>;
  marketplaceSkus?: Maybe<MarketplaceSkus>;
  vatRate?: Maybe<Scalars['Float']>;
  itemCondition?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  pricing?: Maybe<Pricing>;
  productStatus?: Maybe<Array<Maybe<ProductStatus>>>;
  autopricing?: Maybe<Autopricing>;
};

export type ProductVariantInput = {
  _id?: Maybe<Scalars['MongoID']>;
  companyId?: Maybe<Scalars['String']>;
  sku?: Maybe<Scalars['String']>;
  barcode?: Maybe<BarcodeInput>;
  image?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  stock?: Maybe<Scalars['Int']>;
  prices?: Maybe<PricesInput>;
  removedAt?: Maybe<Scalars['Date']>;
  asins?: Maybe<AsinsInput>;
  shippingTemplate?: Maybe<Scalars['String']>;
  locks?: Maybe<Array<Maybe<Scalars['String']>>>;
  parent?: Maybe<Scalars['String']>;
  ecoFee?: Maybe<Scalars['Float']>;
  marketplaceSkus?: Maybe<MarketplaceSkusInput>;
  vatRate?: Maybe<Scalars['Float']>;
  itemCondition?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  pricing?: Maybe<PricingInput>;
  productStatus?: Maybe<Array<Maybe<ProductStatusInput>>>;
  autopricing?: Maybe<AutopricingInput>;
  forbidListings?: Maybe<ForbidListingsInput>;
};

/** List of items with pagination. */
export type ProductVariantPagination = {
  __typename?: 'ProductVariantPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<ProductVariant>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type ProductsSortInput = {
  _id?: Maybe<Sort>;
  stock?: Maybe<Sort>;
  prices?: Maybe<Sort>;
};

export type Query = {
  __typename?: 'Query';
  productExport?: Maybe<ProductExport>;
  productExports?: Maybe<Array<Maybe<ProductExport>>>;
  productFeedResult?: Maybe<ProductFeedResult>;
  user?: Maybe<UserQuery>;
  products?: Maybe<ProductVariantPagination>;
  productLookup?: Maybe<ProductLookup>;
  marketplaces?: Maybe<Array<Maybe<MarketplaceStatus>>>;
  company?: Maybe<CompanyQuery>;
  userStats?: Maybe<Array<Maybe<UserRow>>>;
  productSync?: Maybe<ProductSync>;
  productStats?: Maybe<ProductStats>;
  syncSettings?: Maybe<SyncSettings>;
  pickupLists?: Maybe<Array<Maybe<PickupList>>>;
  pickupListsAggregation?: Maybe<Array<Maybe<PickupListsAggregation>>>;
  importSettings?: Maybe<Array<Maybe<ImportSettings>>>;
  getGoogleDataStudioUrl?: Maybe<googleDataStudioUrl>;
  getInternalCompanyName?: Maybe<internalCompanyName>;
  getReturnAddress?: Maybe<CompanyReturnAddressDoc>;
  orders?: Maybe<OrderPagination>;
  ordersByIds?: Maybe<Array<Maybe<Order>>>;
  autopricingStatistics?: Maybe<AutopricingStatistics>;
  unshippedOrdersCount: Scalars['Int'];
  shippedOrdersCount: Scalars['Int'];
  lateOrdersCount: Scalars['Int'];
  orderStatistics?: Maybe<Array<Maybe<OrderStatistics>>>;
  orderStatisticsPerMarketplace?: Maybe<Array<Maybe<OrderstatisticsPerMarketplace>>>;
  orderStatisticsPerCountry?: Maybe<Array<Maybe<OrderStatisticsPerCountry>>>;
  fulfillment?: Maybe<Fulfillment>;
  apiToken?: Maybe<ApiToken>;
  alzaCredentials?: Maybe<AlzaCredentials>;
  mallCredentials?: Maybe<MallCredentials>;
  credentials?: Maybe<Scalars['JSON']>;
  platformStatuses?: Maybe<PlatformStatuses>;
  emailNotificationSettings?: Maybe<EmailNotificationSettings>;
  shoptetPaymentMethods?: Maybe<Array<Maybe<ShoptetPaymentMethod>>>;
  glamiDeliveryMethods?: Maybe<Array<Maybe<GlamiDeliveryMethod>>>;
  customProductFeed?: Maybe<CustomProductFeed>;
  pdf?: Maybe<Pdfs>;
  featureToggle?: Maybe<FeatureToggle>;
  featureToggleList?: Maybe<FeatureToggleList>;
  shopInfo?: Maybe<ShopInfo>;
  getAutopricingReport?: Maybe<AutopricingReport>;
  getPricingReport?: Maybe<PricingReport>;
  getFeedConvertReport?: Maybe<FeedConvertReport>;
  getFeatureToggle?: Maybe<FeatureToggleResult>;
  getFeatureToggleAsAdmin?: Maybe<FeatureToggleResult>;
  getShipmentInfo?: Maybe<ShipmentInfoResult>;
  getItemConditionList?: Maybe<Array<Maybe<ItemCondition>>>;
  alzaCarrierName?: Maybe<AlzaCarrierName>;
  amazonCarrierName?: Maybe<AmazonCarrierName>;
  cdiscountCarrierName?: Maybe<CdiscountCarrierName>;
  bolCarrierName?: Maybe<BolCarrierName>;
  carrierName?: Maybe<CarrierName>;
  advancedSearchableFields?: Maybe<AdvancedSearchableFields>;
  rangedOrdersStatistics?: Maybe<RangedOrderStatistics>;
  usersPagination?: Maybe<UserQueryPagination>;
  shoptetShipmentMethods?: Maybe<Array<Maybe<ShoptetShipmentMethod>>>;
  shoptetOrderStatuses?: Maybe<Array<Maybe<ShoptetOrderStatus>>>;
  mallDeliveryMethods?: Maybe<Array<Maybe<MallDeliveryMethod>>>;
  errorCompaniesCount?: Maybe<Scalars['Int']>;
  companyError?: Maybe<Array<Maybe<CompanyError>>>;
};


export type QueryproductExportArgs = {
  exportId: Scalars['String'];
};


export type QueryproductsArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  filter?: Maybe<FilterInputProducts>;
  sort?: Maybe<Array<Maybe<ProductsSortInput>>>;
};


export type QueryproductLookupArgs = {
  query?: Maybe<Scalars['String']>;
  marketplace?: Maybe<Scalars['String']>;
};


export type QueryproductStatsArgs = {
  marketplace?: Maybe<Scalars['String']>;
  hasStockFilter?: Maybe<Scalars['Boolean']>;
};


export type QuerygetGoogleDataStudioUrlArgs = {
  companyId?: Maybe<Scalars['String']>;
};


export type QuerygetInternalCompanyNameArgs = {
  companyId?: Maybe<Scalars['String']>;
};


export type QuerygetReturnAddressArgs = {
  companyId?: Maybe<Scalars['String']>;
};


export type QueryordersArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  filter?: Maybe<FilterOrdersInput>;
  sort?: Maybe<Array<Maybe<OrdersSortInput>>>;
};


export type QueryordersByIdsArgs = {
  marketplaceOrderIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryautopricingStatisticsArgs = {
  since?: Maybe<Scalars['Date']>;
};


export type QueryshippedOrdersCountArgs = {
  since?: Maybe<Scalars['Date']>;
};


export type QueryorderStatisticsArgs = {
  filter?: Maybe<FilterInputStatistics>;
};


export type QueryorderStatisticsPerMarketplaceArgs = {
  filter?: Maybe<FilterInputStatistics>;
};


export type QueryorderStatisticsPerCountryArgs = {
  filter?: Maybe<FilterInputStatistics>;
};


export type QueryfulfillmentArgs = {
  marketplace: MarketplaceName;
  marketplaceOrderId: Scalars['String'];
};


export type QuerymallCredentialsArgs = {
  marketplace?: Maybe<MallMarketplace>;
};


export type QuerycredentialsArgs = {
  serviceScope?: Maybe<MarketplaceRegion>;
};


export type QueryemailNotificationSettingsArgs = {
  platform?: Maybe<Scalars['String']>;
};


export type QuerypdfArgs = {
  id: Scalars['String'];
};


export type QueryfeatureToggleArgs = {
  name: EFeatureName;
};


export type QuerygetPricingReportArgs = {
  id?: Maybe<Scalars['String']>;
};


export type QuerygetFeedConvertReportArgs = {
  id?: Maybe<Scalars['String']>;
};


export type QuerygetFeatureToggleArgs = {
  featureName?: Maybe<Scalars['String']>;
};


export type QuerygetFeatureToggleAsAdminArgs = {
  companyId?: Maybe<Scalars['String']>;
  featureName?: Maybe<Scalars['String']>;
};


export type QuerygetShipmentInfoArgs = {
  shipmentNumbers?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QuerygetItemConditionListArgs = {
  service: Scalars['String'];
};


export type QueryrangedOrdersStatisticsArgs = {
  timeRange: OrderStatisticsTimeRange;
};


export type QueryusersPaginationArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  filter?: Maybe<UserSearchFilter>;
};

export type RangedOrderStatistics = {
  __typename?: 'RangedOrderStatistics';
  count: Scalars['Int'];
  money?: Maybe<Money>;
};

export type ResetPasswordResult = {
  __typename?: 'ResetPasswordResult';
  success: Scalars['Boolean'];
  invalidCode?: Maybe<Scalars['Boolean']>;
  codeAlreadyUsed?: Maybe<Scalars['Boolean']>;
  codeExpired?: Maybe<Scalars['Boolean']>;
};

export type ShipmentDeparture = {
  __typename?: 'ShipmentDeparture';
  response: Scalars['String'];
};

export type ShipmentInfoItem = {
  __typename?: 'ShipmentInfoItem';
  shipmentNumber?: Maybe<Scalars['String']>;
  externalShipmentNumber?: Maybe<Scalars['String']>;
  shipmentStateName?: Maybe<Scalars['String']>;
  shipmentStateDate?: Maybe<Scalars['Date']>;
};

export type ShipmentInfoResult = {
  __typename?: 'ShipmentInfoResult';
  shipments?: Maybe<Array<Maybe<ShipmentInfoItem>>>;
};

export type ShippingTime = {
  __typename?: 'ShippingTime';
  minimumHours?: Maybe<Scalars['Float']>;
  maximumHours?: Maybe<Scalars['Float']>;
};

export type ShippingTimeInput = {
  minimumHours?: Maybe<Scalars['Float']>;
  maximumHours?: Maybe<Scalars['Float']>;
};

export type ShopInfo = {
  __typename?: 'ShopInfo';
  addons?: Maybe<Addons>;
  shopId: Scalars['Int'];
  hostname: Scalars['String'];
  currencies?: Maybe<Array<Scalars['String']>>;
  endpoints?: Maybe<AddonsEndpoints>;
};

export type ShoptetOrderStatus = {
  __typename?: 'ShoptetOrderStatus';
  code: Scalars['Int'];
  name: Scalars['String'];
};

export type ShoptetPaymentMethod = {
  __typename?: 'ShoptetPaymentMethod';
  guid?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type ShoptetShipmentMethod = {
  __typename?: 'ShoptetShipmentMethod';
  guid: Scalars['String'];
  name: Scalars['String'];
};

export enum Sort {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type StartShoptetLoginResult = {
  __typename?: 'StartShoptetLoginResult';
  authUrl?: Maybe<Scalars['String']>;
  shopNotFound: Scalars['Boolean'];
};

export enum Status {
  ok = 'ok',
  paused = 'paused',
  notFound = 'notFound',
  error = 'error',
  missingBarcode = 'missingBarcode'
}

export type SubscriptionSchema = {
  __typename?: 'SubscriptionSchema';
  companyId?: Maybe<Scalars['MongoID']>;
  name?: Maybe<EnumSubscriptionSchemaName>;
  isActive?: Maybe<Scalars['Boolean']>;
  amount?: Maybe<Scalars['Float']>;
  currency?: Maybe<Scalars['String']>;
  from?: Maybe<Scalars['Date']>;
  to?: Maybe<Scalars['Date']>;
  note?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  _id?: Maybe<Scalars['MongoID']>;
};

export type SubscriptionSchemaInput = {
  companyId?: Maybe<Scalars['MongoID']>;
  isActive?: Maybe<Scalars['Boolean']>;
  amount?: Maybe<Scalars['Float']>;
  currency?: Maybe<Scalars['String']>;
  from?: Maybe<Scalars['Date']>;
  _id?: Maybe<Scalars['MongoID']>;
};

export type SuccessMessage = {
  __typename?: 'SuccessMessage';
  success: Scalars['Boolean'];
  message?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
};

export type Summary = {
  __typename?: 'Summary';
  lowest?: Maybe<ChannelLowestPriceInfo>;
  highest?: Maybe<ChannelHighestPriceInfo>;
  buyBox?: Maybe<BuyBoxPriceInfo>;
  totalOffers?: Maybe<Scalars['Float']>;
};

export type SummaryInput = {
  lowest?: Maybe<ChannelLowestPriceInfoInput>;
  highest?: Maybe<ChannelHighestPriceInfoInput>;
  buyBox?: Maybe<BuyBoxPriceInfoInput>;
  totalOffers?: Maybe<Scalars['Float']>;
};

export type SuperloginResult = {
  __typename?: 'SuperloginResult';
  success: Scalars['Boolean'];
};

export type Sync = JobInterface & {
  __typename?: 'Sync';
  company?: Maybe<CompanyQuery>;
  job?: Maybe<Job>;
};

export type SyncSettings = {
  __typename?: 'SyncSettings';
  formulas?: Maybe<SyncSettingsFormulas>;
  autopricing?: Maybe<SyncSettingsAutopricing>;
  fulfillment?: Maybe<SyncSettingsFulfillment>;
  returnLabels?: Maybe<SyncSettingsReturnLabels>;
  japoId?: Maybe<Scalars['String']>;
  vatRates?: Maybe<SyncSettingsVatRates>;
  packetaApiPassword?: Maybe<Scalars['String']>;
  mall?: Maybe<SyncSettingsMall>;
  amazon?: Maybe<SyncSettingsAmazon>;
  emag?: Maybe<SyncSettingsEmag>;
  cdiscount?: Maybe<SyncSettingsCdiscount>;
  bol?: Maybe<SyncSettingsBol>;
  allegro?: Maybe<SyncSettingsAllegro>;
  real?: Maybe<SyncSettingsReal>;
  kaufland_de?: Maybe<SyncSettingsKaufland_de>;
  kaufland_cz?: Maybe<SyncSettingsKaufland_cz>;
  kaufland_sk?: Maybe<SyncSettingsKaufland_sk>;
  kaufland_at?: Maybe<SyncSettingsKaufland_at>;
  kaufland_pl?: Maybe<SyncSettingsKaufland_pl>;
  kaufland_nl?: Maybe<SyncSettingsKaufland_nl>;
  kaufland_es?: Maybe<SyncSettingsKaufland_es>;
  kaufland_fr?: Maybe<SyncSettingsKaufland_fr>;
  kaufland_it?: Maybe<SyncSettingsKaufland_it>;
  aftership?: Maybe<SyncSettingsAftership>;
  _id?: Maybe<Scalars['MongoID']>;
};

export type SyncSettingsAftership = {
  __typename?: 'SyncSettingsAftership';
  active?: Maybe<Scalars['Boolean']>;
};

export type SyncSettingsAftershipInput = {
  active?: Maybe<Scalars['Boolean']>;
};

export type SyncSettingsAllegro = {
  __typename?: 'SyncSettingsAllegro';
  synchronizePrices?: Maybe<Scalars['Boolean']>;
  synchronizeStock?: Maybe<Scalars['Boolean']>;
  matchNewProducts?: Maybe<Scalars['Boolean']>;
};

export type SyncSettingsAllegroInput = {
  synchronizePrices?: Maybe<Scalars['Boolean']>;
  synchronizeStock?: Maybe<Scalars['Boolean']>;
  matchNewProducts?: Maybe<Scalars['Boolean']>;
};

export type SyncSettingsAmazon = {
  __typename?: 'SyncSettingsAmazon';
  synchronizePrices?: Maybe<Scalars['Boolean']>;
  synchronizeStock?: Maybe<Scalars['Boolean']>;
  synchronizeHandlingTime?: Maybe<Scalars['Boolean']>;
  listNewProducts?: Maybe<Scalars['Boolean']>;
  downloadPricing?: Maybe<Scalars['Boolean']>;
  zeroUnmatchedProducts?: Maybe<Scalars['Boolean']>;
  ignoreZeroStockProducts?: Maybe<Scalars['Boolean']>;
  defaultHandlingTime?: Maybe<Scalars['Float']>;
  automaticallyCancelRequest?: Maybe<Scalars['Boolean']>;
};

export type SyncSettingsAmazonInput = {
  synchronizePrices?: Maybe<Scalars['Boolean']>;
  synchronizeStock?: Maybe<Scalars['Boolean']>;
  synchronizeHandlingTime?: Maybe<Scalars['Boolean']>;
  listNewProducts?: Maybe<Scalars['Boolean']>;
  downloadPricing?: Maybe<Scalars['Boolean']>;
  zeroUnmatchedProducts?: Maybe<Scalars['Boolean']>;
  ignoreZeroStockProducts?: Maybe<Scalars['Boolean']>;
  defaultHandlingTime?: Maybe<Scalars['Float']>;
  automaticallyCancelRequest?: Maybe<Scalars['Boolean']>;
};

export type SyncSettingsAutopricing = {
  __typename?: 'SyncSettingsAutopricing';
  amazon_mx?: Maybe<SyncSettingsAutopricingAmazon_mx>;
  amazon_us?: Maybe<SyncSettingsAutopricingAmazon_mx>;
  amazon_ca?: Maybe<SyncSettingsAutopricingAmazon_mx>;
  amazon_br?: Maybe<SyncSettingsAutopricingAmazon_mx>;
  amazon_de?: Maybe<SyncSettingsAutopricingAmazon_mx>;
  amazon_uk?: Maybe<SyncSettingsAutopricingAmazon_mx>;
  amazon_fr?: Maybe<SyncSettingsAutopricingAmazon_mx>;
  amazon_it?: Maybe<SyncSettingsAutopricingAmazon_mx>;
  amazon_es?: Maybe<SyncSettingsAutopricingAmazon_mx>;
  amazon_nl?: Maybe<SyncSettingsAutopricingAmazon_mx>;
  amazon_se?: Maybe<SyncSettingsAutopricingAmazon_mx>;
  amazon_tr?: Maybe<SyncSettingsAutopricingAmazon_mx>;
  amazon_pl?: Maybe<SyncSettingsAutopricingAmazon_mx>;
  amazon_be?: Maybe<SyncSettingsAutopricingAmazon_mx>;
  amazon_ie?: Maybe<SyncSettingsAutopricingAmazon_mx>;
  amazon_sg?: Maybe<SyncSettingsAutopricingAmazon_mx>;
  amazon_au?: Maybe<SyncSettingsAutopricingAmazon_mx>;
  amazon_jp?: Maybe<SyncSettingsAutopricingAmazon_mx>;
  kaufland_de?: Maybe<SyncSettingsAutopricingAmazon_mx>;
  kaufland_cz?: Maybe<SyncSettingsAutopricingAmazon_mx>;
  kaufland_sk?: Maybe<SyncSettingsAutopricingAmazon_mx>;
  kaufland_at?: Maybe<SyncSettingsAutopricingAmazon_mx>;
  kaufland_pl?: Maybe<SyncSettingsAutopricingAmazon_mx>;
  kaufland_nl?: Maybe<SyncSettingsAutopricingAmazon_mx>;
  kaufland_es?: Maybe<SyncSettingsAutopricingAmazon_mx>;
  kaufland_fr?: Maybe<SyncSettingsAutopricingAmazon_mx>;
  kaufland_it?: Maybe<SyncSettingsAutopricingAmazon_mx>;
  cdiscount_fr?: Maybe<SyncSettingsAutopricingAmazon_mx>;
};

export type SyncSettingsAutopricingAmazon_mx = {
  __typename?: 'SyncSettingsAutopricingAmazon_mx';
  active?: Maybe<Scalars['Boolean']>;
  autoActivation?: Maybe<Scalars['Boolean']>;
  progressStrategy?: Maybe<Scalars['Float']>;
  fallbackStrategy?: Maybe<Scalars['Float']>;
  penaltyDrain?: Maybe<Scalars['Float']>;
  amplification?: Maybe<Scalars['Float']>;
  countInShipping?: Maybe<Scalars['Boolean']>;
  defaultTopCap?: Maybe<Scalars['Float']>;
  defaultBottomCap?: Maybe<Scalars['Float']>;
};

export type SyncSettingsAutopricingAmazon_mxInput = {
  active?: Maybe<Scalars['Boolean']>;
  autoActivation?: Maybe<Scalars['Boolean']>;
  progressStrategy?: Maybe<Scalars['Float']>;
  fallbackStrategy?: Maybe<Scalars['Float']>;
  penaltyDrain?: Maybe<Scalars['Float']>;
  amplification?: Maybe<Scalars['Float']>;
  countInShipping?: Maybe<Scalars['Boolean']>;
  defaultTopCap?: Maybe<Scalars['Float']>;
  defaultBottomCap?: Maybe<Scalars['Float']>;
};

export type SyncSettingsAutopricingInput = {
  amazon_mx?: Maybe<SyncSettingsAutopricingAmazon_mxInput>;
  amazon_us?: Maybe<SyncSettingsAutopricingAmazon_mxInput>;
  amazon_ca?: Maybe<SyncSettingsAutopricingAmazon_mxInput>;
  amazon_br?: Maybe<SyncSettingsAutopricingAmazon_mxInput>;
  amazon_de?: Maybe<SyncSettingsAutopricingAmazon_mxInput>;
  amazon_uk?: Maybe<SyncSettingsAutopricingAmazon_mxInput>;
  amazon_fr?: Maybe<SyncSettingsAutopricingAmazon_mxInput>;
  amazon_it?: Maybe<SyncSettingsAutopricingAmazon_mxInput>;
  amazon_es?: Maybe<SyncSettingsAutopricingAmazon_mxInput>;
  amazon_nl?: Maybe<SyncSettingsAutopricingAmazon_mxInput>;
  amazon_se?: Maybe<SyncSettingsAutopricingAmazon_mxInput>;
  amazon_tr?: Maybe<SyncSettingsAutopricingAmazon_mxInput>;
  amazon_pl?: Maybe<SyncSettingsAutopricingAmazon_mxInput>;
  amazon_be?: Maybe<SyncSettingsAutopricingAmazon_mxInput>;
  amazon_ie?: Maybe<SyncSettingsAutopricingAmazon_mxInput>;
  amazon_sg?: Maybe<SyncSettingsAutopricingAmazon_mxInput>;
  amazon_au?: Maybe<SyncSettingsAutopricingAmazon_mxInput>;
  amazon_jp?: Maybe<SyncSettingsAutopricingAmazon_mxInput>;
  kaufland_de?: Maybe<SyncSettingsAutopricingAmazon_mxInput>;
  kaufland_cz?: Maybe<SyncSettingsAutopricingAmazon_mxInput>;
  kaufland_sk?: Maybe<SyncSettingsAutopricingAmazon_mxInput>;
  kaufland_at?: Maybe<SyncSettingsAutopricingAmazon_mxInput>;
  kaufland_pl?: Maybe<SyncSettingsAutopricingAmazon_mxInput>;
  kaufland_nl?: Maybe<SyncSettingsAutopricingAmazon_mxInput>;
  kaufland_es?: Maybe<SyncSettingsAutopricingAmazon_mxInput>;
  kaufland_fr?: Maybe<SyncSettingsAutopricingAmazon_mxInput>;
  kaufland_it?: Maybe<SyncSettingsAutopricingAmazon_mxInput>;
  cdiscount_fr?: Maybe<SyncSettingsAutopricingAmazon_mxInput>;
};

export type SyncSettingsBol = {
  __typename?: 'SyncSettingsBol';
  synchronizePrices?: Maybe<Scalars['Boolean']>;
  synchronizeStock?: Maybe<Scalars['Boolean']>;
  matchNewProducts?: Maybe<Scalars['Boolean']>;
};

export type SyncSettingsBolInput = {
  synchronizePrices?: Maybe<Scalars['Boolean']>;
  synchronizeStock?: Maybe<Scalars['Boolean']>;
  matchNewProducts?: Maybe<Scalars['Boolean']>;
};

export type SyncSettingsCdiscount = {
  __typename?: 'SyncSettingsCdiscount';
  synchronizePrices?: Maybe<Scalars['Boolean']>;
  synchronizeStock?: Maybe<Scalars['Boolean']>;
  matchNewProducts?: Maybe<Scalars['Boolean']>;
};

export type SyncSettingsCdiscountInput = {
  synchronizePrices?: Maybe<Scalars['Boolean']>;
  synchronizeStock?: Maybe<Scalars['Boolean']>;
  matchNewProducts?: Maybe<Scalars['Boolean']>;
};

export type SyncSettingsEmag = {
  __typename?: 'SyncSettingsEmag';
  listNewProducts?: Maybe<Scalars['Boolean']>;
  ignoreZeroStockProducts?: Maybe<Scalars['Boolean']>;
};

export type SyncSettingsEmagInput = {
  listNewProducts?: Maybe<Scalars['Boolean']>;
  ignoreZeroStockProducts?: Maybe<Scalars['Boolean']>;
};

export type SyncSettingsFormulas = {
  __typename?: 'SyncSettingsFormulas';
  alza_cz?: Maybe<Formula>;
  amazon_mx?: Maybe<Formula>;
  amazon_us?: Maybe<Formula>;
  amazon_ca?: Maybe<Formula>;
  amazon_br?: Maybe<Formula>;
  amazon_de?: Maybe<Formula>;
  amazon_uk?: Maybe<Formula>;
  amazon_fr?: Maybe<Formula>;
  amazon_it?: Maybe<Formula>;
  amazon_es?: Maybe<Formula>;
  amazon_nl?: Maybe<Formula>;
  amazon_se?: Maybe<Formula>;
  amazon_tr?: Maybe<Formula>;
  amazon_pl?: Maybe<Formula>;
  amazon_be?: Maybe<Formula>;
  amazon_ie?: Maybe<Formula>;
  amazon_sg?: Maybe<Formula>;
  amazon_au?: Maybe<Formula>;
  amazon_jp?: Maybe<Formula>;
  emag_bg?: Maybe<Formula>;
  emag_hu?: Maybe<Formula>;
  emag_pl?: Maybe<Formula>;
  emag_ro?: Maybe<Formula>;
  mall_cz?: Maybe<Formula>;
  mall_hu?: Maybe<Formula>;
  mall_pl?: Maybe<Formula>;
  mall_si?: Maybe<Formula>;
  mall_sk?: Maybe<Formula>;
  real_de?: Maybe<Formula>;
  kaufland_de?: Maybe<Formula>;
  kaufland_cz?: Maybe<Formula>;
  kaufland_sk?: Maybe<Formula>;
  kaufland_at?: Maybe<Formula>;
  kaufland_pl?: Maybe<Formula>;
  kaufland_nl?: Maybe<Formula>;
  kaufland_es?: Maybe<Formula>;
  kaufland_fr?: Maybe<Formula>;
  kaufland_it?: Maybe<Formula>;
  glami_cz?: Maybe<Formula>;
  cdiscount_fr?: Maybe<Formula>;
  ebay_at?: Maybe<Formula>;
  ebay_cz?: Maybe<Formula>;
  ebay_fr?: Maybe<Formula>;
  ebay_pl?: Maybe<Formula>;
  ebay_de?: Maybe<Formula>;
  ebay_us?: Maybe<Formula>;
  ebay_uk?: Maybe<Formula>;
  allegro_cz?: Maybe<Formula>;
  allegro_pl?: Maybe<Formula>;
  allegro_sk?: Maybe<Formula>;
  baskedo_bg?: Maybe<Formula>;
  baskedo_hu?: Maybe<Formula>;
  bol_nl?: Maybe<Formula>;
  expando_shop_ro?: Maybe<Formula>;
  limetka_cz?: Maybe<Formula>;
  limetka_gr?: Maybe<Formula>;
  limetka_sk?: Maybe<Formula>;
};

export type SyncSettingsFormulasInput = {
  alza_cz?: Maybe<FormulaInput>;
  amazon_mx?: Maybe<FormulaInput>;
  amazon_us?: Maybe<FormulaInput>;
  amazon_ca?: Maybe<FormulaInput>;
  amazon_br?: Maybe<FormulaInput>;
  amazon_de?: Maybe<FormulaInput>;
  amazon_uk?: Maybe<FormulaInput>;
  amazon_fr?: Maybe<FormulaInput>;
  amazon_it?: Maybe<FormulaInput>;
  amazon_es?: Maybe<FormulaInput>;
  amazon_nl?: Maybe<FormulaInput>;
  amazon_se?: Maybe<FormulaInput>;
  amazon_tr?: Maybe<FormulaInput>;
  amazon_pl?: Maybe<FormulaInput>;
  amazon_be?: Maybe<FormulaInput>;
  amazon_ie?: Maybe<FormulaInput>;
  amazon_sg?: Maybe<FormulaInput>;
  amazon_au?: Maybe<FormulaInput>;
  amazon_jp?: Maybe<FormulaInput>;
  emag_bg?: Maybe<FormulaInput>;
  emag_hu?: Maybe<FormulaInput>;
  emag_pl?: Maybe<FormulaInput>;
  emag_ro?: Maybe<FormulaInput>;
  mall_cz?: Maybe<FormulaInput>;
  mall_hu?: Maybe<FormulaInput>;
  mall_pl?: Maybe<FormulaInput>;
  mall_si?: Maybe<FormulaInput>;
  mall_sk?: Maybe<FormulaInput>;
  real_de?: Maybe<FormulaInput>;
  kaufland_de?: Maybe<FormulaInput>;
  kaufland_cz?: Maybe<FormulaInput>;
  kaufland_sk?: Maybe<FormulaInput>;
  kaufland_at?: Maybe<FormulaInput>;
  kaufland_pl?: Maybe<FormulaInput>;
  kaufland_nl?: Maybe<FormulaInput>;
  kaufland_es?: Maybe<FormulaInput>;
  kaufland_fr?: Maybe<FormulaInput>;
  kaufland_it?: Maybe<FormulaInput>;
  glami_cz?: Maybe<FormulaInput>;
  cdiscount_fr?: Maybe<FormulaInput>;
  ebay_at?: Maybe<FormulaInput>;
  ebay_cz?: Maybe<FormulaInput>;
  ebay_fr?: Maybe<FormulaInput>;
  ebay_pl?: Maybe<FormulaInput>;
  ebay_de?: Maybe<FormulaInput>;
  ebay_us?: Maybe<FormulaInput>;
  ebay_uk?: Maybe<FormulaInput>;
  allegro_cz?: Maybe<FormulaInput>;
  allegro_pl?: Maybe<FormulaInput>;
  allegro_sk?: Maybe<FormulaInput>;
  baskedo_bg?: Maybe<FormulaInput>;
  baskedo_hu?: Maybe<FormulaInput>;
  bol_nl?: Maybe<FormulaInput>;
  expando_shop_ro?: Maybe<FormulaInput>;
  limetka_cz?: Maybe<FormulaInput>;
  limetka_gr?: Maybe<FormulaInput>;
  limetka_sk?: Maybe<FormulaInput>;
};

export type SyncSettingsFulfillment = {
  __typename?: 'SyncSettingsFulfillment';
  automapCarrier?: Maybe<Scalars['Boolean']>;
};

export type SyncSettingsFulfillmentInput = {
  automapCarrier?: Maybe<Scalars['Boolean']>;
};

export type SyncSettingsInput = {
  formulas?: Maybe<SyncSettingsFormulasInput>;
  autopricing?: Maybe<SyncSettingsAutopricingInput>;
  fulfillment?: Maybe<SyncSettingsFulfillmentInput>;
  returnLabels?: Maybe<SyncSettingsReturnLabelsInput>;
  japoId?: Maybe<Scalars['String']>;
  vatRates?: Maybe<SyncSettingsVatRatesInput>;
  packetaApiPassword?: Maybe<Scalars['String']>;
  mall?: Maybe<SyncSettingsMallInput>;
  amazon?: Maybe<SyncSettingsAmazonInput>;
  emag?: Maybe<SyncSettingsEmagInput>;
  cdiscount?: Maybe<SyncSettingsCdiscountInput>;
  bol?: Maybe<SyncSettingsBolInput>;
  allegro?: Maybe<SyncSettingsAllegroInput>;
  real?: Maybe<SyncSettingsRealInput>;
  kaufland_de?: Maybe<SyncSettingsKaufland_deInput>;
  kaufland_cz?: Maybe<SyncSettingsKaufland_czInput>;
  kaufland_sk?: Maybe<SyncSettingsKaufland_skInput>;
  kaufland_at?: Maybe<SyncSettingsKaufland_atInput>;
  kaufland_pl?: Maybe<SyncSettingsKaufland_plInput>;
  kaufland_nl?: Maybe<SyncSettingsKaufland_nlInput>;
  kaufland_es?: Maybe<SyncSettingsKaufland_esInput>;
  kaufland_fr?: Maybe<SyncSettingsKaufland_frInput>;
  kaufland_it?: Maybe<SyncSettingsKaufland_itInput>;
  aftership?: Maybe<SyncSettingsAftershipInput>;
};

export type SyncSettingsKaufland_at = {
  __typename?: 'SyncSettingsKaufland_at';
  synchronizePrices?: Maybe<Scalars['Boolean']>;
  synchronizeStock?: Maybe<Scalars['Boolean']>;
  matchNewProducts?: Maybe<Scalars['Boolean']>;
  downloadNewOrders?: Maybe<Scalars['Boolean']>;
  downloadOrderUnitStatusChange?: Maybe<Scalars['Boolean']>;
};

export type SyncSettingsKaufland_atInput = {
  synchronizePrices?: Maybe<Scalars['Boolean']>;
  synchronizeStock?: Maybe<Scalars['Boolean']>;
  matchNewProducts?: Maybe<Scalars['Boolean']>;
  downloadNewOrders?: Maybe<Scalars['Boolean']>;
  downloadOrderUnitStatusChange?: Maybe<Scalars['Boolean']>;
};

export type SyncSettingsKaufland_cz = {
  __typename?: 'SyncSettingsKaufland_cz';
  synchronizePrices?: Maybe<Scalars['Boolean']>;
  synchronizeStock?: Maybe<Scalars['Boolean']>;
  matchNewProducts?: Maybe<Scalars['Boolean']>;
  downloadNewOrders?: Maybe<Scalars['Boolean']>;
  downloadOrderUnitStatusChange?: Maybe<Scalars['Boolean']>;
};

export type SyncSettingsKaufland_czInput = {
  synchronizePrices?: Maybe<Scalars['Boolean']>;
  synchronizeStock?: Maybe<Scalars['Boolean']>;
  matchNewProducts?: Maybe<Scalars['Boolean']>;
  downloadNewOrders?: Maybe<Scalars['Boolean']>;
  downloadOrderUnitStatusChange?: Maybe<Scalars['Boolean']>;
};

export type SyncSettingsKaufland_de = {
  __typename?: 'SyncSettingsKaufland_de';
  synchronizePrices?: Maybe<Scalars['Boolean']>;
  synchronizeStock?: Maybe<Scalars['Boolean']>;
  matchNewProducts?: Maybe<Scalars['Boolean']>;
  downloadNewOrders?: Maybe<Scalars['Boolean']>;
  downloadOrderUnitStatusChange?: Maybe<Scalars['Boolean']>;
};

export type SyncSettingsKaufland_deInput = {
  synchronizePrices?: Maybe<Scalars['Boolean']>;
  synchronizeStock?: Maybe<Scalars['Boolean']>;
  matchNewProducts?: Maybe<Scalars['Boolean']>;
  downloadNewOrders?: Maybe<Scalars['Boolean']>;
  downloadOrderUnitStatusChange?: Maybe<Scalars['Boolean']>;
};

export type SyncSettingsKaufland_es = {
  __typename?: 'SyncSettingsKaufland_es';
  synchronizePrices?: Maybe<Scalars['Boolean']>;
  synchronizeStock?: Maybe<Scalars['Boolean']>;
  matchNewProducts?: Maybe<Scalars['Boolean']>;
  downloadNewOrders?: Maybe<Scalars['Boolean']>;
  downloadOrderUnitStatusChange?: Maybe<Scalars['Boolean']>;
};

export type SyncSettingsKaufland_esInput = {
  synchronizePrices?: Maybe<Scalars['Boolean']>;
  synchronizeStock?: Maybe<Scalars['Boolean']>;
  matchNewProducts?: Maybe<Scalars['Boolean']>;
  downloadNewOrders?: Maybe<Scalars['Boolean']>;
  downloadOrderUnitStatusChange?: Maybe<Scalars['Boolean']>;
};

export type SyncSettingsKaufland_fr = {
  __typename?: 'SyncSettingsKaufland_fr';
  synchronizePrices?: Maybe<Scalars['Boolean']>;
  synchronizeStock?: Maybe<Scalars['Boolean']>;
  matchNewProducts?: Maybe<Scalars['Boolean']>;
  downloadNewOrders?: Maybe<Scalars['Boolean']>;
  downloadOrderUnitStatusChange?: Maybe<Scalars['Boolean']>;
};

export type SyncSettingsKaufland_frInput = {
  synchronizePrices?: Maybe<Scalars['Boolean']>;
  synchronizeStock?: Maybe<Scalars['Boolean']>;
  matchNewProducts?: Maybe<Scalars['Boolean']>;
  downloadNewOrders?: Maybe<Scalars['Boolean']>;
  downloadOrderUnitStatusChange?: Maybe<Scalars['Boolean']>;
};

export type SyncSettingsKaufland_it = {
  __typename?: 'SyncSettingsKaufland_it';
  synchronizePrices?: Maybe<Scalars['Boolean']>;
  synchronizeStock?: Maybe<Scalars['Boolean']>;
  matchNewProducts?: Maybe<Scalars['Boolean']>;
  downloadNewOrders?: Maybe<Scalars['Boolean']>;
  downloadOrderUnitStatusChange?: Maybe<Scalars['Boolean']>;
};

export type SyncSettingsKaufland_itInput = {
  synchronizePrices?: Maybe<Scalars['Boolean']>;
  synchronizeStock?: Maybe<Scalars['Boolean']>;
  matchNewProducts?: Maybe<Scalars['Boolean']>;
  downloadNewOrders?: Maybe<Scalars['Boolean']>;
  downloadOrderUnitStatusChange?: Maybe<Scalars['Boolean']>;
};

export type SyncSettingsKaufland_nl = {
  __typename?: 'SyncSettingsKaufland_nl';
  synchronizePrices?: Maybe<Scalars['Boolean']>;
  synchronizeStock?: Maybe<Scalars['Boolean']>;
  matchNewProducts?: Maybe<Scalars['Boolean']>;
  downloadNewOrders?: Maybe<Scalars['Boolean']>;
  downloadOrderUnitStatusChange?: Maybe<Scalars['Boolean']>;
};

export type SyncSettingsKaufland_nlInput = {
  synchronizePrices?: Maybe<Scalars['Boolean']>;
  synchronizeStock?: Maybe<Scalars['Boolean']>;
  matchNewProducts?: Maybe<Scalars['Boolean']>;
  downloadNewOrders?: Maybe<Scalars['Boolean']>;
  downloadOrderUnitStatusChange?: Maybe<Scalars['Boolean']>;
};

export type SyncSettingsKaufland_pl = {
  __typename?: 'SyncSettingsKaufland_pl';
  synchronizePrices?: Maybe<Scalars['Boolean']>;
  synchronizeStock?: Maybe<Scalars['Boolean']>;
  matchNewProducts?: Maybe<Scalars['Boolean']>;
  downloadNewOrders?: Maybe<Scalars['Boolean']>;
  downloadOrderUnitStatusChange?: Maybe<Scalars['Boolean']>;
};

export type SyncSettingsKaufland_plInput = {
  synchronizePrices?: Maybe<Scalars['Boolean']>;
  synchronizeStock?: Maybe<Scalars['Boolean']>;
  matchNewProducts?: Maybe<Scalars['Boolean']>;
  downloadNewOrders?: Maybe<Scalars['Boolean']>;
  downloadOrderUnitStatusChange?: Maybe<Scalars['Boolean']>;
};

export type SyncSettingsKaufland_sk = {
  __typename?: 'SyncSettingsKaufland_sk';
  synchronizePrices?: Maybe<Scalars['Boolean']>;
  synchronizeStock?: Maybe<Scalars['Boolean']>;
  matchNewProducts?: Maybe<Scalars['Boolean']>;
  downloadNewOrders?: Maybe<Scalars['Boolean']>;
  downloadOrderUnitStatusChange?: Maybe<Scalars['Boolean']>;
};

export type SyncSettingsKaufland_skInput = {
  synchronizePrices?: Maybe<Scalars['Boolean']>;
  synchronizeStock?: Maybe<Scalars['Boolean']>;
  matchNewProducts?: Maybe<Scalars['Boolean']>;
  downloadNewOrders?: Maybe<Scalars['Boolean']>;
  downloadOrderUnitStatusChange?: Maybe<Scalars['Boolean']>;
};

export type SyncSettingsMall = {
  __typename?: 'SyncSettingsMall';
  synchronizePrices?: Maybe<Scalars['Boolean']>;
  synchronizeStock?: Maybe<Scalars['Boolean']>;
  matchNewProducts?: Maybe<Scalars['Boolean']>;
};

export type SyncSettingsMallInput = {
  synchronizePrices?: Maybe<Scalars['Boolean']>;
  synchronizeStock?: Maybe<Scalars['Boolean']>;
  matchNewProducts?: Maybe<Scalars['Boolean']>;
};

export type SyncSettingsReal = {
  __typename?: 'SyncSettingsReal';
  synchronizePrices?: Maybe<Scalars['Boolean']>;
  synchronizeStock?: Maybe<Scalars['Boolean']>;
  matchNewProducts?: Maybe<Scalars['Boolean']>;
};

export type SyncSettingsRealInput = {
  synchronizePrices?: Maybe<Scalars['Boolean']>;
  synchronizeStock?: Maybe<Scalars['Boolean']>;
  matchNewProducts?: Maybe<Scalars['Boolean']>;
};

export type SyncSettingsReturnLabels = {
  __typename?: 'SyncSettingsReturnLabels';
  automaticLabelCreation?: Maybe<Scalars['Boolean']>;
};

export type SyncSettingsReturnLabelsInput = {
  automaticLabelCreation?: Maybe<Scalars['Boolean']>;
};

export type SyncSettingsVatRates = {
  __typename?: 'SyncSettingsVatRates';
  alza_cz?: Maybe<SyncSettingsVatRatesAlza_cz>;
  amazon_mx?: Maybe<SyncSettingsVatRatesAlza_cz>;
  amazon_us?: Maybe<SyncSettingsVatRatesAlza_cz>;
  amazon_ca?: Maybe<SyncSettingsVatRatesAlza_cz>;
  amazon_br?: Maybe<SyncSettingsVatRatesAlza_cz>;
  amazon_de?: Maybe<SyncSettingsVatRatesAlza_cz>;
  amazon_uk?: Maybe<SyncSettingsVatRatesAlza_cz>;
  amazon_fr?: Maybe<SyncSettingsVatRatesAlza_cz>;
  amazon_it?: Maybe<SyncSettingsVatRatesAlza_cz>;
  amazon_es?: Maybe<SyncSettingsVatRatesAlza_cz>;
  amazon_nl?: Maybe<SyncSettingsVatRatesAlza_cz>;
  amazon_se?: Maybe<SyncSettingsVatRatesAlza_cz>;
  amazon_tr?: Maybe<SyncSettingsVatRatesAlza_cz>;
  amazon_pl?: Maybe<SyncSettingsVatRatesAlza_cz>;
  amazon_be?: Maybe<SyncSettingsVatRatesAlza_cz>;
  amazon_ie?: Maybe<SyncSettingsVatRatesAlza_cz>;
  amazon_sg?: Maybe<SyncSettingsVatRatesAlza_cz>;
  amazon_au?: Maybe<SyncSettingsVatRatesAlza_cz>;
  amazon_jp?: Maybe<SyncSettingsVatRatesAlza_cz>;
  emag_bg?: Maybe<SyncSettingsVatRatesAlza_cz>;
  emag_hu?: Maybe<SyncSettingsVatRatesAlza_cz>;
  emag_pl?: Maybe<SyncSettingsVatRatesAlza_cz>;
  emag_ro?: Maybe<SyncSettingsVatRatesAlza_cz>;
  mall_cz?: Maybe<SyncSettingsVatRatesAlza_cz>;
  mall_hu?: Maybe<SyncSettingsVatRatesAlza_cz>;
  mall_pl?: Maybe<SyncSettingsVatRatesAlza_cz>;
  mall_si?: Maybe<SyncSettingsVatRatesAlza_cz>;
  mall_sk?: Maybe<SyncSettingsVatRatesAlza_cz>;
  real_de?: Maybe<SyncSettingsVatRatesAlza_cz>;
  kaufland_de?: Maybe<SyncSettingsVatRatesAlza_cz>;
  kaufland_cz?: Maybe<SyncSettingsVatRatesAlza_cz>;
  kaufland_sk?: Maybe<SyncSettingsVatRatesAlza_cz>;
  kaufland_at?: Maybe<SyncSettingsVatRatesAlza_cz>;
  kaufland_pl?: Maybe<SyncSettingsVatRatesAlza_cz>;
  kaufland_nl?: Maybe<SyncSettingsVatRatesAlza_cz>;
  kaufland_es?: Maybe<SyncSettingsVatRatesAlza_cz>;
  kaufland_fr?: Maybe<SyncSettingsVatRatesAlza_cz>;
  kaufland_it?: Maybe<SyncSettingsVatRatesAlza_cz>;
  glami_cz?: Maybe<SyncSettingsVatRatesAlza_cz>;
  cdiscount_fr?: Maybe<SyncSettingsVatRatesAlza_cz>;
  ebay_at?: Maybe<SyncSettingsVatRatesAlza_cz>;
  ebay_cz?: Maybe<SyncSettingsVatRatesAlza_cz>;
  ebay_fr?: Maybe<SyncSettingsVatRatesAlza_cz>;
  ebay_pl?: Maybe<SyncSettingsVatRatesAlza_cz>;
  ebay_de?: Maybe<SyncSettingsVatRatesAlza_cz>;
  ebay_us?: Maybe<SyncSettingsVatRatesAlza_cz>;
  ebay_uk?: Maybe<SyncSettingsVatRatesAlza_cz>;
  allegro_cz?: Maybe<SyncSettingsVatRatesAlza_cz>;
  allegro_pl?: Maybe<SyncSettingsVatRatesAlza_cz>;
  allegro_sk?: Maybe<SyncSettingsVatRatesAlza_cz>;
  baskedo_bg?: Maybe<SyncSettingsVatRatesAlza_cz>;
  baskedo_hu?: Maybe<SyncSettingsVatRatesAlza_cz>;
  bol_nl?: Maybe<SyncSettingsVatRatesAlza_cz>;
  expando_shop_ro?: Maybe<SyncSettingsVatRatesAlza_cz>;
  limetka_cz?: Maybe<SyncSettingsVatRatesAlza_cz>;
  limetka_gr?: Maybe<SyncSettingsVatRatesAlza_cz>;
  limetka_sk?: Maybe<SyncSettingsVatRatesAlza_cz>;
};

export type SyncSettingsVatRatesAlza_cz = {
  __typename?: 'SyncSettingsVatRatesAlza_cz';
  rate?: Maybe<Scalars['Float']>;
};

export type SyncSettingsVatRatesAlza_czInput = {
  rate?: Maybe<Scalars['Float']>;
};

export type SyncSettingsVatRatesInput = {
  alza_cz?: Maybe<SyncSettingsVatRatesAlza_czInput>;
  amazon_mx?: Maybe<SyncSettingsVatRatesAlza_czInput>;
  amazon_us?: Maybe<SyncSettingsVatRatesAlza_czInput>;
  amazon_ca?: Maybe<SyncSettingsVatRatesAlza_czInput>;
  amazon_br?: Maybe<SyncSettingsVatRatesAlza_czInput>;
  amazon_de?: Maybe<SyncSettingsVatRatesAlza_czInput>;
  amazon_uk?: Maybe<SyncSettingsVatRatesAlza_czInput>;
  amazon_fr?: Maybe<SyncSettingsVatRatesAlza_czInput>;
  amazon_it?: Maybe<SyncSettingsVatRatesAlza_czInput>;
  amazon_es?: Maybe<SyncSettingsVatRatesAlza_czInput>;
  amazon_nl?: Maybe<SyncSettingsVatRatesAlza_czInput>;
  amazon_se?: Maybe<SyncSettingsVatRatesAlza_czInput>;
  amazon_tr?: Maybe<SyncSettingsVatRatesAlza_czInput>;
  amazon_pl?: Maybe<SyncSettingsVatRatesAlza_czInput>;
  amazon_be?: Maybe<SyncSettingsVatRatesAlza_czInput>;
  amazon_ie?: Maybe<SyncSettingsVatRatesAlza_czInput>;
  amazon_sg?: Maybe<SyncSettingsVatRatesAlza_czInput>;
  amazon_au?: Maybe<SyncSettingsVatRatesAlza_czInput>;
  amazon_jp?: Maybe<SyncSettingsVatRatesAlza_czInput>;
  emag_bg?: Maybe<SyncSettingsVatRatesAlza_czInput>;
  emag_hu?: Maybe<SyncSettingsVatRatesAlza_czInput>;
  emag_pl?: Maybe<SyncSettingsVatRatesAlza_czInput>;
  emag_ro?: Maybe<SyncSettingsVatRatesAlza_czInput>;
  mall_cz?: Maybe<SyncSettingsVatRatesAlza_czInput>;
  mall_hu?: Maybe<SyncSettingsVatRatesAlza_czInput>;
  mall_pl?: Maybe<SyncSettingsVatRatesAlza_czInput>;
  mall_si?: Maybe<SyncSettingsVatRatesAlza_czInput>;
  mall_sk?: Maybe<SyncSettingsVatRatesAlza_czInput>;
  real_de?: Maybe<SyncSettingsVatRatesAlza_czInput>;
  kaufland_de?: Maybe<SyncSettingsVatRatesAlza_czInput>;
  kaufland_cz?: Maybe<SyncSettingsVatRatesAlza_czInput>;
  kaufland_sk?: Maybe<SyncSettingsVatRatesAlza_czInput>;
  kaufland_at?: Maybe<SyncSettingsVatRatesAlza_czInput>;
  kaufland_pl?: Maybe<SyncSettingsVatRatesAlza_czInput>;
  kaufland_nl?: Maybe<SyncSettingsVatRatesAlza_czInput>;
  kaufland_es?: Maybe<SyncSettingsVatRatesAlza_czInput>;
  kaufland_fr?: Maybe<SyncSettingsVatRatesAlza_czInput>;
  kaufland_it?: Maybe<SyncSettingsVatRatesAlza_czInput>;
  glami_cz?: Maybe<SyncSettingsVatRatesAlza_czInput>;
  cdiscount_fr?: Maybe<SyncSettingsVatRatesAlza_czInput>;
  ebay_at?: Maybe<SyncSettingsVatRatesAlza_czInput>;
  ebay_cz?: Maybe<SyncSettingsVatRatesAlza_czInput>;
  ebay_fr?: Maybe<SyncSettingsVatRatesAlza_czInput>;
  ebay_pl?: Maybe<SyncSettingsVatRatesAlza_czInput>;
  ebay_de?: Maybe<SyncSettingsVatRatesAlza_czInput>;
  ebay_us?: Maybe<SyncSettingsVatRatesAlza_czInput>;
  ebay_uk?: Maybe<SyncSettingsVatRatesAlza_czInput>;
  allegro_cz?: Maybe<SyncSettingsVatRatesAlza_czInput>;
  allegro_pl?: Maybe<SyncSettingsVatRatesAlza_czInput>;
  allegro_sk?: Maybe<SyncSettingsVatRatesAlza_czInput>;
  baskedo_bg?: Maybe<SyncSettingsVatRatesAlza_czInput>;
  baskedo_hu?: Maybe<SyncSettingsVatRatesAlza_czInput>;
  bol_nl?: Maybe<SyncSettingsVatRatesAlza_czInput>;
  expando_shop_ro?: Maybe<SyncSettingsVatRatesAlza_czInput>;
  limetka_cz?: Maybe<SyncSettingsVatRatesAlza_czInput>;
  limetka_gr?: Maybe<SyncSettingsVatRatesAlza_czInput>;
  limetka_sk?: Maybe<SyncSettingsVatRatesAlza_czInput>;
};

export type UpdateForbidListingsResult = {
  __typename?: 'UpdateForbidListingsResult';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  totalCount?: Maybe<Scalars['Int']>;
  foundCount?: Maybe<Scalars['Int']>;
  notFoundSkus?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export enum UpdateMwsMarketplaceInputStatus {
  online = 'online',
  offline = 'offline'
}

export type UserInput = {
  name?: Maybe<Scalars['String']>;
  language?: Maybe<EnumUserLanguage>;
  tos?: Maybe<UserTosInput>;
};

export type UserQuery = {
  __typename?: 'UserQuery';
  email?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Maybe<UserRoles>>>;
  name?: Maybe<Scalars['String']>;
  confirmedAt?: Maybe<Scalars['Date']>;
  language?: Maybe<EnumUserLanguage>;
  tos?: Maybe<UserTos>;
  _id: Scalars['MongoID'];
  createdAt?: Maybe<Scalars['Date']>;
  isSuperadmin: Scalars['Boolean'];
  isConfirmed: Scalars['Boolean'];
  daysLeftToConfirm: Scalars['Int'];
};

/** List of items with pagination. */
export type UserQueryPagination = {
  __typename?: 'UserQueryPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<UserQuery>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type UserRegistrationDto = {
  email: Scalars['String'];
  password: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  shopUrl?: Maybe<Scalars['String']>;
};

export type UserRegistrationRes = {
  __typename?: 'UserRegistrationRes';
  email: Scalars['String'];
  error?: Maybe<Scalars['String']>;
};

export type UserRoles = {
  __typename?: 'UserRoles';
  type?: Maybe<EnumUserRolesType>;
  companyId?: Maybe<Scalars['MongoID']>;
  company?: Maybe<CompanyQuery>;
  settings?: Maybe<SyncSettings>;
  companyErrors?: Maybe<Array<Maybe<CompanyError>>>;
  marketplaces?: Maybe<Array<Maybe<MarketplaceActivity>>>;
};

export type UserRow = {
  __typename?: 'UserRow';
  username?: Maybe<Scalars['String']>;
  feedUrl?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['String']>;
  productsTotal?: Maybe<Scalars['Int']>;
  productsInStock?: Maybe<Scalars['Int']>;
  productsWithBarcode?: Maybe<Scalars['Int']>;
  productsReadyToList?: Maybe<Scalars['Int']>;
  lastSynced?: Maybe<Scalars['Date']>;
  lastFeedSync?: Maybe<Scalars['Date']>;
  hoursUnsynced?: Maybe<Scalars['String']>;
  marketplaces?: Maybe<Array<Maybe<UserTableMarketplace>>>;
  syncSettings?: Maybe<SyncSettings>;
};

export type UserSearchFilter = {
  search: Scalars['String'];
  isAutopricingFilterActive: Scalars['Boolean'];
  autopricingFilterValue?: Maybe<Scalars['Boolean']>;
  feedTypeFilterValue?: Maybe<Scalars['String']>;
  onboardingStateFilterValue?: Maybe<Scalars['String']>;
};

export type UserTableMarketplace = {
  __typename?: 'UserTableMarketplace';
  name?: Maybe<Scalars['String']>;
  productsListed?: Maybe<Scalars['Int']>;
  productsError?: Maybe<Scalars['Int']>;
  isRunning?: Maybe<Scalars['Boolean']>;
  isAllowed?: Maybe<Scalars['Boolean']>;
};

export type UserTos = {
  __typename?: 'UserTos';
  acceptedAt?: Maybe<Scalars['Date']>;
  acceptedIpAddress?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  userAgent?: Maybe<Scalars['String']>;
};

export type UserTosInput = {
  acceptedAt?: Maybe<Scalars['Date']>;
  acceptedIpAddress?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  userAgent?: Maybe<Scalars['String']>;
};

export type ValidateProductFeedField = {
  __typename?: 'ValidateProductFeedField';
  value: Scalars['String'];
  parsedValue: Scalars['String'];
  status: Scalars['String'];
};

export enum ValidationFieldTypeEnum {
  STOCK = 'STOCK',
  PRICE = 'PRICE',
  BARCODE = 'BARCODE',
  SKU = 'SKU',
  OPTIONAL_STRING = 'OPTIONAL_STRING'
}

export type VerifyEmailResult = {
  __typename?: 'VerifyEmailResult';
  success: Scalars['Boolean'];
};

export type googleDataStudioUrl = {
  __typename?: 'googleDataStudioUrl';
  googleDataStudioUrl?: Maybe<Scalars['String']>;
  _id: Scalars['MongoID'];
};

export type internalCompanyName = {
  __typename?: 'internalCompanyName';
  internalName?: Maybe<Scalars['String']>;
  _id: Scalars['MongoID'];
};

export type newSettings = {
  amazon_mx?: Maybe<Array<Maybe<productAutopricingCaps>>>;
  amazon_us?: Maybe<Array<Maybe<productAutopricingCaps>>>;
  amazon_ca?: Maybe<Array<Maybe<productAutopricingCaps>>>;
  amazon_br?: Maybe<Array<Maybe<productAutopricingCaps>>>;
  amazon_de?: Maybe<Array<Maybe<productAutopricingCaps>>>;
  amazon_uk?: Maybe<Array<Maybe<productAutopricingCaps>>>;
  amazon_fr?: Maybe<Array<Maybe<productAutopricingCaps>>>;
  amazon_it?: Maybe<Array<Maybe<productAutopricingCaps>>>;
  amazon_es?: Maybe<Array<Maybe<productAutopricingCaps>>>;
  amazon_nl?: Maybe<Array<Maybe<productAutopricingCaps>>>;
  amazon_se?: Maybe<Array<Maybe<productAutopricingCaps>>>;
  amazon_tr?: Maybe<Array<Maybe<productAutopricingCaps>>>;
  amazon_pl?: Maybe<Array<Maybe<productAutopricingCaps>>>;
  amazon_be?: Maybe<Array<Maybe<productAutopricingCaps>>>;
  amazon_ie?: Maybe<Array<Maybe<productAutopricingCaps>>>;
  amazon_sg?: Maybe<Array<Maybe<productAutopricingCaps>>>;
  amazon_au?: Maybe<Array<Maybe<productAutopricingCaps>>>;
  amazon_jp?: Maybe<Array<Maybe<productAutopricingCaps>>>;
};

export type productAutopricingCaps = {
  sku: Scalars['String'];
  status?: Maybe<Scalars['Boolean']>;
  topCap?: Maybe<Scalars['Float']>;
  bottomCap?: Maybe<Scalars['Float']>;
  topCapAbsolute?: Maybe<Scalars['Float']>;
  bottomCapAbsolute?: Maybe<Scalars['Float']>;
};

export type GetSidebarInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSidebarInfoQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'unshippedOrdersCount' | 'lateOrdersCount'>
);

export type GetMarketplacesSimpleQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMarketplacesSimpleQuery = (
  { __typename?: 'Query' }
  & { marketplaces?: Maybe<Array<Maybe<(
    { __typename?: 'MarketplaceStatus' }
    & Pick<MarketplaceStatus, 'id' | 'status' | 'marketplace'>
  )>>> }
);

export type GetFeatureToggleQueryVariables = Exact<{
  featureName: Scalars['String'];
}>;


export type GetFeatureToggleQuery = (
  { __typename?: 'Query' }
  & { getFeatureToggle?: Maybe<(
    { __typename?: 'FeatureToggleResult' }
    & Pick<FeatureToggleResult, 'allowed'>
  )> }
);

export type GetFeatureToggleAsAdminQueryVariables = Exact<{
  companyId: Scalars['String'];
  featureName: Scalars['String'];
}>;


export type GetFeatureToggleAsAdminQuery = (
  { __typename?: 'Query' }
  & { getFeatureToggleAsAdmin?: Maybe<(
    { __typename?: 'FeatureToggleResult' }
    & Pick<FeatureToggleResult, 'allowed'>
  )> }
);

export type FeatureToggleQueryVariables = Exact<{
  name: EFeatureName;
}>;


export type FeatureToggleQuery = (
  { __typename?: 'Query' }
  & { featureToggle?: Maybe<(
    { __typename?: 'FeatureToggle' }
    & Pick<FeatureToggle, 'enabled'>
  )> }
);

export type ShopInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type ShopInfoQuery = (
  { __typename?: 'Query' }
  & { shopInfo?: Maybe<(
    { __typename?: 'ShopInfo' }
    & { endpoints?: Maybe<(
      { __typename?: 'AddonsEndpoints' }
      & { mall?: Maybe<Array<Maybe<(
        { __typename?: 'Endpoints' }
        & Pick<Endpoints, 'endpoint' | 'access'>
      )>>>, amazon?: Maybe<Array<Maybe<(
        { __typename?: 'Endpoints' }
        & Pick<Endpoints, 'endpoint' | 'access'>
      )>>>, alza?: Maybe<Array<Maybe<(
        { __typename?: 'Endpoints' }
        & Pick<Endpoints, 'endpoint' | 'access'>
      )>>>, kaufland?: Maybe<Array<Maybe<(
        { __typename?: 'Endpoints' }
        & Pick<Endpoints, 'endpoint' | 'access'>
      )>>> }
    )> }
  )> }
);

export type GetApiSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetApiSettingsQuery = (
  { __typename?: 'Query' }
  & { apiToken?: Maybe<(
    { __typename?: 'ApiToken' }
    & Pick<ApiToken, '_id' | 'companyId' | 'token'>
  )>, marketplaces?: Maybe<Array<Maybe<(
    { __typename?: 'MarketplaceStatus' }
    & Pick<MarketplaceStatus, 'id' | 'marketplace'>
  )>>> }
);

export type GetCompanyErrorsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompanyErrorsQuery = (
  { __typename?: 'Query' }
  & { companyError?: Maybe<Array<Maybe<(
    { __typename?: 'CompanyError' }
    & Pick<CompanyError, '_id' | 'companyId' | 'code' | 'count' | 'created' | 'timestamp' | 'message'>
  )>>> }
);

export type ValidateProductFeedFieldMutationVariables = Exact<{
  type?: Maybe<ValidationFieldTypeEnum>;
  values: Array<Maybe<Scalars['String']>>;
}>;


export type ValidateProductFeedFieldMutation = (
  { __typename?: 'Mutation' }
  & { validateProductFeedField?: Maybe<Array<Maybe<(
    { __typename?: 'ValidateProductFeedField' }
    & Pick<ValidateProductFeedField, 'value' | 'parsedValue' | 'status'>
  )>>> }
);

export type UpdateProductVariantSellingPriceMutationVariables = Exact<{
  product?: Maybe<ProductVariantInput>;
}>;


export type UpdateProductVariantSellingPriceMutation = (
  { __typename?: 'Mutation' }
  & { updateProductVariant?: Maybe<Array<Maybe<(
    { __typename?: 'ProductVariant' }
    & Pick<ProductVariant, 'id'>
    & { prices?: Maybe<(
      { __typename?: 'Prices' }
      & { amazon_au?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, amazon_br?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, amazon_ca?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, amazon_de?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, amazon_es?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, amazon_fr?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, amazon_it?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, amazon_jp?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, amazon_mx?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, amazon_sg?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, amazon_uk?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, amazon_nl?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, amazon_us?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, amazon_se?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, amazon_tr?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, amazon_pl?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, amazon_be?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, amazon_ie?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, mall_cz?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, mall_pl?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, mall_si?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, mall_hu?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, mall_sk?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, alza_cz?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, real_de?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, kaufland_de?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, kaufland_cz?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, kaufland_sk?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, kaufland_at?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, kaufland_pl?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, kaufland_nl?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, kaufland_es?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, kaufland_fr?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, kaufland_it?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )> }
    )> }
  )>>> }
);

export type UpdateProductAutopricingActiveStateMutationVariables = Exact<{
  sku: Scalars['String'];
  marketplace?: Maybe<MarketplaceName>;
  active: Scalars['Boolean'];
}>;


export type UpdateProductAutopricingActiveStateMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'updateProductAutopricingActiveState'>
);

export type UpdateProductAutopricingLimitsMutationVariables = Exact<{
  sku: Scalars['String'];
  marketplace?: Maybe<MarketplaceName>;
  topCap?: Maybe<Scalars['Float']>;
  bottomCap?: Maybe<Scalars['Float']>;
  topCapAbsolute?: Maybe<Scalars['Float']>;
  bottomCapAbsolute?: Maybe<Scalars['Float']>;
}>;


export type UpdateProductAutopricingLimitsMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'updateProductAutopricingLimits'>
);

export type MergePdfsMutationVariables = Exact<{
  links?: Maybe<Array<Scalars['String']>>;
}>;


export type MergePdfsMutation = (
  { __typename?: 'Mutation' }
  & { mergePdfs?: Maybe<(
    { __typename?: 'Pdfs' }
    & Pick<Pdfs, '_id' | 'doneAt' | 'downloadLink' | 'failReason' | 'failedAt' | 'requestedAt' | 'status'>
  )> }
);

export type GetMergedPdfsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetMergedPdfsQuery = (
  { __typename?: 'Query' }
  & { pdf?: Maybe<(
    { __typename?: 'Pdfs' }
    & Pick<Pdfs, '_id' | 'doneAt' | 'downloadLink' | 'failReason' | 'failedAt' | 'requestedAt' | 'status'>
  )> }
);

export type GetPricingSpeedNotificationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPricingSpeedNotificationQuery = (
  { __typename?: 'Query' }
  & { syncSettings?: Maybe<(
    { __typename?: 'SyncSettings' }
    & Pick<SyncSettings, '_id'>
    & { amazon?: Maybe<(
      { __typename?: 'SyncSettingsAmazon' }
      & Pick<SyncSettingsAmazon, 'downloadPricing'>
    )> }
  )> }
);

export type GetErrorCompaniesCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetErrorCompaniesCountQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'errorCompaniesCount'>
);

export type SaveLanguageMutationVariables = Exact<{
  language: EnumUserLanguage;
}>;


export type SaveLanguageMutation = (
  { __typename?: 'Mutation' }
  & { updateUser?: Maybe<(
    { __typename?: 'UserQuery' }
    & Pick<UserQuery, 'email' | 'name'>
  )> }
);

export type BulkUpdateAutopricerLimitsMutationVariables = Exact<{
  data?: Maybe<newSettings>;
}>;


export type BulkUpdateAutopricerLimitsMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'updateProductAutopricingLimitsBulk'>
);

export type GetProductPricingCountQueryVariables = Exact<{
  filter?: Maybe<FilterInputProducts>;
}>;


export type GetProductPricingCountQuery = (
  { __typename?: 'Query' }
  & { products?: Maybe<(
    { __typename?: 'ProductVariantPagination' }
    & Pick<ProductVariantPagination, 'count'>
  )> }
);

export type GetProductPricingDataQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  filter?: Maybe<FilterInputProducts>;
  sort?: Maybe<Array<Maybe<ProductsSortInput>>>;
}>;


export type GetProductPricingDataQuery = (
  { __typename?: 'Query' }
  & { products?: Maybe<(
    { __typename?: 'ProductVariantPagination' }
    & { items?: Maybe<Array<(
      { __typename?: 'ProductVariant' }
      & Pick<ProductVariant, 'id' | '_id' | 'sku' | 'image' | 'name' | 'locks' | 'stock'>
      & { barcode?: Maybe<(
        { __typename?: 'Barcode' }
        & Pick<Barcode, 'type' | 'code'>
      )>, prices?: Maybe<(
        { __typename?: 'Prices' }
        & { amazon_br?: Maybe<(
          { __typename?: 'Price' }
          & Pick<Price, 'base' | 'selling'>
        )>, amazon_jp?: Maybe<(
          { __typename?: 'Price' }
          & Pick<Price, 'base' | 'selling'>
        )>, amazon_au?: Maybe<(
          { __typename?: 'Price' }
          & Pick<Price, 'base' | 'selling'>
        )>, amazon_de?: Maybe<(
          { __typename?: 'Price' }
          & Pick<Price, 'base' | 'selling'>
        )>, amazon_uk?: Maybe<(
          { __typename?: 'Price' }
          & Pick<Price, 'base' | 'selling'>
        )>, amazon_nl?: Maybe<(
          { __typename?: 'Price' }
          & Pick<Price, 'base' | 'selling'>
        )>, amazon_it?: Maybe<(
          { __typename?: 'Price' }
          & Pick<Price, 'base' | 'selling'>
        )>, amazon_fr?: Maybe<(
          { __typename?: 'Price' }
          & Pick<Price, 'base' | 'selling'>
        )>, amazon_es?: Maybe<(
          { __typename?: 'Price' }
          & Pick<Price, 'base' | 'selling'>
        )>, amazon_mx?: Maybe<(
          { __typename?: 'Price' }
          & Pick<Price, 'base' | 'selling'>
        )>, amazon_us?: Maybe<(
          { __typename?: 'Price' }
          & Pick<Price, 'base' | 'selling'>
        )>, amazon_ca?: Maybe<(
          { __typename?: 'Price' }
          & Pick<Price, 'base' | 'selling'>
        )>, amazon_se?: Maybe<(
          { __typename?: 'Price' }
          & Pick<Price, 'base' | 'selling'>
        )>, amazon_tr?: Maybe<(
          { __typename?: 'Price' }
          & Pick<Price, 'base' | 'selling'>
        )>, amazon_pl?: Maybe<(
          { __typename?: 'Price' }
          & Pick<Price, 'base' | 'selling'>
        )>, mall_cz?: Maybe<(
          { __typename?: 'Price' }
          & Pick<Price, 'base' | 'selling'>
        )>, mall_pl?: Maybe<(
          { __typename?: 'Price' }
          & Pick<Price, 'base' | 'selling'>
        )>, mall_si?: Maybe<(
          { __typename?: 'Price' }
          & Pick<Price, 'base' | 'selling'>
        )>, mall_hu?: Maybe<(
          { __typename?: 'Price' }
          & Pick<Price, 'base' | 'selling'>
        )>, mall_sk?: Maybe<(
          { __typename?: 'Price' }
          & Pick<Price, 'base' | 'selling'>
        )>, alza_cz?: Maybe<(
          { __typename?: 'Price' }
          & Pick<Price, 'base' | 'selling'>
        )> }
      )>, asins?: Maybe<(
        { __typename?: 'Asins' }
        & Pick<Asins, 'amazon_br' | 'amazon_jp' | 'amazon_au' | 'amazon_de' | 'amazon_uk' | 'amazon_nl' | 'amazon_it' | 'amazon_fr' | 'amazon_es' | 'amazon_mx' | 'amazon_us' | 'amazon_ca'>
      )>, pricing?: Maybe<(
        { __typename?: 'Pricing' }
        & { summary?: Maybe<(
          { __typename?: 'Summary' }
          & Pick<Summary, 'totalOffers'>
          & { lowest?: Maybe<(
            { __typename?: 'ChannelLowestPriceInfo' }
            & Pick<ChannelLowestPriceInfo, 'listing' | 'shipping' | 'channel' | 'landed'>
          )>, highest?: Maybe<(
            { __typename?: 'ChannelHighestPriceInfo' }
            & Pick<ChannelHighestPriceInfo, 'listing' | 'shipping' | 'channel' | 'landed'>
          )>, buyBox?: Maybe<(
            { __typename?: 'BuyBoxPriceInfo' }
            & Pick<BuyBoxPriceInfo, 'listing' | 'shipping' | 'landed'>
          )> }
        )>, offer?: Maybe<(
          { __typename?: 'Offer' }
          & Pick<Offer, 'shippingPrice' | 'sellerId' | 'listingPrice'>
          & { marketplaceDetails?: Maybe<(
            { __typename?: 'MarketplaceOfferDetails' }
            & Pick<MarketplaceOfferDetails, 'isBuyBoxWinner' | 'isFeaturedMerchant' | 'isFulfilledByAmazon'>
          )> }
        )> }
      )>, productStatus?: Maybe<Array<Maybe<(
        { __typename?: 'ProductStatus' }
        & Pick<ProductStatus, 'marketplace' | 'isBuyBoxWinner'>
      )>>>, autopricing?: Maybe<(
        { __typename?: 'Autopricing' }
        & Pick<Autopricing, 'marketplace' | 'autoprice' | 'buybox' | 'selling' | 'active' | 'topCap' | 'bottomCap' | 'topCapAbsolute' | 'bottomCapAbsolute'>
      )> }
    )>>, pageInfo: (
      { __typename?: 'PaginationInfo' }
      & Pick<PaginationInfo, 'hasNextPage' | 'hasPreviousPage' | 'perPage' | 'currentPage'>
    ) }
  )>, syncSettings?: Maybe<(
    { __typename?: 'SyncSettings' }
    & Pick<SyncSettings, '_id'>
    & { autopricing?: Maybe<(
      { __typename?: 'SyncSettingsAutopricing' }
      & { amazon_au?: Maybe<(
        { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
        & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'defaultTopCap' | 'defaultBottomCap'>
      )>, amazon_br?: Maybe<(
        { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
        & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'defaultTopCap' | 'defaultBottomCap'>
      )>, amazon_ca?: Maybe<(
        { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
        & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'defaultTopCap' | 'defaultBottomCap'>
      )>, amazon_de?: Maybe<(
        { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
        & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'defaultTopCap' | 'defaultBottomCap'>
      )>, amazon_es?: Maybe<(
        { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
        & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'defaultTopCap' | 'defaultBottomCap'>
      )>, amazon_fr?: Maybe<(
        { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
        & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'defaultTopCap' | 'defaultBottomCap'>
      )>, amazon_it?: Maybe<(
        { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
        & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'defaultTopCap' | 'defaultBottomCap'>
      )>, amazon_jp?: Maybe<(
        { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
        & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'defaultTopCap' | 'defaultBottomCap'>
      )>, amazon_mx?: Maybe<(
        { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
        & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'defaultTopCap' | 'defaultBottomCap'>
      )>, amazon_uk?: Maybe<(
        { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
        & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'defaultTopCap' | 'defaultBottomCap'>
      )>, amazon_nl?: Maybe<(
        { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
        & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'defaultTopCap' | 'defaultBottomCap'>
      )>, amazon_us?: Maybe<(
        { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
        & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'defaultTopCap' | 'defaultBottomCap'>
      )> }
    )> }
  )> }
);

export type GetProductStatisticsQueryVariables = Exact<{
  hasStockFilter?: Maybe<Scalars['Boolean']>;
}>;


export type GetProductStatisticsQuery = (
  { __typename?: 'Query' }
  & { productFeedResult?: Maybe<(
    { __typename?: 'ProductFeedResult' }
    & Pick<ProductFeedResult, 'productsAll' | 'productsInStock'>
  )>, productStats?: Maybe<(
    { __typename?: 'ProductStats' }
    & Pick<ProductStats, 'ok' | 'paused' | 'notFound' | 'missingBarcode' | 'error'>
  )> }
);

export type GetOrderStatisticsQueryVariables = Exact<{
  autopricingStatsSince?: Maybe<Scalars['Date']>;
  shippedCountSince?: Maybe<Scalars['Date']>;
}>;


export type GetOrderStatisticsQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'shippedOrdersCount' | 'unshippedOrdersCount' | 'lateOrdersCount'>
  & { lastThirtyDaysStats?: Maybe<(
    { __typename?: 'RangedOrderStatistics' }
    & Pick<RangedOrderStatistics, 'count'>
    & { money?: Maybe<(
      { __typename?: 'Money' }
      & Pick<Money, 'currency' | 'value'>
    )> }
  )>, lastSevenDaysStats?: Maybe<(
    { __typename?: 'RangedOrderStatistics' }
    & Pick<RangedOrderStatistics, 'count'>
    & { money?: Maybe<(
      { __typename?: 'Money' }
      & Pick<Money, 'currency' | 'value'>
    )> }
  )>, autopricingStatistics?: Maybe<(
    { __typename?: 'AutopricingStatistics' }
    & Pick<AutopricingStatistics, 'count'>
    & { addedMoney?: Maybe<(
      { __typename?: 'Money' }
      & Pick<Money, 'currency' | 'value'>
    )> }
  )> }
);

export type GetOrderChartDataQueryVariables = Exact<{
  filter?: Maybe<FilterInputStatistics>;
}>;


export type GetOrderChartDataQuery = (
  { __typename?: 'Query' }
  & { orderStatistics?: Maybe<Array<Maybe<(
    { __typename?: 'OrderStatistics' }
    & Pick<OrderStatistics, 'from' | 'to' | 'count'>
  )>>> }
);

export type GetMarketplaceStatisticsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMarketplaceStatisticsQuery = (
  { __typename?: 'Query' }
  & { marketplaces?: Maybe<Array<Maybe<(
    { __typename?: 'MarketplaceStatus' }
    & Pick<MarketplaceStatus, 'id' | 'marketplace' | 'status'>
    & { currentListingStatistics?: Maybe<(
      { __typename?: 'ListingStatistics' }
      & Pick<ListingStatistics, 'ok' | 'error'>
    )>, errorRates?: Maybe<Array<Maybe<(
      { __typename?: 'AmazonErrorRate' }
      & Pick<AmazonErrorRate, 'code' | 'message' | 'count'>
    )>>> }
  )>>>, productFeedResult?: Maybe<(
    { __typename?: 'ProductFeedResult' }
    & Pick<ProductFeedResult, 'productsToBeListed'>
  )> }
);

export type GetProductSyncQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProductSyncQuery = (
  { __typename?: 'Query' }
  & { productSync?: Maybe<(
    { __typename?: 'ProductSync' }
    & Pick<ProductSync, 'startedOn' | 'isSyncing'>
  )> }
);

export type TriggerAlzaSyncMutationVariables = Exact<{ [key: string]: never; }>;


export type TriggerAlzaSyncMutation = (
  { __typename?: 'Mutation' }
  & { triggerAlzaSync?: Maybe<(
    { __typename?: 'AlzaFullSync' }
    & Pick<AlzaFullSync, 'message' | 'willRunAt'>
  )> }
);

export type SyncControlQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type SyncControlQueryQuery = (
  { __typename?: 'Query' }
  & { marketplaces?: Maybe<Array<Maybe<(
    { __typename?: 'MarketplaceStatus' }
    & Pick<MarketplaceStatus, 'id' | 'status' | 'error' | 'marketplace' | 'currency'>
  )>>>, productSync?: Maybe<(
    { __typename?: 'ProductSync' }
    & Pick<ProductSync, '_id' | 'interval' | 'startedOn' | 'nextSyncOn' | 'finishedOn' | 'isSyncing'>
  )> }
);

export type DoSyncMutationVariables = Exact<{ [key: string]: never; }>;


export type DoSyncMutation = (
  { __typename?: 'Mutation' }
  & { sync?: Maybe<(
    { __typename?: 'ProductSync' }
    & Pick<ProductSync, '_id' | 'interval' | 'startedOn' | 'nextSyncOn' | 'finishedOn' | 'isSyncing'>
  )> }
);

export type CreateShipmentMutationVariables = Exact<{
  packages: Array<Maybe<PackagesInput>>;
  orderIds: Array<Maybe<Scalars['String']>>;
}>;


export type CreateShipmentMutation = (
  { __typename?: 'Mutation' }
  & { createShipment?: Maybe<(
    { __typename?: 'CreateShipment' }
    & Pick<CreateShipment, 'success' | 'message' | 'error'>
  )> }
);

export type GeneratePackageItemLabelsMutationVariables = Exact<{
  marketplaceOrderIds?: Maybe<Array<Scalars['String']>>;
}>;


export type GeneratePackageItemLabelsMutation = (
  { __typename?: 'Mutation' }
  & { generateBarcodes?: Maybe<(
    { __typename?: 'Pdfs' }
    & Pick<Pdfs, '_id' | 'doneAt' | 'downloadLink' | 'failReason' | 'failedAt' | 'requestedAt' | 'status' | 'input'>
  )> }
);

export type GeneratePackageItemLabelsWithEanMutationVariables = Exact<{
  marketplaceOrderIds?: Maybe<Array<Scalars['String']>>;
}>;


export type GeneratePackageItemLabelsWithEanMutation = (
  { __typename?: 'Mutation' }
  & { generateBarcodesWithEan?: Maybe<(
    { __typename?: 'Pdfs' }
    & Pick<Pdfs, '_id' | 'doneAt' | 'downloadLink' | 'failReason' | 'failedAt' | 'requestedAt' | 'status' | 'input'>
  )> }
);

export type CreateReturnPackageLabelMutationVariables = Exact<{
  marketplace: Scalars['String'];
  marketplaceOrderId: Scalars['String'];
}>;


export type CreateReturnPackageLabelMutation = (
  { __typename?: 'Mutation' }
  & { createReturnPackageLabel?: Maybe<(
    { __typename?: 'Order' }
    & Pick<Order, '_id'>
    & { returnLabels?: Maybe<Array<Maybe<(
      { __typename?: 'OrderReturnLabels' }
      & Pick<OrderReturnLabels, 'status' | 'requestCreatedAt' | 'packageLabelUrls' | 'errorMessage' | 'shipmentNumber' | 'labelNumber'>
    )>>> }
  )> }
);

export type CreateReturnPackageLabelAsAdminMutationVariables = Exact<{
  companyId: Scalars['String'];
  marketplace: Scalars['String'];
  marketplaceOrderId: Scalars['String'];
}>;


export type CreateReturnPackageLabelAsAdminMutation = (
  { __typename?: 'Mutation' }
  & { createReturnPackageLabelAsAdmin?: Maybe<(
    { __typename?: 'Order' }
    & Pick<Order, '_id'>
    & { returnLabels?: Maybe<Array<Maybe<(
      { __typename?: 'OrderReturnLabels' }
      & Pick<OrderReturnLabels, 'status' | 'requestCreatedAt' | 'packageLabelUrls' | 'errorMessage' | 'shipmentNumber' | 'labelNumber'>
    )>>> }
  )> }
);

export type CancelAlzaOrderMutationVariables = Exact<{
  orderId: Scalars['String'];
  deliveryResultStatus: Scalars['String'];
}>;


export type CancelAlzaOrderMutation = (
  { __typename?: 'Mutation' }
  & { cancelAlzaOrder?: Maybe<(
    { __typename?: 'SuccessMessage' }
    & SuccessMessagePropsFragment
  )> }
);

export type CancelAlzaShippingLabelsMutationVariables = Exact<{
  fulfillmentId: Scalars['String'];
}>;


export type CancelAlzaShippingLabelsMutation = (
  { __typename?: 'Mutation' }
  & { cancelAlzaShippingLabels?: Maybe<(
    { __typename?: 'SuccessMessage' }
    & SuccessMessagePropsFragment
  )> }
);

export type GetPickupListsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPickupListsQuery = (
  { __typename?: 'Query' }
  & { pickupListsAggregation?: Maybe<Array<Maybe<(
    { __typename?: 'PickupListsAggregation' }
    & Pick<PickupListsAggregation, 'pickupTime' | 'count' | 'pickupLists' | 'pickupListGroups'>
  )>>> }
);

export type RetryAlzaShipmentMutationVariables = Exact<{
  fulfillmentId: Scalars['String'];
  expectedRunId: Scalars['String'];
}>;


export type RetryAlzaShipmentMutation = (
  { __typename?: 'Mutation' }
  & { retryAlzaShipment?: Maybe<(
    { __typename?: 'SuccessMessage' }
    & Pick<SuccessMessage, 'success' | 'message'>
  )> }
);

export type ShipmentDepartureMutationVariables = Exact<{
  orderId: Scalars['String'];
}>;


export type ShipmentDepartureMutation = (
  { __typename?: 'Mutation' }
  & { shipmentDeparture?: Maybe<(
    { __typename?: 'ShipmentDeparture' }
    & Pick<ShipmentDeparture, 'response'>
  )> }
);

export type GetProductSourceSettingsPageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProductSourceSettingsPageQuery = (
  { __typename?: 'Query' }
  & { company?: Maybe<(
    { __typename?: 'CompanyQuery' }
    & Pick<CompanyQuery, '_id' | 'feedType'>
  )>, productSync?: Maybe<(
    { __typename?: 'ProductSync' }
    & Pick<ProductSync, '_id' | 'isFeedSyncing'>
  )>, customProductFeed?: Maybe<(
    { __typename?: 'CustomProductFeed' }
    & Pick<CustomProductFeed, 'feedUrl'>
  )> }
);

export type DeleteProductFromAppMutationVariables = Exact<{
  sku: Scalars['String'];
}>;


export type DeleteProductFromAppMutation = (
  { __typename?: 'Mutation' }
  & { deleteProduct?: Maybe<(
    { __typename?: 'SuccessMessage' }
    & SuccessMessagePropsFragment
  )> }
);

export type UpdateProductVariantMutationVariables = Exact<{
  product: ProductVariantInput;
}>;


export type UpdateProductVariantMutation = (
  { __typename?: 'Mutation' }
  & { updateProductVariant?: Maybe<Array<Maybe<(
    { __typename?: 'ProductVariant' }
    & Pick<ProductVariant, 'id' | 'sku' | 'stock' | 'locks'>
    & { asins?: Maybe<(
      { __typename?: 'Asins' }
      & Pick<Asins, 'amazon_de' | 'amazon_uk' | 'amazon_nl' | 'amazon_it' | 'amazon_fr' | 'amazon_es' | 'amazon_mx' | 'amazon_us' | 'amazon_ca' | 'amazon_br' | 'amazon_jp' | 'amazon_sg' | 'amazon_au' | 'amazon_se' | 'amazon_tr' | 'amazon_pl' | 'amazon_be' | 'amazon_ie'>
    )>, barcode?: Maybe<(
      { __typename?: 'Barcode' }
      & Pick<Barcode, 'type' | 'code'>
    )>, productStatus?: Maybe<Array<Maybe<(
      { __typename?: 'ProductStatus' }
      & Pick<ProductStatus, 'companyId' | 'marketplace' | 'sku' | 'hasAsin' | 'hasStock' | 'hasValidBarcode' | 'isBuyBoxWinner' | 'listingStatus' | 'status' | 'forbidListing'>
      & { listingErrors?: Maybe<Array<Maybe<(
        { __typename?: 'ListingError' }
        & Pick<ListingError, 'code' | 'message'>
      )>>> }
    )>>>, prices?: Maybe<(
      { __typename?: 'Prices' }
      & { amazon_de?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, amazon_uk?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, amazon_nl?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, amazon_it?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, amazon_fr?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, amazon_es?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, amazon_mx?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, amazon_us?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, amazon_ca?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, amazon_br?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, amazon_jp?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, amazon_au?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, amazon_se?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, amazon_tr?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, amazon_pl?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, amazon_be?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, amazon_ie?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, amazon_sg?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, mall_cz?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, mall_pl?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, mall_si?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, mall_hu?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, mall_sk?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, alza_cz?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )> }
    )> }
  )>>> }
);

export type UpdateForbidListingsMutationVariables = Exact<{
  productVariants?: Maybe<Array<Maybe<ProductVariantInput>>>;
}>;


export type UpdateForbidListingsMutation = (
  { __typename?: 'Mutation' }
  & { updateForbidListings?: Maybe<(
    { __typename?: 'UpdateForbidListingsResult' }
    & Pick<UpdateForbidListingsResult, 'success' | 'error' | 'totalCount' | 'foundCount' | 'notFoundSkus'>
  )> }
);

export type GetInitProductLookupQueryVariables = Exact<{
  query?: Maybe<Scalars['String']>;
  marketplace?: Maybe<Scalars['String']>;
}>;


export type GetInitProductLookupQuery = (
  { __typename?: 'Query' }
  & { productLookup?: Maybe<(
    { __typename?: 'ProductLookup' }
    & Pick<ProductLookup, 'error' | 'quotaRemaining' | 'quotaMax' | 'quotaResetIn'>
    & { products?: Maybe<Array<Maybe<(
      { __typename?: 'ProductLookupItem' }
      & Pick<ProductLookupItem, 'image' | 'title' | 'asin' | 'url' | 'group' | 'price' | 'currency' | 'color' | 'size' | 'categoryId' | 'rank'>
    )>>> }
  )> }
);

export type GetProductsWithIdQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  filter?: Maybe<FilterInputProducts>;
  sort?: Maybe<Array<Maybe<ProductsSortInput>>>;
}>;


export type GetProductsWithIdQuery = (
  { __typename?: 'Query' }
  & { products?: Maybe<(
    { __typename?: 'ProductVariantPagination' }
    & Pick<ProductVariantPagination, 'count'>
    & { items?: Maybe<Array<(
      { __typename?: 'ProductVariant' }
      & Pick<ProductVariant, '_id' | 'sku' | 'image' | 'name' | 'stock' | 'locks' | 'ecoFee' | 'vatRate' | 'itemCondition'>
      & { barcode?: Maybe<(
        { __typename?: 'Barcode' }
        & Pick<Barcode, 'type' | 'code'>
      )>, prices?: Maybe<(
        { __typename?: 'Prices' }
        & { amazon_br?: Maybe<(
          { __typename?: 'Price' }
          & Pick<Price, 'base' | 'selling'>
        )>, amazon_jp?: Maybe<(
          { __typename?: 'Price' }
          & Pick<Price, 'base' | 'selling'>
        )>, amazon_au?: Maybe<(
          { __typename?: 'Price' }
          & Pick<Price, 'base' | 'selling'>
        )>, amazon_sg?: Maybe<(
          { __typename?: 'Price' }
          & Pick<Price, 'base' | 'selling'>
        )>, amazon_de?: Maybe<(
          { __typename?: 'Price' }
          & Pick<Price, 'base' | 'selling'>
        )>, amazon_uk?: Maybe<(
          { __typename?: 'Price' }
          & Pick<Price, 'base' | 'selling'>
        )>, amazon_nl?: Maybe<(
          { __typename?: 'Price' }
          & Pick<Price, 'base' | 'selling'>
        )>, amazon_it?: Maybe<(
          { __typename?: 'Price' }
          & Pick<Price, 'base' | 'selling'>
        )>, amazon_fr?: Maybe<(
          { __typename?: 'Price' }
          & Pick<Price, 'base' | 'selling'>
        )>, amazon_es?: Maybe<(
          { __typename?: 'Price' }
          & Pick<Price, 'base' | 'selling'>
        )>, amazon_mx?: Maybe<(
          { __typename?: 'Price' }
          & Pick<Price, 'base' | 'selling'>
        )>, amazon_us?: Maybe<(
          { __typename?: 'Price' }
          & Pick<Price, 'base' | 'selling'>
        )>, amazon_ca?: Maybe<(
          { __typename?: 'Price' }
          & Pick<Price, 'base' | 'selling'>
        )>, amazon_se?: Maybe<(
          { __typename?: 'Price' }
          & Pick<Price, 'base' | 'selling'>
        )>, amazon_tr?: Maybe<(
          { __typename?: 'Price' }
          & Pick<Price, 'base' | 'selling'>
        )>, amazon_pl?: Maybe<(
          { __typename?: 'Price' }
          & Pick<Price, 'base' | 'selling'>
        )>, amazon_be?: Maybe<(
          { __typename?: 'Price' }
          & Pick<Price, 'base' | 'selling'>
        )>, amazon_ie?: Maybe<(
          { __typename?: 'Price' }
          & Pick<Price, 'base' | 'selling'>
        )>, mall_cz?: Maybe<(
          { __typename?: 'Price' }
          & Pick<Price, 'base' | 'selling'>
        )>, mall_pl?: Maybe<(
          { __typename?: 'Price' }
          & Pick<Price, 'base' | 'selling'>
        )>, mall_si?: Maybe<(
          { __typename?: 'Price' }
          & Pick<Price, 'base' | 'selling'>
        )>, mall_hu?: Maybe<(
          { __typename?: 'Price' }
          & Pick<Price, 'base' | 'selling'>
        )>, mall_sk?: Maybe<(
          { __typename?: 'Price' }
          & Pick<Price, 'base' | 'selling'>
        )>, alza_cz?: Maybe<(
          { __typename?: 'Price' }
          & Pick<Price, 'base' | 'selling'>
        )>, cdiscount_fr?: Maybe<(
          { __typename?: 'Price' }
          & Pick<Price, 'base' | 'selling'>
        )>, kaufland_de?: Maybe<(
          { __typename?: 'Price' }
          & Pick<Price, 'base' | 'selling'>
        )>, kaufland_cz?: Maybe<(
          { __typename?: 'Price' }
          & Pick<Price, 'base' | 'selling'>
        )>, kaufland_sk?: Maybe<(
          { __typename?: 'Price' }
          & Pick<Price, 'base' | 'selling'>
        )>, kaufland_at?: Maybe<(
          { __typename?: 'Price' }
          & Pick<Price, 'base' | 'selling'>
        )>, kaufland_pl?: Maybe<(
          { __typename?: 'Price' }
          & Pick<Price, 'base' | 'selling'>
        )>, kaufland_nl?: Maybe<(
          { __typename?: 'Price' }
          & Pick<Price, 'base' | 'selling'>
        )>, kaufland_es?: Maybe<(
          { __typename?: 'Price' }
          & Pick<Price, 'base' | 'selling'>
        )>, kaufland_fr?: Maybe<(
          { __typename?: 'Price' }
          & Pick<Price, 'base' | 'selling'>
        )>, kaufland_it?: Maybe<(
          { __typename?: 'Price' }
          & Pick<Price, 'base' | 'selling'>
        )> }
      )>, asins?: Maybe<(
        { __typename?: 'Asins' }
        & Pick<Asins, 'amazon_mx' | 'amazon_us' | 'amazon_ca' | 'amazon_br' | 'amazon_de' | 'amazon_uk' | 'amazon_fr' | 'amazon_it' | 'amazon_es' | 'amazon_nl' | 'amazon_se' | 'amazon_tr' | 'amazon_pl' | 'amazon_be' | 'amazon_ie' | 'amazon_sg' | 'amazon_au' | 'amazon_jp'>
      )>, marketplaceSkus?: Maybe<(
        { __typename?: 'MarketplaceSkus' }
        & Pick<MarketplaceSkus, 'emag'>
      )>, productStatus?: Maybe<Array<Maybe<(
        { __typename?: 'ProductStatus' }
        & Pick<ProductStatus, 'companyId' | 'marketplace' | 'sku' | 'hasAsin' | 'hasStock' | 'hasValidBarcode' | 'isBuyBoxWinner' | 'listingStatus' | 'status' | 'forbidListing'>
        & { listingErrors?: Maybe<Array<Maybe<(
          { __typename?: 'ListingError' }
          & Pick<ListingError, 'code' | 'message'>
        )>>> }
      )>>> }
    )>>, pageInfo: (
      { __typename?: 'PaginationInfo' }
      & Pick<PaginationInfo, 'pageCount' | 'itemCount' | 'hasNextPage' | 'hasPreviousPage' | 'perPage' | 'currentPage'>
    ) }
  )> }
);

export type RemoveAllProductsMutationVariables = Exact<{ [key: string]: never; }>;


export type RemoveAllProductsMutation = (
  { __typename?: 'Mutation' }
  & { deleteProduct?: Maybe<(
    { __typename?: 'SuccessMessage' }
    & SuccessMessagePropsFragment
  )> }
);

export type SyncSettingsFieldsFragment = (
  { __typename?: 'SyncSettings' }
  & Pick<SyncSettings, '_id' | 'japoId' | 'packetaApiPassword'>
  & { fulfillment?: Maybe<(
    { __typename?: 'SyncSettingsFulfillment' }
    & Pick<SyncSettingsFulfillment, 'automapCarrier'>
  )>, mall?: Maybe<(
    { __typename?: 'SyncSettingsMall' }
    & Pick<SyncSettingsMall, 'synchronizePrices' | 'synchronizeStock' | 'matchNewProducts'>
  )>, cdiscount?: Maybe<(
    { __typename?: 'SyncSettingsCdiscount' }
    & Pick<SyncSettingsCdiscount, 'synchronizePrices' | 'synchronizeStock' | 'matchNewProducts'>
  )>, bol?: Maybe<(
    { __typename?: 'SyncSettingsBol' }
    & Pick<SyncSettingsBol, 'synchronizePrices' | 'synchronizeStock' | 'matchNewProducts'>
  )>, allegro?: Maybe<(
    { __typename?: 'SyncSettingsAllegro' }
    & Pick<SyncSettingsAllegro, 'synchronizePrices' | 'synchronizeStock' | 'matchNewProducts'>
  )>, real?: Maybe<(
    { __typename?: 'SyncSettingsReal' }
    & Pick<SyncSettingsReal, 'synchronizePrices' | 'synchronizeStock' | 'matchNewProducts'>
  )>, kaufland_de?: Maybe<(
    { __typename?: 'SyncSettingsKaufland_de' }
    & Pick<SyncSettingsKaufland_de, 'synchronizePrices' | 'synchronizeStock' | 'matchNewProducts' | 'downloadNewOrders' | 'downloadOrderUnitStatusChange'>
  )>, kaufland_cz?: Maybe<(
    { __typename?: 'SyncSettingsKaufland_cz' }
    & Pick<SyncSettingsKaufland_cz, 'synchronizePrices' | 'synchronizeStock' | 'matchNewProducts' | 'downloadNewOrders' | 'downloadOrderUnitStatusChange'>
  )>, kaufland_sk?: Maybe<(
    { __typename?: 'SyncSettingsKaufland_sk' }
    & Pick<SyncSettingsKaufland_sk, 'synchronizePrices' | 'synchronizeStock' | 'matchNewProducts' | 'downloadNewOrders' | 'downloadOrderUnitStatusChange'>
  )>, kaufland_at?: Maybe<(
    { __typename?: 'SyncSettingsKaufland_at' }
    & Pick<SyncSettingsKaufland_at, 'synchronizePrices' | 'synchronizeStock' | 'matchNewProducts' | 'downloadNewOrders' | 'downloadOrderUnitStatusChange'>
  )>, kaufland_pl?: Maybe<(
    { __typename?: 'SyncSettingsKaufland_pl' }
    & Pick<SyncSettingsKaufland_pl, 'synchronizePrices' | 'synchronizeStock' | 'matchNewProducts' | 'downloadNewOrders' | 'downloadOrderUnitStatusChange'>
  )>, kaufland_nl?: Maybe<(
    { __typename?: 'SyncSettingsKaufland_nl' }
    & Pick<SyncSettingsKaufland_nl, 'synchronizePrices' | 'synchronizeStock' | 'matchNewProducts' | 'downloadNewOrders' | 'downloadOrderUnitStatusChange'>
  )>, kaufland_es?: Maybe<(
    { __typename?: 'SyncSettingsKaufland_es' }
    & Pick<SyncSettingsKaufland_es, 'synchronizePrices' | 'synchronizeStock' | 'matchNewProducts' | 'downloadNewOrders' | 'downloadOrderUnitStatusChange'>
  )>, kaufland_fr?: Maybe<(
    { __typename?: 'SyncSettingsKaufland_fr' }
    & Pick<SyncSettingsKaufland_fr, 'synchronizePrices' | 'synchronizeStock' | 'matchNewProducts' | 'downloadNewOrders' | 'downloadOrderUnitStatusChange'>
  )>, kaufland_it?: Maybe<(
    { __typename?: 'SyncSettingsKaufland_it' }
    & Pick<SyncSettingsKaufland_it, 'synchronizePrices' | 'synchronizeStock' | 'matchNewProducts' | 'downloadNewOrders' | 'downloadOrderUnitStatusChange'>
  )>, amazon?: Maybe<(
    { __typename?: 'SyncSettingsAmazon' }
    & Pick<SyncSettingsAmazon, 'listNewProducts' | 'synchronizePrices' | 'synchronizeStock' | 'downloadPricing' | 'zeroUnmatchedProducts' | 'ignoreZeroStockProducts' | 'automaticallyCancelRequest'>
  )>, autopricing?: Maybe<(
    { __typename?: 'SyncSettingsAutopricing' }
    & { amazon_de?: Maybe<(
      { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
      & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'autoActivation' | 'defaultTopCap' | 'defaultBottomCap'>
    )>, amazon_uk?: Maybe<(
      { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
      & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'autoActivation' | 'defaultTopCap' | 'defaultBottomCap'>
    )>, amazon_es?: Maybe<(
      { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
      & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'autoActivation' | 'defaultTopCap' | 'defaultBottomCap'>
    )>, amazon_it?: Maybe<(
      { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
      & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'autoActivation' | 'defaultTopCap' | 'defaultBottomCap'>
    )>, amazon_fr?: Maybe<(
      { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
      & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'autoActivation' | 'defaultTopCap' | 'defaultBottomCap'>
    )>, amazon_nl?: Maybe<(
      { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
      & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'autoActivation' | 'defaultTopCap' | 'defaultBottomCap'>
    )>, amazon_us?: Maybe<(
      { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
      & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'autoActivation' | 'defaultTopCap' | 'defaultBottomCap'>
    )>, amazon_mx?: Maybe<(
      { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
      & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'autoActivation' | 'defaultTopCap' | 'defaultBottomCap'>
    )>, amazon_ca?: Maybe<(
      { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
      & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'autoActivation' | 'defaultTopCap' | 'defaultBottomCap'>
    )>, amazon_br?: Maybe<(
      { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
      & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'autoActivation' | 'defaultTopCap' | 'defaultBottomCap'>
    )>, amazon_sg?: Maybe<(
      { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
      & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'autoActivation' | 'defaultTopCap' | 'defaultBottomCap'>
    )>, amazon_jp?: Maybe<(
      { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
      & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'autoActivation' | 'defaultTopCap' | 'defaultBottomCap'>
    )>, amazon_au?: Maybe<(
      { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
      & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'autoActivation' | 'defaultTopCap' | 'defaultBottomCap'>
    )>, amazon_se?: Maybe<(
      { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
      & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'autoActivation' | 'defaultTopCap' | 'defaultBottomCap'>
    )>, amazon_tr?: Maybe<(
      { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
      & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'autoActivation' | 'defaultTopCap' | 'defaultBottomCap'>
    )>, amazon_pl?: Maybe<(
      { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
      & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'autoActivation' | 'defaultTopCap' | 'defaultBottomCap'>
    )>, amazon_be?: Maybe<(
      { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
      & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'autoActivation' | 'defaultTopCap' | 'defaultBottomCap'>
    )>, amazon_ie?: Maybe<(
      { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
      & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'autoActivation' | 'defaultTopCap' | 'defaultBottomCap'>
    )>, kaufland_de?: Maybe<(
      { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
      & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'autoActivation' | 'defaultTopCap' | 'defaultBottomCap'>
    )>, kaufland_cz?: Maybe<(
      { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
      & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'autoActivation' | 'defaultTopCap' | 'defaultBottomCap'>
    )>, kaufland_sk?: Maybe<(
      { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
      & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'autoActivation' | 'defaultTopCap' | 'defaultBottomCap'>
    )>, kaufland_at?: Maybe<(
      { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
      & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'autoActivation' | 'defaultTopCap' | 'defaultBottomCap'>
    )>, kaufland_pl?: Maybe<(
      { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
      & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'autoActivation' | 'defaultTopCap' | 'defaultBottomCap'>
    )>, kaufland_nl?: Maybe<(
      { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
      & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'autoActivation' | 'defaultTopCap' | 'defaultBottomCap'>
    )>, kaufland_es?: Maybe<(
      { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
      & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'autoActivation' | 'defaultTopCap' | 'defaultBottomCap'>
    )>, kaufland_fr?: Maybe<(
      { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
      & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'autoActivation' | 'defaultTopCap' | 'defaultBottomCap'>
    )>, kaufland_it?: Maybe<(
      { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
      & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'autoActivation' | 'defaultTopCap' | 'defaultBottomCap'>
    )>, cdiscount_fr?: Maybe<(
      { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
      & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'autoActivation' | 'defaultTopCap' | 'defaultBottomCap'>
    )> }
  )>, returnLabels?: Maybe<(
    { __typename?: 'SyncSettingsReturnLabels' }
    & Pick<SyncSettingsReturnLabels, 'automaticLabelCreation'>
  )> }
);

export type GetSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSettingsQuery = (
  { __typename?: 'Query' }
  & { company?: Maybe<(
    { __typename?: 'CompanyQuery' }
    & Pick<CompanyQuery, '_id' | 'feedType'>
  )>, marketplaces?: Maybe<Array<Maybe<(
    { __typename?: 'MarketplaceStatus' }
    & Pick<MarketplaceStatus, 'id' | 'marketplace' | 'region' | 'hidden'>
  )>>>, syncSettings?: Maybe<(
    { __typename?: 'SyncSettings' }
    & SyncSettingsFieldsFragment
  )>, shoptetOrderStatuses?: Maybe<Array<Maybe<(
    { __typename?: 'ShoptetOrderStatus' }
    & Pick<ShoptetOrderStatus, 'code' | 'name'>
  )>>>, mallDeliveryMethods?: Maybe<Array<Maybe<(
    { __typename?: 'MallDeliveryMethod' }
    & Pick<MallDeliveryMethod, 'marketplace' | 'code' | 'title'>
  )>>>, glamiDeliveryMethods?: Maybe<Array<Maybe<(
    { __typename?: 'GlamiDeliveryMethod' }
    & Pick<GlamiDeliveryMethod, 'code' | 'title'>
  )>>>, importSettings?: Maybe<Array<Maybe<(
    { __typename?: 'ImportSettings' }
    & Pick<ImportSettings, '_id' | 'marketplaceType' | 'service' | 'defaultOrderStatus' | 'lowerStockOnOrder' | 'importOrderJustOnce' | 'synchronizeOrders' | 'synchronizeFbaOrders' | 'shipmentMethod' | 'carrier' | 'carrierName' | 'autoconfirmOrderOnStatus' | 'orderShippingOnStatus' | 'orderDeliveredOnStatus' | 'importShoptetCancelOrderStatus' | 'shoptetCancelOrderStatus'>
    & { deliveryMethodsMapping?: Maybe<Array<Maybe<(
      { __typename?: 'ImportSettingsDeliveryMethodsMapping' }
      & Pick<ImportSettingsDeliveryMethodsMapping, 'marketplace' | 'method' | 'serviceMethod'>
    )>>>, paymentMethodsMapping?: Maybe<Array<Maybe<(
      { __typename?: 'ImportSettingsPaymentMethodsMapping' }
      & Pick<ImportSettingsPaymentMethodsMapping, 'method' | 'serviceMethod'>
    )>>> }
  )>>>, platformStatuses?: Maybe<(
    { __typename?: 'PlatformStatuses' }
    & { amazon?: Maybe<(
      { __typename?: 'PlatformStatus' }
      & Pick<PlatformStatus, 'active' | 'connected'>
    )>, mall?: Maybe<(
      { __typename?: 'PlatformStatus' }
      & Pick<PlatformStatus, 'active' | 'connected'>
    )>, alza?: Maybe<(
      { __typename?: 'PlatformStatus' }
      & Pick<PlatformStatus, 'active' | 'connected'>
    )>, glami?: Maybe<(
      { __typename?: 'PlatformStatus' }
      & Pick<PlatformStatus, 'active' | 'connected'>
    )>, cdiscount?: Maybe<(
      { __typename?: 'PlatformStatus' }
      & Pick<PlatformStatus, 'active' | 'connected'>
    )>, real?: Maybe<(
      { __typename?: 'PlatformStatus' }
      & Pick<PlatformStatus, 'active' | 'connected'>
    )>, kaufland?: Maybe<(
      { __typename?: 'PlatformStatus' }
      & Pick<PlatformStatus, 'active' | 'connected'>
    )>, bol?: Maybe<(
      { __typename?: 'PlatformStatus' }
      & Pick<PlatformStatus, 'active' | 'connected'>
    )>, allegro?: Maybe<(
      { __typename?: 'PlatformStatus' }
      & Pick<PlatformStatus, 'active' | 'connected'>
    )> }
  )>, shoptetPaymentMethods?: Maybe<Array<Maybe<(
    { __typename?: 'ShoptetPaymentMethod' }
    & Pick<ShoptetPaymentMethod, 'guid' | 'name'>
  )>>>, stornoStatusEnabledFeatureToggle?: Maybe<(
    { __typename?: 'FeatureToggle' }
    & Pick<FeatureToggle, 'enabled'>
  )>, automatchFeatureToggle?: Maybe<(
    { __typename?: 'FeatureToggle' }
    & Pick<FeatureToggle, 'enabled'>
  )>, kauflandNew?: Maybe<(
    { __typename?: 'FeatureToggle' }
    & Pick<FeatureToggle, 'enabled'>
  )>, partnerMarketplaces?: Maybe<(
    { __typename?: 'FeatureToggle' }
    & Pick<FeatureToggle, 'enabled'>
  )> }
);

export type GetEmailNotificationSettingsQueryVariables = Exact<{
  platform?: Maybe<Scalars['String']>;
}>;


export type GetEmailNotificationSettingsQuery = (
  { __typename?: 'Query' }
  & { emailNotificationSettings?: Maybe<(
    { __typename?: 'EmailNotificationSettings' }
    & Pick<EmailNotificationSettings, 'platform' | 'active'>
  )> }
);

export type SaveEmailNotificationSettingsMutationVariables = Exact<{
  platform: Platform;
  active: Scalars['Boolean'];
}>;


export type SaveEmailNotificationSettingsMutation = (
  { __typename?: 'Mutation' }
  & { saveEmailNotificationSettings?: Maybe<(
    { __typename?: 'SuccessMessage' }
    & SuccessMessagePropsFragment
  )> }
);

export type UpdateSettingsMutationVariables = Exact<{
  settings?: Maybe<SyncSettingsInput>;
}>;


export type UpdateSettingsMutation = (
  { __typename?: 'Mutation' }
  & { setSyncSettings?: Maybe<(
    { __typename?: 'SyncSettings' }
    & SyncSettingsFieldsFragment
  )> }
);

export type UpdateImportSettingsMutationVariables = Exact<{
  settings?: Maybe<ImportSettingsInput>;
}>;


export type UpdateImportSettingsMutation = (
  { __typename?: 'Mutation' }
  & { setImportSettings?: Maybe<Array<Maybe<(
    { __typename?: 'ImportSettings' }
    & Pick<ImportSettings, '_id' | 'marketplaceType' | 'service' | 'defaultOrderStatus' | 'lowerStockOnOrder' | 'importOrderJustOnce' | 'synchronizeOrders' | 'synchronizeFbaOrders' | 'shipmentMethod' | 'carrier' | 'carrierName' | 'autoconfirmOrderOnStatus' | 'orderShippingOnStatus' | 'orderDeliveredOnStatus' | 'importShoptetCancelOrderStatus' | 'shoptetCancelOrderStatus'>
    & { deliveryMethodsMapping?: Maybe<Array<Maybe<(
      { __typename?: 'ImportSettingsDeliveryMethodsMapping' }
      & Pick<ImportSettingsDeliveryMethodsMapping, 'marketplace' | 'method' | 'serviceMethod'>
    )>>> }
  )>>> }
);

export type GetShipmentMethodsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetShipmentMethodsQuery = (
  { __typename?: 'Query' }
  & { shoptetShipmentMethods?: Maybe<Array<Maybe<(
    { __typename?: 'ShoptetShipmentMethod' }
    & Pick<ShoptetShipmentMethod, 'guid' | 'name'>
  )>>> }
);

export type GetCompanyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompanyQuery = (
  { __typename?: 'Query' }
  & { company?: Maybe<(
    { __typename?: 'CompanyQuery' }
    & Pick<CompanyQuery, '_id' | 'feedType'>
  )> }
);

export type GetCompanySettingsQueryVariables = Exact<{
  companyId?: Maybe<Scalars['String']>;
}>;


export type GetCompanySettingsQuery = (
  { __typename?: 'Query' }
  & { getGoogleDataStudioUrl?: Maybe<(
    { __typename?: 'googleDataStudioUrl' }
    & Pick<googleDataStudioUrl, '_id' | 'googleDataStudioUrl'>
  )>, getInternalCompanyName?: Maybe<(
    { __typename?: 'internalCompanyName' }
    & Pick<internalCompanyName, '_id' | 'internalName'>
  )>, getReturnAddress?: Maybe<(
    { __typename?: 'CompanyReturnAddressDoc' }
    & Pick<CompanyReturnAddressDoc, '_id'>
    & { returnAddress?: Maybe<(
      { __typename?: 'CompanyReturnAddress' }
      & Pick<CompanyReturnAddress, 'companyName' | 'name' | 'countryCode' | 'city' | 'zipCode' | 'street' | 'phone' | 'email'>
    )> }
  )> }
);

export type UpdateGdsUrlMutationVariables = Exact<{
  companyId?: Maybe<Scalars['String']>;
  googleDataStudioUrl?: Maybe<Scalars['String']>;
}>;


export type UpdateGdsUrlMutation = (
  { __typename?: 'Mutation' }
  & { updateGoogleDataStudioUrl?: Maybe<(
    { __typename?: 'CompanyQuery' }
    & Pick<CompanyQuery, '_id' | 'googleDataStudioUrl'>
  )> }
);

export type UpdateInternalCompanyNameMutationVariables = Exact<{
  companyId?: Maybe<Scalars['String']>;
  internalName?: Maybe<Scalars['String']>;
}>;


export type UpdateInternalCompanyNameMutation = (
  { __typename?: 'Mutation' }
  & { updateInternalCompanyName?: Maybe<(
    { __typename?: 'CompanyQuery' }
    & Pick<CompanyQuery, '_id' | 'internalName'>
  )> }
);

export type UpdateReturnAddressDocMutationVariables = Exact<{
  companyId?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  countryCode: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  street: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  zipCode: Scalars['String'];
  city: Scalars['String'];
}>;


export type UpdateReturnAddressDocMutation = (
  { __typename?: 'Mutation' }
  & { updateReturnAddressDoc?: Maybe<(
    { __typename?: 'CompanyQuery' }
    & Pick<CompanyQuery, '_id'>
    & { returnAddress?: Maybe<(
      { __typename?: 'CompanyReturnAddress' }
      & Pick<CompanyReturnAddress, 'companyName' | 'name' | 'countryCode' | 'email' | 'street' | 'phone' | 'zipCode' | 'city'>
    )> }
  )> }
);

export type UpdateSubscriptionMutationVariables = Exact<{
  subscriptionSettingsInput?: Maybe<SubscriptionSchemaInput>;
}>;


export type UpdateSubscriptionMutation = (
  { __typename?: 'Mutation' }
  & { setSubscription?: Maybe<(
    { __typename?: 'SubscriptionSchema' }
    & Pick<SubscriptionSchema, '_id' | 'companyId' | 'isActive' | 'amount' | 'from' | 'currency'>
  )> }
);

export type DiscardTrialDeadlineMutationVariables = Exact<{
  email: Scalars['String'];
  companyId: Scalars['String'];
}>;


export type DiscardTrialDeadlineMutation = (
  { __typename?: 'Mutation' }
  & { discardTrialDeadline: (
    { __typename?: 'DiscardTrialDeadlineResult' }
    & Pick<DiscardTrialDeadlineResult, 'success'>
  ) }
);

export type ThanosCompanyMutationVariables = Exact<{
  companyId?: Maybe<Scalars['String']>;
}>;


export type ThanosCompanyMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'thanos'>
);

export type GetUsersTableDataQueryVariables = Exact<{
  page: Scalars['Int'];
  perPage: Scalars['Int'];
  search: Scalars['String'];
  isAutopricingFilterActive: Scalars['Boolean'];
  autopricingFilterValue?: Maybe<Scalars['Boolean']>;
  feedTypeFilterValue?: Maybe<Scalars['String']>;
  onboardingStateFilterValue?: Maybe<Scalars['String']>;
}>;


export type GetUsersTableDataQuery = (
  { __typename?: 'Query' }
  & { usersPagination?: Maybe<(
    { __typename?: 'UserQueryPagination' }
    & Pick<UserQueryPagination, 'count'>
    & { items?: Maybe<Array<(
      { __typename?: 'UserQuery' }
      & Pick<UserQuery, '_id' | 'email' | 'createdAt' | 'name'>
      & { roles?: Maybe<Array<Maybe<(
        { __typename?: 'UserRoles' }
        & Pick<UserRoles, 'type' | 'companyId'>
        & { company?: Maybe<(
          { __typename?: 'CompanyQuery' }
          & Pick<CompanyQuery, '_id' | 'active' | 'blocked' | 'name' | 'internalName' | 'onboardingState' | 'feedType' | 'googleDataStudioUrl'>
          & { subscription?: Maybe<(
            { __typename?: 'SubscriptionSchema' }
            & Pick<SubscriptionSchema, '_id' | 'companyId' | 'isActive' | 'amount' | 'from' | 'currency'>
          )> }
        )>, settings?: Maybe<(
          { __typename?: 'SyncSettings' }
          & Pick<SyncSettings, '_id'>
          & { amazon?: Maybe<(
            { __typename?: 'SyncSettingsAmazon' }
            & Pick<SyncSettingsAmazon, 'downloadPricing' | 'listNewProducts' | 'synchronizePrices' | 'synchronizeStock' | 'zeroUnmatchedProducts' | 'ignoreZeroStockProducts' | 'automaticallyCancelRequest'>
          )>, autopricing?: Maybe<(
            { __typename?: 'SyncSettingsAutopricing' }
            & { amazon_au?: Maybe<(
              { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
              & Pick<SyncSettingsAutopricingAmazon_mx, 'active'>
            )>, amazon_br?: Maybe<(
              { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
              & Pick<SyncSettingsAutopricingAmazon_mx, 'active'>
            )>, amazon_ca?: Maybe<(
              { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
              & Pick<SyncSettingsAutopricingAmazon_mx, 'active'>
            )>, amazon_de?: Maybe<(
              { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
              & Pick<SyncSettingsAutopricingAmazon_mx, 'active'>
            )>, amazon_es?: Maybe<(
              { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
              & Pick<SyncSettingsAutopricingAmazon_mx, 'active'>
            )>, amazon_fr?: Maybe<(
              { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
              & Pick<SyncSettingsAutopricingAmazon_mx, 'active'>
            )>, amazon_it?: Maybe<(
              { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
              & Pick<SyncSettingsAutopricingAmazon_mx, 'active'>
            )>, amazon_jp?: Maybe<(
              { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
              & Pick<SyncSettingsAutopricingAmazon_mx, 'active'>
            )>, amazon_mx?: Maybe<(
              { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
              & Pick<SyncSettingsAutopricingAmazon_mx, 'active'>
            )>, amazon_uk?: Maybe<(
              { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
              & Pick<SyncSettingsAutopricingAmazon_mx, 'active'>
            )>, amazon_nl?: Maybe<(
              { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
              & Pick<SyncSettingsAutopricingAmazon_mx, 'active'>
            )>, amazon_us?: Maybe<(
              { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
              & Pick<SyncSettingsAutopricingAmazon_mx, 'active'>
            )>, amazon_se?: Maybe<(
              { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
              & Pick<SyncSettingsAutopricingAmazon_mx, 'active'>
            )>, amazon_tr?: Maybe<(
              { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
              & Pick<SyncSettingsAutopricingAmazon_mx, 'active'>
            )>, amazon_pl?: Maybe<(
              { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
              & Pick<SyncSettingsAutopricingAmazon_mx, 'active'>
            )> }
          )> }
        )>, marketplaces?: Maybe<Array<Maybe<(
          { __typename?: 'MarketplaceActivity' }
          & Pick<MarketplaceActivity, 'marketplace' | 'status'>
        )>>> }
      )>>> }
    )>>, pageInfo: (
      { __typename?: 'PaginationInfo' }
      & Pick<PaginationInfo, 'currentPage' | 'perPage' | 'itemCount'>
    ) }
  )>, deleteCompanyEnabledFeaturetoggle?: Maybe<(
    { __typename?: 'FeatureToggle' }
    & Pick<FeatureToggle, 'enabled'>
  )> }
);

export type SuccessMessagePropsFragment = (
  { __typename?: 'SuccessMessage' }
  & Pick<SuccessMessage, 'success' | 'message' | 'error'>
);

export type CompleteShoptetLoginMutationVariables = Exact<{
  code: Scalars['String'];
  state: Scalars['String'];
}>;


export type CompleteShoptetLoginMutation = (
  { __typename?: 'Mutation' }
  & { completeShoptetLogin?: Maybe<(
    { __typename?: 'CompleteShoptetLoginResult' }
    & Pick<CompleteShoptetLoginResult, 'redirectUrl'>
  )> }
);

export type ConfirmEmailMutationVariables = Exact<{
  code: Scalars['String'];
}>;


export type ConfirmEmailMutation = (
  { __typename?: 'Mutation' }
  & { completeRegistration?: Maybe<(
    { __typename?: 'EmailVerification' }
    & Pick<EmailVerification, 'email' | 'hasExpired' | 'verified'>
  )> }
);

export type FinalizePasswordResetMutationVariables = Exact<{
  code: Scalars['String'];
  password: Scalars['String'];
}>;


export type FinalizePasswordResetMutation = (
  { __typename?: 'Mutation' }
  & { resetPassword?: Maybe<(
    { __typename?: 'ResetPasswordResult' }
    & Pick<ResetPasswordResult, 'codeAlreadyUsed' | 'codeExpired' | 'invalidCode' | 'success'>
  )> }
);

export type LoginAsUserMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type LoginAsUserMutation = (
  { __typename?: 'Mutation' }
  & { superLogin: (
    { __typename?: 'SuperloginResult' }
    & Pick<SuperloginResult, 'success'>
  ) }
);

export type ResetPasswordMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type ResetPasswordMutation = (
  { __typename?: 'Mutation' }
  & { sendPasswordResetEmail: (
    { __typename?: 'CreatePasswordResetEmailResult' }
    & Pick<CreatePasswordResetEmailResult, 'email' | 'invalidEmail' | 'success'>
  ) }
);

export type StartShoptetLoginMutationVariables = Exact<{
  redirectUrl?: Maybe<Scalars['String']>;
  shopId?: Maybe<Scalars['String']>;
  shopHostname?: Maybe<Scalars['String']>;
}>;


export type StartShoptetLoginMutation = (
  { __typename?: 'Mutation' }
  & { startShoptetLogin?: Maybe<(
    { __typename?: 'StartShoptetLoginResult' }
    & Pick<StartShoptetLoginResult, 'authUrl'>
  )> }
);

export type RequestAutopricingReportMutationVariables = Exact<{
  filters?: Maybe<AutopricingReportFilterOptionsInput>;
  relevantRanges?: Maybe<AutopricingReportRelevantRangesOptionsInput>;
  fieldWeights?: Maybe<AutopricingReportFieldWeightsOptionsInput>;
}>;


export type RequestAutopricingReportMutation = (
  { __typename?: 'Mutation' }
  & { requestAutopricingReport?: Maybe<(
    { __typename?: 'AutopricingReport' }
    & Pick<AutopricingReport, 'state'>
  )> }
);

export type GetAutopricingReportQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAutopricingReportQuery = (
  { __typename?: 'Query' }
  & { getAutopricingReport?: Maybe<(
    { __typename?: 'AutopricingReport' }
    & Pick<AutopricingReport, 'state' | 'progress' | 'createdAt' | 'finishedAt'>
    & { resultItems?: Maybe<Array<Maybe<(
      { __typename?: 'AutopricingReportResultItem' }
      & { autopricing?: Maybe<(
        { __typename?: 'Autopricing' }
        & Pick<Autopricing, 'marketplace' | 'autoprice' | 'topCap' | 'bottomCap'>
        & { salesRank?: Maybe<(
          { __typename?: 'PricingSalesRank' }
          & Pick<PricingSalesRank, 'rank'>
        )> }
      )>, variant?: Maybe<(
        { __typename?: 'ProductVariant' }
        & Pick<ProductVariant, 'sku' | 'name' | 'stock'>
      )>, recommendation?: Maybe<(
        { __typename?: 'AutopricingReportRecommendation' }
        & Pick<AutopricingReportRecommendation, 'bottomLimitShift' | 'topLimitShift'>
      )> }
    )>>> }
  )> }
);

export type GetSyncSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSyncSettingsQuery = (
  { __typename?: 'Query' }
  & { syncSettings?: Maybe<(
    { __typename?: 'SyncSettings' }
    & Pick<SyncSettings, '_id'>
    & { autopricing?: Maybe<(
      { __typename?: 'SyncSettingsAutopricing' }
      & { amazon_au?: Maybe<(
        { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
        & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'defaultTopCap' | 'defaultBottomCap'>
      )>, amazon_br?: Maybe<(
        { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
        & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'defaultTopCap' | 'defaultBottomCap'>
      )>, amazon_ca?: Maybe<(
        { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
        & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'defaultTopCap' | 'defaultBottomCap'>
      )>, amazon_de?: Maybe<(
        { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
        & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'defaultTopCap' | 'defaultBottomCap'>
      )>, amazon_es?: Maybe<(
        { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
        & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'defaultTopCap' | 'defaultBottomCap'>
      )>, amazon_fr?: Maybe<(
        { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
        & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'defaultTopCap' | 'defaultBottomCap'>
      )>, amazon_it?: Maybe<(
        { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
        & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'defaultTopCap' | 'defaultBottomCap'>
      )>, amazon_jp?: Maybe<(
        { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
        & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'defaultTopCap' | 'defaultBottomCap'>
      )>, amazon_mx?: Maybe<(
        { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
        & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'defaultTopCap' | 'defaultBottomCap'>
      )>, amazon_uk?: Maybe<(
        { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
        & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'defaultTopCap' | 'defaultBottomCap'>
      )>, amazon_nl?: Maybe<(
        { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
        & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'defaultTopCap' | 'defaultBottomCap'>
      )>, amazon_us?: Maybe<(
        { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
        & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'defaultTopCap' | 'defaultBottomCap'>
      )>, kaufland_de?: Maybe<(
        { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
        & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'defaultTopCap' | 'defaultBottomCap'>
      )>, kaufland_sk?: Maybe<(
        { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
        & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'defaultTopCap' | 'defaultBottomCap'>
      )>, kaufland_cz?: Maybe<(
        { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
        & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'defaultTopCap' | 'defaultBottomCap'>
      )>, kaufland_at?: Maybe<(
        { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
        & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'defaultTopCap' | 'defaultBottomCap'>
      )>, kaufland_pl?: Maybe<(
        { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
        & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'defaultTopCap' | 'defaultBottomCap'>
      )>, kaufland_nl?: Maybe<(
        { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
        & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'defaultTopCap' | 'defaultBottomCap'>
      )>, kaufland_es?: Maybe<(
        { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
        & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'defaultTopCap' | 'defaultBottomCap'>
      )>, kaufland_fr?: Maybe<(
        { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
        & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'defaultTopCap' | 'defaultBottomCap'>
      )>, kaufland_it?: Maybe<(
        { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
        & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'defaultTopCap' | 'defaultBottomCap'>
      )>, cdiscount_fr?: Maybe<(
        { __typename?: 'SyncSettingsAutopricingAmazon_mx' }
        & Pick<SyncSettingsAutopricingAmazon_mx, 'active' | 'defaultTopCap' | 'defaultBottomCap'>
      )> }
    )> }
  )> }
);

export type GetReturnAddressAsUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReturnAddressAsUserQuery = (
  { __typename?: 'Query' }
  & { company?: Maybe<(
    { __typename?: 'CompanyQuery' }
    & { returnAddress?: Maybe<(
      { __typename?: 'CompanyReturnAddress' }
      & Pick<CompanyReturnAddress, 'companyName' | 'name' | 'countryCode' | 'city' | 'zipCode' | 'street' | 'phone' | 'email'>
    )> }
  )> }
);

export type GetReturnAddressAsAdminQueryVariables = Exact<{
  companyId: Scalars['String'];
}>;


export type GetReturnAddressAsAdminQuery = (
  { __typename?: 'Query' }
  & { getReturnAddress?: Maybe<(
    { __typename?: 'CompanyReturnAddressDoc' }
    & Pick<CompanyReturnAddressDoc, '_id'>
    & { returnAddress?: Maybe<(
      { __typename?: 'CompanyReturnAddress' }
      & Pick<CompanyReturnAddress, 'companyName' | 'name' | 'countryCode' | 'city' | 'zipCode' | 'street' | 'phone' | 'email'>
    )> }
  )> }
);

export type UpdateOnboardingStateMutationVariables = Exact<{
  state: EnumCompanyOnboardingState;
}>;


export type UpdateOnboardingStateMutation = (
  { __typename?: 'Mutation' }
  & { updateOnboardingState?: Maybe<(
    { __typename?: 'CompanyQuery' }
    & Pick<CompanyQuery, 'isOnboarding' | 'onboardingState'>
  )> }
);

export type UpdateReturnAddressMutationVariables = Exact<{
  companyName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  countryCode: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  street: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  zipCode: Scalars['String'];
  city: Scalars['String'];
}>;


export type UpdateReturnAddressMutation = (
  { __typename?: 'Mutation' }
  & { updateReturnAddress?: Maybe<(
    { __typename?: 'CompanyQuery' }
    & { returnAddress?: Maybe<(
      { __typename?: 'CompanyReturnAddress' }
      & Pick<CompanyReturnAddress, 'companyName' | 'name' | 'countryCode' | 'email' | 'street' | 'phone' | 'zipCode' | 'city'>
    )> }
  )> }
);

export type GetFeedConvertReportQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
}>;


export type GetFeedConvertReportQuery = (
  { __typename?: 'Query' }
  & { getFeedConvertReport?: Maybe<(
    { __typename?: 'FeedConvertReport' }
    & Pick<FeedConvertReport, 'id' | 'state' | 'progress'>
    & { result?: Maybe<(
      { __typename?: 'FeedConvertResultItem' }
      & Pick<FeedConvertResultItem, 'downloadUrl'>
    )> }
  )> }
);

export type RequestFeedConvertReportMutationVariables = Exact<{
  url?: Maybe<Scalars['String']>;
}>;


export type RequestFeedConvertReportMutation = (
  { __typename?: 'Mutation' }
  & { requestFeedConvertReport?: Maybe<(
    { __typename?: 'FeedConvertReport' }
    & Pick<FeedConvertReport, 'id' | 'state'>
  )> }
);

export type FeedPropsFragment = (
  { __typename?: 'CustomProductFeed' }
  & Pick<CustomProductFeed, 'feedUrl' | 'feedSample' | 'setupState' | 'status' | 'item' | 'elementNames'>
  & { mapping?: Maybe<(
    { __typename?: 'CustomFeedMapping' }
    & Pick<CustomFeedMapping, 'g__id' | 'g__gtin' | 'g__price' | 'g__title' | 'g__image_link' | 'eco_fee' | 'quantity' | 'shipping_template' | 'handling_time' | 'vat_rate' | 'condition' | 'prices_amazon_de' | 'prices_amazon_fr' | 'prices_amazon_it' | 'prices_amazon_es' | 'prices_amazon_uk' | 'prices_amazon_nl' | 'prices_amazon_se' | 'prices_amazon_be' | 'prices_amazon_ie' | 'prices_amazon_tr' | 'prices_amazon_pl' | 'prices_amazon_sg' | 'prices_amazon_au' | 'prices_amazon_jp' | 'prices_amazon_us' | 'prices_amazon_ca' | 'prices_amazon_mx' | 'prices_amazon_br' | 'prices_alza_cz' | 'prices_mall_cz' | 'prices_mall_sk' | 'prices_mall_pl' | 'prices_mall_hu' | 'prices_emag_pl' | 'prices_emag_hu' | 'prices_emag_ro' | 'prices_emag_bg' | 'prices_cdiscount_fr' | 'prices_kaufland_de' | 'prices_kaufland_cz' | 'prices_kaufland_sk' | 'prices_kaufland_at' | 'prices_kaufland_pl' | 'prices_kaufland_nl' | 'prices_kaufland_es' | 'prices_kaufland_fr' | 'prices_kaufland_it' | 'autopricing_amazon_mx_status' | 'autopricing_amazon_mx_min_percentage' | 'autopricing_amazon_mx_max_percentage' | 'autopricing_amazon_mx_min_absolute' | 'autopricing_amazon_mx_max_absolute' | 'autopricing_amazon_us_status' | 'autopricing_amazon_us_min_percentage' | 'autopricing_amazon_us_max_percentage' | 'autopricing_amazon_us_min_absolute' | 'autopricing_amazon_us_max_absolute' | 'autopricing_amazon_ca_status' | 'autopricing_amazon_ca_min_percentage' | 'autopricing_amazon_ca_max_percentage' | 'autopricing_amazon_ca_min_absolute' | 'autopricing_amazon_ca_max_absolute' | 'autopricing_amazon_br_status' | 'autopricing_amazon_br_min_percentage' | 'autopricing_amazon_br_max_percentage' | 'autopricing_amazon_br_min_absolute' | 'autopricing_amazon_br_max_absolute' | 'autopricing_amazon_de_status' | 'autopricing_amazon_de_min_percentage' | 'autopricing_amazon_de_max_percentage' | 'autopricing_amazon_de_min_absolute' | 'autopricing_amazon_de_max_absolute' | 'autopricing_amazon_uk_status' | 'autopricing_amazon_uk_min_percentage' | 'autopricing_amazon_uk_max_percentage' | 'autopricing_amazon_uk_min_absolute' | 'autopricing_amazon_uk_max_absolute' | 'autopricing_amazon_fr_status' | 'autopricing_amazon_fr_min_percentage' | 'autopricing_amazon_fr_max_percentage' | 'autopricing_amazon_fr_min_absolute' | 'autopricing_amazon_fr_max_absolute' | 'autopricing_amazon_it_status' | 'autopricing_amazon_it_min_percentage' | 'autopricing_amazon_it_max_percentage' | 'autopricing_amazon_it_min_absolute' | 'autopricing_amazon_it_max_absolute' | 'autopricing_amazon_es_status' | 'autopricing_amazon_es_min_percentage' | 'autopricing_amazon_es_max_percentage' | 'autopricing_amazon_es_min_absolute' | 'autopricing_amazon_es_max_absolute' | 'autopricing_amazon_nl_status' | 'autopricing_amazon_nl_min_percentage' | 'autopricing_amazon_nl_max_percentage' | 'autopricing_amazon_nl_min_absolute' | 'autopricing_amazon_nl_max_absolute' | 'autopricing_amazon_se_status' | 'autopricing_amazon_se_min_percentage' | 'autopricing_amazon_se_max_percentage' | 'autopricing_amazon_se_min_absolute' | 'autopricing_amazon_se_max_absolute' | 'autopricing_amazon_tr_status' | 'autopricing_amazon_tr_min_percentage' | 'autopricing_amazon_tr_max_percentage' | 'autopricing_amazon_tr_min_absolute' | 'autopricing_amazon_tr_max_absolute' | 'autopricing_amazon_pl_status' | 'autopricing_amazon_pl_min_percentage' | 'autopricing_amazon_pl_max_percentage' | 'autopricing_amazon_pl_min_absolute' | 'autopricing_amazon_pl_max_absolute' | 'autopricing_amazon_be_status' | 'autopricing_amazon_be_min_percentage' | 'autopricing_amazon_be_max_percentage' | 'autopricing_amazon_be_min_absolute' | 'autopricing_amazon_be_max_absolute' | 'autopricing_amazon_ie_status' | 'autopricing_amazon_ie_min_percentage' | 'autopricing_amazon_ie_max_percentage' | 'autopricing_amazon_ie_min_absolute' | 'autopricing_amazon_ie_max_absolute' | 'autopricing_amazon_sg_status' | 'autopricing_amazon_sg_min_percentage' | 'autopricing_amazon_sg_max_percentage' | 'autopricing_amazon_sg_min_absolute' | 'autopricing_amazon_sg_max_absolute' | 'autopricing_amazon_au_status' | 'autopricing_amazon_au_min_percentage' | 'autopricing_amazon_au_max_percentage' | 'autopricing_amazon_au_min_absolute' | 'autopricing_amazon_au_max_absolute' | 'autopricing_amazon_jp_status' | 'autopricing_amazon_jp_min_percentage' | 'autopricing_amazon_jp_max_percentage' | 'autopricing_amazon_jp_min_absolute' | 'autopricing_amazon_jp_max_absolute'>
  )>, pathValues?: Maybe<Array<Maybe<(
    { __typename?: 'FeedPathValues' }
    & Pick<FeedPathValues, 'path' | 'values'>
  )>>> }
);

export type SaveCustomFeedMutationVariables = Exact<{
  feed?: Maybe<CustomProductFeedInput>;
  step?: Maybe<EFeedSetupState>;
}>;


export type SaveCustomFeedMutation = (
  { __typename?: 'Mutation' }
  & { setCustomProductFeed?: Maybe<(
    { __typename?: 'CustomProductFeed' }
    & FeedPropsFragment
  )> }
);

export type CustomProductFeedQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomProductFeedQuery = (
  { __typename?: 'Query' }
  & { customProductFeed?: Maybe<(
    { __typename?: 'CustomProductFeed' }
    & FeedPropsFragment
  )> }
);

export type GetFeedSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFeedSummaryQuery = (
  { __typename?: 'Query' }
  & { productFeedResult?: Maybe<(
    { __typename?: 'ProductFeedResult' }
    & Pick<ProductFeedResult, 'isConnected' | 'productsInStock' | 'productsWithEAN' | 'productsAll' | 'productsToBeListed' | 'error'>
  )>, productSync?: Maybe<(
    { __typename?: 'ProductSync' }
    & Pick<ProductSync, '_id' | 'isFeedSyncing'>
  )> }
);

export type GetFulfillmentQueryVariables = Exact<{
  marketplace: MarketplaceName;
  marketplaceOrderId: Scalars['String'];
}>;


export type GetFulfillmentQuery = (
  { __typename?: 'Query' }
  & { fulfillment?: Maybe<(
    { __typename?: 'Fulfillment' }
    & Pick<Fulfillment, '_id' | 'trackingNumber' | 'shipDate' | 'carrier' | 'carrierName' | 'shipMethod' | 'trackingUrl' | 'marketplaceOrderIds'>
    & { packages?: Maybe<Array<Maybe<(
      { __typename?: 'FulfillmentPackages' }
      & Pick<FulfillmentPackages, 'number' | 'fullNumber' | 'weight'>
      & { items?: Maybe<Array<Maybe<(
        { __typename?: 'FulfillmentPackagesItems' }
        & Pick<FulfillmentPackagesItems, 'marketplaceItemId' | 'marketplaceOrderId' | 'quantity' | 'serials'>
      )>>> }
    )>>> }
  )> }
);

export type UpdateFulfillmentMutationVariables = Exact<{
  fulfillment: FulfillmentInput;
  fulfillmentChannel: Scalars['String'];
}>;


export type UpdateFulfillmentMutation = (
  { __typename?: 'Mutation' }
  & { updateFulfillment?: Maybe<(
    { __typename?: 'Fulfillment' }
    & Pick<Fulfillment, '_id' | 'trackingNumber' | 'shipDate' | 'carrier' | 'trackingUrl' | 'syncError'>
  )> }
);

export type DeleteMarketplaceConnectionMutationVariables = Exact<{
  serviceScope?: Maybe<MarketplaceRegion>;
}>;


export type DeleteMarketplaceConnectionMutation = (
  { __typename?: 'Mutation' }
  & { deleteMarketplaceConnection?: Maybe<(
    { __typename?: 'SuccessMessage' }
    & SuccessMessagePropsFragment
  )> }
);

export type CredentialsQueryVariables = Exact<{
  serviceScope?: Maybe<MarketplaceRegion>;
}>;


export type CredentialsQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'credentials'>
);

export type GetMarketplacesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMarketplacesQuery = (
  { __typename?: 'Query' }
  & { marketplaces?: Maybe<Array<Maybe<(
    { __typename?: 'MarketplaceStatus' }
    & Pick<MarketplaceStatus, 'id' | 'marketplace' | 'region' | 'currency' | 'error' | 'hidden' | 'status'>
    & { formula?: Maybe<(
      { __typename?: 'Formula' }
      & Pick<Formula, 'add' | 'multiply'>
    )> }
  )>>> }
);

export type SaveCredentialsMutationVariables = Exact<{
  serviceScope?: Maybe<MarketplaceRegion>;
  apiBaseUrl?: Maybe<Scalars['String']>;
  buyerId?: Maybe<Scalars['String']>;
  supplierId?: Maybe<Scalars['String']>;
  supplierBranchId?: Maybe<Scalars['String']>;
  sellerId?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  clientId?: Maybe<Scalars['String']>;
  clientKey?: Maybe<Scalars['String']>;
  secretKey?: Maybe<Scalars['String']>;
}>;


export type SaveCredentialsMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'saveCredentials'>
);

export type UpdateMarketplaceMutationVariables = Exact<{
  status?: Maybe<UpdateMwsMarketplaceInputStatus>;
  marketplace: MarketplaceName;
}>;


export type UpdateMarketplaceMutation = (
  { __typename?: 'Mutation' }
  & { updateMarketplaceStatus?: Maybe<Array<Maybe<(
    { __typename?: 'MarketplaceStatus' }
    & Pick<MarketplaceStatus, 'id' | 'marketplace' | 'region' | 'currency' | 'error' | 'hidden' | 'status'>
    & { formula?: Maybe<(
      { __typename?: 'Formula' }
      & Pick<Formula, 'add' | 'multiply'>
    )> }
  )>>> }
);

export type GetOrdersPageQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  filter?: Maybe<FilterOrdersInput>;
  sort?: Maybe<Array<Maybe<OrdersSortInput>>>;
  featureToggleName: EFeatureName;
}>;


export type GetOrdersPageQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'unshippedOrdersCount'>
  & { orders?: Maybe<(
    { __typename?: 'OrderPagination' }
    & Pick<OrderPagination, 'count'>
    & { items?: Maybe<Array<(
      { __typename?: 'Order' }
      & Pick<Order, '_id' | 'companyId' | 'marketplaceOrderId' | 'totalPrice' | 'totalDiscount' | 'shipServiceLevel' | 'shippingCarrierIdentification' | 'currencyCode' | 'packageLabels' | 'fulfillmentChannel' | 'status' | 'purchaseDate' | 'marketplace' | 'isComplete' | 'isBusinessOrder' | 'isPremiumOrder' | 'isRefunded' | 'shippingPrice' | 'deliveryBranchId' | 'latestShipDate' | 'selectedShipDate' | 'autopricingTotal'>
      & { delivery?: Maybe<(
        { __typename?: 'OrderDelivery' }
        & Pick<OrderDelivery, 'shippingCarrier' | 'shippingCarrierService'>
      )>, invoices?: Maybe<Array<Maybe<(
        { __typename?: 'OrderInvoices' }
        & Pick<OrderInvoices, 'url'>
      )>>>, parcelShop?: Maybe<(
        { __typename?: 'OrderParcelShop' }
        & Pick<OrderParcelShop, 'parcelShopBranchCode'>
      )>, marketplaceDeliveryMethod?: Maybe<(
        { __typename?: 'OrderMarketplaceDeliveryMethod' }
        & Pick<OrderMarketplaceDeliveryMethod, 'code' | 'name'>
      )>, payment?: Maybe<(
        { __typename?: 'OrderPayment' }
        & Pick<OrderPayment, 'paymentMethod'>
        & { cashOnDelivery?: Maybe<(
          { __typename?: 'OrderPaymentCashOnDelivery' }
          & Pick<OrderPaymentCashOnDelivery, 'toPay' | 'servicePrice'>
        )> }
      )>, items?: Maybe<Array<Maybe<(
        { __typename?: 'OrderItems' }
        & Pick<OrderItems, 'sku' | 'asin' | 'quantity' | 'price' | 'name' | 'tax' | 'marketplaceItemId' | 'deliveryItemIds' | 'serialNumbersRequired'>
      )>>>, buyer?: Maybe<(
        { __typename?: 'OrderBuyer' }
        & Pick<OrderBuyer, 'companyName' | 'name' | 'city' | 'addressLine' | 'countryCode' | 'zipCode' | 'taxId' | 'email' | 'phone' | 'stateOrRegion'>
      )>, deliveryAddress?: Maybe<(
        { __typename?: 'OrderBillingAddress' }
        & Pick<OrderBillingAddress, 'companyName' | 'name' | 'city' | 'addressLine' | 'countryCode' | 'zip' | 'email' | 'phone' | 'province'>
      )>, returnLabels?: Maybe<Array<Maybe<(
        { __typename?: 'OrderReturnLabels' }
        & Pick<OrderReturnLabels, 'status' | 'requestCreatedAt' | 'packageLabelUrls' | 'errorMessage' | 'shipmentNumber' | 'labelNumber'>
      )>>>, fulfillment?: Maybe<(
        { __typename?: 'Fulfillment' }
        & Pick<Fulfillment, '_id' | 'fulfillmentId' | 'shipDate' | 'shipMethod' | 'trackingNumber' | 'trackingUrl' | 'marketplaceOrderIds' | 'carrier' | 'carrierName' | 'status' | 'lastChanged' | 'lastConfirmed' | 'nextRetryAt' | 'labelGenerationStopped' | 'labelGenerationContactAlza' | 'labelGenerationRetryRunId' | 'syncError'>
        & { packages?: Maybe<Array<Maybe<(
          { __typename?: 'FulfillmentPackages' }
          & Pick<FulfillmentPackages, 'weight' | 'number' | 'fullNumber'>
          & { items?: Maybe<Array<Maybe<(
            { __typename?: 'FulfillmentPackagesItems' }
            & Pick<FulfillmentPackagesItems, 'marketplaceItemId' | 'marketplaceOrderId' | 'quantity' | 'serials'>
          )>>> }
        )>>> }
      )>, user?: Maybe<(
        { __typename?: 'UserQuery' }
        & Pick<UserQuery, '_id' | 'email'>
      )> }
    )>>, pageInfo: (
      { __typename?: 'PaginationInfo' }
      & Pick<PaginationInfo, 'currentPage' | 'hasNextPage' | 'hasPreviousPage' | 'itemCount'>
    ) }
  )>, todayStats?: Maybe<(
    { __typename?: 'RangedOrderStatistics' }
    & Pick<RangedOrderStatistics, 'count'>
    & { money?: Maybe<(
      { __typename?: 'Money' }
      & Pick<Money, 'currency' | 'value'>
    )> }
  )>, lastThirtyDaysStats?: Maybe<(
    { __typename?: 'RangedOrderStatistics' }
    & Pick<RangedOrderStatistics, 'count'>
    & { money?: Maybe<(
      { __typename?: 'Money' }
      & Pick<Money, 'currency' | 'value'>
    )> }
  )>, user?: Maybe<(
    { __typename?: 'UserQuery' }
    & Pick<UserQuery, '_id' | 'isSuperadmin'>
  )>, syncSettings?: Maybe<(
    { __typename?: 'SyncSettings' }
    & Pick<SyncSettings, '_id' | 'japoId'>
  )>, bulkConfirmOrdersFeatureToggle?: Maybe<(
    { __typename?: 'FeatureToggle' }
    & Pick<FeatureToggle, 'enabled'>
  )>, alzaFullnumberFeaturetoggle?: Maybe<(
    { __typename?: 'FeatureToggle' }
    & Pick<FeatureToggle, 'enabled'>
  )> }
);

export type FindAllByIdsQueryVariables = Exact<{
  marketplaceOrderIds: Array<Maybe<Scalars['String']>>;
}>;


export type FindAllByIdsQuery = (
  { __typename?: 'Query' }
  & { ordersByIds?: Maybe<Array<Maybe<(
    { __typename?: 'Order' }
    & Pick<Order, '_id'>
    & { items?: Maybe<Array<Maybe<(
      { __typename?: 'OrderItems' }
      & Pick<OrderItems, 'sku' | 'asin' | 'quantity' | 'price' | 'name' | 'marketplaceItemId' | 'deliveryItemIds' | 'serialNumbersRequired'>
    )>>> }
  )>>> }
);

export type GetPlatformStatusesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPlatformStatusesQuery = (
  { __typename?: 'Query' }
  & { platformStatuses?: Maybe<(
    { __typename?: 'PlatformStatuses' }
    & { alza?: Maybe<(
      { __typename?: 'PlatformStatus' }
      & Pick<PlatformStatus, 'active' | 'connected'>
    )>, amazon?: Maybe<(
      { __typename?: 'PlatformStatus' }
      & Pick<PlatformStatus, 'active' | 'connected'>
    )>, mall?: Maybe<(
      { __typename?: 'PlatformStatus' }
      & Pick<PlatformStatus, 'active' | 'connected'>
    )>, real?: Maybe<(
      { __typename?: 'PlatformStatus' }
      & Pick<PlatformStatus, 'active' | 'connected'>
    )>, kaufland?: Maybe<(
      { __typename?: 'PlatformStatus' }
      & Pick<PlatformStatus, 'active' | 'connected'>
    )>, glami?: Maybe<(
      { __typename?: 'PlatformStatus' }
      & Pick<PlatformStatus, 'active' | 'connected'>
    )> }
  )>, glamiEnabledFeaturetoggle?: Maybe<(
    { __typename?: 'FeatureToggle' }
    & Pick<FeatureToggle, 'enabled'>
  )>, ebayEnabledFeaturetoggle?: Maybe<(
    { __typename?: 'FeatureToggle' }
    & Pick<FeatureToggle, 'enabled'>
  )> }
);

export type CountProductVariantsMutationVariables = Exact<{ [key: string]: never; }>;


export type CountProductVariantsMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'countProductVariants'>
);

export type ExportProductsMutationVariables = Exact<{
  filter?: Maybe<FilterInputProducts>;
  sort?: Maybe<Array<Maybe<ProductsSortInput>>>;
}>;


export type ExportProductsMutation = (
  { __typename?: 'Mutation' }
  & { exportProducts?: Maybe<(
    { __typename?: 'ProductExport' }
    & Pick<ProductExport, '_id' | 'status' | 'requestedAt'>
  )> }
);

export type GetProductExportQueryVariables = Exact<{
  exportId: Scalars['String'];
}>;


export type GetProductExportQuery = (
  { __typename?: 'Query' }
  & { productExport?: Maybe<(
    { __typename?: 'ProductExport' }
    & Pick<ProductExport, '_id' | 'status' | 'requestedAt' | 'doneAt' | 'failedAt' | 'downloadLink'>
  )> }
);

export type GetProductExportsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProductExportsQuery = (
  { __typename?: 'Query' }
  & { productExports?: Maybe<Array<Maybe<(
    { __typename?: 'ProductExport' }
    & Pick<ProductExport, '_id' | 'status' | 'requestedAt' | 'doneAt' | 'failedAt' | 'downloadLink'>
  )>>> }
);

export type GetItemConditionsQueryVariables = Exact<{
  service: Scalars['String'];
}>;


export type GetItemConditionsQuery = (
  { __typename?: 'Query' }
  & { getItemConditionList?: Maybe<Array<Maybe<(
    { __typename?: 'ItemCondition' }
    & Pick<ItemCondition, 'isDefault' | 'itemCondition' | 'itemConditionCode' | 'itemNote'>
  )>>> }
);

export type GetProductStatsQueryVariables = Exact<{
  marketplace?: Maybe<Scalars['String']>;
  hasStockFilter?: Maybe<Scalars['Boolean']>;
}>;


export type GetProductStatsQuery = (
  { __typename?: 'Query' }
  & { productStats?: Maybe<(
    { __typename?: 'ProductStats' }
    & Pick<ProductStats, 'marketplaces' | 'ok' | 'paused' | 'notFound' | 'error' | 'missingBarcode'>
  )> }
);

export type ImportProductVariantsMutationVariables = Exact<{
  products: Array<Maybe<ProductVariantInput>>;
}>;


export type ImportProductVariantsMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'uploadProductVariants'>
);

export type UpdateProductVariantsMutationVariables = Exact<{
  products: Array<Maybe<ProductVariantInput>>;
}>;


export type UpdateProductVariantsMutation = (
  { __typename?: 'Mutation' }
  & { updateProductVariant?: Maybe<Array<Maybe<(
    { __typename?: 'ProductVariant' }
    & Pick<ProductVariant, 'id' | 'sku' | 'stock' | 'locks'>
    & { asins?: Maybe<(
      { __typename?: 'Asins' }
      & Pick<Asins, 'amazon_de' | 'amazon_uk' | 'amazon_nl' | 'amazon_it' | 'amazon_fr' | 'amazon_es' | 'amazon_mx' | 'amazon_us' | 'amazon_ca' | 'amazon_br' | 'amazon_jp' | 'amazon_au' | 'amazon_se' | 'amazon_tr' | 'amazon_pl' | 'amazon_be' | 'amazon_ie' | 'amazon_sg'>
    )>, barcode?: Maybe<(
      { __typename?: 'Barcode' }
      & Pick<Barcode, 'type' | 'code'>
    )>, prices?: Maybe<(
      { __typename?: 'Prices' }
      & { amazon_de?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, amazon_uk?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, amazon_nl?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, amazon_it?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, amazon_fr?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, amazon_es?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, amazon_mx?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, amazon_us?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, amazon_ca?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, amazon_br?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, amazon_jp?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, amazon_au?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, amazon_se?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, amazon_tr?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, amazon_pl?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, amazon_be?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, amazon_ie?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, amazon_sg?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, mall_cz?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, mall_pl?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, mall_si?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, mall_hu?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, mall_sk?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, alza_cz?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, emag_pl?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, emag_hu?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, emag_ro?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, emag_bg?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, real_de?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, kaufland_de?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, kaufland_cz?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, kaufland_sk?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, kaufland_at?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, kaufland_pl?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, kaufland_nl?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, kaufland_es?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, kaufland_fr?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, kaufland_it?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )>, cdiscount_fr?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'selling'>
      )> }
    )> }
  )>>> }
);

export type GetPricingReportQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
}>;


export type GetPricingReportQuery = (
  { __typename?: 'Query' }
  & { getPricingReport?: Maybe<(
    { __typename?: 'PricingReport' }
    & Pick<PricingReport, 'id' | 'state'>
    & { result?: Maybe<(
      { __typename?: 'PricingReportResultItem' }
      & Pick<PricingReportResultItem, 'reportLink'>
    )> }
  )> }
);

export type RequestPricingReportMutationVariables = Exact<{
  service?: Maybe<MarketplaceName>;
}>;


export type RequestPricingReportMutation = (
  { __typename?: 'Mutation' }
  & { requestPricingReport?: Maybe<(
    { __typename?: 'PricingReport' }
    & Pick<PricingReport, 'id' | 'state'>
  )> }
);

export type GetShipmentInfoQueryVariables = Exact<{
  shipmentNumbers?: Maybe<Array<Scalars['String']>>;
}>;


export type GetShipmentInfoQuery = (
  { __typename?: 'Query' }
  & { getShipmentInfo?: Maybe<(
    { __typename?: 'ShipmentInfoResult' }
    & { shipments?: Maybe<Array<Maybe<(
      { __typename?: 'ShipmentInfoItem' }
      & Pick<ShipmentInfoItem, 'shipmentNumber' | 'externalShipmentNumber' | 'shipmentStateName' | 'shipmentStateDate'>
    )>>> }
  )> }
);

export type ShoptetFullSyncMutationVariables = Exact<{ [key: string]: never; }>;


export type ShoptetFullSyncMutation = (
  { __typename?: 'Mutation' }
  & { shoptetFullSync?: Maybe<(
    { __typename?: 'SuccessMessage' }
    & Pick<SuccessMessage, 'success' | 'message' | 'error'>
  )> }
);

export type GetShopInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetShopInfoQuery = (
  { __typename?: 'Query' }
  & { shopInfo?: Maybe<(
    { __typename?: 'ShopInfo' }
    & Pick<ShopInfo, 'shopId' | 'hostname'>
    & { addons?: Maybe<(
      { __typename?: 'Addons' }
      & { mall?: Maybe<(
        { __typename?: 'Addon' }
        & Pick<Addon, 'active'>
      )>, amazon?: Maybe<(
        { __typename?: 'Addon' }
        & Pick<Addon, 'active'>
      )>, alza?: Maybe<(
        { __typename?: 'Addon' }
        & Pick<Addon, 'active'>
      )>, kaufland?: Maybe<(
        { __typename?: 'Addon' }
        & Pick<Addon, 'active'>
      )> }
    )> }
  )> }
);

export type GetUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserQuery = (
  { __typename?: 'Query' }
  & { user?: Maybe<(
    { __typename?: 'UserQuery' }
    & Pick<UserQuery, '_id' | 'email' | 'name' | 'isSuperadmin' | 'isConfirmed' | 'daysLeftToConfirm'>
    & { tos?: Maybe<(
      { __typename?: 'UserTos' }
      & Pick<UserTos, 'acceptedAt' | 'acceptedIpAddress' | 'version'>
    )>, roles?: Maybe<Array<Maybe<(
      { __typename?: 'UserRoles' }
      & Pick<UserRoles, 'companyId'>
    )>>> }
  )> }
);

export type GetUserCompanyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserCompanyQuery = (
  { __typename?: 'Query' }
  & { company?: Maybe<(
    { __typename?: 'CompanyQuery' }
    & Pick<CompanyQuery, '_id' | 'name' | 'feedType' | 'onboardingState' | 'isOnboarding'>
  )> }
);

export type GetUserFeaturesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserFeaturesQuery = (
  { __typename?: 'Query' }
  & { featureToggleList?: Maybe<(
    { __typename?: 'FeatureToggleList' }
    & Pick<FeatureToggleList, 'pass' | 'block'>
  )> }
);

export type UpdateToSMutationVariables = Exact<{
  update: UserInput;
}>;


export type UpdateToSMutation = (
  { __typename?: 'Mutation' }
  & { updateUser?: Maybe<(
    { __typename?: 'UserQuery' }
    & Pick<UserQuery, '_id'>
    & { tos?: Maybe<(
      { __typename?: 'UserTos' }
      & Pick<UserTos, 'acceptedAt' | 'version'>
    )> }
  )> }
);

export type userStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type userStatsQuery = (
  { __typename?: 'Query' }
  & { userStats?: Maybe<Array<Maybe<(
    { __typename?: 'UserRow' }
    & Pick<UserRow, 'username' | 'companyId'>
  )>>> }
);

export type UserRegistrationMutationVariables = Exact<{
  dto: UserRegistrationDto;
}>;


export type UserRegistrationMutation = (
  { __typename?: 'Mutation' }
  & { userRegistration?: Maybe<(
    { __typename?: 'UserRegistrationRes' }
    & Pick<UserRegistrationRes, 'email' | 'error'>
  )> }
);

export const SyncSettingsFieldsFragmentDoc = gql`
    fragment SyncSettingsFields on SyncSettings {
  _id
  japoId
  packetaApiPassword
  fulfillment {
    automapCarrier
  }
  mall {
    synchronizePrices
    synchronizeStock
    matchNewProducts
  }
  cdiscount {
    synchronizePrices
    synchronizeStock
    matchNewProducts
  }
  bol {
    synchronizePrices
    synchronizeStock
    matchNewProducts
  }
  allegro {
    synchronizePrices
    synchronizeStock
    matchNewProducts
  }
  real {
    synchronizePrices
    synchronizeStock
    matchNewProducts
  }
  kaufland_de {
    synchronizePrices
    synchronizeStock
    matchNewProducts
    downloadNewOrders
    downloadOrderUnitStatusChange
  }
  kaufland_cz {
    synchronizePrices
    synchronizeStock
    matchNewProducts
    downloadNewOrders
    downloadOrderUnitStatusChange
  }
  kaufland_sk {
    synchronizePrices
    synchronizeStock
    matchNewProducts
    downloadNewOrders
    downloadOrderUnitStatusChange
  }
  kaufland_at {
    synchronizePrices
    synchronizeStock
    matchNewProducts
    downloadNewOrders
    downloadOrderUnitStatusChange
  }
  kaufland_pl {
    synchronizePrices
    synchronizeStock
    matchNewProducts
    downloadNewOrders
    downloadOrderUnitStatusChange
  }
  kaufland_nl {
    synchronizePrices
    synchronizeStock
    matchNewProducts
    downloadNewOrders
    downloadOrderUnitStatusChange
  }
  kaufland_es {
    synchronizePrices
    synchronizeStock
    matchNewProducts
    downloadNewOrders
    downloadOrderUnitStatusChange
  }
  kaufland_fr {
    synchronizePrices
    synchronizeStock
    matchNewProducts
    downloadNewOrders
    downloadOrderUnitStatusChange
  }
  kaufland_it {
    synchronizePrices
    synchronizeStock
    matchNewProducts
    downloadNewOrders
    downloadOrderUnitStatusChange
  }
  amazon {
    listNewProducts
    synchronizePrices
    synchronizeStock
    downloadPricing
    zeroUnmatchedProducts
    ignoreZeroStockProducts
    automaticallyCancelRequest
  }
  autopricing {
    amazon_de {
      active
      autoActivation
      defaultTopCap
      defaultBottomCap
    }
    amazon_uk {
      active
      autoActivation
      defaultTopCap
      defaultBottomCap
    }
    amazon_es {
      active
      autoActivation
      defaultTopCap
      defaultBottomCap
    }
    amazon_it {
      active
      autoActivation
      defaultTopCap
      defaultBottomCap
    }
    amazon_fr {
      active
      autoActivation
      defaultTopCap
      defaultBottomCap
    }
    amazon_nl {
      active
      autoActivation
      defaultTopCap
      defaultBottomCap
    }
    amazon_us {
      active
      autoActivation
      defaultTopCap
      defaultBottomCap
    }
    amazon_mx {
      active
      autoActivation
      defaultTopCap
      defaultBottomCap
    }
    amazon_ca {
      active
      autoActivation
      defaultTopCap
      defaultBottomCap
    }
    amazon_br {
      active
      autoActivation
      defaultTopCap
      defaultBottomCap
    }
    amazon_sg {
      active
      autoActivation
      defaultTopCap
      defaultBottomCap
    }
    amazon_jp {
      active
      autoActivation
      defaultTopCap
      defaultBottomCap
    }
    amazon_au {
      active
      autoActivation
      defaultTopCap
      defaultBottomCap
    }
    amazon_se {
      active
      autoActivation
      defaultTopCap
      defaultBottomCap
    }
    amazon_tr {
      active
      autoActivation
      defaultTopCap
      defaultBottomCap
    }
    amazon_pl {
      active
      autoActivation
      defaultTopCap
      defaultBottomCap
    }
    amazon_be {
      active
      autoActivation
      defaultTopCap
      defaultBottomCap
    }
    amazon_ie {
      active
      autoActivation
      defaultTopCap
      defaultBottomCap
    }
    kaufland_de {
      active
      autoActivation
      defaultTopCap
      defaultBottomCap
    }
    kaufland_cz {
      active
      autoActivation
      defaultTopCap
      defaultBottomCap
    }
    kaufland_sk {
      active
      autoActivation
      defaultTopCap
      defaultBottomCap
    }
    kaufland_at {
      active
      autoActivation
      defaultTopCap
      defaultBottomCap
    }
    kaufland_pl {
      active
      autoActivation
      defaultTopCap
      defaultBottomCap
    }
    kaufland_nl {
      active
      autoActivation
      defaultTopCap
      defaultBottomCap
    }
    kaufland_es {
      active
      autoActivation
      defaultTopCap
      defaultBottomCap
    }
    kaufland_fr {
      active
      autoActivation
      defaultTopCap
      defaultBottomCap
    }
    kaufland_it {
      active
      autoActivation
      defaultTopCap
      defaultBottomCap
    }
    cdiscount_fr {
      active
      autoActivation
      defaultTopCap
      defaultBottomCap
    }
  }
  returnLabels {
    automaticLabelCreation
  }
}
    `;
export const SuccessMessagePropsFragmentDoc = gql`
    fragment SuccessMessageProps on SuccessMessage {
  success
  message
  error
}
    `;
export const FeedPropsFragmentDoc = gql`
    fragment FeedProps on CustomProductFeed {
  feedUrl
  feedSample
  setupState
  status
  item
  elementNames
  mapping {
    g__id
    g__gtin
    g__price
    g__title
    g__image_link
    eco_fee
    quantity
    shipping_template
    handling_time
    vat_rate
    condition
    prices_amazon_de
    prices_amazon_fr
    prices_amazon_it
    prices_amazon_es
    prices_amazon_uk
    prices_amazon_nl
    prices_amazon_se
    prices_amazon_be
    prices_amazon_ie
    prices_amazon_tr
    prices_amazon_pl
    prices_amazon_sg
    prices_amazon_au
    prices_amazon_jp
    prices_amazon_us
    prices_amazon_ca
    prices_amazon_mx
    prices_amazon_br
    prices_alza_cz
    prices_mall_cz
    prices_mall_sk
    prices_mall_pl
    prices_mall_hu
    prices_emag_pl
    prices_emag_hu
    prices_emag_ro
    prices_emag_bg
    prices_cdiscount_fr
    prices_kaufland_de
    prices_kaufland_cz
    prices_kaufland_sk
    prices_kaufland_at
    prices_kaufland_pl
    prices_kaufland_nl
    prices_kaufland_es
    prices_kaufland_fr
    prices_kaufland_it
    autopricing_amazon_mx_status
    autopricing_amazon_mx_min_percentage
    autopricing_amazon_mx_max_percentage
    autopricing_amazon_mx_min_absolute
    autopricing_amazon_mx_max_absolute
    autopricing_amazon_us_status
    autopricing_amazon_us_min_percentage
    autopricing_amazon_us_max_percentage
    autopricing_amazon_us_min_absolute
    autopricing_amazon_us_max_absolute
    autopricing_amazon_ca_status
    autopricing_amazon_ca_min_percentage
    autopricing_amazon_ca_max_percentage
    autopricing_amazon_ca_min_absolute
    autopricing_amazon_ca_max_absolute
    autopricing_amazon_br_status
    autopricing_amazon_br_min_percentage
    autopricing_amazon_br_max_percentage
    autopricing_amazon_br_min_absolute
    autopricing_amazon_br_max_absolute
    autopricing_amazon_de_status
    autopricing_amazon_de_min_percentage
    autopricing_amazon_de_max_percentage
    autopricing_amazon_de_min_absolute
    autopricing_amazon_de_max_absolute
    autopricing_amazon_uk_status
    autopricing_amazon_uk_min_percentage
    autopricing_amazon_uk_max_percentage
    autopricing_amazon_uk_min_absolute
    autopricing_amazon_uk_max_absolute
    autopricing_amazon_fr_status
    autopricing_amazon_fr_min_percentage
    autopricing_amazon_fr_max_percentage
    autopricing_amazon_fr_min_absolute
    autopricing_amazon_fr_max_absolute
    autopricing_amazon_it_status
    autopricing_amazon_it_min_percentage
    autopricing_amazon_it_max_percentage
    autopricing_amazon_it_min_absolute
    autopricing_amazon_it_max_absolute
    autopricing_amazon_es_status
    autopricing_amazon_es_min_percentage
    autopricing_amazon_es_max_percentage
    autopricing_amazon_es_min_absolute
    autopricing_amazon_es_max_absolute
    autopricing_amazon_nl_status
    autopricing_amazon_nl_min_percentage
    autopricing_amazon_nl_max_percentage
    autopricing_amazon_nl_min_absolute
    autopricing_amazon_nl_max_absolute
    autopricing_amazon_se_status
    autopricing_amazon_se_min_percentage
    autopricing_amazon_se_max_percentage
    autopricing_amazon_se_min_absolute
    autopricing_amazon_se_max_absolute
    autopricing_amazon_tr_status
    autopricing_amazon_tr_min_percentage
    autopricing_amazon_tr_max_percentage
    autopricing_amazon_tr_min_absolute
    autopricing_amazon_tr_max_absolute
    autopricing_amazon_pl_status
    autopricing_amazon_pl_min_percentage
    autopricing_amazon_pl_max_percentage
    autopricing_amazon_pl_min_absolute
    autopricing_amazon_pl_max_absolute
    autopricing_amazon_be_status
    autopricing_amazon_be_min_percentage
    autopricing_amazon_be_max_percentage
    autopricing_amazon_be_min_absolute
    autopricing_amazon_be_max_absolute
    autopricing_amazon_ie_status
    autopricing_amazon_ie_min_percentage
    autopricing_amazon_ie_max_percentage
    autopricing_amazon_ie_min_absolute
    autopricing_amazon_ie_max_absolute
    autopricing_amazon_sg_status
    autopricing_amazon_sg_min_percentage
    autopricing_amazon_sg_max_percentage
    autopricing_amazon_sg_min_absolute
    autopricing_amazon_sg_max_absolute
    autopricing_amazon_au_status
    autopricing_amazon_au_min_percentage
    autopricing_amazon_au_max_percentage
    autopricing_amazon_au_min_absolute
    autopricing_amazon_au_max_absolute
    autopricing_amazon_jp_status
    autopricing_amazon_jp_min_percentage
    autopricing_amazon_jp_max_percentage
    autopricing_amazon_jp_min_absolute
    autopricing_amazon_jp_max_absolute
  }
  pathValues {
    path
    values
  }
}
    `;
export const GetSidebarInfoDocument = gql`
    query GetSidebarInfo {
  unshippedOrdersCount
  lateOrdersCount
}
    `;
export type GetSidebarInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetSidebarInfoQuery, GetSidebarInfoQueryVariables>, 'query'>;

    export const GetSidebarInfoComponent = (props: GetSidebarInfoComponentProps) => (
      <ApolloReactComponents.Query<GetSidebarInfoQuery, GetSidebarInfoQueryVariables> query={GetSidebarInfoDocument} {...props} />
    );
    
export type GetSidebarInfoProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetSidebarInfoQuery, GetSidebarInfoQueryVariables>
    } & TChildProps;
export function withGetSidebarInfo<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetSidebarInfoQuery,
  GetSidebarInfoQueryVariables,
  GetSidebarInfoProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetSidebarInfoQuery, GetSidebarInfoQueryVariables, GetSidebarInfoProps<TChildProps, TDataName>>(GetSidebarInfoDocument, {
      alias: 'getSidebarInfo',
      ...operationOptions
    });
};

/**
 * __useGetSidebarInfoQuery__
 *
 * To run a query within a React component, call `useGetSidebarInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSidebarInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSidebarInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSidebarInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetSidebarInfoQuery, GetSidebarInfoQueryVariables>) {
        return ApolloReactHooks.useQuery<GetSidebarInfoQuery, GetSidebarInfoQueryVariables>(GetSidebarInfoDocument, baseOptions);
      }
export function useGetSidebarInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSidebarInfoQuery, GetSidebarInfoQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetSidebarInfoQuery, GetSidebarInfoQueryVariables>(GetSidebarInfoDocument, baseOptions);
        }
export type GetSidebarInfoQueryHookResult = ReturnType<typeof useGetSidebarInfoQuery>;
export type GetSidebarInfoLazyQueryHookResult = ReturnType<typeof useGetSidebarInfoLazyQuery>;
export type GetSidebarInfoQueryResult = ApolloReactCommon.QueryResult<GetSidebarInfoQuery, GetSidebarInfoQueryVariables>;
export const GetMarketplacesSimpleDocument = gql`
    query GetMarketplacesSimple {
  marketplaces {
    id
    status
    marketplace
  }
}
    `;
export type GetMarketplacesSimpleComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetMarketplacesSimpleQuery, GetMarketplacesSimpleQueryVariables>, 'query'>;

    export const GetMarketplacesSimpleComponent = (props: GetMarketplacesSimpleComponentProps) => (
      <ApolloReactComponents.Query<GetMarketplacesSimpleQuery, GetMarketplacesSimpleQueryVariables> query={GetMarketplacesSimpleDocument} {...props} />
    );
    
export type GetMarketplacesSimpleProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetMarketplacesSimpleQuery, GetMarketplacesSimpleQueryVariables>
    } & TChildProps;
export function withGetMarketplacesSimple<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetMarketplacesSimpleQuery,
  GetMarketplacesSimpleQueryVariables,
  GetMarketplacesSimpleProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetMarketplacesSimpleQuery, GetMarketplacesSimpleQueryVariables, GetMarketplacesSimpleProps<TChildProps, TDataName>>(GetMarketplacesSimpleDocument, {
      alias: 'getMarketplacesSimple',
      ...operationOptions
    });
};

/**
 * __useGetMarketplacesSimpleQuery__
 *
 * To run a query within a React component, call `useGetMarketplacesSimpleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarketplacesSimpleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMarketplacesSimpleQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMarketplacesSimpleQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMarketplacesSimpleQuery, GetMarketplacesSimpleQueryVariables>) {
        return ApolloReactHooks.useQuery<GetMarketplacesSimpleQuery, GetMarketplacesSimpleQueryVariables>(GetMarketplacesSimpleDocument, baseOptions);
      }
export function useGetMarketplacesSimpleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMarketplacesSimpleQuery, GetMarketplacesSimpleQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetMarketplacesSimpleQuery, GetMarketplacesSimpleQueryVariables>(GetMarketplacesSimpleDocument, baseOptions);
        }
export type GetMarketplacesSimpleQueryHookResult = ReturnType<typeof useGetMarketplacesSimpleQuery>;
export type GetMarketplacesSimpleLazyQueryHookResult = ReturnType<typeof useGetMarketplacesSimpleLazyQuery>;
export type GetMarketplacesSimpleQueryResult = ApolloReactCommon.QueryResult<GetMarketplacesSimpleQuery, GetMarketplacesSimpleQueryVariables>;
export const GetFeatureToggleDocument = gql`
    query GetFeatureToggle($featureName: String!) {
  getFeatureToggle(featureName: $featureName) {
    allowed
  }
}
    `;
export type GetFeatureToggleComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetFeatureToggleQuery, GetFeatureToggleQueryVariables>, 'query'> & ({ variables: GetFeatureToggleQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetFeatureToggleComponent = (props: GetFeatureToggleComponentProps) => (
      <ApolloReactComponents.Query<GetFeatureToggleQuery, GetFeatureToggleQueryVariables> query={GetFeatureToggleDocument} {...props} />
    );
    
export type GetFeatureToggleProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetFeatureToggleQuery, GetFeatureToggleQueryVariables>
    } & TChildProps;
export function withGetFeatureToggle<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetFeatureToggleQuery,
  GetFeatureToggleQueryVariables,
  GetFeatureToggleProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetFeatureToggleQuery, GetFeatureToggleQueryVariables, GetFeatureToggleProps<TChildProps, TDataName>>(GetFeatureToggleDocument, {
      alias: 'getFeatureToggle',
      ...operationOptions
    });
};

/**
 * __useGetFeatureToggleQuery__
 *
 * To run a query within a React component, call `useGetFeatureToggleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeatureToggleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeatureToggleQuery({
 *   variables: {
 *      featureName: // value for 'featureName'
 *   },
 * });
 */
export function useGetFeatureToggleQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetFeatureToggleQuery, GetFeatureToggleQueryVariables>) {
        return ApolloReactHooks.useQuery<GetFeatureToggleQuery, GetFeatureToggleQueryVariables>(GetFeatureToggleDocument, baseOptions);
      }
export function useGetFeatureToggleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFeatureToggleQuery, GetFeatureToggleQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetFeatureToggleQuery, GetFeatureToggleQueryVariables>(GetFeatureToggleDocument, baseOptions);
        }
export type GetFeatureToggleQueryHookResult = ReturnType<typeof useGetFeatureToggleQuery>;
export type GetFeatureToggleLazyQueryHookResult = ReturnType<typeof useGetFeatureToggleLazyQuery>;
export type GetFeatureToggleQueryResult = ApolloReactCommon.QueryResult<GetFeatureToggleQuery, GetFeatureToggleQueryVariables>;
export const GetFeatureToggleAsAdminDocument = gql`
    query GetFeatureToggleAsAdmin($companyId: String!, $featureName: String!) {
  getFeatureToggleAsAdmin(companyId: $companyId, featureName: $featureName) {
    allowed
  }
}
    `;
export type GetFeatureToggleAsAdminComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetFeatureToggleAsAdminQuery, GetFeatureToggleAsAdminQueryVariables>, 'query'> & ({ variables: GetFeatureToggleAsAdminQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetFeatureToggleAsAdminComponent = (props: GetFeatureToggleAsAdminComponentProps) => (
      <ApolloReactComponents.Query<GetFeatureToggleAsAdminQuery, GetFeatureToggleAsAdminQueryVariables> query={GetFeatureToggleAsAdminDocument} {...props} />
    );
    
export type GetFeatureToggleAsAdminProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetFeatureToggleAsAdminQuery, GetFeatureToggleAsAdminQueryVariables>
    } & TChildProps;
export function withGetFeatureToggleAsAdmin<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetFeatureToggleAsAdminQuery,
  GetFeatureToggleAsAdminQueryVariables,
  GetFeatureToggleAsAdminProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetFeatureToggleAsAdminQuery, GetFeatureToggleAsAdminQueryVariables, GetFeatureToggleAsAdminProps<TChildProps, TDataName>>(GetFeatureToggleAsAdminDocument, {
      alias: 'getFeatureToggleAsAdmin',
      ...operationOptions
    });
};

/**
 * __useGetFeatureToggleAsAdminQuery__
 *
 * To run a query within a React component, call `useGetFeatureToggleAsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeatureToggleAsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeatureToggleAsAdminQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      featureName: // value for 'featureName'
 *   },
 * });
 */
export function useGetFeatureToggleAsAdminQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetFeatureToggleAsAdminQuery, GetFeatureToggleAsAdminQueryVariables>) {
        return ApolloReactHooks.useQuery<GetFeatureToggleAsAdminQuery, GetFeatureToggleAsAdminQueryVariables>(GetFeatureToggleAsAdminDocument, baseOptions);
      }
export function useGetFeatureToggleAsAdminLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFeatureToggleAsAdminQuery, GetFeatureToggleAsAdminQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetFeatureToggleAsAdminQuery, GetFeatureToggleAsAdminQueryVariables>(GetFeatureToggleAsAdminDocument, baseOptions);
        }
export type GetFeatureToggleAsAdminQueryHookResult = ReturnType<typeof useGetFeatureToggleAsAdminQuery>;
export type GetFeatureToggleAsAdminLazyQueryHookResult = ReturnType<typeof useGetFeatureToggleAsAdminLazyQuery>;
export type GetFeatureToggleAsAdminQueryResult = ApolloReactCommon.QueryResult<GetFeatureToggleAsAdminQuery, GetFeatureToggleAsAdminQueryVariables>;
export const FeatureToggleDocument = gql`
    query FeatureToggle($name: EFeatureName!) {
  featureToggle(name: $name) {
    enabled
  }
}
    `;
export type FeatureToggleComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FeatureToggleQuery, FeatureToggleQueryVariables>, 'query'> & ({ variables: FeatureToggleQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FeatureToggleComponent = (props: FeatureToggleComponentProps) => (
      <ApolloReactComponents.Query<FeatureToggleQuery, FeatureToggleQueryVariables> query={FeatureToggleDocument} {...props} />
    );
    
export type FeatureToggleProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FeatureToggleQuery, FeatureToggleQueryVariables>
    } & TChildProps;
export function withFeatureToggle<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FeatureToggleQuery,
  FeatureToggleQueryVariables,
  FeatureToggleProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FeatureToggleQuery, FeatureToggleQueryVariables, FeatureToggleProps<TChildProps, TDataName>>(FeatureToggleDocument, {
      alias: 'featureToggle',
      ...operationOptions
    });
};

/**
 * __useFeatureToggleQuery__
 *
 * To run a query within a React component, call `useFeatureToggleQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureToggleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureToggleQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useFeatureToggleQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FeatureToggleQuery, FeatureToggleQueryVariables>) {
        return ApolloReactHooks.useQuery<FeatureToggleQuery, FeatureToggleQueryVariables>(FeatureToggleDocument, baseOptions);
      }
export function useFeatureToggleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FeatureToggleQuery, FeatureToggleQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<FeatureToggleQuery, FeatureToggleQueryVariables>(FeatureToggleDocument, baseOptions);
        }
export type FeatureToggleQueryHookResult = ReturnType<typeof useFeatureToggleQuery>;
export type FeatureToggleLazyQueryHookResult = ReturnType<typeof useFeatureToggleLazyQuery>;
export type FeatureToggleQueryResult = ApolloReactCommon.QueryResult<FeatureToggleQuery, FeatureToggleQueryVariables>;
export const ShopInfoDocument = gql`
    query ShopInfo {
  shopInfo {
    endpoints {
      mall {
        endpoint
        access
      }
      amazon {
        endpoint
        access
      }
      alza {
        endpoint
        access
      }
      kaufland {
        endpoint
        access
      }
    }
  }
}
    `;
export type ShopInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ShopInfoQuery, ShopInfoQueryVariables>, 'query'>;

    export const ShopInfoComponent = (props: ShopInfoComponentProps) => (
      <ApolloReactComponents.Query<ShopInfoQuery, ShopInfoQueryVariables> query={ShopInfoDocument} {...props} />
    );
    
export type ShopInfoProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ShopInfoQuery, ShopInfoQueryVariables>
    } & TChildProps;
export function withShopInfo<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ShopInfoQuery,
  ShopInfoQueryVariables,
  ShopInfoProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ShopInfoQuery, ShopInfoQueryVariables, ShopInfoProps<TChildProps, TDataName>>(ShopInfoDocument, {
      alias: 'shopInfo',
      ...operationOptions
    });
};

/**
 * __useShopInfoQuery__
 *
 * To run a query within a React component, call `useShopInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useShopInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShopInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useShopInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ShopInfoQuery, ShopInfoQueryVariables>) {
        return ApolloReactHooks.useQuery<ShopInfoQuery, ShopInfoQueryVariables>(ShopInfoDocument, baseOptions);
      }
export function useShopInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ShopInfoQuery, ShopInfoQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ShopInfoQuery, ShopInfoQueryVariables>(ShopInfoDocument, baseOptions);
        }
export type ShopInfoQueryHookResult = ReturnType<typeof useShopInfoQuery>;
export type ShopInfoLazyQueryHookResult = ReturnType<typeof useShopInfoLazyQuery>;
export type ShopInfoQueryResult = ApolloReactCommon.QueryResult<ShopInfoQuery, ShopInfoQueryVariables>;
export const GetApiSettingsDocument = gql`
    query GetApiSettings {
  apiToken {
    _id
    companyId
    token
  }
  marketplaces {
    id
    marketplace
  }
}
    `;
export type GetApiSettingsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetApiSettingsQuery, GetApiSettingsQueryVariables>, 'query'>;

    export const GetApiSettingsComponent = (props: GetApiSettingsComponentProps) => (
      <ApolloReactComponents.Query<GetApiSettingsQuery, GetApiSettingsQueryVariables> query={GetApiSettingsDocument} {...props} />
    );
    
export type GetApiSettingsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetApiSettingsQuery, GetApiSettingsQueryVariables>
    } & TChildProps;
export function withGetApiSettings<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetApiSettingsQuery,
  GetApiSettingsQueryVariables,
  GetApiSettingsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetApiSettingsQuery, GetApiSettingsQueryVariables, GetApiSettingsProps<TChildProps, TDataName>>(GetApiSettingsDocument, {
      alias: 'getApiSettings',
      ...operationOptions
    });
};

/**
 * __useGetApiSettingsQuery__
 *
 * To run a query within a React component, call `useGetApiSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApiSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApiSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetApiSettingsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetApiSettingsQuery, GetApiSettingsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetApiSettingsQuery, GetApiSettingsQueryVariables>(GetApiSettingsDocument, baseOptions);
      }
export function useGetApiSettingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetApiSettingsQuery, GetApiSettingsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetApiSettingsQuery, GetApiSettingsQueryVariables>(GetApiSettingsDocument, baseOptions);
        }
export type GetApiSettingsQueryHookResult = ReturnType<typeof useGetApiSettingsQuery>;
export type GetApiSettingsLazyQueryHookResult = ReturnType<typeof useGetApiSettingsLazyQuery>;
export type GetApiSettingsQueryResult = ApolloReactCommon.QueryResult<GetApiSettingsQuery, GetApiSettingsQueryVariables>;
export const GetCompanyErrorsDocument = gql`
    query GetCompanyErrors {
  companyError {
    _id
    companyId
    code
    count
    created
    timestamp
    message
  }
}
    `;
export type GetCompanyErrorsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetCompanyErrorsQuery, GetCompanyErrorsQueryVariables>, 'query'>;

    export const GetCompanyErrorsComponent = (props: GetCompanyErrorsComponentProps) => (
      <ApolloReactComponents.Query<GetCompanyErrorsQuery, GetCompanyErrorsQueryVariables> query={GetCompanyErrorsDocument} {...props} />
    );
    
export type GetCompanyErrorsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetCompanyErrorsQuery, GetCompanyErrorsQueryVariables>
    } & TChildProps;
export function withGetCompanyErrors<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetCompanyErrorsQuery,
  GetCompanyErrorsQueryVariables,
  GetCompanyErrorsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetCompanyErrorsQuery, GetCompanyErrorsQueryVariables, GetCompanyErrorsProps<TChildProps, TDataName>>(GetCompanyErrorsDocument, {
      alias: 'getCompanyErrors',
      ...operationOptions
    });
};

/**
 * __useGetCompanyErrorsQuery__
 *
 * To run a query within a React component, call `useGetCompanyErrorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyErrorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyErrorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCompanyErrorsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCompanyErrorsQuery, GetCompanyErrorsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCompanyErrorsQuery, GetCompanyErrorsQueryVariables>(GetCompanyErrorsDocument, baseOptions);
      }
export function useGetCompanyErrorsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCompanyErrorsQuery, GetCompanyErrorsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCompanyErrorsQuery, GetCompanyErrorsQueryVariables>(GetCompanyErrorsDocument, baseOptions);
        }
export type GetCompanyErrorsQueryHookResult = ReturnType<typeof useGetCompanyErrorsQuery>;
export type GetCompanyErrorsLazyQueryHookResult = ReturnType<typeof useGetCompanyErrorsLazyQuery>;
export type GetCompanyErrorsQueryResult = ApolloReactCommon.QueryResult<GetCompanyErrorsQuery, GetCompanyErrorsQueryVariables>;
export const ValidateProductFeedFieldDocument = gql`
    mutation ValidateProductFeedField($type: ValidationFieldTypeEnum, $values: [String]!) {
  validateProductFeedField(type: $type, values: $values) {
    value
    parsedValue
    status
  }
}
    `;
export type ValidateProductFeedFieldMutationFn = ApolloReactCommon.MutationFunction<ValidateProductFeedFieldMutation, ValidateProductFeedFieldMutationVariables>;
export type ValidateProductFeedFieldComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ValidateProductFeedFieldMutation, ValidateProductFeedFieldMutationVariables>, 'mutation'>;

    export const ValidateProductFeedFieldComponent = (props: ValidateProductFeedFieldComponentProps) => (
      <ApolloReactComponents.Mutation<ValidateProductFeedFieldMutation, ValidateProductFeedFieldMutationVariables> mutation={ValidateProductFeedFieldDocument} {...props} />
    );
    
export type ValidateProductFeedFieldProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<ValidateProductFeedFieldMutation, ValidateProductFeedFieldMutationVariables>
    } & TChildProps;
export function withValidateProductFeedField<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ValidateProductFeedFieldMutation,
  ValidateProductFeedFieldMutationVariables,
  ValidateProductFeedFieldProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, ValidateProductFeedFieldMutation, ValidateProductFeedFieldMutationVariables, ValidateProductFeedFieldProps<TChildProps, TDataName>>(ValidateProductFeedFieldDocument, {
      alias: 'validateProductFeedField',
      ...operationOptions
    });
};

/**
 * __useValidateProductFeedFieldMutation__
 *
 * To run a mutation, you first call `useValidateProductFeedFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateProductFeedFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateProductFeedFieldMutation, { data, loading, error }] = useValidateProductFeedFieldMutation({
 *   variables: {
 *      type: // value for 'type'
 *      values: // value for 'values'
 *   },
 * });
 */
export function useValidateProductFeedFieldMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ValidateProductFeedFieldMutation, ValidateProductFeedFieldMutationVariables>) {
        return ApolloReactHooks.useMutation<ValidateProductFeedFieldMutation, ValidateProductFeedFieldMutationVariables>(ValidateProductFeedFieldDocument, baseOptions);
      }
export type ValidateProductFeedFieldMutationHookResult = ReturnType<typeof useValidateProductFeedFieldMutation>;
export type ValidateProductFeedFieldMutationResult = ApolloReactCommon.MutationResult<ValidateProductFeedFieldMutation>;
export type ValidateProductFeedFieldMutationOptions = ApolloReactCommon.BaseMutationOptions<ValidateProductFeedFieldMutation, ValidateProductFeedFieldMutationVariables>;
export const UpdateProductVariantSellingPriceDocument = gql`
    mutation UpdateProductVariantSellingPrice($product: ProductVariantInput) {
  updateProductVariant(products: [$product]) {
    id
    prices {
      amazon_au {
        selling
      }
      amazon_br {
        selling
      }
      amazon_ca {
        selling
      }
      amazon_de {
        selling
      }
      amazon_es {
        selling
      }
      amazon_fr {
        selling
      }
      amazon_it {
        selling
      }
      amazon_jp {
        selling
      }
      amazon_mx {
        selling
      }
      amazon_sg {
        selling
      }
      amazon_uk {
        selling
      }
      amazon_nl {
        selling
      }
      amazon_us {
        selling
      }
      amazon_se {
        selling
      }
      amazon_tr {
        selling
      }
      amazon_pl {
        selling
      }
      amazon_be {
        selling
      }
      amazon_ie {
        selling
      }
      mall_cz {
        selling
      }
      mall_pl {
        selling
      }
      mall_si {
        selling
      }
      mall_hu {
        selling
      }
      mall_sk {
        selling
      }
      alza_cz {
        selling
      }
      real_de {
        selling
      }
      kaufland_de {
        selling
      }
      kaufland_cz {
        selling
      }
      kaufland_sk {
        selling
      }
      kaufland_at {
        selling
      }
      kaufland_pl {
        selling
      }
      kaufland_nl {
        selling
      }
      kaufland_es {
        selling
      }
      kaufland_fr {
        selling
      }
      kaufland_it {
        selling
      }
    }
  }
}
    `;
export type UpdateProductVariantSellingPriceMutationFn = ApolloReactCommon.MutationFunction<UpdateProductVariantSellingPriceMutation, UpdateProductVariantSellingPriceMutationVariables>;
export type UpdateProductVariantSellingPriceComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateProductVariantSellingPriceMutation, UpdateProductVariantSellingPriceMutationVariables>, 'mutation'>;

    export const UpdateProductVariantSellingPriceComponent = (props: UpdateProductVariantSellingPriceComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateProductVariantSellingPriceMutation, UpdateProductVariantSellingPriceMutationVariables> mutation={UpdateProductVariantSellingPriceDocument} {...props} />
    );
    
export type UpdateProductVariantSellingPriceProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateProductVariantSellingPriceMutation, UpdateProductVariantSellingPriceMutationVariables>
    } & TChildProps;
export function withUpdateProductVariantSellingPrice<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateProductVariantSellingPriceMutation,
  UpdateProductVariantSellingPriceMutationVariables,
  UpdateProductVariantSellingPriceProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateProductVariantSellingPriceMutation, UpdateProductVariantSellingPriceMutationVariables, UpdateProductVariantSellingPriceProps<TChildProps, TDataName>>(UpdateProductVariantSellingPriceDocument, {
      alias: 'updateProductVariantSellingPrice',
      ...operationOptions
    });
};

/**
 * __useUpdateProductVariantSellingPriceMutation__
 *
 * To run a mutation, you first call `useUpdateProductVariantSellingPriceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductVariantSellingPriceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductVariantSellingPriceMutation, { data, loading, error }] = useUpdateProductVariantSellingPriceMutation({
 *   variables: {
 *      product: // value for 'product'
 *   },
 * });
 */
export function useUpdateProductVariantSellingPriceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateProductVariantSellingPriceMutation, UpdateProductVariantSellingPriceMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateProductVariantSellingPriceMutation, UpdateProductVariantSellingPriceMutationVariables>(UpdateProductVariantSellingPriceDocument, baseOptions);
      }
export type UpdateProductVariantSellingPriceMutationHookResult = ReturnType<typeof useUpdateProductVariantSellingPriceMutation>;
export type UpdateProductVariantSellingPriceMutationResult = ApolloReactCommon.MutationResult<UpdateProductVariantSellingPriceMutation>;
export type UpdateProductVariantSellingPriceMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateProductVariantSellingPriceMutation, UpdateProductVariantSellingPriceMutationVariables>;
export const UpdateProductAutopricingActiveStateDocument = gql`
    mutation UpdateProductAutopricingActiveState($sku: String!, $marketplace: MarketplaceName, $active: Boolean!) {
  updateProductAutopricingActiveState(
    sku: $sku
    marketplace: $marketplace
    active: $active
  )
}
    `;
export type UpdateProductAutopricingActiveStateMutationFn = ApolloReactCommon.MutationFunction<UpdateProductAutopricingActiveStateMutation, UpdateProductAutopricingActiveStateMutationVariables>;
export type UpdateProductAutopricingActiveStateComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateProductAutopricingActiveStateMutation, UpdateProductAutopricingActiveStateMutationVariables>, 'mutation'>;

    export const UpdateProductAutopricingActiveStateComponent = (props: UpdateProductAutopricingActiveStateComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateProductAutopricingActiveStateMutation, UpdateProductAutopricingActiveStateMutationVariables> mutation={UpdateProductAutopricingActiveStateDocument} {...props} />
    );
    
export type UpdateProductAutopricingActiveStateProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateProductAutopricingActiveStateMutation, UpdateProductAutopricingActiveStateMutationVariables>
    } & TChildProps;
export function withUpdateProductAutopricingActiveState<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateProductAutopricingActiveStateMutation,
  UpdateProductAutopricingActiveStateMutationVariables,
  UpdateProductAutopricingActiveStateProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateProductAutopricingActiveStateMutation, UpdateProductAutopricingActiveStateMutationVariables, UpdateProductAutopricingActiveStateProps<TChildProps, TDataName>>(UpdateProductAutopricingActiveStateDocument, {
      alias: 'updateProductAutopricingActiveState',
      ...operationOptions
    });
};

/**
 * __useUpdateProductAutopricingActiveStateMutation__
 *
 * To run a mutation, you first call `useUpdateProductAutopricingActiveStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductAutopricingActiveStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductAutopricingActiveStateMutation, { data, loading, error }] = useUpdateProductAutopricingActiveStateMutation({
 *   variables: {
 *      sku: // value for 'sku'
 *      marketplace: // value for 'marketplace'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useUpdateProductAutopricingActiveStateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateProductAutopricingActiveStateMutation, UpdateProductAutopricingActiveStateMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateProductAutopricingActiveStateMutation, UpdateProductAutopricingActiveStateMutationVariables>(UpdateProductAutopricingActiveStateDocument, baseOptions);
      }
export type UpdateProductAutopricingActiveStateMutationHookResult = ReturnType<typeof useUpdateProductAutopricingActiveStateMutation>;
export type UpdateProductAutopricingActiveStateMutationResult = ApolloReactCommon.MutationResult<UpdateProductAutopricingActiveStateMutation>;
export type UpdateProductAutopricingActiveStateMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateProductAutopricingActiveStateMutation, UpdateProductAutopricingActiveStateMutationVariables>;
export const UpdateProductAutopricingLimitsDocument = gql`
    mutation UpdateProductAutopricingLimits($sku: String!, $marketplace: MarketplaceName, $topCap: Float, $bottomCap: Float, $topCapAbsolute: Float, $bottomCapAbsolute: Float) {
  updateProductAutopricingLimits(
    sku: $sku
    marketplace: $marketplace
    topCap: $topCap
    bottomCap: $bottomCap
    topCapAbsolute: $topCapAbsolute
    bottomCapAbsolute: $bottomCapAbsolute
  )
}
    `;
export type UpdateProductAutopricingLimitsMutationFn = ApolloReactCommon.MutationFunction<UpdateProductAutopricingLimitsMutation, UpdateProductAutopricingLimitsMutationVariables>;
export type UpdateProductAutopricingLimitsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateProductAutopricingLimitsMutation, UpdateProductAutopricingLimitsMutationVariables>, 'mutation'>;

    export const UpdateProductAutopricingLimitsComponent = (props: UpdateProductAutopricingLimitsComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateProductAutopricingLimitsMutation, UpdateProductAutopricingLimitsMutationVariables> mutation={UpdateProductAutopricingLimitsDocument} {...props} />
    );
    
export type UpdateProductAutopricingLimitsProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateProductAutopricingLimitsMutation, UpdateProductAutopricingLimitsMutationVariables>
    } & TChildProps;
export function withUpdateProductAutopricingLimits<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateProductAutopricingLimitsMutation,
  UpdateProductAutopricingLimitsMutationVariables,
  UpdateProductAutopricingLimitsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateProductAutopricingLimitsMutation, UpdateProductAutopricingLimitsMutationVariables, UpdateProductAutopricingLimitsProps<TChildProps, TDataName>>(UpdateProductAutopricingLimitsDocument, {
      alias: 'updateProductAutopricingLimits',
      ...operationOptions
    });
};

/**
 * __useUpdateProductAutopricingLimitsMutation__
 *
 * To run a mutation, you first call `useUpdateProductAutopricingLimitsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductAutopricingLimitsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductAutopricingLimitsMutation, { data, loading, error }] = useUpdateProductAutopricingLimitsMutation({
 *   variables: {
 *      sku: // value for 'sku'
 *      marketplace: // value for 'marketplace'
 *      topCap: // value for 'topCap'
 *      bottomCap: // value for 'bottomCap'
 *      topCapAbsolute: // value for 'topCapAbsolute'
 *      bottomCapAbsolute: // value for 'bottomCapAbsolute'
 *   },
 * });
 */
export function useUpdateProductAutopricingLimitsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateProductAutopricingLimitsMutation, UpdateProductAutopricingLimitsMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateProductAutopricingLimitsMutation, UpdateProductAutopricingLimitsMutationVariables>(UpdateProductAutopricingLimitsDocument, baseOptions);
      }
export type UpdateProductAutopricingLimitsMutationHookResult = ReturnType<typeof useUpdateProductAutopricingLimitsMutation>;
export type UpdateProductAutopricingLimitsMutationResult = ApolloReactCommon.MutationResult<UpdateProductAutopricingLimitsMutation>;
export type UpdateProductAutopricingLimitsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateProductAutopricingLimitsMutation, UpdateProductAutopricingLimitsMutationVariables>;
export const MergePdfsDocument = gql`
    mutation MergePdfs($links: [String!]) {
  mergePdfs(links: $links) {
    _id
    doneAt
    downloadLink
    failReason
    failedAt
    requestedAt
    status
  }
}
    `;
export type MergePdfsMutationFn = ApolloReactCommon.MutationFunction<MergePdfsMutation, MergePdfsMutationVariables>;
export type MergePdfsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<MergePdfsMutation, MergePdfsMutationVariables>, 'mutation'>;

    export const MergePdfsComponent = (props: MergePdfsComponentProps) => (
      <ApolloReactComponents.Mutation<MergePdfsMutation, MergePdfsMutationVariables> mutation={MergePdfsDocument} {...props} />
    );
    
export type MergePdfsProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<MergePdfsMutation, MergePdfsMutationVariables>
    } & TChildProps;
export function withMergePdfs<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  MergePdfsMutation,
  MergePdfsMutationVariables,
  MergePdfsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, MergePdfsMutation, MergePdfsMutationVariables, MergePdfsProps<TChildProps, TDataName>>(MergePdfsDocument, {
      alias: 'mergePdfs',
      ...operationOptions
    });
};

/**
 * __useMergePdfsMutation__
 *
 * To run a mutation, you first call `useMergePdfsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergePdfsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergePdfsMutation, { data, loading, error }] = useMergePdfsMutation({
 *   variables: {
 *      links: // value for 'links'
 *   },
 * });
 */
export function useMergePdfsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MergePdfsMutation, MergePdfsMutationVariables>) {
        return ApolloReactHooks.useMutation<MergePdfsMutation, MergePdfsMutationVariables>(MergePdfsDocument, baseOptions);
      }
export type MergePdfsMutationHookResult = ReturnType<typeof useMergePdfsMutation>;
export type MergePdfsMutationResult = ApolloReactCommon.MutationResult<MergePdfsMutation>;
export type MergePdfsMutationOptions = ApolloReactCommon.BaseMutationOptions<MergePdfsMutation, MergePdfsMutationVariables>;
export const GetMergedPdfsDocument = gql`
    query GetMergedPdfs($id: String!) {
  pdf(id: $id) {
    _id
    doneAt
    downloadLink
    failReason
    failedAt
    requestedAt
    status
  }
}
    `;
export type GetMergedPdfsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetMergedPdfsQuery, GetMergedPdfsQueryVariables>, 'query'> & ({ variables: GetMergedPdfsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetMergedPdfsComponent = (props: GetMergedPdfsComponentProps) => (
      <ApolloReactComponents.Query<GetMergedPdfsQuery, GetMergedPdfsQueryVariables> query={GetMergedPdfsDocument} {...props} />
    );
    
export type GetMergedPdfsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetMergedPdfsQuery, GetMergedPdfsQueryVariables>
    } & TChildProps;
export function withGetMergedPdfs<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetMergedPdfsQuery,
  GetMergedPdfsQueryVariables,
  GetMergedPdfsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetMergedPdfsQuery, GetMergedPdfsQueryVariables, GetMergedPdfsProps<TChildProps, TDataName>>(GetMergedPdfsDocument, {
      alias: 'getMergedPdfs',
      ...operationOptions
    });
};

/**
 * __useGetMergedPdfsQuery__
 *
 * To run a query within a React component, call `useGetMergedPdfsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMergedPdfsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMergedPdfsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMergedPdfsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMergedPdfsQuery, GetMergedPdfsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetMergedPdfsQuery, GetMergedPdfsQueryVariables>(GetMergedPdfsDocument, baseOptions);
      }
export function useGetMergedPdfsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMergedPdfsQuery, GetMergedPdfsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetMergedPdfsQuery, GetMergedPdfsQueryVariables>(GetMergedPdfsDocument, baseOptions);
        }
export type GetMergedPdfsQueryHookResult = ReturnType<typeof useGetMergedPdfsQuery>;
export type GetMergedPdfsLazyQueryHookResult = ReturnType<typeof useGetMergedPdfsLazyQuery>;
export type GetMergedPdfsQueryResult = ApolloReactCommon.QueryResult<GetMergedPdfsQuery, GetMergedPdfsQueryVariables>;
export const GetPricingSpeedNotificationDocument = gql`
    query GetPricingSpeedNotification {
  syncSettings {
    _id
    amazon {
      downloadPricing
    }
  }
}
    `;
export type GetPricingSpeedNotificationComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetPricingSpeedNotificationQuery, GetPricingSpeedNotificationQueryVariables>, 'query'>;

    export const GetPricingSpeedNotificationComponent = (props: GetPricingSpeedNotificationComponentProps) => (
      <ApolloReactComponents.Query<GetPricingSpeedNotificationQuery, GetPricingSpeedNotificationQueryVariables> query={GetPricingSpeedNotificationDocument} {...props} />
    );
    
export type GetPricingSpeedNotificationProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetPricingSpeedNotificationQuery, GetPricingSpeedNotificationQueryVariables>
    } & TChildProps;
export function withGetPricingSpeedNotification<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetPricingSpeedNotificationQuery,
  GetPricingSpeedNotificationQueryVariables,
  GetPricingSpeedNotificationProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetPricingSpeedNotificationQuery, GetPricingSpeedNotificationQueryVariables, GetPricingSpeedNotificationProps<TChildProps, TDataName>>(GetPricingSpeedNotificationDocument, {
      alias: 'getPricingSpeedNotification',
      ...operationOptions
    });
};

/**
 * __useGetPricingSpeedNotificationQuery__
 *
 * To run a query within a React component, call `useGetPricingSpeedNotificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPricingSpeedNotificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPricingSpeedNotificationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPricingSpeedNotificationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPricingSpeedNotificationQuery, GetPricingSpeedNotificationQueryVariables>) {
        return ApolloReactHooks.useQuery<GetPricingSpeedNotificationQuery, GetPricingSpeedNotificationQueryVariables>(GetPricingSpeedNotificationDocument, baseOptions);
      }
export function useGetPricingSpeedNotificationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPricingSpeedNotificationQuery, GetPricingSpeedNotificationQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetPricingSpeedNotificationQuery, GetPricingSpeedNotificationQueryVariables>(GetPricingSpeedNotificationDocument, baseOptions);
        }
export type GetPricingSpeedNotificationQueryHookResult = ReturnType<typeof useGetPricingSpeedNotificationQuery>;
export type GetPricingSpeedNotificationLazyQueryHookResult = ReturnType<typeof useGetPricingSpeedNotificationLazyQuery>;
export type GetPricingSpeedNotificationQueryResult = ApolloReactCommon.QueryResult<GetPricingSpeedNotificationQuery, GetPricingSpeedNotificationQueryVariables>;
export const GetErrorCompaniesCountDocument = gql`
    query GetErrorCompaniesCount {
  errorCompaniesCount
}
    `;
export type GetErrorCompaniesCountComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetErrorCompaniesCountQuery, GetErrorCompaniesCountQueryVariables>, 'query'>;

    export const GetErrorCompaniesCountComponent = (props: GetErrorCompaniesCountComponentProps) => (
      <ApolloReactComponents.Query<GetErrorCompaniesCountQuery, GetErrorCompaniesCountQueryVariables> query={GetErrorCompaniesCountDocument} {...props} />
    );
    
export type GetErrorCompaniesCountProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetErrorCompaniesCountQuery, GetErrorCompaniesCountQueryVariables>
    } & TChildProps;
export function withGetErrorCompaniesCount<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetErrorCompaniesCountQuery,
  GetErrorCompaniesCountQueryVariables,
  GetErrorCompaniesCountProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetErrorCompaniesCountQuery, GetErrorCompaniesCountQueryVariables, GetErrorCompaniesCountProps<TChildProps, TDataName>>(GetErrorCompaniesCountDocument, {
      alias: 'getErrorCompaniesCount',
      ...operationOptions
    });
};

/**
 * __useGetErrorCompaniesCountQuery__
 *
 * To run a query within a React component, call `useGetErrorCompaniesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetErrorCompaniesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetErrorCompaniesCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetErrorCompaniesCountQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetErrorCompaniesCountQuery, GetErrorCompaniesCountQueryVariables>) {
        return ApolloReactHooks.useQuery<GetErrorCompaniesCountQuery, GetErrorCompaniesCountQueryVariables>(GetErrorCompaniesCountDocument, baseOptions);
      }
export function useGetErrorCompaniesCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetErrorCompaniesCountQuery, GetErrorCompaniesCountQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetErrorCompaniesCountQuery, GetErrorCompaniesCountQueryVariables>(GetErrorCompaniesCountDocument, baseOptions);
        }
export type GetErrorCompaniesCountQueryHookResult = ReturnType<typeof useGetErrorCompaniesCountQuery>;
export type GetErrorCompaniesCountLazyQueryHookResult = ReturnType<typeof useGetErrorCompaniesCountLazyQuery>;
export type GetErrorCompaniesCountQueryResult = ApolloReactCommon.QueryResult<GetErrorCompaniesCountQuery, GetErrorCompaniesCountQueryVariables>;
export const SaveLanguageDocument = gql`
    mutation SaveLanguage($language: EnumUserLanguage!) {
  updateUser(user: {language: $language}) {
    email
    name
  }
}
    `;
export type SaveLanguageMutationFn = ApolloReactCommon.MutationFunction<SaveLanguageMutation, SaveLanguageMutationVariables>;
export type SaveLanguageComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<SaveLanguageMutation, SaveLanguageMutationVariables>, 'mutation'>;

    export const SaveLanguageComponent = (props: SaveLanguageComponentProps) => (
      <ApolloReactComponents.Mutation<SaveLanguageMutation, SaveLanguageMutationVariables> mutation={SaveLanguageDocument} {...props} />
    );
    
export type SaveLanguageProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<SaveLanguageMutation, SaveLanguageMutationVariables>
    } & TChildProps;
export function withSaveLanguage<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SaveLanguageMutation,
  SaveLanguageMutationVariables,
  SaveLanguageProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, SaveLanguageMutation, SaveLanguageMutationVariables, SaveLanguageProps<TChildProps, TDataName>>(SaveLanguageDocument, {
      alias: 'saveLanguage',
      ...operationOptions
    });
};

/**
 * __useSaveLanguageMutation__
 *
 * To run a mutation, you first call `useSaveLanguageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveLanguageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveLanguageMutation, { data, loading, error }] = useSaveLanguageMutation({
 *   variables: {
 *      language: // value for 'language'
 *   },
 * });
 */
export function useSaveLanguageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveLanguageMutation, SaveLanguageMutationVariables>) {
        return ApolloReactHooks.useMutation<SaveLanguageMutation, SaveLanguageMutationVariables>(SaveLanguageDocument, baseOptions);
      }
export type SaveLanguageMutationHookResult = ReturnType<typeof useSaveLanguageMutation>;
export type SaveLanguageMutationResult = ApolloReactCommon.MutationResult<SaveLanguageMutation>;
export type SaveLanguageMutationOptions = ApolloReactCommon.BaseMutationOptions<SaveLanguageMutation, SaveLanguageMutationVariables>;
export const BulkUpdateAutopricerLimitsDocument = gql`
    mutation BulkUpdateAutopricerLimits($data: newSettings) {
  updateProductAutopricingLimitsBulk(newSettings: $data)
}
    `;
export type BulkUpdateAutopricerLimitsMutationFn = ApolloReactCommon.MutationFunction<BulkUpdateAutopricerLimitsMutation, BulkUpdateAutopricerLimitsMutationVariables>;
export type BulkUpdateAutopricerLimitsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<BulkUpdateAutopricerLimitsMutation, BulkUpdateAutopricerLimitsMutationVariables>, 'mutation'>;

    export const BulkUpdateAutopricerLimitsComponent = (props: BulkUpdateAutopricerLimitsComponentProps) => (
      <ApolloReactComponents.Mutation<BulkUpdateAutopricerLimitsMutation, BulkUpdateAutopricerLimitsMutationVariables> mutation={BulkUpdateAutopricerLimitsDocument} {...props} />
    );
    
export type BulkUpdateAutopricerLimitsProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<BulkUpdateAutopricerLimitsMutation, BulkUpdateAutopricerLimitsMutationVariables>
    } & TChildProps;
export function withBulkUpdateAutopricerLimits<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  BulkUpdateAutopricerLimitsMutation,
  BulkUpdateAutopricerLimitsMutationVariables,
  BulkUpdateAutopricerLimitsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, BulkUpdateAutopricerLimitsMutation, BulkUpdateAutopricerLimitsMutationVariables, BulkUpdateAutopricerLimitsProps<TChildProps, TDataName>>(BulkUpdateAutopricerLimitsDocument, {
      alias: 'bulkUpdateAutopricerLimits',
      ...operationOptions
    });
};

/**
 * __useBulkUpdateAutopricerLimitsMutation__
 *
 * To run a mutation, you first call `useBulkUpdateAutopricerLimitsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateAutopricerLimitsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateAutopricerLimitsMutation, { data, loading, error }] = useBulkUpdateAutopricerLimitsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useBulkUpdateAutopricerLimitsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BulkUpdateAutopricerLimitsMutation, BulkUpdateAutopricerLimitsMutationVariables>) {
        return ApolloReactHooks.useMutation<BulkUpdateAutopricerLimitsMutation, BulkUpdateAutopricerLimitsMutationVariables>(BulkUpdateAutopricerLimitsDocument, baseOptions);
      }
export type BulkUpdateAutopricerLimitsMutationHookResult = ReturnType<typeof useBulkUpdateAutopricerLimitsMutation>;
export type BulkUpdateAutopricerLimitsMutationResult = ApolloReactCommon.MutationResult<BulkUpdateAutopricerLimitsMutation>;
export type BulkUpdateAutopricerLimitsMutationOptions = ApolloReactCommon.BaseMutationOptions<BulkUpdateAutopricerLimitsMutation, BulkUpdateAutopricerLimitsMutationVariables>;
export const GetProductPricingCountDocument = gql`
    query GetProductPricingCount($filter: FilterInputProducts) {
  products(filter: $filter) {
    count
  }
}
    `;
export type GetProductPricingCountComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetProductPricingCountQuery, GetProductPricingCountQueryVariables>, 'query'>;

    export const GetProductPricingCountComponent = (props: GetProductPricingCountComponentProps) => (
      <ApolloReactComponents.Query<GetProductPricingCountQuery, GetProductPricingCountQueryVariables> query={GetProductPricingCountDocument} {...props} />
    );
    
export type GetProductPricingCountProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetProductPricingCountQuery, GetProductPricingCountQueryVariables>
    } & TChildProps;
export function withGetProductPricingCount<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetProductPricingCountQuery,
  GetProductPricingCountQueryVariables,
  GetProductPricingCountProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetProductPricingCountQuery, GetProductPricingCountQueryVariables, GetProductPricingCountProps<TChildProps, TDataName>>(GetProductPricingCountDocument, {
      alias: 'getProductPricingCount',
      ...operationOptions
    });
};

/**
 * __useGetProductPricingCountQuery__
 *
 * To run a query within a React component, call `useGetProductPricingCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductPricingCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductPricingCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetProductPricingCountQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetProductPricingCountQuery, GetProductPricingCountQueryVariables>) {
        return ApolloReactHooks.useQuery<GetProductPricingCountQuery, GetProductPricingCountQueryVariables>(GetProductPricingCountDocument, baseOptions);
      }
export function useGetProductPricingCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProductPricingCountQuery, GetProductPricingCountQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetProductPricingCountQuery, GetProductPricingCountQueryVariables>(GetProductPricingCountDocument, baseOptions);
        }
export type GetProductPricingCountQueryHookResult = ReturnType<typeof useGetProductPricingCountQuery>;
export type GetProductPricingCountLazyQueryHookResult = ReturnType<typeof useGetProductPricingCountLazyQuery>;
export type GetProductPricingCountQueryResult = ApolloReactCommon.QueryResult<GetProductPricingCountQuery, GetProductPricingCountQueryVariables>;
export const GetProductPricingDataDocument = gql`
    query GetProductPricingData($page: Int, $perPage: Int, $filter: FilterInputProducts, $sort: [ProductsSortInput]) {
  products(page: $page, perPage: $perPage, filter: $filter, sort: $sort) {
    items {
      id
      _id
      sku
      barcode {
        type
        code
      }
      image
      name
      locks
      prices {
        amazon_br {
          base
          selling
        }
        amazon_jp {
          base
          selling
        }
        amazon_au {
          base
          selling
        }
        amazon_de {
          base
          selling
        }
        amazon_uk {
          base
          selling
        }
        amazon_nl {
          base
          selling
        }
        amazon_it {
          base
          selling
        }
        amazon_fr {
          base
          selling
        }
        amazon_es {
          base
          selling
        }
        amazon_mx {
          base
          selling
        }
        amazon_us {
          base
          selling
        }
        amazon_ca {
          base
          selling
        }
        amazon_se {
          base
          selling
        }
        amazon_tr {
          base
          selling
        }
        amazon_pl {
          base
          selling
        }
        mall_cz {
          base
          selling
        }
        mall_pl {
          base
          selling
        }
        mall_si {
          base
          selling
        }
        mall_hu {
          base
          selling
        }
        mall_sk {
          base
          selling
        }
        alza_cz {
          base
          selling
        }
      }
      asins {
        amazon_br
        amazon_jp
        amazon_au
        amazon_de
        amazon_uk
        amazon_nl
        amazon_it
        amazon_fr
        amazon_es
        amazon_mx
        amazon_us
        amazon_ca
      }
      stock
      pricing {
        summary {
          totalOffers
          lowest {
            listing
            shipping
            channel
            landed
          }
          highest {
            listing
            shipping
            channel
            landed
          }
          buyBox {
            listing
            shipping
            landed
          }
        }
        offer {
          shippingPrice
          sellerId
          listingPrice
          marketplaceDetails {
            isBuyBoxWinner
            isFeaturedMerchant
            isFulfilledByAmazon
          }
        }
      }
      productStatus {
        marketplace
        isBuyBoxWinner
      }
      autopricing {
        marketplace
        autoprice
        buybox
        selling
        active
        topCap
        bottomCap
        topCapAbsolute
        bottomCapAbsolute
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      perPage
      currentPage
    }
  }
  syncSettings {
    _id
    autopricing {
      amazon_au {
        active
        defaultTopCap
        defaultBottomCap
      }
      amazon_br {
        active
        defaultTopCap
        defaultBottomCap
      }
      amazon_ca {
        active
        defaultTopCap
        defaultBottomCap
      }
      amazon_de {
        active
        defaultTopCap
        defaultBottomCap
      }
      amazon_es {
        active
        defaultTopCap
        defaultBottomCap
      }
      amazon_fr {
        active
        defaultTopCap
        defaultBottomCap
      }
      amazon_it {
        active
        defaultTopCap
        defaultBottomCap
      }
      amazon_jp {
        active
        defaultTopCap
        defaultBottomCap
      }
      amazon_mx {
        active
        defaultTopCap
        defaultBottomCap
      }
      amazon_uk {
        active
        defaultTopCap
        defaultBottomCap
      }
      amazon_nl {
        active
        defaultTopCap
        defaultBottomCap
      }
      amazon_us {
        active
        defaultTopCap
        defaultBottomCap
      }
    }
  }
}
    `;
export type GetProductPricingDataComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetProductPricingDataQuery, GetProductPricingDataQueryVariables>, 'query'>;

    export const GetProductPricingDataComponent = (props: GetProductPricingDataComponentProps) => (
      <ApolloReactComponents.Query<GetProductPricingDataQuery, GetProductPricingDataQueryVariables> query={GetProductPricingDataDocument} {...props} />
    );
    
export type GetProductPricingDataProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetProductPricingDataQuery, GetProductPricingDataQueryVariables>
    } & TChildProps;
export function withGetProductPricingData<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetProductPricingDataQuery,
  GetProductPricingDataQueryVariables,
  GetProductPricingDataProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetProductPricingDataQuery, GetProductPricingDataQueryVariables, GetProductPricingDataProps<TChildProps, TDataName>>(GetProductPricingDataDocument, {
      alias: 'getProductPricingData',
      ...operationOptions
    });
};

/**
 * __useGetProductPricingDataQuery__
 *
 * To run a query within a React component, call `useGetProductPricingDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductPricingDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductPricingDataQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetProductPricingDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetProductPricingDataQuery, GetProductPricingDataQueryVariables>) {
        return ApolloReactHooks.useQuery<GetProductPricingDataQuery, GetProductPricingDataQueryVariables>(GetProductPricingDataDocument, baseOptions);
      }
export function useGetProductPricingDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProductPricingDataQuery, GetProductPricingDataQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetProductPricingDataQuery, GetProductPricingDataQueryVariables>(GetProductPricingDataDocument, baseOptions);
        }
export type GetProductPricingDataQueryHookResult = ReturnType<typeof useGetProductPricingDataQuery>;
export type GetProductPricingDataLazyQueryHookResult = ReturnType<typeof useGetProductPricingDataLazyQuery>;
export type GetProductPricingDataQueryResult = ApolloReactCommon.QueryResult<GetProductPricingDataQuery, GetProductPricingDataQueryVariables>;
export const GetProductStatisticsDocument = gql`
    query GetProductStatistics($hasStockFilter: Boolean) {
  productFeedResult {
    productsAll
    productsInStock
  }
  productStats(hasStockFilter: $hasStockFilter) {
    ok
    paused
    notFound
    missingBarcode
    error
  }
}
    `;
export type GetProductStatisticsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetProductStatisticsQuery, GetProductStatisticsQueryVariables>, 'query'>;

    export const GetProductStatisticsComponent = (props: GetProductStatisticsComponentProps) => (
      <ApolloReactComponents.Query<GetProductStatisticsQuery, GetProductStatisticsQueryVariables> query={GetProductStatisticsDocument} {...props} />
    );
    
export type GetProductStatisticsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetProductStatisticsQuery, GetProductStatisticsQueryVariables>
    } & TChildProps;
export function withGetProductStatistics<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetProductStatisticsQuery,
  GetProductStatisticsQueryVariables,
  GetProductStatisticsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetProductStatisticsQuery, GetProductStatisticsQueryVariables, GetProductStatisticsProps<TChildProps, TDataName>>(GetProductStatisticsDocument, {
      alias: 'getProductStatistics',
      ...operationOptions
    });
};

/**
 * __useGetProductStatisticsQuery__
 *
 * To run a query within a React component, call `useGetProductStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductStatisticsQuery({
 *   variables: {
 *      hasStockFilter: // value for 'hasStockFilter'
 *   },
 * });
 */
export function useGetProductStatisticsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetProductStatisticsQuery, GetProductStatisticsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetProductStatisticsQuery, GetProductStatisticsQueryVariables>(GetProductStatisticsDocument, baseOptions);
      }
export function useGetProductStatisticsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProductStatisticsQuery, GetProductStatisticsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetProductStatisticsQuery, GetProductStatisticsQueryVariables>(GetProductStatisticsDocument, baseOptions);
        }
export type GetProductStatisticsQueryHookResult = ReturnType<typeof useGetProductStatisticsQuery>;
export type GetProductStatisticsLazyQueryHookResult = ReturnType<typeof useGetProductStatisticsLazyQuery>;
export type GetProductStatisticsQueryResult = ApolloReactCommon.QueryResult<GetProductStatisticsQuery, GetProductStatisticsQueryVariables>;
export const GetOrderStatisticsDocument = gql`
    query GetOrderStatistics($autopricingStatsSince: Date, $shippedCountSince: Date) {
  lastThirtyDaysStats: rangedOrdersStatistics(timeRange: lastThirtyDays) {
    count
    money {
      currency
      value
    }
  }
  lastSevenDaysStats: rangedOrdersStatistics(timeRange: lastSevenDays) {
    count
    money {
      currency
      value
    }
  }
  autopricingStatistics(since: $autopricingStatsSince) {
    count
    addedMoney {
      currency
      value
    }
  }
  shippedOrdersCount(since: $shippedCountSince)
  unshippedOrdersCount
  lateOrdersCount
}
    `;
export type GetOrderStatisticsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetOrderStatisticsQuery, GetOrderStatisticsQueryVariables>, 'query'>;

    export const GetOrderStatisticsComponent = (props: GetOrderStatisticsComponentProps) => (
      <ApolloReactComponents.Query<GetOrderStatisticsQuery, GetOrderStatisticsQueryVariables> query={GetOrderStatisticsDocument} {...props} />
    );
    
export type GetOrderStatisticsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetOrderStatisticsQuery, GetOrderStatisticsQueryVariables>
    } & TChildProps;
export function withGetOrderStatistics<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetOrderStatisticsQuery,
  GetOrderStatisticsQueryVariables,
  GetOrderStatisticsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetOrderStatisticsQuery, GetOrderStatisticsQueryVariables, GetOrderStatisticsProps<TChildProps, TDataName>>(GetOrderStatisticsDocument, {
      alias: 'getOrderStatistics',
      ...operationOptions
    });
};

/**
 * __useGetOrderStatisticsQuery__
 *
 * To run a query within a React component, call `useGetOrderStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderStatisticsQuery({
 *   variables: {
 *      autopricingStatsSince: // value for 'autopricingStatsSince'
 *      shippedCountSince: // value for 'shippedCountSince'
 *   },
 * });
 */
export function useGetOrderStatisticsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetOrderStatisticsQuery, GetOrderStatisticsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetOrderStatisticsQuery, GetOrderStatisticsQueryVariables>(GetOrderStatisticsDocument, baseOptions);
      }
export function useGetOrderStatisticsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOrderStatisticsQuery, GetOrderStatisticsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetOrderStatisticsQuery, GetOrderStatisticsQueryVariables>(GetOrderStatisticsDocument, baseOptions);
        }
export type GetOrderStatisticsQueryHookResult = ReturnType<typeof useGetOrderStatisticsQuery>;
export type GetOrderStatisticsLazyQueryHookResult = ReturnType<typeof useGetOrderStatisticsLazyQuery>;
export type GetOrderStatisticsQueryResult = ApolloReactCommon.QueryResult<GetOrderStatisticsQuery, GetOrderStatisticsQueryVariables>;
export const GetOrderChartDataDocument = gql`
    query GetOrderChartData($filter: FilterInputStatistics) {
  orderStatistics(filter: $filter) {
    from
    to
    count
  }
}
    `;
export type GetOrderChartDataComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetOrderChartDataQuery, GetOrderChartDataQueryVariables>, 'query'>;

    export const GetOrderChartDataComponent = (props: GetOrderChartDataComponentProps) => (
      <ApolloReactComponents.Query<GetOrderChartDataQuery, GetOrderChartDataQueryVariables> query={GetOrderChartDataDocument} {...props} />
    );
    
export type GetOrderChartDataProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetOrderChartDataQuery, GetOrderChartDataQueryVariables>
    } & TChildProps;
export function withGetOrderChartData<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetOrderChartDataQuery,
  GetOrderChartDataQueryVariables,
  GetOrderChartDataProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetOrderChartDataQuery, GetOrderChartDataQueryVariables, GetOrderChartDataProps<TChildProps, TDataName>>(GetOrderChartDataDocument, {
      alias: 'getOrderChartData',
      ...operationOptions
    });
};

/**
 * __useGetOrderChartDataQuery__
 *
 * To run a query within a React component, call `useGetOrderChartDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderChartDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderChartDataQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetOrderChartDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetOrderChartDataQuery, GetOrderChartDataQueryVariables>) {
        return ApolloReactHooks.useQuery<GetOrderChartDataQuery, GetOrderChartDataQueryVariables>(GetOrderChartDataDocument, baseOptions);
      }
export function useGetOrderChartDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOrderChartDataQuery, GetOrderChartDataQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetOrderChartDataQuery, GetOrderChartDataQueryVariables>(GetOrderChartDataDocument, baseOptions);
        }
export type GetOrderChartDataQueryHookResult = ReturnType<typeof useGetOrderChartDataQuery>;
export type GetOrderChartDataLazyQueryHookResult = ReturnType<typeof useGetOrderChartDataLazyQuery>;
export type GetOrderChartDataQueryResult = ApolloReactCommon.QueryResult<GetOrderChartDataQuery, GetOrderChartDataQueryVariables>;
export const GetMarketplaceStatisticsDocument = gql`
    query GetMarketplaceStatistics {
  marketplaces {
    id
    marketplace
    status
    currentListingStatistics {
      ok
      error
    }
    errorRates {
      code
      message
      count
    }
  }
  productFeedResult {
    productsToBeListed
  }
}
    `;
export type GetMarketplaceStatisticsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetMarketplaceStatisticsQuery, GetMarketplaceStatisticsQueryVariables>, 'query'>;

    export const GetMarketplaceStatisticsComponent = (props: GetMarketplaceStatisticsComponentProps) => (
      <ApolloReactComponents.Query<GetMarketplaceStatisticsQuery, GetMarketplaceStatisticsQueryVariables> query={GetMarketplaceStatisticsDocument} {...props} />
    );
    
export type GetMarketplaceStatisticsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetMarketplaceStatisticsQuery, GetMarketplaceStatisticsQueryVariables>
    } & TChildProps;
export function withGetMarketplaceStatistics<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetMarketplaceStatisticsQuery,
  GetMarketplaceStatisticsQueryVariables,
  GetMarketplaceStatisticsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetMarketplaceStatisticsQuery, GetMarketplaceStatisticsQueryVariables, GetMarketplaceStatisticsProps<TChildProps, TDataName>>(GetMarketplaceStatisticsDocument, {
      alias: 'getMarketplaceStatistics',
      ...operationOptions
    });
};

/**
 * __useGetMarketplaceStatisticsQuery__
 *
 * To run a query within a React component, call `useGetMarketplaceStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarketplaceStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMarketplaceStatisticsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMarketplaceStatisticsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMarketplaceStatisticsQuery, GetMarketplaceStatisticsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetMarketplaceStatisticsQuery, GetMarketplaceStatisticsQueryVariables>(GetMarketplaceStatisticsDocument, baseOptions);
      }
export function useGetMarketplaceStatisticsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMarketplaceStatisticsQuery, GetMarketplaceStatisticsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetMarketplaceStatisticsQuery, GetMarketplaceStatisticsQueryVariables>(GetMarketplaceStatisticsDocument, baseOptions);
        }
export type GetMarketplaceStatisticsQueryHookResult = ReturnType<typeof useGetMarketplaceStatisticsQuery>;
export type GetMarketplaceStatisticsLazyQueryHookResult = ReturnType<typeof useGetMarketplaceStatisticsLazyQuery>;
export type GetMarketplaceStatisticsQueryResult = ApolloReactCommon.QueryResult<GetMarketplaceStatisticsQuery, GetMarketplaceStatisticsQueryVariables>;
export const GetProductSyncDocument = gql`
    query GetProductSync {
  productSync {
    startedOn
    isSyncing
  }
}
    `;
export type GetProductSyncComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetProductSyncQuery, GetProductSyncQueryVariables>, 'query'>;

    export const GetProductSyncComponent = (props: GetProductSyncComponentProps) => (
      <ApolloReactComponents.Query<GetProductSyncQuery, GetProductSyncQueryVariables> query={GetProductSyncDocument} {...props} />
    );
    
export type GetProductSyncProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetProductSyncQuery, GetProductSyncQueryVariables>
    } & TChildProps;
export function withGetProductSync<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetProductSyncQuery,
  GetProductSyncQueryVariables,
  GetProductSyncProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetProductSyncQuery, GetProductSyncQueryVariables, GetProductSyncProps<TChildProps, TDataName>>(GetProductSyncDocument, {
      alias: 'getProductSync',
      ...operationOptions
    });
};

/**
 * __useGetProductSyncQuery__
 *
 * To run a query within a React component, call `useGetProductSyncQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductSyncQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductSyncQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProductSyncQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetProductSyncQuery, GetProductSyncQueryVariables>) {
        return ApolloReactHooks.useQuery<GetProductSyncQuery, GetProductSyncQueryVariables>(GetProductSyncDocument, baseOptions);
      }
export function useGetProductSyncLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProductSyncQuery, GetProductSyncQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetProductSyncQuery, GetProductSyncQueryVariables>(GetProductSyncDocument, baseOptions);
        }
export type GetProductSyncQueryHookResult = ReturnType<typeof useGetProductSyncQuery>;
export type GetProductSyncLazyQueryHookResult = ReturnType<typeof useGetProductSyncLazyQuery>;
export type GetProductSyncQueryResult = ApolloReactCommon.QueryResult<GetProductSyncQuery, GetProductSyncQueryVariables>;
export const TriggerAlzaSyncDocument = gql`
    mutation TriggerAlzaSync {
  triggerAlzaSync {
    message
    willRunAt
  }
}
    `;
export type TriggerAlzaSyncMutationFn = ApolloReactCommon.MutationFunction<TriggerAlzaSyncMutation, TriggerAlzaSyncMutationVariables>;
export type TriggerAlzaSyncComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<TriggerAlzaSyncMutation, TriggerAlzaSyncMutationVariables>, 'mutation'>;

    export const TriggerAlzaSyncComponent = (props: TriggerAlzaSyncComponentProps) => (
      <ApolloReactComponents.Mutation<TriggerAlzaSyncMutation, TriggerAlzaSyncMutationVariables> mutation={TriggerAlzaSyncDocument} {...props} />
    );
    
export type TriggerAlzaSyncProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<TriggerAlzaSyncMutation, TriggerAlzaSyncMutationVariables>
    } & TChildProps;
export function withTriggerAlzaSync<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  TriggerAlzaSyncMutation,
  TriggerAlzaSyncMutationVariables,
  TriggerAlzaSyncProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, TriggerAlzaSyncMutation, TriggerAlzaSyncMutationVariables, TriggerAlzaSyncProps<TChildProps, TDataName>>(TriggerAlzaSyncDocument, {
      alias: 'triggerAlzaSync',
      ...operationOptions
    });
};

/**
 * __useTriggerAlzaSyncMutation__
 *
 * To run a mutation, you first call `useTriggerAlzaSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerAlzaSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerAlzaSyncMutation, { data, loading, error }] = useTriggerAlzaSyncMutation({
 *   variables: {
 *   },
 * });
 */
export function useTriggerAlzaSyncMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TriggerAlzaSyncMutation, TriggerAlzaSyncMutationVariables>) {
        return ApolloReactHooks.useMutation<TriggerAlzaSyncMutation, TriggerAlzaSyncMutationVariables>(TriggerAlzaSyncDocument, baseOptions);
      }
export type TriggerAlzaSyncMutationHookResult = ReturnType<typeof useTriggerAlzaSyncMutation>;
export type TriggerAlzaSyncMutationResult = ApolloReactCommon.MutationResult<TriggerAlzaSyncMutation>;
export type TriggerAlzaSyncMutationOptions = ApolloReactCommon.BaseMutationOptions<TriggerAlzaSyncMutation, TriggerAlzaSyncMutationVariables>;
export const SyncControlQueryDocument = gql`
    query SyncControlQuery {
  marketplaces {
    id
    status
    error
    marketplace
    currency
  }
  productSync {
    _id
    interval
    startedOn
    nextSyncOn
    finishedOn
    isSyncing
  }
}
    `;
export type SyncControlQueryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SyncControlQueryQuery, SyncControlQueryQueryVariables>, 'query'>;

    export const SyncControlQueryComponent = (props: SyncControlQueryComponentProps) => (
      <ApolloReactComponents.Query<SyncControlQueryQuery, SyncControlQueryQueryVariables> query={SyncControlQueryDocument} {...props} />
    );
    
export type SyncControlQueryProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<SyncControlQueryQuery, SyncControlQueryQueryVariables>
    } & TChildProps;
export function withSyncControlQuery<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SyncControlQueryQuery,
  SyncControlQueryQueryVariables,
  SyncControlQueryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, SyncControlQueryQuery, SyncControlQueryQueryVariables, SyncControlQueryProps<TChildProps, TDataName>>(SyncControlQueryDocument, {
      alias: 'syncControlQuery',
      ...operationOptions
    });
};

/**
 * __useSyncControlQueryQuery__
 *
 * To run a query within a React component, call `useSyncControlQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSyncControlQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSyncControlQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useSyncControlQueryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SyncControlQueryQuery, SyncControlQueryQueryVariables>) {
        return ApolloReactHooks.useQuery<SyncControlQueryQuery, SyncControlQueryQueryVariables>(SyncControlQueryDocument, baseOptions);
      }
export function useSyncControlQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SyncControlQueryQuery, SyncControlQueryQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SyncControlQueryQuery, SyncControlQueryQueryVariables>(SyncControlQueryDocument, baseOptions);
        }
export type SyncControlQueryQueryHookResult = ReturnType<typeof useSyncControlQueryQuery>;
export type SyncControlQueryLazyQueryHookResult = ReturnType<typeof useSyncControlQueryLazyQuery>;
export type SyncControlQueryQueryResult = ApolloReactCommon.QueryResult<SyncControlQueryQuery, SyncControlQueryQueryVariables>;
export const DoSyncDocument = gql`
    mutation DoSync {
  sync {
    _id
    interval
    startedOn
    nextSyncOn
    finishedOn
    isSyncing
  }
}
    `;
export type DoSyncMutationFn = ApolloReactCommon.MutationFunction<DoSyncMutation, DoSyncMutationVariables>;
export type DoSyncComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DoSyncMutation, DoSyncMutationVariables>, 'mutation'>;

    export const DoSyncComponent = (props: DoSyncComponentProps) => (
      <ApolloReactComponents.Mutation<DoSyncMutation, DoSyncMutationVariables> mutation={DoSyncDocument} {...props} />
    );
    
export type DoSyncProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DoSyncMutation, DoSyncMutationVariables>
    } & TChildProps;
export function withDoSync<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DoSyncMutation,
  DoSyncMutationVariables,
  DoSyncProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DoSyncMutation, DoSyncMutationVariables, DoSyncProps<TChildProps, TDataName>>(DoSyncDocument, {
      alias: 'doSync',
      ...operationOptions
    });
};

/**
 * __useDoSyncMutation__
 *
 * To run a mutation, you first call `useDoSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doSyncMutation, { data, loading, error }] = useDoSyncMutation({
 *   variables: {
 *   },
 * });
 */
export function useDoSyncMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DoSyncMutation, DoSyncMutationVariables>) {
        return ApolloReactHooks.useMutation<DoSyncMutation, DoSyncMutationVariables>(DoSyncDocument, baseOptions);
      }
export type DoSyncMutationHookResult = ReturnType<typeof useDoSyncMutation>;
export type DoSyncMutationResult = ApolloReactCommon.MutationResult<DoSyncMutation>;
export type DoSyncMutationOptions = ApolloReactCommon.BaseMutationOptions<DoSyncMutation, DoSyncMutationVariables>;
export const CreateShipmentDocument = gql`
    mutation CreateShipment($packages: [PackagesInput]!, $orderIds: [String]!) {
  createShipment(packages: $packages, orderIds: $orderIds) {
    success
    message
    error
  }
}
    `;
export type CreateShipmentMutationFn = ApolloReactCommon.MutationFunction<CreateShipmentMutation, CreateShipmentMutationVariables>;
export type CreateShipmentComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateShipmentMutation, CreateShipmentMutationVariables>, 'mutation'>;

    export const CreateShipmentComponent = (props: CreateShipmentComponentProps) => (
      <ApolloReactComponents.Mutation<CreateShipmentMutation, CreateShipmentMutationVariables> mutation={CreateShipmentDocument} {...props} />
    );
    
export type CreateShipmentProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateShipmentMutation, CreateShipmentMutationVariables>
    } & TChildProps;
export function withCreateShipment<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateShipmentMutation,
  CreateShipmentMutationVariables,
  CreateShipmentProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateShipmentMutation, CreateShipmentMutationVariables, CreateShipmentProps<TChildProps, TDataName>>(CreateShipmentDocument, {
      alias: 'createShipment',
      ...operationOptions
    });
};

/**
 * __useCreateShipmentMutation__
 *
 * To run a mutation, you first call `useCreateShipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateShipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createShipmentMutation, { data, loading, error }] = useCreateShipmentMutation({
 *   variables: {
 *      packages: // value for 'packages'
 *      orderIds: // value for 'orderIds'
 *   },
 * });
 */
export function useCreateShipmentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateShipmentMutation, CreateShipmentMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateShipmentMutation, CreateShipmentMutationVariables>(CreateShipmentDocument, baseOptions);
      }
export type CreateShipmentMutationHookResult = ReturnType<typeof useCreateShipmentMutation>;
export type CreateShipmentMutationResult = ApolloReactCommon.MutationResult<CreateShipmentMutation>;
export type CreateShipmentMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateShipmentMutation, CreateShipmentMutationVariables>;
export const GeneratePackageItemLabelsDocument = gql`
    mutation GeneratePackageItemLabels($marketplaceOrderIds: [String!]) {
  generateBarcodes(marketplaceOrderIds: $marketplaceOrderIds) {
    _id
    doneAt
    downloadLink
    failReason
    failedAt
    requestedAt
    status
    input
  }
}
    `;
export type GeneratePackageItemLabelsMutationFn = ApolloReactCommon.MutationFunction<GeneratePackageItemLabelsMutation, GeneratePackageItemLabelsMutationVariables>;
export type GeneratePackageItemLabelsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<GeneratePackageItemLabelsMutation, GeneratePackageItemLabelsMutationVariables>, 'mutation'>;

    export const GeneratePackageItemLabelsComponent = (props: GeneratePackageItemLabelsComponentProps) => (
      <ApolloReactComponents.Mutation<GeneratePackageItemLabelsMutation, GeneratePackageItemLabelsMutationVariables> mutation={GeneratePackageItemLabelsDocument} {...props} />
    );
    
export type GeneratePackageItemLabelsProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<GeneratePackageItemLabelsMutation, GeneratePackageItemLabelsMutationVariables>
    } & TChildProps;
export function withGeneratePackageItemLabels<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GeneratePackageItemLabelsMutation,
  GeneratePackageItemLabelsMutationVariables,
  GeneratePackageItemLabelsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, GeneratePackageItemLabelsMutation, GeneratePackageItemLabelsMutationVariables, GeneratePackageItemLabelsProps<TChildProps, TDataName>>(GeneratePackageItemLabelsDocument, {
      alias: 'generatePackageItemLabels',
      ...operationOptions
    });
};

/**
 * __useGeneratePackageItemLabelsMutation__
 *
 * To run a mutation, you first call `useGeneratePackageItemLabelsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGeneratePackageItemLabelsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generatePackageItemLabelsMutation, { data, loading, error }] = useGeneratePackageItemLabelsMutation({
 *   variables: {
 *      marketplaceOrderIds: // value for 'marketplaceOrderIds'
 *   },
 * });
 */
export function useGeneratePackageItemLabelsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GeneratePackageItemLabelsMutation, GeneratePackageItemLabelsMutationVariables>) {
        return ApolloReactHooks.useMutation<GeneratePackageItemLabelsMutation, GeneratePackageItemLabelsMutationVariables>(GeneratePackageItemLabelsDocument, baseOptions);
      }
export type GeneratePackageItemLabelsMutationHookResult = ReturnType<typeof useGeneratePackageItemLabelsMutation>;
export type GeneratePackageItemLabelsMutationResult = ApolloReactCommon.MutationResult<GeneratePackageItemLabelsMutation>;
export type GeneratePackageItemLabelsMutationOptions = ApolloReactCommon.BaseMutationOptions<GeneratePackageItemLabelsMutation, GeneratePackageItemLabelsMutationVariables>;
export const GeneratePackageItemLabelsWithEanDocument = gql`
    mutation GeneratePackageItemLabelsWithEan($marketplaceOrderIds: [String!]) {
  generateBarcodesWithEan(marketplaceOrderIds: $marketplaceOrderIds) {
    _id
    doneAt
    downloadLink
    failReason
    failedAt
    requestedAt
    status
    input
  }
}
    `;
export type GeneratePackageItemLabelsWithEanMutationFn = ApolloReactCommon.MutationFunction<GeneratePackageItemLabelsWithEanMutation, GeneratePackageItemLabelsWithEanMutationVariables>;
export type GeneratePackageItemLabelsWithEanComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<GeneratePackageItemLabelsWithEanMutation, GeneratePackageItemLabelsWithEanMutationVariables>, 'mutation'>;

    export const GeneratePackageItemLabelsWithEanComponent = (props: GeneratePackageItemLabelsWithEanComponentProps) => (
      <ApolloReactComponents.Mutation<GeneratePackageItemLabelsWithEanMutation, GeneratePackageItemLabelsWithEanMutationVariables> mutation={GeneratePackageItemLabelsWithEanDocument} {...props} />
    );
    
export type GeneratePackageItemLabelsWithEanProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<GeneratePackageItemLabelsWithEanMutation, GeneratePackageItemLabelsWithEanMutationVariables>
    } & TChildProps;
export function withGeneratePackageItemLabelsWithEan<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GeneratePackageItemLabelsWithEanMutation,
  GeneratePackageItemLabelsWithEanMutationVariables,
  GeneratePackageItemLabelsWithEanProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, GeneratePackageItemLabelsWithEanMutation, GeneratePackageItemLabelsWithEanMutationVariables, GeneratePackageItemLabelsWithEanProps<TChildProps, TDataName>>(GeneratePackageItemLabelsWithEanDocument, {
      alias: 'generatePackageItemLabelsWithEan',
      ...operationOptions
    });
};

/**
 * __useGeneratePackageItemLabelsWithEanMutation__
 *
 * To run a mutation, you first call `useGeneratePackageItemLabelsWithEanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGeneratePackageItemLabelsWithEanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generatePackageItemLabelsWithEanMutation, { data, loading, error }] = useGeneratePackageItemLabelsWithEanMutation({
 *   variables: {
 *      marketplaceOrderIds: // value for 'marketplaceOrderIds'
 *   },
 * });
 */
export function useGeneratePackageItemLabelsWithEanMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GeneratePackageItemLabelsWithEanMutation, GeneratePackageItemLabelsWithEanMutationVariables>) {
        return ApolloReactHooks.useMutation<GeneratePackageItemLabelsWithEanMutation, GeneratePackageItemLabelsWithEanMutationVariables>(GeneratePackageItemLabelsWithEanDocument, baseOptions);
      }
export type GeneratePackageItemLabelsWithEanMutationHookResult = ReturnType<typeof useGeneratePackageItemLabelsWithEanMutation>;
export type GeneratePackageItemLabelsWithEanMutationResult = ApolloReactCommon.MutationResult<GeneratePackageItemLabelsWithEanMutation>;
export type GeneratePackageItemLabelsWithEanMutationOptions = ApolloReactCommon.BaseMutationOptions<GeneratePackageItemLabelsWithEanMutation, GeneratePackageItemLabelsWithEanMutationVariables>;
export const CreateReturnPackageLabelDocument = gql`
    mutation CreateReturnPackageLabel($marketplace: String!, $marketplaceOrderId: String!) {
  createReturnPackageLabel(
    marketplace: $marketplace
    marketplaceOrderId: $marketplaceOrderId
  ) {
    _id
    returnLabels {
      status
      requestCreatedAt
      packageLabelUrls
      errorMessage
      shipmentNumber
      labelNumber
    }
  }
}
    `;
export type CreateReturnPackageLabelMutationFn = ApolloReactCommon.MutationFunction<CreateReturnPackageLabelMutation, CreateReturnPackageLabelMutationVariables>;
export type CreateReturnPackageLabelComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateReturnPackageLabelMutation, CreateReturnPackageLabelMutationVariables>, 'mutation'>;

    export const CreateReturnPackageLabelComponent = (props: CreateReturnPackageLabelComponentProps) => (
      <ApolloReactComponents.Mutation<CreateReturnPackageLabelMutation, CreateReturnPackageLabelMutationVariables> mutation={CreateReturnPackageLabelDocument} {...props} />
    );
    
export type CreateReturnPackageLabelProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateReturnPackageLabelMutation, CreateReturnPackageLabelMutationVariables>
    } & TChildProps;
export function withCreateReturnPackageLabel<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateReturnPackageLabelMutation,
  CreateReturnPackageLabelMutationVariables,
  CreateReturnPackageLabelProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateReturnPackageLabelMutation, CreateReturnPackageLabelMutationVariables, CreateReturnPackageLabelProps<TChildProps, TDataName>>(CreateReturnPackageLabelDocument, {
      alias: 'createReturnPackageLabel',
      ...operationOptions
    });
};

/**
 * __useCreateReturnPackageLabelMutation__
 *
 * To run a mutation, you first call `useCreateReturnPackageLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReturnPackageLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReturnPackageLabelMutation, { data, loading, error }] = useCreateReturnPackageLabelMutation({
 *   variables: {
 *      marketplace: // value for 'marketplace'
 *      marketplaceOrderId: // value for 'marketplaceOrderId'
 *   },
 * });
 */
export function useCreateReturnPackageLabelMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateReturnPackageLabelMutation, CreateReturnPackageLabelMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateReturnPackageLabelMutation, CreateReturnPackageLabelMutationVariables>(CreateReturnPackageLabelDocument, baseOptions);
      }
export type CreateReturnPackageLabelMutationHookResult = ReturnType<typeof useCreateReturnPackageLabelMutation>;
export type CreateReturnPackageLabelMutationResult = ApolloReactCommon.MutationResult<CreateReturnPackageLabelMutation>;
export type CreateReturnPackageLabelMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateReturnPackageLabelMutation, CreateReturnPackageLabelMutationVariables>;
export const CreateReturnPackageLabelAsAdminDocument = gql`
    mutation CreateReturnPackageLabelAsAdmin($companyId: String!, $marketplace: String!, $marketplaceOrderId: String!) {
  createReturnPackageLabelAsAdmin(
    companyId: $companyId
    marketplace: $marketplace
    marketplaceOrderId: $marketplaceOrderId
  ) {
    _id
    returnLabels {
      status
      requestCreatedAt
      packageLabelUrls
      errorMessage
      shipmentNumber
      labelNumber
    }
  }
}
    `;
export type CreateReturnPackageLabelAsAdminMutationFn = ApolloReactCommon.MutationFunction<CreateReturnPackageLabelAsAdminMutation, CreateReturnPackageLabelAsAdminMutationVariables>;
export type CreateReturnPackageLabelAsAdminComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateReturnPackageLabelAsAdminMutation, CreateReturnPackageLabelAsAdminMutationVariables>, 'mutation'>;

    export const CreateReturnPackageLabelAsAdminComponent = (props: CreateReturnPackageLabelAsAdminComponentProps) => (
      <ApolloReactComponents.Mutation<CreateReturnPackageLabelAsAdminMutation, CreateReturnPackageLabelAsAdminMutationVariables> mutation={CreateReturnPackageLabelAsAdminDocument} {...props} />
    );
    
export type CreateReturnPackageLabelAsAdminProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateReturnPackageLabelAsAdminMutation, CreateReturnPackageLabelAsAdminMutationVariables>
    } & TChildProps;
export function withCreateReturnPackageLabelAsAdmin<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateReturnPackageLabelAsAdminMutation,
  CreateReturnPackageLabelAsAdminMutationVariables,
  CreateReturnPackageLabelAsAdminProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateReturnPackageLabelAsAdminMutation, CreateReturnPackageLabelAsAdminMutationVariables, CreateReturnPackageLabelAsAdminProps<TChildProps, TDataName>>(CreateReturnPackageLabelAsAdminDocument, {
      alias: 'createReturnPackageLabelAsAdmin',
      ...operationOptions
    });
};

/**
 * __useCreateReturnPackageLabelAsAdminMutation__
 *
 * To run a mutation, you first call `useCreateReturnPackageLabelAsAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReturnPackageLabelAsAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReturnPackageLabelAsAdminMutation, { data, loading, error }] = useCreateReturnPackageLabelAsAdminMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      marketplace: // value for 'marketplace'
 *      marketplaceOrderId: // value for 'marketplaceOrderId'
 *   },
 * });
 */
export function useCreateReturnPackageLabelAsAdminMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateReturnPackageLabelAsAdminMutation, CreateReturnPackageLabelAsAdminMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateReturnPackageLabelAsAdminMutation, CreateReturnPackageLabelAsAdminMutationVariables>(CreateReturnPackageLabelAsAdminDocument, baseOptions);
      }
export type CreateReturnPackageLabelAsAdminMutationHookResult = ReturnType<typeof useCreateReturnPackageLabelAsAdminMutation>;
export type CreateReturnPackageLabelAsAdminMutationResult = ApolloReactCommon.MutationResult<CreateReturnPackageLabelAsAdminMutation>;
export type CreateReturnPackageLabelAsAdminMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateReturnPackageLabelAsAdminMutation, CreateReturnPackageLabelAsAdminMutationVariables>;
export const CancelAlzaOrderDocument = gql`
    mutation CancelAlzaOrder($orderId: String!, $deliveryResultStatus: String!) {
  cancelAlzaOrder(orderId: $orderId, deliveryResultStatus: $deliveryResultStatus) {
    ...SuccessMessageProps
  }
}
    ${SuccessMessagePropsFragmentDoc}`;
export type CancelAlzaOrderMutationFn = ApolloReactCommon.MutationFunction<CancelAlzaOrderMutation, CancelAlzaOrderMutationVariables>;
export type CancelAlzaOrderComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CancelAlzaOrderMutation, CancelAlzaOrderMutationVariables>, 'mutation'>;

    export const CancelAlzaOrderComponent = (props: CancelAlzaOrderComponentProps) => (
      <ApolloReactComponents.Mutation<CancelAlzaOrderMutation, CancelAlzaOrderMutationVariables> mutation={CancelAlzaOrderDocument} {...props} />
    );
    
export type CancelAlzaOrderProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CancelAlzaOrderMutation, CancelAlzaOrderMutationVariables>
    } & TChildProps;
export function withCancelAlzaOrder<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CancelAlzaOrderMutation,
  CancelAlzaOrderMutationVariables,
  CancelAlzaOrderProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CancelAlzaOrderMutation, CancelAlzaOrderMutationVariables, CancelAlzaOrderProps<TChildProps, TDataName>>(CancelAlzaOrderDocument, {
      alias: 'cancelAlzaOrder',
      ...operationOptions
    });
};

/**
 * __useCancelAlzaOrderMutation__
 *
 * To run a mutation, you first call `useCancelAlzaOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelAlzaOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelAlzaOrderMutation, { data, loading, error }] = useCancelAlzaOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      deliveryResultStatus: // value for 'deliveryResultStatus'
 *   },
 * });
 */
export function useCancelAlzaOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CancelAlzaOrderMutation, CancelAlzaOrderMutationVariables>) {
        return ApolloReactHooks.useMutation<CancelAlzaOrderMutation, CancelAlzaOrderMutationVariables>(CancelAlzaOrderDocument, baseOptions);
      }
export type CancelAlzaOrderMutationHookResult = ReturnType<typeof useCancelAlzaOrderMutation>;
export type CancelAlzaOrderMutationResult = ApolloReactCommon.MutationResult<CancelAlzaOrderMutation>;
export type CancelAlzaOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<CancelAlzaOrderMutation, CancelAlzaOrderMutationVariables>;
export const CancelAlzaShippingLabelsDocument = gql`
    mutation CancelAlzaShippingLabels($fulfillmentId: String!) {
  cancelAlzaShippingLabels(fulfillmentId: $fulfillmentId) {
    ...SuccessMessageProps
  }
}
    ${SuccessMessagePropsFragmentDoc}`;
export type CancelAlzaShippingLabelsMutationFn = ApolloReactCommon.MutationFunction<CancelAlzaShippingLabelsMutation, CancelAlzaShippingLabelsMutationVariables>;
export type CancelAlzaShippingLabelsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CancelAlzaShippingLabelsMutation, CancelAlzaShippingLabelsMutationVariables>, 'mutation'>;

    export const CancelAlzaShippingLabelsComponent = (props: CancelAlzaShippingLabelsComponentProps) => (
      <ApolloReactComponents.Mutation<CancelAlzaShippingLabelsMutation, CancelAlzaShippingLabelsMutationVariables> mutation={CancelAlzaShippingLabelsDocument} {...props} />
    );
    
export type CancelAlzaShippingLabelsProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CancelAlzaShippingLabelsMutation, CancelAlzaShippingLabelsMutationVariables>
    } & TChildProps;
export function withCancelAlzaShippingLabels<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CancelAlzaShippingLabelsMutation,
  CancelAlzaShippingLabelsMutationVariables,
  CancelAlzaShippingLabelsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CancelAlzaShippingLabelsMutation, CancelAlzaShippingLabelsMutationVariables, CancelAlzaShippingLabelsProps<TChildProps, TDataName>>(CancelAlzaShippingLabelsDocument, {
      alias: 'cancelAlzaShippingLabels',
      ...operationOptions
    });
};

/**
 * __useCancelAlzaShippingLabelsMutation__
 *
 * To run a mutation, you first call `useCancelAlzaShippingLabelsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelAlzaShippingLabelsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelAlzaShippingLabelsMutation, { data, loading, error }] = useCancelAlzaShippingLabelsMutation({
 *   variables: {
 *      fulfillmentId: // value for 'fulfillmentId'
 *   },
 * });
 */
export function useCancelAlzaShippingLabelsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CancelAlzaShippingLabelsMutation, CancelAlzaShippingLabelsMutationVariables>) {
        return ApolloReactHooks.useMutation<CancelAlzaShippingLabelsMutation, CancelAlzaShippingLabelsMutationVariables>(CancelAlzaShippingLabelsDocument, baseOptions);
      }
export type CancelAlzaShippingLabelsMutationHookResult = ReturnType<typeof useCancelAlzaShippingLabelsMutation>;
export type CancelAlzaShippingLabelsMutationResult = ApolloReactCommon.MutationResult<CancelAlzaShippingLabelsMutation>;
export type CancelAlzaShippingLabelsMutationOptions = ApolloReactCommon.BaseMutationOptions<CancelAlzaShippingLabelsMutation, CancelAlzaShippingLabelsMutationVariables>;
export const GetPickupListsDocument = gql`
    query GetPickupLists {
  pickupListsAggregation {
    pickupTime
    count
    pickupLists
    pickupListGroups
  }
}
    `;
export type GetPickupListsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetPickupListsQuery, GetPickupListsQueryVariables>, 'query'>;

    export const GetPickupListsComponent = (props: GetPickupListsComponentProps) => (
      <ApolloReactComponents.Query<GetPickupListsQuery, GetPickupListsQueryVariables> query={GetPickupListsDocument} {...props} />
    );
    
export type GetPickupListsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetPickupListsQuery, GetPickupListsQueryVariables>
    } & TChildProps;
export function withGetPickupLists<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetPickupListsQuery,
  GetPickupListsQueryVariables,
  GetPickupListsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetPickupListsQuery, GetPickupListsQueryVariables, GetPickupListsProps<TChildProps, TDataName>>(GetPickupListsDocument, {
      alias: 'getPickupLists',
      ...operationOptions
    });
};

/**
 * __useGetPickupListsQuery__
 *
 * To run a query within a React component, call `useGetPickupListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPickupListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPickupListsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPickupListsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPickupListsQuery, GetPickupListsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetPickupListsQuery, GetPickupListsQueryVariables>(GetPickupListsDocument, baseOptions);
      }
export function useGetPickupListsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPickupListsQuery, GetPickupListsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetPickupListsQuery, GetPickupListsQueryVariables>(GetPickupListsDocument, baseOptions);
        }
export type GetPickupListsQueryHookResult = ReturnType<typeof useGetPickupListsQuery>;
export type GetPickupListsLazyQueryHookResult = ReturnType<typeof useGetPickupListsLazyQuery>;
export type GetPickupListsQueryResult = ApolloReactCommon.QueryResult<GetPickupListsQuery, GetPickupListsQueryVariables>;
export const RetryAlzaShipmentDocument = gql`
    mutation RetryAlzaShipment($fulfillmentId: String!, $expectedRunId: String!) {
  retryAlzaShipment(fulfillmentId: $fulfillmentId, expectedRunId: $expectedRunId) {
    success
    message
  }
}
    `;
export type RetryAlzaShipmentMutationFn = ApolloReactCommon.MutationFunction<RetryAlzaShipmentMutation, RetryAlzaShipmentMutationVariables>;
export type RetryAlzaShipmentComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<RetryAlzaShipmentMutation, RetryAlzaShipmentMutationVariables>, 'mutation'>;

    export const RetryAlzaShipmentComponent = (props: RetryAlzaShipmentComponentProps) => (
      <ApolloReactComponents.Mutation<RetryAlzaShipmentMutation, RetryAlzaShipmentMutationVariables> mutation={RetryAlzaShipmentDocument} {...props} />
    );
    
export type RetryAlzaShipmentProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<RetryAlzaShipmentMutation, RetryAlzaShipmentMutationVariables>
    } & TChildProps;
export function withRetryAlzaShipment<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RetryAlzaShipmentMutation,
  RetryAlzaShipmentMutationVariables,
  RetryAlzaShipmentProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RetryAlzaShipmentMutation, RetryAlzaShipmentMutationVariables, RetryAlzaShipmentProps<TChildProps, TDataName>>(RetryAlzaShipmentDocument, {
      alias: 'retryAlzaShipment',
      ...operationOptions
    });
};

/**
 * __useRetryAlzaShipmentMutation__
 *
 * To run a mutation, you first call `useRetryAlzaShipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryAlzaShipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryAlzaShipmentMutation, { data, loading, error }] = useRetryAlzaShipmentMutation({
 *   variables: {
 *      fulfillmentId: // value for 'fulfillmentId'
 *      expectedRunId: // value for 'expectedRunId'
 *   },
 * });
 */
export function useRetryAlzaShipmentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RetryAlzaShipmentMutation, RetryAlzaShipmentMutationVariables>) {
        return ApolloReactHooks.useMutation<RetryAlzaShipmentMutation, RetryAlzaShipmentMutationVariables>(RetryAlzaShipmentDocument, baseOptions);
      }
export type RetryAlzaShipmentMutationHookResult = ReturnType<typeof useRetryAlzaShipmentMutation>;
export type RetryAlzaShipmentMutationResult = ApolloReactCommon.MutationResult<RetryAlzaShipmentMutation>;
export type RetryAlzaShipmentMutationOptions = ApolloReactCommon.BaseMutationOptions<RetryAlzaShipmentMutation, RetryAlzaShipmentMutationVariables>;
export const ShipmentDepartureDocument = gql`
    mutation ShipmentDeparture($orderId: String!) {
  shipmentDeparture(orderId: $orderId) {
    response
  }
}
    `;
export type ShipmentDepartureMutationFn = ApolloReactCommon.MutationFunction<ShipmentDepartureMutation, ShipmentDepartureMutationVariables>;
export type ShipmentDepartureComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ShipmentDepartureMutation, ShipmentDepartureMutationVariables>, 'mutation'>;

    export const ShipmentDepartureComponent = (props: ShipmentDepartureComponentProps) => (
      <ApolloReactComponents.Mutation<ShipmentDepartureMutation, ShipmentDepartureMutationVariables> mutation={ShipmentDepartureDocument} {...props} />
    );
    
export type ShipmentDepartureProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<ShipmentDepartureMutation, ShipmentDepartureMutationVariables>
    } & TChildProps;
export function withShipmentDeparture<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ShipmentDepartureMutation,
  ShipmentDepartureMutationVariables,
  ShipmentDepartureProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, ShipmentDepartureMutation, ShipmentDepartureMutationVariables, ShipmentDepartureProps<TChildProps, TDataName>>(ShipmentDepartureDocument, {
      alias: 'shipmentDeparture',
      ...operationOptions
    });
};

/**
 * __useShipmentDepartureMutation__
 *
 * To run a mutation, you first call `useShipmentDepartureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShipmentDepartureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shipmentDepartureMutation, { data, loading, error }] = useShipmentDepartureMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useShipmentDepartureMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ShipmentDepartureMutation, ShipmentDepartureMutationVariables>) {
        return ApolloReactHooks.useMutation<ShipmentDepartureMutation, ShipmentDepartureMutationVariables>(ShipmentDepartureDocument, baseOptions);
      }
export type ShipmentDepartureMutationHookResult = ReturnType<typeof useShipmentDepartureMutation>;
export type ShipmentDepartureMutationResult = ApolloReactCommon.MutationResult<ShipmentDepartureMutation>;
export type ShipmentDepartureMutationOptions = ApolloReactCommon.BaseMutationOptions<ShipmentDepartureMutation, ShipmentDepartureMutationVariables>;
export const GetProductSourceSettingsPageDocument = gql`
    query GetProductSourceSettingsPage {
  company {
    _id
    feedType
  }
  productSync {
    _id
    isFeedSyncing
  }
  customProductFeed {
    feedUrl
  }
}
    `;
export type GetProductSourceSettingsPageComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetProductSourceSettingsPageQuery, GetProductSourceSettingsPageQueryVariables>, 'query'>;

    export const GetProductSourceSettingsPageComponent = (props: GetProductSourceSettingsPageComponentProps) => (
      <ApolloReactComponents.Query<GetProductSourceSettingsPageQuery, GetProductSourceSettingsPageQueryVariables> query={GetProductSourceSettingsPageDocument} {...props} />
    );
    
export type GetProductSourceSettingsPageProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetProductSourceSettingsPageQuery, GetProductSourceSettingsPageQueryVariables>
    } & TChildProps;
export function withGetProductSourceSettingsPage<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetProductSourceSettingsPageQuery,
  GetProductSourceSettingsPageQueryVariables,
  GetProductSourceSettingsPageProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetProductSourceSettingsPageQuery, GetProductSourceSettingsPageQueryVariables, GetProductSourceSettingsPageProps<TChildProps, TDataName>>(GetProductSourceSettingsPageDocument, {
      alias: 'getProductSourceSettingsPage',
      ...operationOptions
    });
};

/**
 * __useGetProductSourceSettingsPageQuery__
 *
 * To run a query within a React component, call `useGetProductSourceSettingsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductSourceSettingsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductSourceSettingsPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProductSourceSettingsPageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetProductSourceSettingsPageQuery, GetProductSourceSettingsPageQueryVariables>) {
        return ApolloReactHooks.useQuery<GetProductSourceSettingsPageQuery, GetProductSourceSettingsPageQueryVariables>(GetProductSourceSettingsPageDocument, baseOptions);
      }
export function useGetProductSourceSettingsPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProductSourceSettingsPageQuery, GetProductSourceSettingsPageQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetProductSourceSettingsPageQuery, GetProductSourceSettingsPageQueryVariables>(GetProductSourceSettingsPageDocument, baseOptions);
        }
export type GetProductSourceSettingsPageQueryHookResult = ReturnType<typeof useGetProductSourceSettingsPageQuery>;
export type GetProductSourceSettingsPageLazyQueryHookResult = ReturnType<typeof useGetProductSourceSettingsPageLazyQuery>;
export type GetProductSourceSettingsPageQueryResult = ApolloReactCommon.QueryResult<GetProductSourceSettingsPageQuery, GetProductSourceSettingsPageQueryVariables>;
export const DeleteProductFromAppDocument = gql`
    mutation DeleteProductFromApp($sku: String!) {
  deleteProduct(skus: [$sku]) {
    ...SuccessMessageProps
  }
}
    ${SuccessMessagePropsFragmentDoc}`;
export type DeleteProductFromAppMutationFn = ApolloReactCommon.MutationFunction<DeleteProductFromAppMutation, DeleteProductFromAppMutationVariables>;
export type DeleteProductFromAppComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteProductFromAppMutation, DeleteProductFromAppMutationVariables>, 'mutation'>;

    export const DeleteProductFromAppComponent = (props: DeleteProductFromAppComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteProductFromAppMutation, DeleteProductFromAppMutationVariables> mutation={DeleteProductFromAppDocument} {...props} />
    );
    
export type DeleteProductFromAppProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeleteProductFromAppMutation, DeleteProductFromAppMutationVariables>
    } & TChildProps;
export function withDeleteProductFromApp<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteProductFromAppMutation,
  DeleteProductFromAppMutationVariables,
  DeleteProductFromAppProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteProductFromAppMutation, DeleteProductFromAppMutationVariables, DeleteProductFromAppProps<TChildProps, TDataName>>(DeleteProductFromAppDocument, {
      alias: 'deleteProductFromApp',
      ...operationOptions
    });
};

/**
 * __useDeleteProductFromAppMutation__
 *
 * To run a mutation, you first call `useDeleteProductFromAppMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductFromAppMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductFromAppMutation, { data, loading, error }] = useDeleteProductFromAppMutation({
 *   variables: {
 *      sku: // value for 'sku'
 *   },
 * });
 */
export function useDeleteProductFromAppMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteProductFromAppMutation, DeleteProductFromAppMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteProductFromAppMutation, DeleteProductFromAppMutationVariables>(DeleteProductFromAppDocument, baseOptions);
      }
export type DeleteProductFromAppMutationHookResult = ReturnType<typeof useDeleteProductFromAppMutation>;
export type DeleteProductFromAppMutationResult = ApolloReactCommon.MutationResult<DeleteProductFromAppMutation>;
export type DeleteProductFromAppMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteProductFromAppMutation, DeleteProductFromAppMutationVariables>;
export const UpdateProductVariantDocument = gql`
    mutation UpdateProductVariant($product: ProductVariantInput!) {
  updateProductVariant(products: [$product]) {
    id
    sku
    stock
    asins {
      amazon_de
      amazon_uk
      amazon_nl
      amazon_it
      amazon_fr
      amazon_es
      amazon_mx
      amazon_us
      amazon_ca
      amazon_br
      amazon_jp
      amazon_sg
      amazon_au
      amazon_se
      amazon_tr
      amazon_pl
      amazon_be
      amazon_ie
    }
    barcode {
      type
      code
    }
    locks
    productStatus {
      companyId
      marketplace
      sku
      hasAsin
      hasStock
      hasValidBarcode
      isBuyBoxWinner
      listingStatus
      listingErrors {
        code
        message
      }
      status
      forbidListing
    }
    prices {
      amazon_de {
        selling
      }
      amazon_uk {
        selling
      }
      amazon_nl {
        selling
      }
      amazon_it {
        selling
      }
      amazon_fr {
        selling
      }
      amazon_es {
        selling
      }
      amazon_mx {
        selling
      }
      amazon_us {
        selling
      }
      amazon_ca {
        selling
      }
      amazon_br {
        selling
      }
      amazon_jp {
        selling
      }
      amazon_au {
        selling
      }
      amazon_se {
        selling
      }
      amazon_tr {
        selling
      }
      amazon_pl {
        selling
      }
      amazon_be {
        selling
      }
      amazon_ie {
        selling
      }
      amazon_sg {
        selling
      }
      mall_cz {
        selling
      }
      mall_pl {
        selling
      }
      mall_si {
        selling
      }
      mall_hu {
        selling
      }
      mall_sk {
        selling
      }
      alza_cz {
        selling
      }
    }
  }
}
    `;
export type UpdateProductVariantMutationFn = ApolloReactCommon.MutationFunction<UpdateProductVariantMutation, UpdateProductVariantMutationVariables>;
export type UpdateProductVariantComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateProductVariantMutation, UpdateProductVariantMutationVariables>, 'mutation'>;

    export const UpdateProductVariantComponent = (props: UpdateProductVariantComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateProductVariantMutation, UpdateProductVariantMutationVariables> mutation={UpdateProductVariantDocument} {...props} />
    );
    
export type UpdateProductVariantProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateProductVariantMutation, UpdateProductVariantMutationVariables>
    } & TChildProps;
export function withUpdateProductVariant<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateProductVariantMutation,
  UpdateProductVariantMutationVariables,
  UpdateProductVariantProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateProductVariantMutation, UpdateProductVariantMutationVariables, UpdateProductVariantProps<TChildProps, TDataName>>(UpdateProductVariantDocument, {
      alias: 'updateProductVariant',
      ...operationOptions
    });
};

/**
 * __useUpdateProductVariantMutation__
 *
 * To run a mutation, you first call `useUpdateProductVariantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductVariantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductVariantMutation, { data, loading, error }] = useUpdateProductVariantMutation({
 *   variables: {
 *      product: // value for 'product'
 *   },
 * });
 */
export function useUpdateProductVariantMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateProductVariantMutation, UpdateProductVariantMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateProductVariantMutation, UpdateProductVariantMutationVariables>(UpdateProductVariantDocument, baseOptions);
      }
export type UpdateProductVariantMutationHookResult = ReturnType<typeof useUpdateProductVariantMutation>;
export type UpdateProductVariantMutationResult = ApolloReactCommon.MutationResult<UpdateProductVariantMutation>;
export type UpdateProductVariantMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateProductVariantMutation, UpdateProductVariantMutationVariables>;
export const UpdateForbidListingsDocument = gql`
    mutation UpdateForbidListings($productVariants: [ProductVariantInput]) {
  updateForbidListings(productVariants: $productVariants) {
    success
    error
    totalCount
    foundCount
    notFoundSkus
  }
}
    `;
export type UpdateForbidListingsMutationFn = ApolloReactCommon.MutationFunction<UpdateForbidListingsMutation, UpdateForbidListingsMutationVariables>;
export type UpdateForbidListingsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateForbidListingsMutation, UpdateForbidListingsMutationVariables>, 'mutation'>;

    export const UpdateForbidListingsComponent = (props: UpdateForbidListingsComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateForbidListingsMutation, UpdateForbidListingsMutationVariables> mutation={UpdateForbidListingsDocument} {...props} />
    );
    
export type UpdateForbidListingsProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateForbidListingsMutation, UpdateForbidListingsMutationVariables>
    } & TChildProps;
export function withUpdateForbidListings<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateForbidListingsMutation,
  UpdateForbidListingsMutationVariables,
  UpdateForbidListingsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateForbidListingsMutation, UpdateForbidListingsMutationVariables, UpdateForbidListingsProps<TChildProps, TDataName>>(UpdateForbidListingsDocument, {
      alias: 'updateForbidListings',
      ...operationOptions
    });
};

/**
 * __useUpdateForbidListingsMutation__
 *
 * To run a mutation, you first call `useUpdateForbidListingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateForbidListingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateForbidListingsMutation, { data, loading, error }] = useUpdateForbidListingsMutation({
 *   variables: {
 *      productVariants: // value for 'productVariants'
 *   },
 * });
 */
export function useUpdateForbidListingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateForbidListingsMutation, UpdateForbidListingsMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateForbidListingsMutation, UpdateForbidListingsMutationVariables>(UpdateForbidListingsDocument, baseOptions);
      }
export type UpdateForbidListingsMutationHookResult = ReturnType<typeof useUpdateForbidListingsMutation>;
export type UpdateForbidListingsMutationResult = ApolloReactCommon.MutationResult<UpdateForbidListingsMutation>;
export type UpdateForbidListingsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateForbidListingsMutation, UpdateForbidListingsMutationVariables>;
export const GetInitProductLookupDocument = gql`
    query GetInitProductLookup($query: String, $marketplace: String) {
  productLookup(query: $query, marketplace: $marketplace) {
    error
    quotaRemaining
    quotaMax
    quotaResetIn
    products {
      image
      title
      asin
      url
      group
      price
      currency
      color
      size
      categoryId
      rank
    }
  }
}
    `;
export type GetInitProductLookupComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetInitProductLookupQuery, GetInitProductLookupQueryVariables>, 'query'>;

    export const GetInitProductLookupComponent = (props: GetInitProductLookupComponentProps) => (
      <ApolloReactComponents.Query<GetInitProductLookupQuery, GetInitProductLookupQueryVariables> query={GetInitProductLookupDocument} {...props} />
    );
    
export type GetInitProductLookupProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetInitProductLookupQuery, GetInitProductLookupQueryVariables>
    } & TChildProps;
export function withGetInitProductLookup<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetInitProductLookupQuery,
  GetInitProductLookupQueryVariables,
  GetInitProductLookupProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetInitProductLookupQuery, GetInitProductLookupQueryVariables, GetInitProductLookupProps<TChildProps, TDataName>>(GetInitProductLookupDocument, {
      alias: 'getInitProductLookup',
      ...operationOptions
    });
};

/**
 * __useGetInitProductLookupQuery__
 *
 * To run a query within a React component, call `useGetInitProductLookupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInitProductLookupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInitProductLookupQuery({
 *   variables: {
 *      query: // value for 'query'
 *      marketplace: // value for 'marketplace'
 *   },
 * });
 */
export function useGetInitProductLookupQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetInitProductLookupQuery, GetInitProductLookupQueryVariables>) {
        return ApolloReactHooks.useQuery<GetInitProductLookupQuery, GetInitProductLookupQueryVariables>(GetInitProductLookupDocument, baseOptions);
      }
export function useGetInitProductLookupLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetInitProductLookupQuery, GetInitProductLookupQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetInitProductLookupQuery, GetInitProductLookupQueryVariables>(GetInitProductLookupDocument, baseOptions);
        }
export type GetInitProductLookupQueryHookResult = ReturnType<typeof useGetInitProductLookupQuery>;
export type GetInitProductLookupLazyQueryHookResult = ReturnType<typeof useGetInitProductLookupLazyQuery>;
export type GetInitProductLookupQueryResult = ApolloReactCommon.QueryResult<GetInitProductLookupQuery, GetInitProductLookupQueryVariables>;
export const GetProductsWithIdDocument = gql`
    query GetProductsWithId($page: Int, $perPage: Int, $filter: FilterInputProducts, $sort: [ProductsSortInput]) {
  products: products(page: $page, perPage: $perPage, filter: $filter, sort: $sort) {
    count
    items {
      _id
      sku
      barcode {
        type
        code
      }
      image
      name
      prices {
        amazon_br {
          base
          selling
        }
        amazon_jp {
          base
          selling
        }
        amazon_au {
          base
          selling
        }
        amazon_sg {
          base
          selling
        }
        amazon_de {
          base
          selling
        }
        amazon_uk {
          base
          selling
        }
        amazon_nl {
          base
          selling
        }
        amazon_it {
          base
          selling
        }
        amazon_fr {
          base
          selling
        }
        amazon_es {
          base
          selling
        }
        amazon_mx {
          base
          selling
        }
        amazon_us {
          base
          selling
        }
        amazon_ca {
          base
          selling
        }
        amazon_se {
          base
          selling
        }
        amazon_tr {
          base
          selling
        }
        amazon_pl {
          base
          selling
        }
        amazon_be {
          base
          selling
        }
        amazon_ie {
          base
          selling
        }
        mall_cz {
          base
          selling
        }
        mall_pl {
          base
          selling
        }
        mall_si {
          base
          selling
        }
        mall_hu {
          base
          selling
        }
        mall_sk {
          base
          selling
        }
        alza_cz {
          base
          selling
        }
        cdiscount_fr {
          base
          selling
        }
        kaufland_de {
          base
          selling
        }
        kaufland_cz {
          base
          selling
        }
        kaufland_sk {
          base
          selling
        }
        kaufland_at {
          base
          selling
        }
        kaufland_pl {
          base
          selling
        }
        kaufland_nl {
          base
          selling
        }
        kaufland_es {
          base
          selling
        }
        kaufland_fr {
          base
          selling
        }
        kaufland_it {
          base
          selling
        }
      }
      asins {
        amazon_mx
        amazon_us
        amazon_ca
        amazon_br
        amazon_de
        amazon_uk
        amazon_fr
        amazon_it
        amazon_es
        amazon_nl
        amazon_se
        amazon_tr
        amazon_pl
        amazon_be
        amazon_ie
        amazon_sg
        amazon_au
        amazon_jp
      }
      stock
      marketplaceSkus {
        emag
      }
      productStatus {
        companyId
        marketplace
        sku
        hasAsin
        hasStock
        hasValidBarcode
        isBuyBoxWinner
        listingStatus
        listingErrors {
          code
          message
        }
        status
        forbidListing
      }
      locks
      ecoFee
      vatRate
      itemCondition
    }
    pageInfo {
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
      perPage
      currentPage
    }
  }
}
    `;
export type GetProductsWithIdComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetProductsWithIdQuery, GetProductsWithIdQueryVariables>, 'query'>;

    export const GetProductsWithIdComponent = (props: GetProductsWithIdComponentProps) => (
      <ApolloReactComponents.Query<GetProductsWithIdQuery, GetProductsWithIdQueryVariables> query={GetProductsWithIdDocument} {...props} />
    );
    
export type GetProductsWithIdProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetProductsWithIdQuery, GetProductsWithIdQueryVariables>
    } & TChildProps;
export function withGetProductsWithId<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetProductsWithIdQuery,
  GetProductsWithIdQueryVariables,
  GetProductsWithIdProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetProductsWithIdQuery, GetProductsWithIdQueryVariables, GetProductsWithIdProps<TChildProps, TDataName>>(GetProductsWithIdDocument, {
      alias: 'getProductsWithId',
      ...operationOptions
    });
};

/**
 * __useGetProductsWithIdQuery__
 *
 * To run a query within a React component, call `useGetProductsWithIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsWithIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsWithIdQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetProductsWithIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetProductsWithIdQuery, GetProductsWithIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetProductsWithIdQuery, GetProductsWithIdQueryVariables>(GetProductsWithIdDocument, baseOptions);
      }
export function useGetProductsWithIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProductsWithIdQuery, GetProductsWithIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetProductsWithIdQuery, GetProductsWithIdQueryVariables>(GetProductsWithIdDocument, baseOptions);
        }
export type GetProductsWithIdQueryHookResult = ReturnType<typeof useGetProductsWithIdQuery>;
export type GetProductsWithIdLazyQueryHookResult = ReturnType<typeof useGetProductsWithIdLazyQuery>;
export type GetProductsWithIdQueryResult = ApolloReactCommon.QueryResult<GetProductsWithIdQuery, GetProductsWithIdQueryVariables>;
export const RemoveAllProductsDocument = gql`
    mutation RemoveAllProducts {
  deleteProduct {
    ...SuccessMessageProps
  }
}
    ${SuccessMessagePropsFragmentDoc}`;
export type RemoveAllProductsMutationFn = ApolloReactCommon.MutationFunction<RemoveAllProductsMutation, RemoveAllProductsMutationVariables>;
export type RemoveAllProductsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<RemoveAllProductsMutation, RemoveAllProductsMutationVariables>, 'mutation'>;

    export const RemoveAllProductsComponent = (props: RemoveAllProductsComponentProps) => (
      <ApolloReactComponents.Mutation<RemoveAllProductsMutation, RemoveAllProductsMutationVariables> mutation={RemoveAllProductsDocument} {...props} />
    );
    
export type RemoveAllProductsProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<RemoveAllProductsMutation, RemoveAllProductsMutationVariables>
    } & TChildProps;
export function withRemoveAllProducts<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RemoveAllProductsMutation,
  RemoveAllProductsMutationVariables,
  RemoveAllProductsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RemoveAllProductsMutation, RemoveAllProductsMutationVariables, RemoveAllProductsProps<TChildProps, TDataName>>(RemoveAllProductsDocument, {
      alias: 'removeAllProducts',
      ...operationOptions
    });
};

/**
 * __useRemoveAllProductsMutation__
 *
 * To run a mutation, you first call `useRemoveAllProductsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAllProductsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAllProductsMutation, { data, loading, error }] = useRemoveAllProductsMutation({
 *   variables: {
 *   },
 * });
 */
export function useRemoveAllProductsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveAllProductsMutation, RemoveAllProductsMutationVariables>) {
        return ApolloReactHooks.useMutation<RemoveAllProductsMutation, RemoveAllProductsMutationVariables>(RemoveAllProductsDocument, baseOptions);
      }
export type RemoveAllProductsMutationHookResult = ReturnType<typeof useRemoveAllProductsMutation>;
export type RemoveAllProductsMutationResult = ApolloReactCommon.MutationResult<RemoveAllProductsMutation>;
export type RemoveAllProductsMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveAllProductsMutation, RemoveAllProductsMutationVariables>;
export const GetSettingsDocument = gql`
    query GetSettings {
  company {
    _id
    feedType
  }
  marketplaces {
    id
    marketplace
    region
    hidden
  }
  syncSettings {
    ...SyncSettingsFields
  }
  shoptetOrderStatuses {
    code
    name
  }
  mallDeliveryMethods {
    marketplace
    code
    title
  }
  glamiDeliveryMethods {
    code
    title
  }
  importSettings {
    _id
    marketplaceType
    service
    defaultOrderStatus
    lowerStockOnOrder
    importOrderJustOnce
    synchronizeOrders
    synchronizeFbaOrders
    shipmentMethod
    carrier
    carrierName
    deliveryMethodsMapping {
      marketplace
      method
      serviceMethod
    }
    autoconfirmOrderOnStatus
    orderShippingOnStatus
    orderDeliveredOnStatus
    paymentMethodsMapping {
      method
      serviceMethod
    }
    importShoptetCancelOrderStatus
    shoptetCancelOrderStatus
  }
  platformStatuses {
    amazon {
      active
      connected
    }
    mall {
      active
      connected
    }
    alza {
      active
      connected
    }
    glami {
      active
      connected
    }
    cdiscount {
      active
      connected
    }
    real {
      active
      connected
    }
    kaufland {
      active
      connected
    }
    bol {
      active
      connected
    }
    allegro {
      active
      connected
    }
  }
  shoptetPaymentMethods {
    guid
    name
  }
  stornoStatusEnabledFeatureToggle: featureToggle(name: storno_status_enabled) {
    enabled
  }
  automatchFeatureToggle: featureToggle(name: show_automatch_toggle) {
    enabled
  }
  kauflandNew: featureToggle(name: new_kaufland) {
    enabled
  }
  partnerMarketplaces: featureToggle(name: partner_marketplaces) {
    enabled
  }
}
    ${SyncSettingsFieldsFragmentDoc}`;
export type GetSettingsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetSettingsQuery, GetSettingsQueryVariables>, 'query'>;

    export const GetSettingsComponent = (props: GetSettingsComponentProps) => (
      <ApolloReactComponents.Query<GetSettingsQuery, GetSettingsQueryVariables> query={GetSettingsDocument} {...props} />
    );
    
export type GetSettingsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetSettingsQuery, GetSettingsQueryVariables>
    } & TChildProps;
export function withGetSettings<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetSettingsQuery,
  GetSettingsQueryVariables,
  GetSettingsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetSettingsQuery, GetSettingsQueryVariables, GetSettingsProps<TChildProps, TDataName>>(GetSettingsDocument, {
      alias: 'getSettings',
      ...operationOptions
    });
};

/**
 * __useGetSettingsQuery__
 *
 * To run a query within a React component, call `useGetSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSettingsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetSettingsQuery, GetSettingsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetSettingsQuery, GetSettingsQueryVariables>(GetSettingsDocument, baseOptions);
      }
export function useGetSettingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSettingsQuery, GetSettingsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetSettingsQuery, GetSettingsQueryVariables>(GetSettingsDocument, baseOptions);
        }
export type GetSettingsQueryHookResult = ReturnType<typeof useGetSettingsQuery>;
export type GetSettingsLazyQueryHookResult = ReturnType<typeof useGetSettingsLazyQuery>;
export type GetSettingsQueryResult = ApolloReactCommon.QueryResult<GetSettingsQuery, GetSettingsQueryVariables>;
export const GetEmailNotificationSettingsDocument = gql`
    query GetEmailNotificationSettings($platform: String) {
  emailNotificationSettings(platform: $platform) {
    platform
    active
  }
}
    `;
export type GetEmailNotificationSettingsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetEmailNotificationSettingsQuery, GetEmailNotificationSettingsQueryVariables>, 'query'>;

    export const GetEmailNotificationSettingsComponent = (props: GetEmailNotificationSettingsComponentProps) => (
      <ApolloReactComponents.Query<GetEmailNotificationSettingsQuery, GetEmailNotificationSettingsQueryVariables> query={GetEmailNotificationSettingsDocument} {...props} />
    );
    
export type GetEmailNotificationSettingsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetEmailNotificationSettingsQuery, GetEmailNotificationSettingsQueryVariables>
    } & TChildProps;
export function withGetEmailNotificationSettings<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetEmailNotificationSettingsQuery,
  GetEmailNotificationSettingsQueryVariables,
  GetEmailNotificationSettingsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetEmailNotificationSettingsQuery, GetEmailNotificationSettingsQueryVariables, GetEmailNotificationSettingsProps<TChildProps, TDataName>>(GetEmailNotificationSettingsDocument, {
      alias: 'getEmailNotificationSettings',
      ...operationOptions
    });
};

/**
 * __useGetEmailNotificationSettingsQuery__
 *
 * To run a query within a React component, call `useGetEmailNotificationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailNotificationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailNotificationSettingsQuery({
 *   variables: {
 *      platform: // value for 'platform'
 *   },
 * });
 */
export function useGetEmailNotificationSettingsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEmailNotificationSettingsQuery, GetEmailNotificationSettingsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetEmailNotificationSettingsQuery, GetEmailNotificationSettingsQueryVariables>(GetEmailNotificationSettingsDocument, baseOptions);
      }
export function useGetEmailNotificationSettingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEmailNotificationSettingsQuery, GetEmailNotificationSettingsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetEmailNotificationSettingsQuery, GetEmailNotificationSettingsQueryVariables>(GetEmailNotificationSettingsDocument, baseOptions);
        }
export type GetEmailNotificationSettingsQueryHookResult = ReturnType<typeof useGetEmailNotificationSettingsQuery>;
export type GetEmailNotificationSettingsLazyQueryHookResult = ReturnType<typeof useGetEmailNotificationSettingsLazyQuery>;
export type GetEmailNotificationSettingsQueryResult = ApolloReactCommon.QueryResult<GetEmailNotificationSettingsQuery, GetEmailNotificationSettingsQueryVariables>;
export const SaveEmailNotificationSettingsDocument = gql`
    mutation SaveEmailNotificationSettings($platform: Platform!, $active: Boolean!) {
  saveEmailNotificationSettings(platform: $platform, active: $active) {
    ...SuccessMessageProps
  }
}
    ${SuccessMessagePropsFragmentDoc}`;
export type SaveEmailNotificationSettingsMutationFn = ApolloReactCommon.MutationFunction<SaveEmailNotificationSettingsMutation, SaveEmailNotificationSettingsMutationVariables>;
export type SaveEmailNotificationSettingsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<SaveEmailNotificationSettingsMutation, SaveEmailNotificationSettingsMutationVariables>, 'mutation'>;

    export const SaveEmailNotificationSettingsComponent = (props: SaveEmailNotificationSettingsComponentProps) => (
      <ApolloReactComponents.Mutation<SaveEmailNotificationSettingsMutation, SaveEmailNotificationSettingsMutationVariables> mutation={SaveEmailNotificationSettingsDocument} {...props} />
    );
    
export type SaveEmailNotificationSettingsProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<SaveEmailNotificationSettingsMutation, SaveEmailNotificationSettingsMutationVariables>
    } & TChildProps;
export function withSaveEmailNotificationSettings<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SaveEmailNotificationSettingsMutation,
  SaveEmailNotificationSettingsMutationVariables,
  SaveEmailNotificationSettingsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, SaveEmailNotificationSettingsMutation, SaveEmailNotificationSettingsMutationVariables, SaveEmailNotificationSettingsProps<TChildProps, TDataName>>(SaveEmailNotificationSettingsDocument, {
      alias: 'saveEmailNotificationSettings',
      ...operationOptions
    });
};

/**
 * __useSaveEmailNotificationSettingsMutation__
 *
 * To run a mutation, you first call `useSaveEmailNotificationSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveEmailNotificationSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveEmailNotificationSettingsMutation, { data, loading, error }] = useSaveEmailNotificationSettingsMutation({
 *   variables: {
 *      platform: // value for 'platform'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useSaveEmailNotificationSettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveEmailNotificationSettingsMutation, SaveEmailNotificationSettingsMutationVariables>) {
        return ApolloReactHooks.useMutation<SaveEmailNotificationSettingsMutation, SaveEmailNotificationSettingsMutationVariables>(SaveEmailNotificationSettingsDocument, baseOptions);
      }
export type SaveEmailNotificationSettingsMutationHookResult = ReturnType<typeof useSaveEmailNotificationSettingsMutation>;
export type SaveEmailNotificationSettingsMutationResult = ApolloReactCommon.MutationResult<SaveEmailNotificationSettingsMutation>;
export type SaveEmailNotificationSettingsMutationOptions = ApolloReactCommon.BaseMutationOptions<SaveEmailNotificationSettingsMutation, SaveEmailNotificationSettingsMutationVariables>;
export const UpdateSettingsDocument = gql`
    mutation UpdateSettings($settings: SyncSettingsInput) {
  setSyncSettings(settings: $settings) {
    ...SyncSettingsFields
  }
}
    ${SyncSettingsFieldsFragmentDoc}`;
export type UpdateSettingsMutationFn = ApolloReactCommon.MutationFunction<UpdateSettingsMutation, UpdateSettingsMutationVariables>;
export type UpdateSettingsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateSettingsMutation, UpdateSettingsMutationVariables>, 'mutation'>;

    export const UpdateSettingsComponent = (props: UpdateSettingsComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateSettingsMutation, UpdateSettingsMutationVariables> mutation={UpdateSettingsDocument} {...props} />
    );
    
export type UpdateSettingsProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateSettingsMutation, UpdateSettingsMutationVariables>
    } & TChildProps;
export function withUpdateSettings<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateSettingsMutation,
  UpdateSettingsMutationVariables,
  UpdateSettingsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateSettingsMutation, UpdateSettingsMutationVariables, UpdateSettingsProps<TChildProps, TDataName>>(UpdateSettingsDocument, {
      alias: 'updateSettings',
      ...operationOptions
    });
};

/**
 * __useUpdateSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSettingsMutation, { data, loading, error }] = useUpdateSettingsMutation({
 *   variables: {
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useUpdateSettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateSettingsMutation, UpdateSettingsMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateSettingsMutation, UpdateSettingsMutationVariables>(UpdateSettingsDocument, baseOptions);
      }
export type UpdateSettingsMutationHookResult = ReturnType<typeof useUpdateSettingsMutation>;
export type UpdateSettingsMutationResult = ApolloReactCommon.MutationResult<UpdateSettingsMutation>;
export type UpdateSettingsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateSettingsMutation, UpdateSettingsMutationVariables>;
export const UpdateImportSettingsDocument = gql`
    mutation UpdateImportSettings($settings: ImportSettingsInput) {
  setImportSettings(importSettings: $settings) {
    _id
    marketplaceType
    service
    defaultOrderStatus
    lowerStockOnOrder
    importOrderJustOnce
    synchronizeOrders
    synchronizeFbaOrders
    shipmentMethod
    carrier
    carrierName
    deliveryMethodsMapping {
      marketplace
      method
      serviceMethod
    }
    autoconfirmOrderOnStatus
    orderShippingOnStatus
    orderDeliveredOnStatus
    importShoptetCancelOrderStatus
    shoptetCancelOrderStatus
  }
}
    `;
export type UpdateImportSettingsMutationFn = ApolloReactCommon.MutationFunction<UpdateImportSettingsMutation, UpdateImportSettingsMutationVariables>;
export type UpdateImportSettingsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateImportSettingsMutation, UpdateImportSettingsMutationVariables>, 'mutation'>;

    export const UpdateImportSettingsComponent = (props: UpdateImportSettingsComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateImportSettingsMutation, UpdateImportSettingsMutationVariables> mutation={UpdateImportSettingsDocument} {...props} />
    );
    
export type UpdateImportSettingsProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateImportSettingsMutation, UpdateImportSettingsMutationVariables>
    } & TChildProps;
export function withUpdateImportSettings<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateImportSettingsMutation,
  UpdateImportSettingsMutationVariables,
  UpdateImportSettingsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateImportSettingsMutation, UpdateImportSettingsMutationVariables, UpdateImportSettingsProps<TChildProps, TDataName>>(UpdateImportSettingsDocument, {
      alias: 'updateImportSettings',
      ...operationOptions
    });
};

/**
 * __useUpdateImportSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateImportSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateImportSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateImportSettingsMutation, { data, loading, error }] = useUpdateImportSettingsMutation({
 *   variables: {
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useUpdateImportSettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateImportSettingsMutation, UpdateImportSettingsMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateImportSettingsMutation, UpdateImportSettingsMutationVariables>(UpdateImportSettingsDocument, baseOptions);
      }
export type UpdateImportSettingsMutationHookResult = ReturnType<typeof useUpdateImportSettingsMutation>;
export type UpdateImportSettingsMutationResult = ApolloReactCommon.MutationResult<UpdateImportSettingsMutation>;
export type UpdateImportSettingsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateImportSettingsMutation, UpdateImportSettingsMutationVariables>;
export const GetShipmentMethodsDocument = gql`
    query GetShipmentMethods {
  shoptetShipmentMethods {
    guid
    name
  }
}
    `;
export type GetShipmentMethodsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetShipmentMethodsQuery, GetShipmentMethodsQueryVariables>, 'query'>;

    export const GetShipmentMethodsComponent = (props: GetShipmentMethodsComponentProps) => (
      <ApolloReactComponents.Query<GetShipmentMethodsQuery, GetShipmentMethodsQueryVariables> query={GetShipmentMethodsDocument} {...props} />
    );
    
export type GetShipmentMethodsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetShipmentMethodsQuery, GetShipmentMethodsQueryVariables>
    } & TChildProps;
export function withGetShipmentMethods<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetShipmentMethodsQuery,
  GetShipmentMethodsQueryVariables,
  GetShipmentMethodsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetShipmentMethodsQuery, GetShipmentMethodsQueryVariables, GetShipmentMethodsProps<TChildProps, TDataName>>(GetShipmentMethodsDocument, {
      alias: 'getShipmentMethods',
      ...operationOptions
    });
};

/**
 * __useGetShipmentMethodsQuery__
 *
 * To run a query within a React component, call `useGetShipmentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShipmentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShipmentMethodsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetShipmentMethodsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetShipmentMethodsQuery, GetShipmentMethodsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetShipmentMethodsQuery, GetShipmentMethodsQueryVariables>(GetShipmentMethodsDocument, baseOptions);
      }
export function useGetShipmentMethodsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetShipmentMethodsQuery, GetShipmentMethodsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetShipmentMethodsQuery, GetShipmentMethodsQueryVariables>(GetShipmentMethodsDocument, baseOptions);
        }
export type GetShipmentMethodsQueryHookResult = ReturnType<typeof useGetShipmentMethodsQuery>;
export type GetShipmentMethodsLazyQueryHookResult = ReturnType<typeof useGetShipmentMethodsLazyQuery>;
export type GetShipmentMethodsQueryResult = ApolloReactCommon.QueryResult<GetShipmentMethodsQuery, GetShipmentMethodsQueryVariables>;
export const GetCompanyDocument = gql`
    query GetCompany {
  company {
    _id
    feedType
  }
}
    `;
export type GetCompanyComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetCompanyQuery, GetCompanyQueryVariables>, 'query'>;

    export const GetCompanyComponent = (props: GetCompanyComponentProps) => (
      <ApolloReactComponents.Query<GetCompanyQuery, GetCompanyQueryVariables> query={GetCompanyDocument} {...props} />
    );
    
export type GetCompanyProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetCompanyQuery, GetCompanyQueryVariables>
    } & TChildProps;
export function withGetCompany<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetCompanyQuery,
  GetCompanyQueryVariables,
  GetCompanyProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetCompanyQuery, GetCompanyQueryVariables, GetCompanyProps<TChildProps, TDataName>>(GetCompanyDocument, {
      alias: 'getCompany',
      ...operationOptions
    });
};

/**
 * __useGetCompanyQuery__
 *
 * To run a query within a React component, call `useGetCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCompanyQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCompanyQuery, GetCompanyQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCompanyQuery, GetCompanyQueryVariables>(GetCompanyDocument, baseOptions);
      }
export function useGetCompanyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCompanyQuery, GetCompanyQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCompanyQuery, GetCompanyQueryVariables>(GetCompanyDocument, baseOptions);
        }
export type GetCompanyQueryHookResult = ReturnType<typeof useGetCompanyQuery>;
export type GetCompanyLazyQueryHookResult = ReturnType<typeof useGetCompanyLazyQuery>;
export type GetCompanyQueryResult = ApolloReactCommon.QueryResult<GetCompanyQuery, GetCompanyQueryVariables>;
export const GetCompanySettingsDocument = gql`
    query GetCompanySettings($companyId: String) {
  getGoogleDataStudioUrl(companyId: $companyId) {
    _id
    googleDataStudioUrl
  }
  getInternalCompanyName(companyId: $companyId) {
    _id
    internalName
  }
  getReturnAddress(companyId: $companyId) {
    _id
    returnAddress {
      companyName
      name
      countryCode
      city
      zipCode
      street
      phone
      email
    }
  }
}
    `;
export type GetCompanySettingsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetCompanySettingsQuery, GetCompanySettingsQueryVariables>, 'query'>;

    export const GetCompanySettingsComponent = (props: GetCompanySettingsComponentProps) => (
      <ApolloReactComponents.Query<GetCompanySettingsQuery, GetCompanySettingsQueryVariables> query={GetCompanySettingsDocument} {...props} />
    );
    
export type GetCompanySettingsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetCompanySettingsQuery, GetCompanySettingsQueryVariables>
    } & TChildProps;
export function withGetCompanySettings<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetCompanySettingsQuery,
  GetCompanySettingsQueryVariables,
  GetCompanySettingsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetCompanySettingsQuery, GetCompanySettingsQueryVariables, GetCompanySettingsProps<TChildProps, TDataName>>(GetCompanySettingsDocument, {
      alias: 'getCompanySettings',
      ...operationOptions
    });
};

/**
 * __useGetCompanySettingsQuery__
 *
 * To run a query within a React component, call `useGetCompanySettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanySettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanySettingsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetCompanySettingsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCompanySettingsQuery, GetCompanySettingsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCompanySettingsQuery, GetCompanySettingsQueryVariables>(GetCompanySettingsDocument, baseOptions);
      }
export function useGetCompanySettingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCompanySettingsQuery, GetCompanySettingsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCompanySettingsQuery, GetCompanySettingsQueryVariables>(GetCompanySettingsDocument, baseOptions);
        }
export type GetCompanySettingsQueryHookResult = ReturnType<typeof useGetCompanySettingsQuery>;
export type GetCompanySettingsLazyQueryHookResult = ReturnType<typeof useGetCompanySettingsLazyQuery>;
export type GetCompanySettingsQueryResult = ApolloReactCommon.QueryResult<GetCompanySettingsQuery, GetCompanySettingsQueryVariables>;
export const UpdateGdsUrlDocument = gql`
    mutation UpdateGdsUrl($companyId: String, $googleDataStudioUrl: String) {
  updateGoogleDataStudioUrl(
    companyId: $companyId
    googleDataStudioUrl: $googleDataStudioUrl
  ) {
    _id
    googleDataStudioUrl
  }
}
    `;
export type UpdateGdsUrlMutationFn = ApolloReactCommon.MutationFunction<UpdateGdsUrlMutation, UpdateGdsUrlMutationVariables>;
export type UpdateGdsUrlComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateGdsUrlMutation, UpdateGdsUrlMutationVariables>, 'mutation'>;

    export const UpdateGdsUrlComponent = (props: UpdateGdsUrlComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateGdsUrlMutation, UpdateGdsUrlMutationVariables> mutation={UpdateGdsUrlDocument} {...props} />
    );
    
export type UpdateGdsUrlProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateGdsUrlMutation, UpdateGdsUrlMutationVariables>
    } & TChildProps;
export function withUpdateGdsUrl<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateGdsUrlMutation,
  UpdateGdsUrlMutationVariables,
  UpdateGdsUrlProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateGdsUrlMutation, UpdateGdsUrlMutationVariables, UpdateGdsUrlProps<TChildProps, TDataName>>(UpdateGdsUrlDocument, {
      alias: 'updateGdsUrl',
      ...operationOptions
    });
};

/**
 * __useUpdateGdsUrlMutation__
 *
 * To run a mutation, you first call `useUpdateGdsUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGdsUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGdsUrlMutation, { data, loading, error }] = useUpdateGdsUrlMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      googleDataStudioUrl: // value for 'googleDataStudioUrl'
 *   },
 * });
 */
export function useUpdateGdsUrlMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateGdsUrlMutation, UpdateGdsUrlMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateGdsUrlMutation, UpdateGdsUrlMutationVariables>(UpdateGdsUrlDocument, baseOptions);
      }
export type UpdateGdsUrlMutationHookResult = ReturnType<typeof useUpdateGdsUrlMutation>;
export type UpdateGdsUrlMutationResult = ApolloReactCommon.MutationResult<UpdateGdsUrlMutation>;
export type UpdateGdsUrlMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateGdsUrlMutation, UpdateGdsUrlMutationVariables>;
export const UpdateInternalCompanyNameDocument = gql`
    mutation UpdateInternalCompanyName($companyId: String, $internalName: String) {
  updateInternalCompanyName(companyId: $companyId, internalName: $internalName) {
    _id
    internalName
  }
}
    `;
export type UpdateInternalCompanyNameMutationFn = ApolloReactCommon.MutationFunction<UpdateInternalCompanyNameMutation, UpdateInternalCompanyNameMutationVariables>;
export type UpdateInternalCompanyNameComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateInternalCompanyNameMutation, UpdateInternalCompanyNameMutationVariables>, 'mutation'>;

    export const UpdateInternalCompanyNameComponent = (props: UpdateInternalCompanyNameComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateInternalCompanyNameMutation, UpdateInternalCompanyNameMutationVariables> mutation={UpdateInternalCompanyNameDocument} {...props} />
    );
    
export type UpdateInternalCompanyNameProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateInternalCompanyNameMutation, UpdateInternalCompanyNameMutationVariables>
    } & TChildProps;
export function withUpdateInternalCompanyName<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateInternalCompanyNameMutation,
  UpdateInternalCompanyNameMutationVariables,
  UpdateInternalCompanyNameProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateInternalCompanyNameMutation, UpdateInternalCompanyNameMutationVariables, UpdateInternalCompanyNameProps<TChildProps, TDataName>>(UpdateInternalCompanyNameDocument, {
      alias: 'updateInternalCompanyName',
      ...operationOptions
    });
};

/**
 * __useUpdateInternalCompanyNameMutation__
 *
 * To run a mutation, you first call `useUpdateInternalCompanyNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInternalCompanyNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInternalCompanyNameMutation, { data, loading, error }] = useUpdateInternalCompanyNameMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      internalName: // value for 'internalName'
 *   },
 * });
 */
export function useUpdateInternalCompanyNameMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateInternalCompanyNameMutation, UpdateInternalCompanyNameMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateInternalCompanyNameMutation, UpdateInternalCompanyNameMutationVariables>(UpdateInternalCompanyNameDocument, baseOptions);
      }
export type UpdateInternalCompanyNameMutationHookResult = ReturnType<typeof useUpdateInternalCompanyNameMutation>;
export type UpdateInternalCompanyNameMutationResult = ApolloReactCommon.MutationResult<UpdateInternalCompanyNameMutation>;
export type UpdateInternalCompanyNameMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateInternalCompanyNameMutation, UpdateInternalCompanyNameMutationVariables>;
export const UpdateReturnAddressDocDocument = gql`
    mutation UpdateReturnAddressDoc($companyId: String, $companyName: String, $name: String!, $countryCode: String!, $email: String, $street: String!, $phone: String, $zipCode: String!, $city: String!) {
  updateReturnAddressDoc(
    companyId: $companyId
    companyName: $companyName
    name: $name
    countryCode: $countryCode
    email: $email
    street: $street
    phone: $phone
    zipCode: $zipCode
    city: $city
  ) {
    _id
    returnAddress {
      companyName
      name
      countryCode
      email
      street
      phone
      zipCode
      city
    }
  }
}
    `;
export type UpdateReturnAddressDocMutationFn = ApolloReactCommon.MutationFunction<UpdateReturnAddressDocMutation, UpdateReturnAddressDocMutationVariables>;
export type UpdateReturnAddressDocComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateReturnAddressDocMutation, UpdateReturnAddressDocMutationVariables>, 'mutation'>;

    export const UpdateReturnAddressDocComponent = (props: UpdateReturnAddressDocComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateReturnAddressDocMutation, UpdateReturnAddressDocMutationVariables> mutation={UpdateReturnAddressDocDocument} {...props} />
    );
    
export type UpdateReturnAddressDocProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateReturnAddressDocMutation, UpdateReturnAddressDocMutationVariables>
    } & TChildProps;
export function withUpdateReturnAddressDoc<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateReturnAddressDocMutation,
  UpdateReturnAddressDocMutationVariables,
  UpdateReturnAddressDocProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateReturnAddressDocMutation, UpdateReturnAddressDocMutationVariables, UpdateReturnAddressDocProps<TChildProps, TDataName>>(UpdateReturnAddressDocDocument, {
      alias: 'updateReturnAddressDoc',
      ...operationOptions
    });
};

/**
 * __useUpdateReturnAddressDocMutation__
 *
 * To run a mutation, you first call `useUpdateReturnAddressDocMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReturnAddressDocMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReturnAddressDocMutation, { data, loading, error }] = useUpdateReturnAddressDocMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      companyName: // value for 'companyName'
 *      name: // value for 'name'
 *      countryCode: // value for 'countryCode'
 *      email: // value for 'email'
 *      street: // value for 'street'
 *      phone: // value for 'phone'
 *      zipCode: // value for 'zipCode'
 *      city: // value for 'city'
 *   },
 * });
 */
export function useUpdateReturnAddressDocMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateReturnAddressDocMutation, UpdateReturnAddressDocMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateReturnAddressDocMutation, UpdateReturnAddressDocMutationVariables>(UpdateReturnAddressDocDocument, baseOptions);
      }
export type UpdateReturnAddressDocMutationHookResult = ReturnType<typeof useUpdateReturnAddressDocMutation>;
export type UpdateReturnAddressDocMutationResult = ApolloReactCommon.MutationResult<UpdateReturnAddressDocMutation>;
export type UpdateReturnAddressDocMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateReturnAddressDocMutation, UpdateReturnAddressDocMutationVariables>;
export const UpdateSubscriptionDocument = gql`
    mutation UpdateSubscription($subscriptionSettingsInput: SubscriptionSchemaInput) {
  setSubscription(settings: $subscriptionSettingsInput) {
    _id
    companyId
    isActive
    amount
    from
    currency
  }
}
    `;
export type UpdateSubscriptionMutationFn = ApolloReactCommon.MutationFunction<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>;
export type UpdateSubscriptionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>, 'mutation'>;

    export const UpdateSubscriptionComponent = (props: UpdateSubscriptionComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables> mutation={UpdateSubscriptionDocument} {...props} />
    );
    
export type UpdateSubscriptionProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>
    } & TChildProps;
export function withUpdateSubscription<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateSubscriptionMutation,
  UpdateSubscriptionMutationVariables,
  UpdateSubscriptionProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables, UpdateSubscriptionProps<TChildProps, TDataName>>(UpdateSubscriptionDocument, {
      alias: 'updateSubscription',
      ...operationOptions
    });
};

/**
 * __useUpdateSubscriptionMutation__
 *
 * To run a mutation, you first call `useUpdateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubscriptionMutation, { data, loading, error }] = useUpdateSubscriptionMutation({
 *   variables: {
 *      subscriptionSettingsInput: // value for 'subscriptionSettingsInput'
 *   },
 * });
 */
export function useUpdateSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>(UpdateSubscriptionDocument, baseOptions);
      }
export type UpdateSubscriptionMutationHookResult = ReturnType<typeof useUpdateSubscriptionMutation>;
export type UpdateSubscriptionMutationResult = ApolloReactCommon.MutationResult<UpdateSubscriptionMutation>;
export type UpdateSubscriptionMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>;
export const DiscardTrialDeadlineDocument = gql`
    mutation DiscardTrialDeadline($email: String!, $companyId: String!) {
  discardTrialDeadline(email: $email, companyId: $companyId) {
    success
  }
}
    `;
export type DiscardTrialDeadlineMutationFn = ApolloReactCommon.MutationFunction<DiscardTrialDeadlineMutation, DiscardTrialDeadlineMutationVariables>;
export type DiscardTrialDeadlineComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DiscardTrialDeadlineMutation, DiscardTrialDeadlineMutationVariables>, 'mutation'>;

    export const DiscardTrialDeadlineComponent = (props: DiscardTrialDeadlineComponentProps) => (
      <ApolloReactComponents.Mutation<DiscardTrialDeadlineMutation, DiscardTrialDeadlineMutationVariables> mutation={DiscardTrialDeadlineDocument} {...props} />
    );
    
export type DiscardTrialDeadlineProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DiscardTrialDeadlineMutation, DiscardTrialDeadlineMutationVariables>
    } & TChildProps;
export function withDiscardTrialDeadline<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DiscardTrialDeadlineMutation,
  DiscardTrialDeadlineMutationVariables,
  DiscardTrialDeadlineProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DiscardTrialDeadlineMutation, DiscardTrialDeadlineMutationVariables, DiscardTrialDeadlineProps<TChildProps, TDataName>>(DiscardTrialDeadlineDocument, {
      alias: 'discardTrialDeadline',
      ...operationOptions
    });
};

/**
 * __useDiscardTrialDeadlineMutation__
 *
 * To run a mutation, you first call `useDiscardTrialDeadlineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDiscardTrialDeadlineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [discardTrialDeadlineMutation, { data, loading, error }] = useDiscardTrialDeadlineMutation({
 *   variables: {
 *      email: // value for 'email'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useDiscardTrialDeadlineMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DiscardTrialDeadlineMutation, DiscardTrialDeadlineMutationVariables>) {
        return ApolloReactHooks.useMutation<DiscardTrialDeadlineMutation, DiscardTrialDeadlineMutationVariables>(DiscardTrialDeadlineDocument, baseOptions);
      }
export type DiscardTrialDeadlineMutationHookResult = ReturnType<typeof useDiscardTrialDeadlineMutation>;
export type DiscardTrialDeadlineMutationResult = ApolloReactCommon.MutationResult<DiscardTrialDeadlineMutation>;
export type DiscardTrialDeadlineMutationOptions = ApolloReactCommon.BaseMutationOptions<DiscardTrialDeadlineMutation, DiscardTrialDeadlineMutationVariables>;
export const ThanosCompanyDocument = gql`
    mutation ThanosCompany($companyId: String) {
  thanos(companyId: $companyId)
}
    `;
export type ThanosCompanyMutationFn = ApolloReactCommon.MutationFunction<ThanosCompanyMutation, ThanosCompanyMutationVariables>;
export type ThanosCompanyComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ThanosCompanyMutation, ThanosCompanyMutationVariables>, 'mutation'>;

    export const ThanosCompanyComponent = (props: ThanosCompanyComponentProps) => (
      <ApolloReactComponents.Mutation<ThanosCompanyMutation, ThanosCompanyMutationVariables> mutation={ThanosCompanyDocument} {...props} />
    );
    
export type ThanosCompanyProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<ThanosCompanyMutation, ThanosCompanyMutationVariables>
    } & TChildProps;
export function withThanosCompany<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ThanosCompanyMutation,
  ThanosCompanyMutationVariables,
  ThanosCompanyProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, ThanosCompanyMutation, ThanosCompanyMutationVariables, ThanosCompanyProps<TChildProps, TDataName>>(ThanosCompanyDocument, {
      alias: 'thanosCompany',
      ...operationOptions
    });
};

/**
 * __useThanosCompanyMutation__
 *
 * To run a mutation, you first call `useThanosCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useThanosCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [thanosCompanyMutation, { data, loading, error }] = useThanosCompanyMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useThanosCompanyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ThanosCompanyMutation, ThanosCompanyMutationVariables>) {
        return ApolloReactHooks.useMutation<ThanosCompanyMutation, ThanosCompanyMutationVariables>(ThanosCompanyDocument, baseOptions);
      }
export type ThanosCompanyMutationHookResult = ReturnType<typeof useThanosCompanyMutation>;
export type ThanosCompanyMutationResult = ApolloReactCommon.MutationResult<ThanosCompanyMutation>;
export type ThanosCompanyMutationOptions = ApolloReactCommon.BaseMutationOptions<ThanosCompanyMutation, ThanosCompanyMutationVariables>;
export const GetUsersTableDataDocument = gql`
    query GetUsersTableData($page: Int!, $perPage: Int!, $search: String!, $isAutopricingFilterActive: Boolean!, $autopricingFilterValue: Boolean, $feedTypeFilterValue: String, $onboardingStateFilterValue: String) {
  usersPagination(
    perPage: $perPage
    page: $page
    filter: {search: $search, isAutopricingFilterActive: $isAutopricingFilterActive, autopricingFilterValue: $autopricingFilterValue, feedTypeFilterValue: $feedTypeFilterValue, onboardingStateFilterValue: $onboardingStateFilterValue}
  ) {
    count
    items {
      _id
      email
      createdAt
      roles {
        type
        companyId
        company {
          _id
          active
          blocked
          name
          internalName
          onboardingState
          feedType
          googleDataStudioUrl
          subscription {
            _id
            companyId
            isActive
            amount
            from
            currency
          }
        }
        settings {
          _id
          amazon {
            downloadPricing
            listNewProducts
            synchronizePrices
            synchronizeStock
            zeroUnmatchedProducts
            ignoreZeroStockProducts
            automaticallyCancelRequest
          }
          autopricing {
            amazon_au {
              active
            }
            amazon_br {
              active
            }
            amazon_ca {
              active
            }
            amazon_de {
              active
            }
            amazon_es {
              active
            }
            amazon_fr {
              active
            }
            amazon_it {
              active
            }
            amazon_jp {
              active
            }
            amazon_mx {
              active
            }
            amazon_uk {
              active
            }
            amazon_nl {
              active
            }
            amazon_us {
              active
            }
            amazon_se {
              active
            }
            amazon_tr {
              active
            }
            amazon_pl {
              active
            }
          }
        }
        marketplaces {
          marketplace
          status
        }
      }
      name
    }
    pageInfo {
      currentPage
      perPage
      itemCount
    }
  }
  deleteCompanyEnabledFeaturetoggle: featureToggle(name: delete_company_enabled) {
    enabled
  }
}
    `;
export type GetUsersTableDataComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetUsersTableDataQuery, GetUsersTableDataQueryVariables>, 'query'> & ({ variables: GetUsersTableDataQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetUsersTableDataComponent = (props: GetUsersTableDataComponentProps) => (
      <ApolloReactComponents.Query<GetUsersTableDataQuery, GetUsersTableDataQueryVariables> query={GetUsersTableDataDocument} {...props} />
    );
    
export type GetUsersTableDataProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetUsersTableDataQuery, GetUsersTableDataQueryVariables>
    } & TChildProps;
export function withGetUsersTableData<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetUsersTableDataQuery,
  GetUsersTableDataQueryVariables,
  GetUsersTableDataProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetUsersTableDataQuery, GetUsersTableDataQueryVariables, GetUsersTableDataProps<TChildProps, TDataName>>(GetUsersTableDataDocument, {
      alias: 'getUsersTableData',
      ...operationOptions
    });
};

/**
 * __useGetUsersTableDataQuery__
 *
 * To run a query within a React component, call `useGetUsersTableDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersTableDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersTableDataQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      search: // value for 'search'
 *      isAutopricingFilterActive: // value for 'isAutopricingFilterActive'
 *      autopricingFilterValue: // value for 'autopricingFilterValue'
 *      feedTypeFilterValue: // value for 'feedTypeFilterValue'
 *      onboardingStateFilterValue: // value for 'onboardingStateFilterValue'
 *   },
 * });
 */
export function useGetUsersTableDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUsersTableDataQuery, GetUsersTableDataQueryVariables>) {
        return ApolloReactHooks.useQuery<GetUsersTableDataQuery, GetUsersTableDataQueryVariables>(GetUsersTableDataDocument, baseOptions);
      }
export function useGetUsersTableDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUsersTableDataQuery, GetUsersTableDataQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetUsersTableDataQuery, GetUsersTableDataQueryVariables>(GetUsersTableDataDocument, baseOptions);
        }
export type GetUsersTableDataQueryHookResult = ReturnType<typeof useGetUsersTableDataQuery>;
export type GetUsersTableDataLazyQueryHookResult = ReturnType<typeof useGetUsersTableDataLazyQuery>;
export type GetUsersTableDataQueryResult = ApolloReactCommon.QueryResult<GetUsersTableDataQuery, GetUsersTableDataQueryVariables>;
export const CompleteShoptetLoginDocument = gql`
    mutation CompleteShoptetLogin($code: String!, $state: String!) {
  completeShoptetLogin(code: $code, state: $state) {
    redirectUrl
  }
}
    `;
export type CompleteShoptetLoginMutationFn = ApolloReactCommon.MutationFunction<CompleteShoptetLoginMutation, CompleteShoptetLoginMutationVariables>;
export type CompleteShoptetLoginComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CompleteShoptetLoginMutation, CompleteShoptetLoginMutationVariables>, 'mutation'>;

    export const CompleteShoptetLoginComponent = (props: CompleteShoptetLoginComponentProps) => (
      <ApolloReactComponents.Mutation<CompleteShoptetLoginMutation, CompleteShoptetLoginMutationVariables> mutation={CompleteShoptetLoginDocument} {...props} />
    );
    
export type CompleteShoptetLoginProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CompleteShoptetLoginMutation, CompleteShoptetLoginMutationVariables>
    } & TChildProps;
export function withCompleteShoptetLogin<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CompleteShoptetLoginMutation,
  CompleteShoptetLoginMutationVariables,
  CompleteShoptetLoginProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CompleteShoptetLoginMutation, CompleteShoptetLoginMutationVariables, CompleteShoptetLoginProps<TChildProps, TDataName>>(CompleteShoptetLoginDocument, {
      alias: 'completeShoptetLogin',
      ...operationOptions
    });
};

/**
 * __useCompleteShoptetLoginMutation__
 *
 * To run a mutation, you first call `useCompleteShoptetLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteShoptetLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeShoptetLoginMutation, { data, loading, error }] = useCompleteShoptetLoginMutation({
 *   variables: {
 *      code: // value for 'code'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useCompleteShoptetLoginMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CompleteShoptetLoginMutation, CompleteShoptetLoginMutationVariables>) {
        return ApolloReactHooks.useMutation<CompleteShoptetLoginMutation, CompleteShoptetLoginMutationVariables>(CompleteShoptetLoginDocument, baseOptions);
      }
export type CompleteShoptetLoginMutationHookResult = ReturnType<typeof useCompleteShoptetLoginMutation>;
export type CompleteShoptetLoginMutationResult = ApolloReactCommon.MutationResult<CompleteShoptetLoginMutation>;
export type CompleteShoptetLoginMutationOptions = ApolloReactCommon.BaseMutationOptions<CompleteShoptetLoginMutation, CompleteShoptetLoginMutationVariables>;
export const ConfirmEmailDocument = gql`
    mutation ConfirmEmail($code: String!) {
  completeRegistration(verificationCode: $code) {
    email
    hasExpired
    verified
  }
}
    `;
export type ConfirmEmailMutationFn = ApolloReactCommon.MutationFunction<ConfirmEmailMutation, ConfirmEmailMutationVariables>;
export type ConfirmEmailComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ConfirmEmailMutation, ConfirmEmailMutationVariables>, 'mutation'>;

    export const ConfirmEmailComponent = (props: ConfirmEmailComponentProps) => (
      <ApolloReactComponents.Mutation<ConfirmEmailMutation, ConfirmEmailMutationVariables> mutation={ConfirmEmailDocument} {...props} />
    );
    
export type ConfirmEmailProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<ConfirmEmailMutation, ConfirmEmailMutationVariables>
    } & TChildProps;
export function withConfirmEmail<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ConfirmEmailMutation,
  ConfirmEmailMutationVariables,
  ConfirmEmailProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, ConfirmEmailMutation, ConfirmEmailMutationVariables, ConfirmEmailProps<TChildProps, TDataName>>(ConfirmEmailDocument, {
      alias: 'confirmEmail',
      ...operationOptions
    });
};

/**
 * __useConfirmEmailMutation__
 *
 * To run a mutation, you first call `useConfirmEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmEmailMutation, { data, loading, error }] = useConfirmEmailMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useConfirmEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConfirmEmailMutation, ConfirmEmailMutationVariables>) {
        return ApolloReactHooks.useMutation<ConfirmEmailMutation, ConfirmEmailMutationVariables>(ConfirmEmailDocument, baseOptions);
      }
export type ConfirmEmailMutationHookResult = ReturnType<typeof useConfirmEmailMutation>;
export type ConfirmEmailMutationResult = ApolloReactCommon.MutationResult<ConfirmEmailMutation>;
export type ConfirmEmailMutationOptions = ApolloReactCommon.BaseMutationOptions<ConfirmEmailMutation, ConfirmEmailMutationVariables>;
export const FinalizePasswordResetDocument = gql`
    mutation FinalizePasswordReset($code: String!, $password: String!) {
  resetPassword(code: $code, password: $password) {
    codeAlreadyUsed
    codeExpired
    invalidCode
    success
  }
}
    `;
export type FinalizePasswordResetMutationFn = ApolloReactCommon.MutationFunction<FinalizePasswordResetMutation, FinalizePasswordResetMutationVariables>;
export type FinalizePasswordResetComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<FinalizePasswordResetMutation, FinalizePasswordResetMutationVariables>, 'mutation'>;

    export const FinalizePasswordResetComponent = (props: FinalizePasswordResetComponentProps) => (
      <ApolloReactComponents.Mutation<FinalizePasswordResetMutation, FinalizePasswordResetMutationVariables> mutation={FinalizePasswordResetDocument} {...props} />
    );
    
export type FinalizePasswordResetProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<FinalizePasswordResetMutation, FinalizePasswordResetMutationVariables>
    } & TChildProps;
export function withFinalizePasswordReset<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FinalizePasswordResetMutation,
  FinalizePasswordResetMutationVariables,
  FinalizePasswordResetProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, FinalizePasswordResetMutation, FinalizePasswordResetMutationVariables, FinalizePasswordResetProps<TChildProps, TDataName>>(FinalizePasswordResetDocument, {
      alias: 'finalizePasswordReset',
      ...operationOptions
    });
};

/**
 * __useFinalizePasswordResetMutation__
 *
 * To run a mutation, you first call `useFinalizePasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinalizePasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finalizePasswordResetMutation, { data, loading, error }] = useFinalizePasswordResetMutation({
 *   variables: {
 *      code: // value for 'code'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useFinalizePasswordResetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<FinalizePasswordResetMutation, FinalizePasswordResetMutationVariables>) {
        return ApolloReactHooks.useMutation<FinalizePasswordResetMutation, FinalizePasswordResetMutationVariables>(FinalizePasswordResetDocument, baseOptions);
      }
export type FinalizePasswordResetMutationHookResult = ReturnType<typeof useFinalizePasswordResetMutation>;
export type FinalizePasswordResetMutationResult = ApolloReactCommon.MutationResult<FinalizePasswordResetMutation>;
export type FinalizePasswordResetMutationOptions = ApolloReactCommon.BaseMutationOptions<FinalizePasswordResetMutation, FinalizePasswordResetMutationVariables>;
export const LoginAsUserDocument = gql`
    mutation LoginAsUser($email: String!) {
  superLogin(email: $email) {
    success
  }
}
    `;
export type LoginAsUserMutationFn = ApolloReactCommon.MutationFunction<LoginAsUserMutation, LoginAsUserMutationVariables>;
export type LoginAsUserComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<LoginAsUserMutation, LoginAsUserMutationVariables>, 'mutation'>;

    export const LoginAsUserComponent = (props: LoginAsUserComponentProps) => (
      <ApolloReactComponents.Mutation<LoginAsUserMutation, LoginAsUserMutationVariables> mutation={LoginAsUserDocument} {...props} />
    );
    
export type LoginAsUserProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<LoginAsUserMutation, LoginAsUserMutationVariables>
    } & TChildProps;
export function withLoginAsUser<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  LoginAsUserMutation,
  LoginAsUserMutationVariables,
  LoginAsUserProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, LoginAsUserMutation, LoginAsUserMutationVariables, LoginAsUserProps<TChildProps, TDataName>>(LoginAsUserDocument, {
      alias: 'loginAsUser',
      ...operationOptions
    });
};

/**
 * __useLoginAsUserMutation__
 *
 * To run a mutation, you first call `useLoginAsUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginAsUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginAsUserMutation, { data, loading, error }] = useLoginAsUserMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useLoginAsUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LoginAsUserMutation, LoginAsUserMutationVariables>) {
        return ApolloReactHooks.useMutation<LoginAsUserMutation, LoginAsUserMutationVariables>(LoginAsUserDocument, baseOptions);
      }
export type LoginAsUserMutationHookResult = ReturnType<typeof useLoginAsUserMutation>;
export type LoginAsUserMutationResult = ApolloReactCommon.MutationResult<LoginAsUserMutation>;
export type LoginAsUserMutationOptions = ApolloReactCommon.BaseMutationOptions<LoginAsUserMutation, LoginAsUserMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation ResetPassword($email: String!) {
  sendPasswordResetEmail(email: $email) {
    email
    invalidEmail
    success
  }
}
    `;
export type ResetPasswordMutationFn = ApolloReactCommon.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;
export type ResetPasswordComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ResetPasswordMutation, ResetPasswordMutationVariables>, 'mutation'>;

    export const ResetPasswordComponent = (props: ResetPasswordComponentProps) => (
      <ApolloReactComponents.Mutation<ResetPasswordMutation, ResetPasswordMutationVariables> mutation={ResetPasswordDocument} {...props} />
    );
    
export type ResetPasswordProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>
    } & TChildProps;
export function withResetPassword<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ResetPasswordMutation,
  ResetPasswordMutationVariables,
  ResetPasswordProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, ResetPasswordMutation, ResetPasswordMutationVariables, ResetPasswordProps<TChildProps, TDataName>>(ResetPasswordDocument, {
      alias: 'resetPassword',
      ...operationOptions
    });
};

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        return ApolloReactHooks.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, baseOptions);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = ApolloReactCommon.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = ApolloReactCommon.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const StartShoptetLoginDocument = gql`
    mutation StartShoptetLogin($redirectUrl: String, $shopId: String, $shopHostname: String) {
  startShoptetLogin(
    redirectUrl: $redirectUrl
    shopId: $shopId
    shopHostname: $shopHostname
  ) {
    authUrl
  }
}
    `;
export type StartShoptetLoginMutationFn = ApolloReactCommon.MutationFunction<StartShoptetLoginMutation, StartShoptetLoginMutationVariables>;
export type StartShoptetLoginComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<StartShoptetLoginMutation, StartShoptetLoginMutationVariables>, 'mutation'>;

    export const StartShoptetLoginComponent = (props: StartShoptetLoginComponentProps) => (
      <ApolloReactComponents.Mutation<StartShoptetLoginMutation, StartShoptetLoginMutationVariables> mutation={StartShoptetLoginDocument} {...props} />
    );
    
export type StartShoptetLoginProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<StartShoptetLoginMutation, StartShoptetLoginMutationVariables>
    } & TChildProps;
export function withStartShoptetLogin<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  StartShoptetLoginMutation,
  StartShoptetLoginMutationVariables,
  StartShoptetLoginProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, StartShoptetLoginMutation, StartShoptetLoginMutationVariables, StartShoptetLoginProps<TChildProps, TDataName>>(StartShoptetLoginDocument, {
      alias: 'startShoptetLogin',
      ...operationOptions
    });
};

/**
 * __useStartShoptetLoginMutation__
 *
 * To run a mutation, you first call `useStartShoptetLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartShoptetLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startShoptetLoginMutation, { data, loading, error }] = useStartShoptetLoginMutation({
 *   variables: {
 *      redirectUrl: // value for 'redirectUrl'
 *      shopId: // value for 'shopId'
 *      shopHostname: // value for 'shopHostname'
 *   },
 * });
 */
export function useStartShoptetLoginMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StartShoptetLoginMutation, StartShoptetLoginMutationVariables>) {
        return ApolloReactHooks.useMutation<StartShoptetLoginMutation, StartShoptetLoginMutationVariables>(StartShoptetLoginDocument, baseOptions);
      }
export type StartShoptetLoginMutationHookResult = ReturnType<typeof useStartShoptetLoginMutation>;
export type StartShoptetLoginMutationResult = ApolloReactCommon.MutationResult<StartShoptetLoginMutation>;
export type StartShoptetLoginMutationOptions = ApolloReactCommon.BaseMutationOptions<StartShoptetLoginMutation, StartShoptetLoginMutationVariables>;
export const RequestAutopricingReportDocument = gql`
    mutation RequestAutopricingReport($filters: AutopricingReportFilterOptionsInput, $relevantRanges: AutopricingReportRelevantRangesOptionsInput, $fieldWeights: AutopricingReportFieldWeightsOptionsInput) {
  requestAutopricingReport(
    filters: $filters
    relevantRanges: $relevantRanges
    fieldWeights: $fieldWeights
  ) {
    state
  }
}
    `;
export type RequestAutopricingReportMutationFn = ApolloReactCommon.MutationFunction<RequestAutopricingReportMutation, RequestAutopricingReportMutationVariables>;
export type RequestAutopricingReportComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<RequestAutopricingReportMutation, RequestAutopricingReportMutationVariables>, 'mutation'>;

    export const RequestAutopricingReportComponent = (props: RequestAutopricingReportComponentProps) => (
      <ApolloReactComponents.Mutation<RequestAutopricingReportMutation, RequestAutopricingReportMutationVariables> mutation={RequestAutopricingReportDocument} {...props} />
    );
    
export type RequestAutopricingReportProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<RequestAutopricingReportMutation, RequestAutopricingReportMutationVariables>
    } & TChildProps;
export function withRequestAutopricingReport<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RequestAutopricingReportMutation,
  RequestAutopricingReportMutationVariables,
  RequestAutopricingReportProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RequestAutopricingReportMutation, RequestAutopricingReportMutationVariables, RequestAutopricingReportProps<TChildProps, TDataName>>(RequestAutopricingReportDocument, {
      alias: 'requestAutopricingReport',
      ...operationOptions
    });
};

/**
 * __useRequestAutopricingReportMutation__
 *
 * To run a mutation, you first call `useRequestAutopricingReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestAutopricingReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestAutopricingReportMutation, { data, loading, error }] = useRequestAutopricingReportMutation({
 *   variables: {
 *      filters: // value for 'filters'
 *      relevantRanges: // value for 'relevantRanges'
 *      fieldWeights: // value for 'fieldWeights'
 *   },
 * });
 */
export function useRequestAutopricingReportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RequestAutopricingReportMutation, RequestAutopricingReportMutationVariables>) {
        return ApolloReactHooks.useMutation<RequestAutopricingReportMutation, RequestAutopricingReportMutationVariables>(RequestAutopricingReportDocument, baseOptions);
      }
export type RequestAutopricingReportMutationHookResult = ReturnType<typeof useRequestAutopricingReportMutation>;
export type RequestAutopricingReportMutationResult = ApolloReactCommon.MutationResult<RequestAutopricingReportMutation>;
export type RequestAutopricingReportMutationOptions = ApolloReactCommon.BaseMutationOptions<RequestAutopricingReportMutation, RequestAutopricingReportMutationVariables>;
export const GetAutopricingReportDocument = gql`
    query GetAutopricingReport {
  getAutopricingReport {
    state
    progress
    createdAt
    finishedAt
    resultItems {
      autopricing {
        marketplace
        autoprice
        topCap
        bottomCap
        salesRank {
          rank
        }
      }
      variant {
        sku
        name
        stock
      }
      recommendation {
        bottomLimitShift
        topLimitShift
      }
    }
  }
}
    `;
export type GetAutopricingReportComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAutopricingReportQuery, GetAutopricingReportQueryVariables>, 'query'>;

    export const GetAutopricingReportComponent = (props: GetAutopricingReportComponentProps) => (
      <ApolloReactComponents.Query<GetAutopricingReportQuery, GetAutopricingReportQueryVariables> query={GetAutopricingReportDocument} {...props} />
    );
    
export type GetAutopricingReportProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetAutopricingReportQuery, GetAutopricingReportQueryVariables>
    } & TChildProps;
export function withGetAutopricingReport<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetAutopricingReportQuery,
  GetAutopricingReportQueryVariables,
  GetAutopricingReportProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetAutopricingReportQuery, GetAutopricingReportQueryVariables, GetAutopricingReportProps<TChildProps, TDataName>>(GetAutopricingReportDocument, {
      alias: 'getAutopricingReport',
      ...operationOptions
    });
};

/**
 * __useGetAutopricingReportQuery__
 *
 * To run a query within a React component, call `useGetAutopricingReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAutopricingReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAutopricingReportQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAutopricingReportQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAutopricingReportQuery, GetAutopricingReportQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAutopricingReportQuery, GetAutopricingReportQueryVariables>(GetAutopricingReportDocument, baseOptions);
      }
export function useGetAutopricingReportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAutopricingReportQuery, GetAutopricingReportQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAutopricingReportQuery, GetAutopricingReportQueryVariables>(GetAutopricingReportDocument, baseOptions);
        }
export type GetAutopricingReportQueryHookResult = ReturnType<typeof useGetAutopricingReportQuery>;
export type GetAutopricingReportLazyQueryHookResult = ReturnType<typeof useGetAutopricingReportLazyQuery>;
export type GetAutopricingReportQueryResult = ApolloReactCommon.QueryResult<GetAutopricingReportQuery, GetAutopricingReportQueryVariables>;
export const GetSyncSettingsDocument = gql`
    query GetSyncSettings {
  syncSettings {
    _id
    autopricing {
      amazon_au {
        active
        defaultTopCap
        defaultBottomCap
      }
      amazon_br {
        active
        defaultTopCap
        defaultBottomCap
      }
      amazon_ca {
        active
        defaultTopCap
        defaultBottomCap
      }
      amazon_de {
        active
        defaultTopCap
        defaultBottomCap
      }
      amazon_es {
        active
        defaultTopCap
        defaultBottomCap
      }
      amazon_fr {
        active
        defaultTopCap
        defaultBottomCap
      }
      amazon_it {
        active
        defaultTopCap
        defaultBottomCap
      }
      amazon_jp {
        active
        defaultTopCap
        defaultBottomCap
      }
      amazon_mx {
        active
        defaultTopCap
        defaultBottomCap
      }
      amazon_uk {
        active
        defaultTopCap
        defaultBottomCap
      }
      amazon_nl {
        active
        defaultTopCap
        defaultBottomCap
      }
      amazon_us {
        active
        defaultTopCap
        defaultBottomCap
      }
      kaufland_de {
        active
        defaultTopCap
        defaultBottomCap
      }
      kaufland_sk {
        active
        defaultTopCap
        defaultBottomCap
      }
      kaufland_cz {
        active
        defaultTopCap
        defaultBottomCap
      }
      kaufland_at {
        active
        defaultTopCap
        defaultBottomCap
      }
      kaufland_pl {
        active
        defaultTopCap
        defaultBottomCap
      }
      kaufland_nl {
        active
        defaultTopCap
        defaultBottomCap
      }
      kaufland_es {
        active
        defaultTopCap
        defaultBottomCap
      }
      kaufland_fr {
        active
        defaultTopCap
        defaultBottomCap
      }
      kaufland_it {
        active
        defaultTopCap
        defaultBottomCap
      }
      cdiscount_fr {
        active
        defaultTopCap
        defaultBottomCap
      }
    }
  }
}
    `;
export type GetSyncSettingsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetSyncSettingsQuery, GetSyncSettingsQueryVariables>, 'query'>;

    export const GetSyncSettingsComponent = (props: GetSyncSettingsComponentProps) => (
      <ApolloReactComponents.Query<GetSyncSettingsQuery, GetSyncSettingsQueryVariables> query={GetSyncSettingsDocument} {...props} />
    );
    
export type GetSyncSettingsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetSyncSettingsQuery, GetSyncSettingsQueryVariables>
    } & TChildProps;
export function withGetSyncSettings<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetSyncSettingsQuery,
  GetSyncSettingsQueryVariables,
  GetSyncSettingsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetSyncSettingsQuery, GetSyncSettingsQueryVariables, GetSyncSettingsProps<TChildProps, TDataName>>(GetSyncSettingsDocument, {
      alias: 'getSyncSettings',
      ...operationOptions
    });
};

/**
 * __useGetSyncSettingsQuery__
 *
 * To run a query within a React component, call `useGetSyncSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSyncSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSyncSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSyncSettingsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetSyncSettingsQuery, GetSyncSettingsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetSyncSettingsQuery, GetSyncSettingsQueryVariables>(GetSyncSettingsDocument, baseOptions);
      }
export function useGetSyncSettingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSyncSettingsQuery, GetSyncSettingsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetSyncSettingsQuery, GetSyncSettingsQueryVariables>(GetSyncSettingsDocument, baseOptions);
        }
export type GetSyncSettingsQueryHookResult = ReturnType<typeof useGetSyncSettingsQuery>;
export type GetSyncSettingsLazyQueryHookResult = ReturnType<typeof useGetSyncSettingsLazyQuery>;
export type GetSyncSettingsQueryResult = ApolloReactCommon.QueryResult<GetSyncSettingsQuery, GetSyncSettingsQueryVariables>;
export const GetReturnAddressAsUserDocument = gql`
    query GetReturnAddressAsUser {
  company {
    returnAddress {
      companyName
      name
      countryCode
      city
      zipCode
      street
      phone
      email
    }
  }
}
    `;
export type GetReturnAddressAsUserComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetReturnAddressAsUserQuery, GetReturnAddressAsUserQueryVariables>, 'query'>;

    export const GetReturnAddressAsUserComponent = (props: GetReturnAddressAsUserComponentProps) => (
      <ApolloReactComponents.Query<GetReturnAddressAsUserQuery, GetReturnAddressAsUserQueryVariables> query={GetReturnAddressAsUserDocument} {...props} />
    );
    
export type GetReturnAddressAsUserProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetReturnAddressAsUserQuery, GetReturnAddressAsUserQueryVariables>
    } & TChildProps;
export function withGetReturnAddressAsUser<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetReturnAddressAsUserQuery,
  GetReturnAddressAsUserQueryVariables,
  GetReturnAddressAsUserProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetReturnAddressAsUserQuery, GetReturnAddressAsUserQueryVariables, GetReturnAddressAsUserProps<TChildProps, TDataName>>(GetReturnAddressAsUserDocument, {
      alias: 'getReturnAddressAsUser',
      ...operationOptions
    });
};

/**
 * __useGetReturnAddressAsUserQuery__
 *
 * To run a query within a React component, call `useGetReturnAddressAsUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReturnAddressAsUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReturnAddressAsUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetReturnAddressAsUserQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetReturnAddressAsUserQuery, GetReturnAddressAsUserQueryVariables>) {
        return ApolloReactHooks.useQuery<GetReturnAddressAsUserQuery, GetReturnAddressAsUserQueryVariables>(GetReturnAddressAsUserDocument, baseOptions);
      }
export function useGetReturnAddressAsUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetReturnAddressAsUserQuery, GetReturnAddressAsUserQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetReturnAddressAsUserQuery, GetReturnAddressAsUserQueryVariables>(GetReturnAddressAsUserDocument, baseOptions);
        }
export type GetReturnAddressAsUserQueryHookResult = ReturnType<typeof useGetReturnAddressAsUserQuery>;
export type GetReturnAddressAsUserLazyQueryHookResult = ReturnType<typeof useGetReturnAddressAsUserLazyQuery>;
export type GetReturnAddressAsUserQueryResult = ApolloReactCommon.QueryResult<GetReturnAddressAsUserQuery, GetReturnAddressAsUserQueryVariables>;
export const GetReturnAddressAsAdminDocument = gql`
    query GetReturnAddressAsAdmin($companyId: String!) {
  getReturnAddress(companyId: $companyId) {
    _id
    returnAddress {
      companyName
      name
      countryCode
      city
      zipCode
      street
      phone
      email
    }
  }
}
    `;
export type GetReturnAddressAsAdminComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetReturnAddressAsAdminQuery, GetReturnAddressAsAdminQueryVariables>, 'query'> & ({ variables: GetReturnAddressAsAdminQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetReturnAddressAsAdminComponent = (props: GetReturnAddressAsAdminComponentProps) => (
      <ApolloReactComponents.Query<GetReturnAddressAsAdminQuery, GetReturnAddressAsAdminQueryVariables> query={GetReturnAddressAsAdminDocument} {...props} />
    );
    
export type GetReturnAddressAsAdminProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetReturnAddressAsAdminQuery, GetReturnAddressAsAdminQueryVariables>
    } & TChildProps;
export function withGetReturnAddressAsAdmin<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetReturnAddressAsAdminQuery,
  GetReturnAddressAsAdminQueryVariables,
  GetReturnAddressAsAdminProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetReturnAddressAsAdminQuery, GetReturnAddressAsAdminQueryVariables, GetReturnAddressAsAdminProps<TChildProps, TDataName>>(GetReturnAddressAsAdminDocument, {
      alias: 'getReturnAddressAsAdmin',
      ...operationOptions
    });
};

/**
 * __useGetReturnAddressAsAdminQuery__
 *
 * To run a query within a React component, call `useGetReturnAddressAsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReturnAddressAsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReturnAddressAsAdminQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetReturnAddressAsAdminQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetReturnAddressAsAdminQuery, GetReturnAddressAsAdminQueryVariables>) {
        return ApolloReactHooks.useQuery<GetReturnAddressAsAdminQuery, GetReturnAddressAsAdminQueryVariables>(GetReturnAddressAsAdminDocument, baseOptions);
      }
export function useGetReturnAddressAsAdminLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetReturnAddressAsAdminQuery, GetReturnAddressAsAdminQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetReturnAddressAsAdminQuery, GetReturnAddressAsAdminQueryVariables>(GetReturnAddressAsAdminDocument, baseOptions);
        }
export type GetReturnAddressAsAdminQueryHookResult = ReturnType<typeof useGetReturnAddressAsAdminQuery>;
export type GetReturnAddressAsAdminLazyQueryHookResult = ReturnType<typeof useGetReturnAddressAsAdminLazyQuery>;
export type GetReturnAddressAsAdminQueryResult = ApolloReactCommon.QueryResult<GetReturnAddressAsAdminQuery, GetReturnAddressAsAdminQueryVariables>;
export const UpdateOnboardingStateDocument = gql`
    mutation UpdateOnboardingState($state: EnumCompanyOnboardingState!) {
  updateOnboardingState(onboardingState: $state) {
    isOnboarding
    onboardingState
  }
}
    `;
export type UpdateOnboardingStateMutationFn = ApolloReactCommon.MutationFunction<UpdateOnboardingStateMutation, UpdateOnboardingStateMutationVariables>;
export type UpdateOnboardingStateComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateOnboardingStateMutation, UpdateOnboardingStateMutationVariables>, 'mutation'>;

    export const UpdateOnboardingStateComponent = (props: UpdateOnboardingStateComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateOnboardingStateMutation, UpdateOnboardingStateMutationVariables> mutation={UpdateOnboardingStateDocument} {...props} />
    );
    
export type UpdateOnboardingStateProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateOnboardingStateMutation, UpdateOnboardingStateMutationVariables>
    } & TChildProps;
export function withUpdateOnboardingState<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateOnboardingStateMutation,
  UpdateOnboardingStateMutationVariables,
  UpdateOnboardingStateProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateOnboardingStateMutation, UpdateOnboardingStateMutationVariables, UpdateOnboardingStateProps<TChildProps, TDataName>>(UpdateOnboardingStateDocument, {
      alias: 'updateOnboardingState',
      ...operationOptions
    });
};

/**
 * __useUpdateOnboardingStateMutation__
 *
 * To run a mutation, you first call `useUpdateOnboardingStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOnboardingStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOnboardingStateMutation, { data, loading, error }] = useUpdateOnboardingStateMutation({
 *   variables: {
 *      state: // value for 'state'
 *   },
 * });
 */
export function useUpdateOnboardingStateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateOnboardingStateMutation, UpdateOnboardingStateMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateOnboardingStateMutation, UpdateOnboardingStateMutationVariables>(UpdateOnboardingStateDocument, baseOptions);
      }
export type UpdateOnboardingStateMutationHookResult = ReturnType<typeof useUpdateOnboardingStateMutation>;
export type UpdateOnboardingStateMutationResult = ApolloReactCommon.MutationResult<UpdateOnboardingStateMutation>;
export type UpdateOnboardingStateMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateOnboardingStateMutation, UpdateOnboardingStateMutationVariables>;
export const UpdateReturnAddressDocument = gql`
    mutation UpdateReturnAddress($companyName: String, $name: String!, $countryCode: String!, $email: String, $street: String!, $phone: String, $zipCode: String!, $city: String!) {
  updateReturnAddress(
    companyName: $companyName
    name: $name
    countryCode: $countryCode
    email: $email
    street: $street
    phone: $phone
    zipCode: $zipCode
    city: $city
  ) {
    returnAddress {
      companyName
      name
      countryCode
      email
      street
      phone
      zipCode
      city
    }
  }
}
    `;
export type UpdateReturnAddressMutationFn = ApolloReactCommon.MutationFunction<UpdateReturnAddressMutation, UpdateReturnAddressMutationVariables>;
export type UpdateReturnAddressComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateReturnAddressMutation, UpdateReturnAddressMutationVariables>, 'mutation'>;

    export const UpdateReturnAddressComponent = (props: UpdateReturnAddressComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateReturnAddressMutation, UpdateReturnAddressMutationVariables> mutation={UpdateReturnAddressDocument} {...props} />
    );
    
export type UpdateReturnAddressProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateReturnAddressMutation, UpdateReturnAddressMutationVariables>
    } & TChildProps;
export function withUpdateReturnAddress<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateReturnAddressMutation,
  UpdateReturnAddressMutationVariables,
  UpdateReturnAddressProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateReturnAddressMutation, UpdateReturnAddressMutationVariables, UpdateReturnAddressProps<TChildProps, TDataName>>(UpdateReturnAddressDocument, {
      alias: 'updateReturnAddress',
      ...operationOptions
    });
};

/**
 * __useUpdateReturnAddressMutation__
 *
 * To run a mutation, you first call `useUpdateReturnAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReturnAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReturnAddressMutation, { data, loading, error }] = useUpdateReturnAddressMutation({
 *   variables: {
 *      companyName: // value for 'companyName'
 *      name: // value for 'name'
 *      countryCode: // value for 'countryCode'
 *      email: // value for 'email'
 *      street: // value for 'street'
 *      phone: // value for 'phone'
 *      zipCode: // value for 'zipCode'
 *      city: // value for 'city'
 *   },
 * });
 */
export function useUpdateReturnAddressMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateReturnAddressMutation, UpdateReturnAddressMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateReturnAddressMutation, UpdateReturnAddressMutationVariables>(UpdateReturnAddressDocument, baseOptions);
      }
export type UpdateReturnAddressMutationHookResult = ReturnType<typeof useUpdateReturnAddressMutation>;
export type UpdateReturnAddressMutationResult = ApolloReactCommon.MutationResult<UpdateReturnAddressMutation>;
export type UpdateReturnAddressMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateReturnAddressMutation, UpdateReturnAddressMutationVariables>;
export const GetFeedConvertReportDocument = gql`
    query GetFeedConvertReport($id: String) {
  getFeedConvertReport(id: $id) {
    id
    state
    progress
    result {
      downloadUrl
    }
  }
}
    `;
export type GetFeedConvertReportComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetFeedConvertReportQuery, GetFeedConvertReportQueryVariables>, 'query'>;

    export const GetFeedConvertReportComponent = (props: GetFeedConvertReportComponentProps) => (
      <ApolloReactComponents.Query<GetFeedConvertReportQuery, GetFeedConvertReportQueryVariables> query={GetFeedConvertReportDocument} {...props} />
    );
    
export type GetFeedConvertReportProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetFeedConvertReportQuery, GetFeedConvertReportQueryVariables>
    } & TChildProps;
export function withGetFeedConvertReport<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetFeedConvertReportQuery,
  GetFeedConvertReportQueryVariables,
  GetFeedConvertReportProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetFeedConvertReportQuery, GetFeedConvertReportQueryVariables, GetFeedConvertReportProps<TChildProps, TDataName>>(GetFeedConvertReportDocument, {
      alias: 'getFeedConvertReport',
      ...operationOptions
    });
};

/**
 * __useGetFeedConvertReportQuery__
 *
 * To run a query within a React component, call `useGetFeedConvertReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedConvertReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedConvertReportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFeedConvertReportQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetFeedConvertReportQuery, GetFeedConvertReportQueryVariables>) {
        return ApolloReactHooks.useQuery<GetFeedConvertReportQuery, GetFeedConvertReportQueryVariables>(GetFeedConvertReportDocument, baseOptions);
      }
export function useGetFeedConvertReportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFeedConvertReportQuery, GetFeedConvertReportQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetFeedConvertReportQuery, GetFeedConvertReportQueryVariables>(GetFeedConvertReportDocument, baseOptions);
        }
export type GetFeedConvertReportQueryHookResult = ReturnType<typeof useGetFeedConvertReportQuery>;
export type GetFeedConvertReportLazyQueryHookResult = ReturnType<typeof useGetFeedConvertReportLazyQuery>;
export type GetFeedConvertReportQueryResult = ApolloReactCommon.QueryResult<GetFeedConvertReportQuery, GetFeedConvertReportQueryVariables>;
export const RequestFeedConvertReportDocument = gql`
    mutation RequestFeedConvertReport($url: String) {
  requestFeedConvertReport(url: $url) {
    id
    state
  }
}
    `;
export type RequestFeedConvertReportMutationFn = ApolloReactCommon.MutationFunction<RequestFeedConvertReportMutation, RequestFeedConvertReportMutationVariables>;
export type RequestFeedConvertReportComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<RequestFeedConvertReportMutation, RequestFeedConvertReportMutationVariables>, 'mutation'>;

    export const RequestFeedConvertReportComponent = (props: RequestFeedConvertReportComponentProps) => (
      <ApolloReactComponents.Mutation<RequestFeedConvertReportMutation, RequestFeedConvertReportMutationVariables> mutation={RequestFeedConvertReportDocument} {...props} />
    );
    
export type RequestFeedConvertReportProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<RequestFeedConvertReportMutation, RequestFeedConvertReportMutationVariables>
    } & TChildProps;
export function withRequestFeedConvertReport<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RequestFeedConvertReportMutation,
  RequestFeedConvertReportMutationVariables,
  RequestFeedConvertReportProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RequestFeedConvertReportMutation, RequestFeedConvertReportMutationVariables, RequestFeedConvertReportProps<TChildProps, TDataName>>(RequestFeedConvertReportDocument, {
      alias: 'requestFeedConvertReport',
      ...operationOptions
    });
};

/**
 * __useRequestFeedConvertReportMutation__
 *
 * To run a mutation, you first call `useRequestFeedConvertReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestFeedConvertReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestFeedConvertReportMutation, { data, loading, error }] = useRequestFeedConvertReportMutation({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useRequestFeedConvertReportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RequestFeedConvertReportMutation, RequestFeedConvertReportMutationVariables>) {
        return ApolloReactHooks.useMutation<RequestFeedConvertReportMutation, RequestFeedConvertReportMutationVariables>(RequestFeedConvertReportDocument, baseOptions);
      }
export type RequestFeedConvertReportMutationHookResult = ReturnType<typeof useRequestFeedConvertReportMutation>;
export type RequestFeedConvertReportMutationResult = ApolloReactCommon.MutationResult<RequestFeedConvertReportMutation>;
export type RequestFeedConvertReportMutationOptions = ApolloReactCommon.BaseMutationOptions<RequestFeedConvertReportMutation, RequestFeedConvertReportMutationVariables>;
export const SaveCustomFeedDocument = gql`
    mutation SaveCustomFeed($feed: CustomProductFeedInput, $step: EFeedSetupState) {
  setCustomProductFeed(feed: $feed, step: $step) {
    ...FeedProps
  }
}
    ${FeedPropsFragmentDoc}`;
export type SaveCustomFeedMutationFn = ApolloReactCommon.MutationFunction<SaveCustomFeedMutation, SaveCustomFeedMutationVariables>;
export type SaveCustomFeedComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<SaveCustomFeedMutation, SaveCustomFeedMutationVariables>, 'mutation'>;

    export const SaveCustomFeedComponent = (props: SaveCustomFeedComponentProps) => (
      <ApolloReactComponents.Mutation<SaveCustomFeedMutation, SaveCustomFeedMutationVariables> mutation={SaveCustomFeedDocument} {...props} />
    );
    
export type SaveCustomFeedProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<SaveCustomFeedMutation, SaveCustomFeedMutationVariables>
    } & TChildProps;
export function withSaveCustomFeed<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SaveCustomFeedMutation,
  SaveCustomFeedMutationVariables,
  SaveCustomFeedProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, SaveCustomFeedMutation, SaveCustomFeedMutationVariables, SaveCustomFeedProps<TChildProps, TDataName>>(SaveCustomFeedDocument, {
      alias: 'saveCustomFeed',
      ...operationOptions
    });
};

/**
 * __useSaveCustomFeedMutation__
 *
 * To run a mutation, you first call `useSaveCustomFeedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCustomFeedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCustomFeedMutation, { data, loading, error }] = useSaveCustomFeedMutation({
 *   variables: {
 *      feed: // value for 'feed'
 *      step: // value for 'step'
 *   },
 * });
 */
export function useSaveCustomFeedMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveCustomFeedMutation, SaveCustomFeedMutationVariables>) {
        return ApolloReactHooks.useMutation<SaveCustomFeedMutation, SaveCustomFeedMutationVariables>(SaveCustomFeedDocument, baseOptions);
      }
export type SaveCustomFeedMutationHookResult = ReturnType<typeof useSaveCustomFeedMutation>;
export type SaveCustomFeedMutationResult = ApolloReactCommon.MutationResult<SaveCustomFeedMutation>;
export type SaveCustomFeedMutationOptions = ApolloReactCommon.BaseMutationOptions<SaveCustomFeedMutation, SaveCustomFeedMutationVariables>;
export const CustomProductFeedDocument = gql`
    query CustomProductFeed {
  customProductFeed {
    ...FeedProps
  }
}
    ${FeedPropsFragmentDoc}`;
export type CustomProductFeedComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CustomProductFeedQuery, CustomProductFeedQueryVariables>, 'query'>;

    export const CustomProductFeedComponent = (props: CustomProductFeedComponentProps) => (
      <ApolloReactComponents.Query<CustomProductFeedQuery, CustomProductFeedQueryVariables> query={CustomProductFeedDocument} {...props} />
    );
    
export type CustomProductFeedProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<CustomProductFeedQuery, CustomProductFeedQueryVariables>
    } & TChildProps;
export function withCustomProductFeed<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CustomProductFeedQuery,
  CustomProductFeedQueryVariables,
  CustomProductFeedProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, CustomProductFeedQuery, CustomProductFeedQueryVariables, CustomProductFeedProps<TChildProps, TDataName>>(CustomProductFeedDocument, {
      alias: 'customProductFeed',
      ...operationOptions
    });
};

/**
 * __useCustomProductFeedQuery__
 *
 * To run a query within a React component, call `useCustomProductFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomProductFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomProductFeedQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomProductFeedQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CustomProductFeedQuery, CustomProductFeedQueryVariables>) {
        return ApolloReactHooks.useQuery<CustomProductFeedQuery, CustomProductFeedQueryVariables>(CustomProductFeedDocument, baseOptions);
      }
export function useCustomProductFeedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CustomProductFeedQuery, CustomProductFeedQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CustomProductFeedQuery, CustomProductFeedQueryVariables>(CustomProductFeedDocument, baseOptions);
        }
export type CustomProductFeedQueryHookResult = ReturnType<typeof useCustomProductFeedQuery>;
export type CustomProductFeedLazyQueryHookResult = ReturnType<typeof useCustomProductFeedLazyQuery>;
export type CustomProductFeedQueryResult = ApolloReactCommon.QueryResult<CustomProductFeedQuery, CustomProductFeedQueryVariables>;
export const GetFeedSummaryDocument = gql`
    query GetFeedSummary {
  productFeedResult {
    isConnected
    productsInStock
    productsWithEAN
    productsAll
    productsToBeListed
    error
  }
  productSync {
    _id
    isFeedSyncing
  }
}
    `;
export type GetFeedSummaryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetFeedSummaryQuery, GetFeedSummaryQueryVariables>, 'query'>;

    export const GetFeedSummaryComponent = (props: GetFeedSummaryComponentProps) => (
      <ApolloReactComponents.Query<GetFeedSummaryQuery, GetFeedSummaryQueryVariables> query={GetFeedSummaryDocument} {...props} />
    );
    
export type GetFeedSummaryProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetFeedSummaryQuery, GetFeedSummaryQueryVariables>
    } & TChildProps;
export function withGetFeedSummary<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetFeedSummaryQuery,
  GetFeedSummaryQueryVariables,
  GetFeedSummaryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetFeedSummaryQuery, GetFeedSummaryQueryVariables, GetFeedSummaryProps<TChildProps, TDataName>>(GetFeedSummaryDocument, {
      alias: 'getFeedSummary',
      ...operationOptions
    });
};

/**
 * __useGetFeedSummaryQuery__
 *
 * To run a query within a React component, call `useGetFeedSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFeedSummaryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetFeedSummaryQuery, GetFeedSummaryQueryVariables>) {
        return ApolloReactHooks.useQuery<GetFeedSummaryQuery, GetFeedSummaryQueryVariables>(GetFeedSummaryDocument, baseOptions);
      }
export function useGetFeedSummaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFeedSummaryQuery, GetFeedSummaryQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetFeedSummaryQuery, GetFeedSummaryQueryVariables>(GetFeedSummaryDocument, baseOptions);
        }
export type GetFeedSummaryQueryHookResult = ReturnType<typeof useGetFeedSummaryQuery>;
export type GetFeedSummaryLazyQueryHookResult = ReturnType<typeof useGetFeedSummaryLazyQuery>;
export type GetFeedSummaryQueryResult = ApolloReactCommon.QueryResult<GetFeedSummaryQuery, GetFeedSummaryQueryVariables>;
export const GetFulfillmentDocument = gql`
    query GetFulfillment($marketplace: MarketplaceName!, $marketplaceOrderId: String!) {
  fulfillment(marketplace: $marketplace, marketplaceOrderId: $marketplaceOrderId) {
    _id
    trackingNumber
    shipDate
    carrier
    carrierName
    shipMethod
    trackingUrl
    marketplaceOrderIds
    packages {
      number
      fullNumber
      weight
      items {
        marketplaceItemId
        marketplaceOrderId
        quantity
        serials
      }
    }
  }
}
    `;
export type GetFulfillmentComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetFulfillmentQuery, GetFulfillmentQueryVariables>, 'query'> & ({ variables: GetFulfillmentQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetFulfillmentComponent = (props: GetFulfillmentComponentProps) => (
      <ApolloReactComponents.Query<GetFulfillmentQuery, GetFulfillmentQueryVariables> query={GetFulfillmentDocument} {...props} />
    );
    
export type GetFulfillmentProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetFulfillmentQuery, GetFulfillmentQueryVariables>
    } & TChildProps;
export function withGetFulfillment<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetFulfillmentQuery,
  GetFulfillmentQueryVariables,
  GetFulfillmentProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetFulfillmentQuery, GetFulfillmentQueryVariables, GetFulfillmentProps<TChildProps, TDataName>>(GetFulfillmentDocument, {
      alias: 'getFulfillment',
      ...operationOptions
    });
};

/**
 * __useGetFulfillmentQuery__
 *
 * To run a query within a React component, call `useGetFulfillmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFulfillmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFulfillmentQuery({
 *   variables: {
 *      marketplace: // value for 'marketplace'
 *      marketplaceOrderId: // value for 'marketplaceOrderId'
 *   },
 * });
 */
export function useGetFulfillmentQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetFulfillmentQuery, GetFulfillmentQueryVariables>) {
        return ApolloReactHooks.useQuery<GetFulfillmentQuery, GetFulfillmentQueryVariables>(GetFulfillmentDocument, baseOptions);
      }
export function useGetFulfillmentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFulfillmentQuery, GetFulfillmentQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetFulfillmentQuery, GetFulfillmentQueryVariables>(GetFulfillmentDocument, baseOptions);
        }
export type GetFulfillmentQueryHookResult = ReturnType<typeof useGetFulfillmentQuery>;
export type GetFulfillmentLazyQueryHookResult = ReturnType<typeof useGetFulfillmentLazyQuery>;
export type GetFulfillmentQueryResult = ApolloReactCommon.QueryResult<GetFulfillmentQuery, GetFulfillmentQueryVariables>;
export const UpdateFulfillmentDocument = gql`
    mutation UpdateFulfillment($fulfillment: FulfillmentInput!, $fulfillmentChannel: String!) {
  updateFulfillment(
    fulfillment: $fulfillment
    fulfillmentChannel: $fulfillmentChannel
  ) {
    _id
    trackingNumber
    shipDate
    carrier
    trackingUrl
    syncError
  }
}
    `;
export type UpdateFulfillmentMutationFn = ApolloReactCommon.MutationFunction<UpdateFulfillmentMutation, UpdateFulfillmentMutationVariables>;
export type UpdateFulfillmentComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateFulfillmentMutation, UpdateFulfillmentMutationVariables>, 'mutation'>;

    export const UpdateFulfillmentComponent = (props: UpdateFulfillmentComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateFulfillmentMutation, UpdateFulfillmentMutationVariables> mutation={UpdateFulfillmentDocument} {...props} />
    );
    
export type UpdateFulfillmentProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateFulfillmentMutation, UpdateFulfillmentMutationVariables>
    } & TChildProps;
export function withUpdateFulfillment<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateFulfillmentMutation,
  UpdateFulfillmentMutationVariables,
  UpdateFulfillmentProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateFulfillmentMutation, UpdateFulfillmentMutationVariables, UpdateFulfillmentProps<TChildProps, TDataName>>(UpdateFulfillmentDocument, {
      alias: 'updateFulfillment',
      ...operationOptions
    });
};

/**
 * __useUpdateFulfillmentMutation__
 *
 * To run a mutation, you first call `useUpdateFulfillmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFulfillmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFulfillmentMutation, { data, loading, error }] = useUpdateFulfillmentMutation({
 *   variables: {
 *      fulfillment: // value for 'fulfillment'
 *      fulfillmentChannel: // value for 'fulfillmentChannel'
 *   },
 * });
 */
export function useUpdateFulfillmentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateFulfillmentMutation, UpdateFulfillmentMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateFulfillmentMutation, UpdateFulfillmentMutationVariables>(UpdateFulfillmentDocument, baseOptions);
      }
export type UpdateFulfillmentMutationHookResult = ReturnType<typeof useUpdateFulfillmentMutation>;
export type UpdateFulfillmentMutationResult = ApolloReactCommon.MutationResult<UpdateFulfillmentMutation>;
export type UpdateFulfillmentMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateFulfillmentMutation, UpdateFulfillmentMutationVariables>;
export const DeleteMarketplaceConnectionDocument = gql`
    mutation DeleteMarketplaceConnection($serviceScope: MarketplaceRegion) {
  deleteMarketplaceConnection(serviceScope: $serviceScope) {
    ...SuccessMessageProps
  }
}
    ${SuccessMessagePropsFragmentDoc}`;
export type DeleteMarketplaceConnectionMutationFn = ApolloReactCommon.MutationFunction<DeleteMarketplaceConnectionMutation, DeleteMarketplaceConnectionMutationVariables>;
export type DeleteMarketplaceConnectionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteMarketplaceConnectionMutation, DeleteMarketplaceConnectionMutationVariables>, 'mutation'>;

    export const DeleteMarketplaceConnectionComponent = (props: DeleteMarketplaceConnectionComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteMarketplaceConnectionMutation, DeleteMarketplaceConnectionMutationVariables> mutation={DeleteMarketplaceConnectionDocument} {...props} />
    );
    
export type DeleteMarketplaceConnectionProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeleteMarketplaceConnectionMutation, DeleteMarketplaceConnectionMutationVariables>
    } & TChildProps;
export function withDeleteMarketplaceConnection<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteMarketplaceConnectionMutation,
  DeleteMarketplaceConnectionMutationVariables,
  DeleteMarketplaceConnectionProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteMarketplaceConnectionMutation, DeleteMarketplaceConnectionMutationVariables, DeleteMarketplaceConnectionProps<TChildProps, TDataName>>(DeleteMarketplaceConnectionDocument, {
      alias: 'deleteMarketplaceConnection',
      ...operationOptions
    });
};

/**
 * __useDeleteMarketplaceConnectionMutation__
 *
 * To run a mutation, you first call `useDeleteMarketplaceConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMarketplaceConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMarketplaceConnectionMutation, { data, loading, error }] = useDeleteMarketplaceConnectionMutation({
 *   variables: {
 *      serviceScope: // value for 'serviceScope'
 *   },
 * });
 */
export function useDeleteMarketplaceConnectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteMarketplaceConnectionMutation, DeleteMarketplaceConnectionMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteMarketplaceConnectionMutation, DeleteMarketplaceConnectionMutationVariables>(DeleteMarketplaceConnectionDocument, baseOptions);
      }
export type DeleteMarketplaceConnectionMutationHookResult = ReturnType<typeof useDeleteMarketplaceConnectionMutation>;
export type DeleteMarketplaceConnectionMutationResult = ApolloReactCommon.MutationResult<DeleteMarketplaceConnectionMutation>;
export type DeleteMarketplaceConnectionMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteMarketplaceConnectionMutation, DeleteMarketplaceConnectionMutationVariables>;
export const CredentialsDocument = gql`
    query Credentials($serviceScope: MarketplaceRegion) {
  credentials(serviceScope: $serviceScope)
}
    `;
export type CredentialsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CredentialsQuery, CredentialsQueryVariables>, 'query'>;

    export const CredentialsComponent = (props: CredentialsComponentProps) => (
      <ApolloReactComponents.Query<CredentialsQuery, CredentialsQueryVariables> query={CredentialsDocument} {...props} />
    );
    
export type CredentialsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<CredentialsQuery, CredentialsQueryVariables>
    } & TChildProps;
export function withCredentials<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CredentialsQuery,
  CredentialsQueryVariables,
  CredentialsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, CredentialsQuery, CredentialsQueryVariables, CredentialsProps<TChildProps, TDataName>>(CredentialsDocument, {
      alias: 'credentials',
      ...operationOptions
    });
};

/**
 * __useCredentialsQuery__
 *
 * To run a query within a React component, call `useCredentialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCredentialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCredentialsQuery({
 *   variables: {
 *      serviceScope: // value for 'serviceScope'
 *   },
 * });
 */
export function useCredentialsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CredentialsQuery, CredentialsQueryVariables>) {
        return ApolloReactHooks.useQuery<CredentialsQuery, CredentialsQueryVariables>(CredentialsDocument, baseOptions);
      }
export function useCredentialsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CredentialsQuery, CredentialsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CredentialsQuery, CredentialsQueryVariables>(CredentialsDocument, baseOptions);
        }
export type CredentialsQueryHookResult = ReturnType<typeof useCredentialsQuery>;
export type CredentialsLazyQueryHookResult = ReturnType<typeof useCredentialsLazyQuery>;
export type CredentialsQueryResult = ApolloReactCommon.QueryResult<CredentialsQuery, CredentialsQueryVariables>;
export const GetMarketplacesDocument = gql`
    query GetMarketplaces {
  marketplaces {
    id
    marketplace
    region
    currency
    error
    hidden
    status
    formula {
      add
      multiply
    }
  }
}
    `;
export type GetMarketplacesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetMarketplacesQuery, GetMarketplacesQueryVariables>, 'query'>;

    export const GetMarketplacesComponent = (props: GetMarketplacesComponentProps) => (
      <ApolloReactComponents.Query<GetMarketplacesQuery, GetMarketplacesQueryVariables> query={GetMarketplacesDocument} {...props} />
    );
    
export type GetMarketplacesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetMarketplacesQuery, GetMarketplacesQueryVariables>
    } & TChildProps;
export function withGetMarketplaces<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetMarketplacesQuery,
  GetMarketplacesQueryVariables,
  GetMarketplacesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetMarketplacesQuery, GetMarketplacesQueryVariables, GetMarketplacesProps<TChildProps, TDataName>>(GetMarketplacesDocument, {
      alias: 'getMarketplaces',
      ...operationOptions
    });
};

/**
 * __useGetMarketplacesQuery__
 *
 * To run a query within a React component, call `useGetMarketplacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarketplacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMarketplacesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMarketplacesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMarketplacesQuery, GetMarketplacesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetMarketplacesQuery, GetMarketplacesQueryVariables>(GetMarketplacesDocument, baseOptions);
      }
export function useGetMarketplacesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMarketplacesQuery, GetMarketplacesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetMarketplacesQuery, GetMarketplacesQueryVariables>(GetMarketplacesDocument, baseOptions);
        }
export type GetMarketplacesQueryHookResult = ReturnType<typeof useGetMarketplacesQuery>;
export type GetMarketplacesLazyQueryHookResult = ReturnType<typeof useGetMarketplacesLazyQuery>;
export type GetMarketplacesQueryResult = ApolloReactCommon.QueryResult<GetMarketplacesQuery, GetMarketplacesQueryVariables>;
export const SaveCredentialsDocument = gql`
    mutation SaveCredentials($serviceScope: MarketplaceRegion, $apiBaseUrl: String, $buyerId: String, $supplierId: String, $supplierBranchId: String, $sellerId: String, $refreshToken: String, $username: String, $password: String, $clientId: String, $clientKey: String, $secretKey: String) {
  saveCredentials(
    serviceScope: $serviceScope
    apiBaseUrl: $apiBaseUrl
    buyerId: $buyerId
    supplierId: $supplierId
    supplierBranchId: $supplierBranchId
    sellerId: $sellerId
    refreshToken: $refreshToken
    username: $username
    password: $password
    clientId: $clientId
    clientKey: $clientKey
    secretKey: $secretKey
  )
}
    `;
export type SaveCredentialsMutationFn = ApolloReactCommon.MutationFunction<SaveCredentialsMutation, SaveCredentialsMutationVariables>;
export type SaveCredentialsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<SaveCredentialsMutation, SaveCredentialsMutationVariables>, 'mutation'>;

    export const SaveCredentialsComponent = (props: SaveCredentialsComponentProps) => (
      <ApolloReactComponents.Mutation<SaveCredentialsMutation, SaveCredentialsMutationVariables> mutation={SaveCredentialsDocument} {...props} />
    );
    
export type SaveCredentialsProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<SaveCredentialsMutation, SaveCredentialsMutationVariables>
    } & TChildProps;
export function withSaveCredentials<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SaveCredentialsMutation,
  SaveCredentialsMutationVariables,
  SaveCredentialsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, SaveCredentialsMutation, SaveCredentialsMutationVariables, SaveCredentialsProps<TChildProps, TDataName>>(SaveCredentialsDocument, {
      alias: 'saveCredentials',
      ...operationOptions
    });
};

/**
 * __useSaveCredentialsMutation__
 *
 * To run a mutation, you first call `useSaveCredentialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCredentialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCredentialsMutation, { data, loading, error }] = useSaveCredentialsMutation({
 *   variables: {
 *      serviceScope: // value for 'serviceScope'
 *      apiBaseUrl: // value for 'apiBaseUrl'
 *      buyerId: // value for 'buyerId'
 *      supplierId: // value for 'supplierId'
 *      supplierBranchId: // value for 'supplierBranchId'
 *      sellerId: // value for 'sellerId'
 *      refreshToken: // value for 'refreshToken'
 *      username: // value for 'username'
 *      password: // value for 'password'
 *      clientId: // value for 'clientId'
 *      clientKey: // value for 'clientKey'
 *      secretKey: // value for 'secretKey'
 *   },
 * });
 */
export function useSaveCredentialsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveCredentialsMutation, SaveCredentialsMutationVariables>) {
        return ApolloReactHooks.useMutation<SaveCredentialsMutation, SaveCredentialsMutationVariables>(SaveCredentialsDocument, baseOptions);
      }
export type SaveCredentialsMutationHookResult = ReturnType<typeof useSaveCredentialsMutation>;
export type SaveCredentialsMutationResult = ApolloReactCommon.MutationResult<SaveCredentialsMutation>;
export type SaveCredentialsMutationOptions = ApolloReactCommon.BaseMutationOptions<SaveCredentialsMutation, SaveCredentialsMutationVariables>;
export const UpdateMarketplaceDocument = gql`
    mutation UpdateMarketplace($status: UpdateMwsMarketplaceInputStatus, $marketplace: MarketplaceName!) {
  updateMarketplaceStatus(status: $status, marketplace: $marketplace) {
    id
    marketplace
    region
    currency
    error
    hidden
    status
    formula {
      add
      multiply
    }
  }
}
    `;
export type UpdateMarketplaceMutationFn = ApolloReactCommon.MutationFunction<UpdateMarketplaceMutation, UpdateMarketplaceMutationVariables>;
export type UpdateMarketplaceComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateMarketplaceMutation, UpdateMarketplaceMutationVariables>, 'mutation'>;

    export const UpdateMarketplaceComponent = (props: UpdateMarketplaceComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateMarketplaceMutation, UpdateMarketplaceMutationVariables> mutation={UpdateMarketplaceDocument} {...props} />
    );
    
export type UpdateMarketplaceProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateMarketplaceMutation, UpdateMarketplaceMutationVariables>
    } & TChildProps;
export function withUpdateMarketplace<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateMarketplaceMutation,
  UpdateMarketplaceMutationVariables,
  UpdateMarketplaceProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateMarketplaceMutation, UpdateMarketplaceMutationVariables, UpdateMarketplaceProps<TChildProps, TDataName>>(UpdateMarketplaceDocument, {
      alias: 'updateMarketplace',
      ...operationOptions
    });
};

/**
 * __useUpdateMarketplaceMutation__
 *
 * To run a mutation, you first call `useUpdateMarketplaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMarketplaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMarketplaceMutation, { data, loading, error }] = useUpdateMarketplaceMutation({
 *   variables: {
 *      status: // value for 'status'
 *      marketplace: // value for 'marketplace'
 *   },
 * });
 */
export function useUpdateMarketplaceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateMarketplaceMutation, UpdateMarketplaceMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateMarketplaceMutation, UpdateMarketplaceMutationVariables>(UpdateMarketplaceDocument, baseOptions);
      }
export type UpdateMarketplaceMutationHookResult = ReturnType<typeof useUpdateMarketplaceMutation>;
export type UpdateMarketplaceMutationResult = ApolloReactCommon.MutationResult<UpdateMarketplaceMutation>;
export type UpdateMarketplaceMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateMarketplaceMutation, UpdateMarketplaceMutationVariables>;
export const GetOrdersPageDocument = gql`
    query GetOrdersPage($page: Int, $perPage: Int, $filter: FilterOrdersInput, $sort: [OrdersSortInput], $featureToggleName: EFeatureName!) {
  unshippedOrdersCount
  orders(page: $page, perPage: $perPage, filter: $filter, sort: $sort) {
    items {
      _id
      companyId
      marketplaceOrderId
      totalPrice
      totalDiscount
      shipServiceLevel
      shippingCarrierIdentification
      delivery {
        shippingCarrier
        shippingCarrierService
      }
      currencyCode
      packageLabels
      fulfillmentChannel
      status
      purchaseDate
      marketplace
      isComplete
      invoices {
        url
      }
      isBusinessOrder
      isPremiumOrder
      isRefunded
      shippingPrice
      shipServiceLevel
      deliveryBranchId
      parcelShop {
        parcelShopBranchCode
      }
      marketplaceDeliveryMethod {
        code
        name
      }
      payment {
        cashOnDelivery {
          toPay
          servicePrice
        }
        paymentMethod
      }
      latestShipDate
      selectedShipDate
      items {
        sku
        asin
        quantity
        price
        name
        tax
        marketplaceItemId
        deliveryItemIds
        serialNumbersRequired
      }
      buyer {
        companyName
        name
        city
        addressLine
        countryCode
        zipCode
        taxId
        email
        phone
        stateOrRegion
      }
      deliveryAddress {
        companyName
        name
        city
        addressLine
        countryCode
        zip
        email
        phone
        province
      }
      returnLabels {
        status
        requestCreatedAt
        packageLabelUrls
        errorMessage
        shipmentNumber
        labelNumber
      }
      fulfillment {
        _id
        fulfillmentId
        shipDate
        shipMethod
        trackingNumber
        trackingUrl
        marketplaceOrderIds
        carrier
        carrierName
        status
        lastChanged
        lastConfirmed
        nextRetryAt
        labelGenerationStopped
        labelGenerationContactAlza
        labelGenerationRetryRunId
        syncError
        packages {
          weight
          number
          fullNumber
          items {
            marketplaceItemId
            marketplaceOrderId
            quantity
            serials
          }
        }
      }
      user {
        _id
        email
      }
      autopricingTotal
    }
    pageInfo {
      currentPage
      hasNextPage
      hasPreviousPage
      itemCount
    }
    count
  }
  todayStats: rangedOrdersStatistics(timeRange: today) {
    count
    money {
      currency
      value
    }
  }
  lastThirtyDaysStats: rangedOrdersStatistics(timeRange: lastThirtyDays) {
    count
    money {
      currency
      value
    }
  }
  user {
    _id
    isSuperadmin
  }
  syncSettings {
    _id
    japoId
  }
  bulkConfirmOrdersFeatureToggle: featureToggle(name: $featureToggleName) {
    enabled
  }
  alzaFullnumberFeaturetoggle: featureToggle(name: alza_fullnumber) {
    enabled
  }
}
    `;
export type GetOrdersPageComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetOrdersPageQuery, GetOrdersPageQueryVariables>, 'query'> & ({ variables: GetOrdersPageQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetOrdersPageComponent = (props: GetOrdersPageComponentProps) => (
      <ApolloReactComponents.Query<GetOrdersPageQuery, GetOrdersPageQueryVariables> query={GetOrdersPageDocument} {...props} />
    );
    
export type GetOrdersPageProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetOrdersPageQuery, GetOrdersPageQueryVariables>
    } & TChildProps;
export function withGetOrdersPage<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetOrdersPageQuery,
  GetOrdersPageQueryVariables,
  GetOrdersPageProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetOrdersPageQuery, GetOrdersPageQueryVariables, GetOrdersPageProps<TChildProps, TDataName>>(GetOrdersPageDocument, {
      alias: 'getOrdersPage',
      ...operationOptions
    });
};

/**
 * __useGetOrdersPageQuery__
 *
 * To run a query within a React component, call `useGetOrdersPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrdersPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrdersPageQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      featureToggleName: // value for 'featureToggleName'
 *   },
 * });
 */
export function useGetOrdersPageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetOrdersPageQuery, GetOrdersPageQueryVariables>) {
        return ApolloReactHooks.useQuery<GetOrdersPageQuery, GetOrdersPageQueryVariables>(GetOrdersPageDocument, baseOptions);
      }
export function useGetOrdersPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOrdersPageQuery, GetOrdersPageQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetOrdersPageQuery, GetOrdersPageQueryVariables>(GetOrdersPageDocument, baseOptions);
        }
export type GetOrdersPageQueryHookResult = ReturnType<typeof useGetOrdersPageQuery>;
export type GetOrdersPageLazyQueryHookResult = ReturnType<typeof useGetOrdersPageLazyQuery>;
export type GetOrdersPageQueryResult = ApolloReactCommon.QueryResult<GetOrdersPageQuery, GetOrdersPageQueryVariables>;
export const FindAllByIdsDocument = gql`
    query FindAllByIds($marketplaceOrderIds: [String]!) {
  ordersByIds(marketplaceOrderIds: $marketplaceOrderIds) {
    _id
    items {
      sku
      asin
      quantity
      price
      name
      marketplaceItemId
      deliveryItemIds
      serialNumbersRequired
    }
  }
}
    `;
export type FindAllByIdsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FindAllByIdsQuery, FindAllByIdsQueryVariables>, 'query'> & ({ variables: FindAllByIdsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FindAllByIdsComponent = (props: FindAllByIdsComponentProps) => (
      <ApolloReactComponents.Query<FindAllByIdsQuery, FindAllByIdsQueryVariables> query={FindAllByIdsDocument} {...props} />
    );
    
export type FindAllByIdsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FindAllByIdsQuery, FindAllByIdsQueryVariables>
    } & TChildProps;
export function withFindAllByIds<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FindAllByIdsQuery,
  FindAllByIdsQueryVariables,
  FindAllByIdsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FindAllByIdsQuery, FindAllByIdsQueryVariables, FindAllByIdsProps<TChildProps, TDataName>>(FindAllByIdsDocument, {
      alias: 'findAllByIds',
      ...operationOptions
    });
};

/**
 * __useFindAllByIdsQuery__
 *
 * To run a query within a React component, call `useFindAllByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllByIdsQuery({
 *   variables: {
 *      marketplaceOrderIds: // value for 'marketplaceOrderIds'
 *   },
 * });
 */
export function useFindAllByIdsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FindAllByIdsQuery, FindAllByIdsQueryVariables>) {
        return ApolloReactHooks.useQuery<FindAllByIdsQuery, FindAllByIdsQueryVariables>(FindAllByIdsDocument, baseOptions);
      }
export function useFindAllByIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FindAllByIdsQuery, FindAllByIdsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<FindAllByIdsQuery, FindAllByIdsQueryVariables>(FindAllByIdsDocument, baseOptions);
        }
export type FindAllByIdsQueryHookResult = ReturnType<typeof useFindAllByIdsQuery>;
export type FindAllByIdsLazyQueryHookResult = ReturnType<typeof useFindAllByIdsLazyQuery>;
export type FindAllByIdsQueryResult = ApolloReactCommon.QueryResult<FindAllByIdsQuery, FindAllByIdsQueryVariables>;
export const GetPlatformStatusesDocument = gql`
    query GetPlatformStatuses {
  platformStatuses {
    alza {
      active
      connected
    }
    amazon {
      active
      connected
    }
    mall {
      active
      connected
    }
    real {
      active
      connected
    }
    kaufland {
      active
      connected
    }
    glami {
      active
      connected
    }
  }
  glamiEnabledFeaturetoggle: featureToggle(name: glami_enabled) {
    enabled
  }
  ebayEnabledFeaturetoggle: featureToggle(name: ebay_orders) {
    enabled
  }
}
    `;
export type GetPlatformStatusesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetPlatformStatusesQuery, GetPlatformStatusesQueryVariables>, 'query'>;

    export const GetPlatformStatusesComponent = (props: GetPlatformStatusesComponentProps) => (
      <ApolloReactComponents.Query<GetPlatformStatusesQuery, GetPlatformStatusesQueryVariables> query={GetPlatformStatusesDocument} {...props} />
    );
    
export type GetPlatformStatusesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetPlatformStatusesQuery, GetPlatformStatusesQueryVariables>
    } & TChildProps;
export function withGetPlatformStatuses<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetPlatformStatusesQuery,
  GetPlatformStatusesQueryVariables,
  GetPlatformStatusesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetPlatformStatusesQuery, GetPlatformStatusesQueryVariables, GetPlatformStatusesProps<TChildProps, TDataName>>(GetPlatformStatusesDocument, {
      alias: 'getPlatformStatuses',
      ...operationOptions
    });
};

/**
 * __useGetPlatformStatusesQuery__
 *
 * To run a query within a React component, call `useGetPlatformStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlatformStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlatformStatusesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPlatformStatusesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPlatformStatusesQuery, GetPlatformStatusesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetPlatformStatusesQuery, GetPlatformStatusesQueryVariables>(GetPlatformStatusesDocument, baseOptions);
      }
export function useGetPlatformStatusesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPlatformStatusesQuery, GetPlatformStatusesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetPlatformStatusesQuery, GetPlatformStatusesQueryVariables>(GetPlatformStatusesDocument, baseOptions);
        }
export type GetPlatformStatusesQueryHookResult = ReturnType<typeof useGetPlatformStatusesQuery>;
export type GetPlatformStatusesLazyQueryHookResult = ReturnType<typeof useGetPlatformStatusesLazyQuery>;
export type GetPlatformStatusesQueryResult = ApolloReactCommon.QueryResult<GetPlatformStatusesQuery, GetPlatformStatusesQueryVariables>;
export const CountProductVariantsDocument = gql`
    mutation CountProductVariants {
  countProductVariants
}
    `;
export type CountProductVariantsMutationFn = ApolloReactCommon.MutationFunction<CountProductVariantsMutation, CountProductVariantsMutationVariables>;
export type CountProductVariantsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CountProductVariantsMutation, CountProductVariantsMutationVariables>, 'mutation'>;

    export const CountProductVariantsComponent = (props: CountProductVariantsComponentProps) => (
      <ApolloReactComponents.Mutation<CountProductVariantsMutation, CountProductVariantsMutationVariables> mutation={CountProductVariantsDocument} {...props} />
    );
    
export type CountProductVariantsProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CountProductVariantsMutation, CountProductVariantsMutationVariables>
    } & TChildProps;
export function withCountProductVariants<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CountProductVariantsMutation,
  CountProductVariantsMutationVariables,
  CountProductVariantsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CountProductVariantsMutation, CountProductVariantsMutationVariables, CountProductVariantsProps<TChildProps, TDataName>>(CountProductVariantsDocument, {
      alias: 'countProductVariants',
      ...operationOptions
    });
};

/**
 * __useCountProductVariantsMutation__
 *
 * To run a mutation, you first call `useCountProductVariantsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCountProductVariantsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [countProductVariantsMutation, { data, loading, error }] = useCountProductVariantsMutation({
 *   variables: {
 *   },
 * });
 */
export function useCountProductVariantsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CountProductVariantsMutation, CountProductVariantsMutationVariables>) {
        return ApolloReactHooks.useMutation<CountProductVariantsMutation, CountProductVariantsMutationVariables>(CountProductVariantsDocument, baseOptions);
      }
export type CountProductVariantsMutationHookResult = ReturnType<typeof useCountProductVariantsMutation>;
export type CountProductVariantsMutationResult = ApolloReactCommon.MutationResult<CountProductVariantsMutation>;
export type CountProductVariantsMutationOptions = ApolloReactCommon.BaseMutationOptions<CountProductVariantsMutation, CountProductVariantsMutationVariables>;
export const ExportProductsDocument = gql`
    mutation ExportProducts($filter: FilterInputProducts, $sort: [ProductsSortInput]) {
  exportProducts(filter: $filter, sort: $sort) {
    _id
    status
    requestedAt
  }
}
    `;
export type ExportProductsMutationFn = ApolloReactCommon.MutationFunction<ExportProductsMutation, ExportProductsMutationVariables>;
export type ExportProductsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ExportProductsMutation, ExportProductsMutationVariables>, 'mutation'>;

    export const ExportProductsComponent = (props: ExportProductsComponentProps) => (
      <ApolloReactComponents.Mutation<ExportProductsMutation, ExportProductsMutationVariables> mutation={ExportProductsDocument} {...props} />
    );
    
export type ExportProductsProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<ExportProductsMutation, ExportProductsMutationVariables>
    } & TChildProps;
export function withExportProducts<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ExportProductsMutation,
  ExportProductsMutationVariables,
  ExportProductsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, ExportProductsMutation, ExportProductsMutationVariables, ExportProductsProps<TChildProps, TDataName>>(ExportProductsDocument, {
      alias: 'exportProducts',
      ...operationOptions
    });
};

/**
 * __useExportProductsMutation__
 *
 * To run a mutation, you first call `useExportProductsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportProductsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportProductsMutation, { data, loading, error }] = useExportProductsMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useExportProductsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ExportProductsMutation, ExportProductsMutationVariables>) {
        return ApolloReactHooks.useMutation<ExportProductsMutation, ExportProductsMutationVariables>(ExportProductsDocument, baseOptions);
      }
export type ExportProductsMutationHookResult = ReturnType<typeof useExportProductsMutation>;
export type ExportProductsMutationResult = ApolloReactCommon.MutationResult<ExportProductsMutation>;
export type ExportProductsMutationOptions = ApolloReactCommon.BaseMutationOptions<ExportProductsMutation, ExportProductsMutationVariables>;
export const GetProductExportDocument = gql`
    query GetProductExport($exportId: String!) {
  productExport(exportId: $exportId) {
    _id
    status
    requestedAt
    doneAt
    failedAt
    downloadLink
  }
}
    `;
export type GetProductExportComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetProductExportQuery, GetProductExportQueryVariables>, 'query'> & ({ variables: GetProductExportQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetProductExportComponent = (props: GetProductExportComponentProps) => (
      <ApolloReactComponents.Query<GetProductExportQuery, GetProductExportQueryVariables> query={GetProductExportDocument} {...props} />
    );
    
export type GetProductExportProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetProductExportQuery, GetProductExportQueryVariables>
    } & TChildProps;
export function withGetProductExport<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetProductExportQuery,
  GetProductExportQueryVariables,
  GetProductExportProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetProductExportQuery, GetProductExportQueryVariables, GetProductExportProps<TChildProps, TDataName>>(GetProductExportDocument, {
      alias: 'getProductExport',
      ...operationOptions
    });
};

/**
 * __useGetProductExportQuery__
 *
 * To run a query within a React component, call `useGetProductExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductExportQuery({
 *   variables: {
 *      exportId: // value for 'exportId'
 *   },
 * });
 */
export function useGetProductExportQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetProductExportQuery, GetProductExportQueryVariables>) {
        return ApolloReactHooks.useQuery<GetProductExportQuery, GetProductExportQueryVariables>(GetProductExportDocument, baseOptions);
      }
export function useGetProductExportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProductExportQuery, GetProductExportQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetProductExportQuery, GetProductExportQueryVariables>(GetProductExportDocument, baseOptions);
        }
export type GetProductExportQueryHookResult = ReturnType<typeof useGetProductExportQuery>;
export type GetProductExportLazyQueryHookResult = ReturnType<typeof useGetProductExportLazyQuery>;
export type GetProductExportQueryResult = ApolloReactCommon.QueryResult<GetProductExportQuery, GetProductExportQueryVariables>;
export const GetProductExportsDocument = gql`
    query GetProductExports {
  productExports {
    _id
    status
    requestedAt
    doneAt
    failedAt
    downloadLink
  }
}
    `;
export type GetProductExportsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetProductExportsQuery, GetProductExportsQueryVariables>, 'query'>;

    export const GetProductExportsComponent = (props: GetProductExportsComponentProps) => (
      <ApolloReactComponents.Query<GetProductExportsQuery, GetProductExportsQueryVariables> query={GetProductExportsDocument} {...props} />
    );
    
export type GetProductExportsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetProductExportsQuery, GetProductExportsQueryVariables>
    } & TChildProps;
export function withGetProductExports<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetProductExportsQuery,
  GetProductExportsQueryVariables,
  GetProductExportsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetProductExportsQuery, GetProductExportsQueryVariables, GetProductExportsProps<TChildProps, TDataName>>(GetProductExportsDocument, {
      alias: 'getProductExports',
      ...operationOptions
    });
};

/**
 * __useGetProductExportsQuery__
 *
 * To run a query within a React component, call `useGetProductExportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductExportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductExportsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProductExportsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetProductExportsQuery, GetProductExportsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetProductExportsQuery, GetProductExportsQueryVariables>(GetProductExportsDocument, baseOptions);
      }
export function useGetProductExportsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProductExportsQuery, GetProductExportsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetProductExportsQuery, GetProductExportsQueryVariables>(GetProductExportsDocument, baseOptions);
        }
export type GetProductExportsQueryHookResult = ReturnType<typeof useGetProductExportsQuery>;
export type GetProductExportsLazyQueryHookResult = ReturnType<typeof useGetProductExportsLazyQuery>;
export type GetProductExportsQueryResult = ApolloReactCommon.QueryResult<GetProductExportsQuery, GetProductExportsQueryVariables>;
export const GetItemConditionsDocument = gql`
    query GetItemConditions($service: String!) {
  getItemConditionList(service: $service) {
    isDefault
    itemCondition
    itemConditionCode
    itemNote
  }
}
    `;
export type GetItemConditionsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetItemConditionsQuery, GetItemConditionsQueryVariables>, 'query'> & ({ variables: GetItemConditionsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetItemConditionsComponent = (props: GetItemConditionsComponentProps) => (
      <ApolloReactComponents.Query<GetItemConditionsQuery, GetItemConditionsQueryVariables> query={GetItemConditionsDocument} {...props} />
    );
    
export type GetItemConditionsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetItemConditionsQuery, GetItemConditionsQueryVariables>
    } & TChildProps;
export function withGetItemConditions<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetItemConditionsQuery,
  GetItemConditionsQueryVariables,
  GetItemConditionsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetItemConditionsQuery, GetItemConditionsQueryVariables, GetItemConditionsProps<TChildProps, TDataName>>(GetItemConditionsDocument, {
      alias: 'getItemConditions',
      ...operationOptions
    });
};

/**
 * __useGetItemConditionsQuery__
 *
 * To run a query within a React component, call `useGetItemConditionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetItemConditionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetItemConditionsQuery({
 *   variables: {
 *      service: // value for 'service'
 *   },
 * });
 */
export function useGetItemConditionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetItemConditionsQuery, GetItemConditionsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetItemConditionsQuery, GetItemConditionsQueryVariables>(GetItemConditionsDocument, baseOptions);
      }
export function useGetItemConditionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetItemConditionsQuery, GetItemConditionsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetItemConditionsQuery, GetItemConditionsQueryVariables>(GetItemConditionsDocument, baseOptions);
        }
export type GetItemConditionsQueryHookResult = ReturnType<typeof useGetItemConditionsQuery>;
export type GetItemConditionsLazyQueryHookResult = ReturnType<typeof useGetItemConditionsLazyQuery>;
export type GetItemConditionsQueryResult = ApolloReactCommon.QueryResult<GetItemConditionsQuery, GetItemConditionsQueryVariables>;
export const GetProductStatsDocument = gql`
    query GetProductStats($marketplace: String, $hasStockFilter: Boolean) {
  productStats(marketplace: $marketplace, hasStockFilter: $hasStockFilter) {
    marketplaces
    ok
    paused
    notFound
    error
    missingBarcode
  }
}
    `;
export type GetProductStatsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetProductStatsQuery, GetProductStatsQueryVariables>, 'query'>;

    export const GetProductStatsComponent = (props: GetProductStatsComponentProps) => (
      <ApolloReactComponents.Query<GetProductStatsQuery, GetProductStatsQueryVariables> query={GetProductStatsDocument} {...props} />
    );
    
export type GetProductStatsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetProductStatsQuery, GetProductStatsQueryVariables>
    } & TChildProps;
export function withGetProductStats<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetProductStatsQuery,
  GetProductStatsQueryVariables,
  GetProductStatsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetProductStatsQuery, GetProductStatsQueryVariables, GetProductStatsProps<TChildProps, TDataName>>(GetProductStatsDocument, {
      alias: 'getProductStats',
      ...operationOptions
    });
};

/**
 * __useGetProductStatsQuery__
 *
 * To run a query within a React component, call `useGetProductStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductStatsQuery({
 *   variables: {
 *      marketplace: // value for 'marketplace'
 *      hasStockFilter: // value for 'hasStockFilter'
 *   },
 * });
 */
export function useGetProductStatsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetProductStatsQuery, GetProductStatsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetProductStatsQuery, GetProductStatsQueryVariables>(GetProductStatsDocument, baseOptions);
      }
export function useGetProductStatsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProductStatsQuery, GetProductStatsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetProductStatsQuery, GetProductStatsQueryVariables>(GetProductStatsDocument, baseOptions);
        }
export type GetProductStatsQueryHookResult = ReturnType<typeof useGetProductStatsQuery>;
export type GetProductStatsLazyQueryHookResult = ReturnType<typeof useGetProductStatsLazyQuery>;
export type GetProductStatsQueryResult = ApolloReactCommon.QueryResult<GetProductStatsQuery, GetProductStatsQueryVariables>;
export const ImportProductVariantsDocument = gql`
    mutation ImportProductVariants($products: [ProductVariantInput]!) {
  uploadProductVariants(products: $products)
}
    `;
export type ImportProductVariantsMutationFn = ApolloReactCommon.MutationFunction<ImportProductVariantsMutation, ImportProductVariantsMutationVariables>;
export type ImportProductVariantsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ImportProductVariantsMutation, ImportProductVariantsMutationVariables>, 'mutation'>;

    export const ImportProductVariantsComponent = (props: ImportProductVariantsComponentProps) => (
      <ApolloReactComponents.Mutation<ImportProductVariantsMutation, ImportProductVariantsMutationVariables> mutation={ImportProductVariantsDocument} {...props} />
    );
    
export type ImportProductVariantsProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<ImportProductVariantsMutation, ImportProductVariantsMutationVariables>
    } & TChildProps;
export function withImportProductVariants<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ImportProductVariantsMutation,
  ImportProductVariantsMutationVariables,
  ImportProductVariantsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, ImportProductVariantsMutation, ImportProductVariantsMutationVariables, ImportProductVariantsProps<TChildProps, TDataName>>(ImportProductVariantsDocument, {
      alias: 'importProductVariants',
      ...operationOptions
    });
};

/**
 * __useImportProductVariantsMutation__
 *
 * To run a mutation, you first call `useImportProductVariantsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportProductVariantsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importProductVariantsMutation, { data, loading, error }] = useImportProductVariantsMutation({
 *   variables: {
 *      products: // value for 'products'
 *   },
 * });
 */
export function useImportProductVariantsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ImportProductVariantsMutation, ImportProductVariantsMutationVariables>) {
        return ApolloReactHooks.useMutation<ImportProductVariantsMutation, ImportProductVariantsMutationVariables>(ImportProductVariantsDocument, baseOptions);
      }
export type ImportProductVariantsMutationHookResult = ReturnType<typeof useImportProductVariantsMutation>;
export type ImportProductVariantsMutationResult = ApolloReactCommon.MutationResult<ImportProductVariantsMutation>;
export type ImportProductVariantsMutationOptions = ApolloReactCommon.BaseMutationOptions<ImportProductVariantsMutation, ImportProductVariantsMutationVariables>;
export const UpdateProductVariantsDocument = gql`
    mutation UpdateProductVariants($products: [ProductVariantInput]!) {
  updateProductVariant(products: $products) {
    id
    sku
    stock
    asins {
      amazon_de
      amazon_uk
      amazon_nl
      amazon_it
      amazon_fr
      amazon_es
      amazon_mx
      amazon_us
      amazon_ca
      amazon_br
      amazon_jp
      amazon_au
      amazon_se
      amazon_tr
      amazon_pl
      amazon_be
      amazon_ie
      amazon_sg
    }
    barcode {
      type
      code
    }
    locks
    prices {
      amazon_de {
        selling
      }
      amazon_uk {
        selling
      }
      amazon_nl {
        selling
      }
      amazon_it {
        selling
      }
      amazon_fr {
        selling
      }
      amazon_es {
        selling
      }
      amazon_mx {
        selling
      }
      amazon_us {
        selling
      }
      amazon_ca {
        selling
      }
      amazon_br {
        selling
      }
      amazon_jp {
        selling
      }
      amazon_au {
        selling
      }
      amazon_se {
        selling
      }
      amazon_tr {
        selling
      }
      amazon_pl {
        selling
      }
      amazon_be {
        selling
      }
      amazon_ie {
        selling
      }
      amazon_sg {
        selling
      }
      mall_cz {
        selling
      }
      mall_pl {
        selling
      }
      mall_si {
        selling
      }
      mall_hu {
        selling
      }
      mall_sk {
        selling
      }
      alza_cz {
        selling
      }
      emag_pl {
        selling
      }
      emag_hu {
        selling
      }
      emag_ro {
        selling
      }
      emag_bg {
        selling
      }
      real_de {
        selling
      }
      kaufland_de {
        selling
      }
      kaufland_cz {
        selling
      }
      kaufland_sk {
        selling
      }
      kaufland_at {
        selling
      }
      kaufland_pl {
        selling
      }
      kaufland_nl {
        selling
      }
      kaufland_es {
        selling
      }
      kaufland_fr {
        selling
      }
      kaufland_it {
        selling
      }
      cdiscount_fr {
        selling
      }
    }
  }
}
    `;
export type UpdateProductVariantsMutationFn = ApolloReactCommon.MutationFunction<UpdateProductVariantsMutation, UpdateProductVariantsMutationVariables>;
export type UpdateProductVariantsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateProductVariantsMutation, UpdateProductVariantsMutationVariables>, 'mutation'>;

    export const UpdateProductVariantsComponent = (props: UpdateProductVariantsComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateProductVariantsMutation, UpdateProductVariantsMutationVariables> mutation={UpdateProductVariantsDocument} {...props} />
    );
    
export type UpdateProductVariantsProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateProductVariantsMutation, UpdateProductVariantsMutationVariables>
    } & TChildProps;
export function withUpdateProductVariants<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateProductVariantsMutation,
  UpdateProductVariantsMutationVariables,
  UpdateProductVariantsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateProductVariantsMutation, UpdateProductVariantsMutationVariables, UpdateProductVariantsProps<TChildProps, TDataName>>(UpdateProductVariantsDocument, {
      alias: 'updateProductVariants',
      ...operationOptions
    });
};

/**
 * __useUpdateProductVariantsMutation__
 *
 * To run a mutation, you first call `useUpdateProductVariantsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductVariantsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductVariantsMutation, { data, loading, error }] = useUpdateProductVariantsMutation({
 *   variables: {
 *      products: // value for 'products'
 *   },
 * });
 */
export function useUpdateProductVariantsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateProductVariantsMutation, UpdateProductVariantsMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateProductVariantsMutation, UpdateProductVariantsMutationVariables>(UpdateProductVariantsDocument, baseOptions);
      }
export type UpdateProductVariantsMutationHookResult = ReturnType<typeof useUpdateProductVariantsMutation>;
export type UpdateProductVariantsMutationResult = ApolloReactCommon.MutationResult<UpdateProductVariantsMutation>;
export type UpdateProductVariantsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateProductVariantsMutation, UpdateProductVariantsMutationVariables>;
export const GetPricingReportDocument = gql`
    query GetPricingReport($id: String) {
  getPricingReport(id: $id) {
    id
    state
    result {
      reportLink
    }
  }
}
    `;
export type GetPricingReportComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetPricingReportQuery, GetPricingReportQueryVariables>, 'query'>;

    export const GetPricingReportComponent = (props: GetPricingReportComponentProps) => (
      <ApolloReactComponents.Query<GetPricingReportQuery, GetPricingReportQueryVariables> query={GetPricingReportDocument} {...props} />
    );
    
export type GetPricingReportProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetPricingReportQuery, GetPricingReportQueryVariables>
    } & TChildProps;
export function withGetPricingReport<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetPricingReportQuery,
  GetPricingReportQueryVariables,
  GetPricingReportProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetPricingReportQuery, GetPricingReportQueryVariables, GetPricingReportProps<TChildProps, TDataName>>(GetPricingReportDocument, {
      alias: 'getPricingReport',
      ...operationOptions
    });
};

/**
 * __useGetPricingReportQuery__
 *
 * To run a query within a React component, call `useGetPricingReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPricingReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPricingReportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPricingReportQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPricingReportQuery, GetPricingReportQueryVariables>) {
        return ApolloReactHooks.useQuery<GetPricingReportQuery, GetPricingReportQueryVariables>(GetPricingReportDocument, baseOptions);
      }
export function useGetPricingReportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPricingReportQuery, GetPricingReportQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetPricingReportQuery, GetPricingReportQueryVariables>(GetPricingReportDocument, baseOptions);
        }
export type GetPricingReportQueryHookResult = ReturnType<typeof useGetPricingReportQuery>;
export type GetPricingReportLazyQueryHookResult = ReturnType<typeof useGetPricingReportLazyQuery>;
export type GetPricingReportQueryResult = ApolloReactCommon.QueryResult<GetPricingReportQuery, GetPricingReportQueryVariables>;
export const RequestPricingReportDocument = gql`
    mutation RequestPricingReport($service: MarketplaceName) {
  requestPricingReport(service: $service) {
    id
    state
  }
}
    `;
export type RequestPricingReportMutationFn = ApolloReactCommon.MutationFunction<RequestPricingReportMutation, RequestPricingReportMutationVariables>;
export type RequestPricingReportComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<RequestPricingReportMutation, RequestPricingReportMutationVariables>, 'mutation'>;

    export const RequestPricingReportComponent = (props: RequestPricingReportComponentProps) => (
      <ApolloReactComponents.Mutation<RequestPricingReportMutation, RequestPricingReportMutationVariables> mutation={RequestPricingReportDocument} {...props} />
    );
    
export type RequestPricingReportProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<RequestPricingReportMutation, RequestPricingReportMutationVariables>
    } & TChildProps;
export function withRequestPricingReport<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RequestPricingReportMutation,
  RequestPricingReportMutationVariables,
  RequestPricingReportProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RequestPricingReportMutation, RequestPricingReportMutationVariables, RequestPricingReportProps<TChildProps, TDataName>>(RequestPricingReportDocument, {
      alias: 'requestPricingReport',
      ...operationOptions
    });
};

/**
 * __useRequestPricingReportMutation__
 *
 * To run a mutation, you first call `useRequestPricingReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPricingReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestPricingReportMutation, { data, loading, error }] = useRequestPricingReportMutation({
 *   variables: {
 *      service: // value for 'service'
 *   },
 * });
 */
export function useRequestPricingReportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RequestPricingReportMutation, RequestPricingReportMutationVariables>) {
        return ApolloReactHooks.useMutation<RequestPricingReportMutation, RequestPricingReportMutationVariables>(RequestPricingReportDocument, baseOptions);
      }
export type RequestPricingReportMutationHookResult = ReturnType<typeof useRequestPricingReportMutation>;
export type RequestPricingReportMutationResult = ApolloReactCommon.MutationResult<RequestPricingReportMutation>;
export type RequestPricingReportMutationOptions = ApolloReactCommon.BaseMutationOptions<RequestPricingReportMutation, RequestPricingReportMutationVariables>;
export const GetShipmentInfoDocument = gql`
    query GetShipmentInfo($shipmentNumbers: [String!]) {
  getShipmentInfo(shipmentNumbers: $shipmentNumbers) {
    shipments {
      shipmentNumber
      externalShipmentNumber
      shipmentStateName
      shipmentStateDate
    }
  }
}
    `;
export type GetShipmentInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetShipmentInfoQuery, GetShipmentInfoQueryVariables>, 'query'>;

    export const GetShipmentInfoComponent = (props: GetShipmentInfoComponentProps) => (
      <ApolloReactComponents.Query<GetShipmentInfoQuery, GetShipmentInfoQueryVariables> query={GetShipmentInfoDocument} {...props} />
    );
    
export type GetShipmentInfoProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetShipmentInfoQuery, GetShipmentInfoQueryVariables>
    } & TChildProps;
export function withGetShipmentInfo<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetShipmentInfoQuery,
  GetShipmentInfoQueryVariables,
  GetShipmentInfoProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetShipmentInfoQuery, GetShipmentInfoQueryVariables, GetShipmentInfoProps<TChildProps, TDataName>>(GetShipmentInfoDocument, {
      alias: 'getShipmentInfo',
      ...operationOptions
    });
};

/**
 * __useGetShipmentInfoQuery__
 *
 * To run a query within a React component, call `useGetShipmentInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShipmentInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShipmentInfoQuery({
 *   variables: {
 *      shipmentNumbers: // value for 'shipmentNumbers'
 *   },
 * });
 */
export function useGetShipmentInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetShipmentInfoQuery, GetShipmentInfoQueryVariables>) {
        return ApolloReactHooks.useQuery<GetShipmentInfoQuery, GetShipmentInfoQueryVariables>(GetShipmentInfoDocument, baseOptions);
      }
export function useGetShipmentInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetShipmentInfoQuery, GetShipmentInfoQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetShipmentInfoQuery, GetShipmentInfoQueryVariables>(GetShipmentInfoDocument, baseOptions);
        }
export type GetShipmentInfoQueryHookResult = ReturnType<typeof useGetShipmentInfoQuery>;
export type GetShipmentInfoLazyQueryHookResult = ReturnType<typeof useGetShipmentInfoLazyQuery>;
export type GetShipmentInfoQueryResult = ApolloReactCommon.QueryResult<GetShipmentInfoQuery, GetShipmentInfoQueryVariables>;
export const ShoptetFullSyncDocument = gql`
    mutation ShoptetFullSync {
  shoptetFullSync {
    success
    message
    error
  }
}
    `;
export type ShoptetFullSyncMutationFn = ApolloReactCommon.MutationFunction<ShoptetFullSyncMutation, ShoptetFullSyncMutationVariables>;
export type ShoptetFullSyncComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ShoptetFullSyncMutation, ShoptetFullSyncMutationVariables>, 'mutation'>;

    export const ShoptetFullSyncComponent = (props: ShoptetFullSyncComponentProps) => (
      <ApolloReactComponents.Mutation<ShoptetFullSyncMutation, ShoptetFullSyncMutationVariables> mutation={ShoptetFullSyncDocument} {...props} />
    );
    
export type ShoptetFullSyncProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<ShoptetFullSyncMutation, ShoptetFullSyncMutationVariables>
    } & TChildProps;
export function withShoptetFullSync<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ShoptetFullSyncMutation,
  ShoptetFullSyncMutationVariables,
  ShoptetFullSyncProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, ShoptetFullSyncMutation, ShoptetFullSyncMutationVariables, ShoptetFullSyncProps<TChildProps, TDataName>>(ShoptetFullSyncDocument, {
      alias: 'shoptetFullSync',
      ...operationOptions
    });
};

/**
 * __useShoptetFullSyncMutation__
 *
 * To run a mutation, you first call `useShoptetFullSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShoptetFullSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shoptetFullSyncMutation, { data, loading, error }] = useShoptetFullSyncMutation({
 *   variables: {
 *   },
 * });
 */
export function useShoptetFullSyncMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ShoptetFullSyncMutation, ShoptetFullSyncMutationVariables>) {
        return ApolloReactHooks.useMutation<ShoptetFullSyncMutation, ShoptetFullSyncMutationVariables>(ShoptetFullSyncDocument, baseOptions);
      }
export type ShoptetFullSyncMutationHookResult = ReturnType<typeof useShoptetFullSyncMutation>;
export type ShoptetFullSyncMutationResult = ApolloReactCommon.MutationResult<ShoptetFullSyncMutation>;
export type ShoptetFullSyncMutationOptions = ApolloReactCommon.BaseMutationOptions<ShoptetFullSyncMutation, ShoptetFullSyncMutationVariables>;
export const GetShopInfoDocument = gql`
    query GetShopInfo {
  shopInfo {
    shopId
    hostname
    addons {
      mall {
        active
      }
      amazon {
        active
      }
      alza {
        active
      }
      kaufland {
        active
      }
    }
  }
}
    `;
export type GetShopInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetShopInfoQuery, GetShopInfoQueryVariables>, 'query'>;

    export const GetShopInfoComponent = (props: GetShopInfoComponentProps) => (
      <ApolloReactComponents.Query<GetShopInfoQuery, GetShopInfoQueryVariables> query={GetShopInfoDocument} {...props} />
    );
    
export type GetShopInfoProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetShopInfoQuery, GetShopInfoQueryVariables>
    } & TChildProps;
export function withGetShopInfo<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetShopInfoQuery,
  GetShopInfoQueryVariables,
  GetShopInfoProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetShopInfoQuery, GetShopInfoQueryVariables, GetShopInfoProps<TChildProps, TDataName>>(GetShopInfoDocument, {
      alias: 'getShopInfo',
      ...operationOptions
    });
};

/**
 * __useGetShopInfoQuery__
 *
 * To run a query within a React component, call `useGetShopInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShopInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShopInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetShopInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetShopInfoQuery, GetShopInfoQueryVariables>) {
        return ApolloReactHooks.useQuery<GetShopInfoQuery, GetShopInfoQueryVariables>(GetShopInfoDocument, baseOptions);
      }
export function useGetShopInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetShopInfoQuery, GetShopInfoQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetShopInfoQuery, GetShopInfoQueryVariables>(GetShopInfoDocument, baseOptions);
        }
export type GetShopInfoQueryHookResult = ReturnType<typeof useGetShopInfoQuery>;
export type GetShopInfoLazyQueryHookResult = ReturnType<typeof useGetShopInfoLazyQuery>;
export type GetShopInfoQueryResult = ApolloReactCommon.QueryResult<GetShopInfoQuery, GetShopInfoQueryVariables>;
export const GetUserDocument = gql`
    query GetUser {
  user {
    _id
    email
    name
    isSuperadmin
    isConfirmed
    daysLeftToConfirm
    tos {
      acceptedAt
      acceptedIpAddress
      version
    }
    roles {
      companyId
    }
  }
}
    `;
export type GetUserComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetUserQuery, GetUserQueryVariables>, 'query'>;

    export const GetUserComponent = (props: GetUserComponentProps) => (
      <ApolloReactComponents.Query<GetUserQuery, GetUserQueryVariables> query={GetUserDocument} {...props} />
    );
    
export type GetUserProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetUserQuery, GetUserQueryVariables>
    } & TChildProps;
export function withGetUser<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetUserQuery,
  GetUserQueryVariables,
  GetUserProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetUserQuery, GetUserQueryVariables, GetUserProps<TChildProps, TDataName>>(GetUserDocument, {
      alias: 'getUser',
      ...operationOptions
    });
};

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
        return ApolloReactHooks.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, baseOptions);
      }
export function useGetUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, baseOptions);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserQueryResult = ApolloReactCommon.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const GetUserCompanyDocument = gql`
    query GetUserCompany {
  company {
    _id
    name
    feedType
    onboardingState
    isOnboarding
  }
}
    `;
export type GetUserCompanyComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetUserCompanyQuery, GetUserCompanyQueryVariables>, 'query'>;

    export const GetUserCompanyComponent = (props: GetUserCompanyComponentProps) => (
      <ApolloReactComponents.Query<GetUserCompanyQuery, GetUserCompanyQueryVariables> query={GetUserCompanyDocument} {...props} />
    );
    
export type GetUserCompanyProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetUserCompanyQuery, GetUserCompanyQueryVariables>
    } & TChildProps;
export function withGetUserCompany<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetUserCompanyQuery,
  GetUserCompanyQueryVariables,
  GetUserCompanyProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetUserCompanyQuery, GetUserCompanyQueryVariables, GetUserCompanyProps<TChildProps, TDataName>>(GetUserCompanyDocument, {
      alias: 'getUserCompany',
      ...operationOptions
    });
};

/**
 * __useGetUserCompanyQuery__
 *
 * To run a query within a React component, call `useGetUserCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserCompanyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserCompanyQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUserCompanyQuery, GetUserCompanyQueryVariables>) {
        return ApolloReactHooks.useQuery<GetUserCompanyQuery, GetUserCompanyQueryVariables>(GetUserCompanyDocument, baseOptions);
      }
export function useGetUserCompanyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserCompanyQuery, GetUserCompanyQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetUserCompanyQuery, GetUserCompanyQueryVariables>(GetUserCompanyDocument, baseOptions);
        }
export type GetUserCompanyQueryHookResult = ReturnType<typeof useGetUserCompanyQuery>;
export type GetUserCompanyLazyQueryHookResult = ReturnType<typeof useGetUserCompanyLazyQuery>;
export type GetUserCompanyQueryResult = ApolloReactCommon.QueryResult<GetUserCompanyQuery, GetUserCompanyQueryVariables>;
export const GetUserFeaturesDocument = gql`
    query GetUserFeatures {
  featureToggleList {
    pass
    block
  }
}
    `;
export type GetUserFeaturesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetUserFeaturesQuery, GetUserFeaturesQueryVariables>, 'query'>;

    export const GetUserFeaturesComponent = (props: GetUserFeaturesComponentProps) => (
      <ApolloReactComponents.Query<GetUserFeaturesQuery, GetUserFeaturesQueryVariables> query={GetUserFeaturesDocument} {...props} />
    );
    
export type GetUserFeaturesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetUserFeaturesQuery, GetUserFeaturesQueryVariables>
    } & TChildProps;
export function withGetUserFeatures<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetUserFeaturesQuery,
  GetUserFeaturesQueryVariables,
  GetUserFeaturesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetUserFeaturesQuery, GetUserFeaturesQueryVariables, GetUserFeaturesProps<TChildProps, TDataName>>(GetUserFeaturesDocument, {
      alias: 'getUserFeatures',
      ...operationOptions
    });
};

/**
 * __useGetUserFeaturesQuery__
 *
 * To run a query within a React component, call `useGetUserFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserFeaturesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserFeaturesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUserFeaturesQuery, GetUserFeaturesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetUserFeaturesQuery, GetUserFeaturesQueryVariables>(GetUserFeaturesDocument, baseOptions);
      }
export function useGetUserFeaturesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserFeaturesQuery, GetUserFeaturesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetUserFeaturesQuery, GetUserFeaturesQueryVariables>(GetUserFeaturesDocument, baseOptions);
        }
export type GetUserFeaturesQueryHookResult = ReturnType<typeof useGetUserFeaturesQuery>;
export type GetUserFeaturesLazyQueryHookResult = ReturnType<typeof useGetUserFeaturesLazyQuery>;
export type GetUserFeaturesQueryResult = ApolloReactCommon.QueryResult<GetUserFeaturesQuery, GetUserFeaturesQueryVariables>;
export const UpdateToSDocument = gql`
    mutation UpdateToS($update: UserInput!) {
  updateUser(user: $update) {
    _id
    tos {
      acceptedAt
      version
    }
  }
}
    `;
export type UpdateToSMutationFn = ApolloReactCommon.MutationFunction<UpdateToSMutation, UpdateToSMutationVariables>;
export type UpdateToSComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateToSMutation, UpdateToSMutationVariables>, 'mutation'>;

    export const UpdateToSComponent = (props: UpdateToSComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateToSMutation, UpdateToSMutationVariables> mutation={UpdateToSDocument} {...props} />
    );
    
export type UpdateToSProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateToSMutation, UpdateToSMutationVariables>
    } & TChildProps;
export function withUpdateToS<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateToSMutation,
  UpdateToSMutationVariables,
  UpdateToSProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateToSMutation, UpdateToSMutationVariables, UpdateToSProps<TChildProps, TDataName>>(UpdateToSDocument, {
      alias: 'updateToS',
      ...operationOptions
    });
};

/**
 * __useUpdateToSMutation__
 *
 * To run a mutation, you first call `useUpdateToSMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateToSMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateToSMutation, { data, loading, error }] = useUpdateToSMutation({
 *   variables: {
 *      update: // value for 'update'
 *   },
 * });
 */
export function useUpdateToSMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateToSMutation, UpdateToSMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateToSMutation, UpdateToSMutationVariables>(UpdateToSDocument, baseOptions);
      }
export type UpdateToSMutationHookResult = ReturnType<typeof useUpdateToSMutation>;
export type UpdateToSMutationResult = ApolloReactCommon.MutationResult<UpdateToSMutation>;
export type UpdateToSMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateToSMutation, UpdateToSMutationVariables>;
export const userStatsDocument = gql`
    query userStats {
  userStats {
    username
    companyId
  }
}
    `;
export type userStatsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<userStatsQuery, userStatsQueryVariables>, 'query'>;

    export const userStatsComponent = (props: userStatsComponentProps) => (
      <ApolloReactComponents.Query<userStatsQuery, userStatsQueryVariables> query={userStatsDocument} {...props} />
    );
    
export type userStatsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<userStatsQuery, userStatsQueryVariables>
    } & TChildProps;
export function withuserStats<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  userStatsQuery,
  userStatsQueryVariables,
  userStatsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, userStatsQuery, userStatsQueryVariables, userStatsProps<TChildProps, TDataName>>(userStatsDocument, {
      alias: 'userStats',
      ...operationOptions
    });
};

/**
 * __useuserStatsQuery__
 *
 * To run a query within a React component, call `useuserStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useuserStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useuserStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useuserStatsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<userStatsQuery, userStatsQueryVariables>) {
        return ApolloReactHooks.useQuery<userStatsQuery, userStatsQueryVariables>(userStatsDocument, baseOptions);
      }
export function useuserStatsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<userStatsQuery, userStatsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<userStatsQuery, userStatsQueryVariables>(userStatsDocument, baseOptions);
        }
export type userStatsQueryHookResult = ReturnType<typeof useuserStatsQuery>;
export type userStatsLazyQueryHookResult = ReturnType<typeof useuserStatsLazyQuery>;
export type userStatsQueryResult = ApolloReactCommon.QueryResult<userStatsQuery, userStatsQueryVariables>;
export const UserRegistrationDocument = gql`
    mutation UserRegistration($dto: UserRegistrationDto!) {
  userRegistration(dto: $dto) {
    email
    error
  }
}
    `;
export type UserRegistrationMutationFn = ApolloReactCommon.MutationFunction<UserRegistrationMutation, UserRegistrationMutationVariables>;
export type UserRegistrationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UserRegistrationMutation, UserRegistrationMutationVariables>, 'mutation'>;

    export const UserRegistrationComponent = (props: UserRegistrationComponentProps) => (
      <ApolloReactComponents.Mutation<UserRegistrationMutation, UserRegistrationMutationVariables> mutation={UserRegistrationDocument} {...props} />
    );
    
export type UserRegistrationProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UserRegistrationMutation, UserRegistrationMutationVariables>
    } & TChildProps;
export function withUserRegistration<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UserRegistrationMutation,
  UserRegistrationMutationVariables,
  UserRegistrationProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UserRegistrationMutation, UserRegistrationMutationVariables, UserRegistrationProps<TChildProps, TDataName>>(UserRegistrationDocument, {
      alias: 'userRegistration',
      ...operationOptions
    });
};

/**
 * __useUserRegistrationMutation__
 *
 * To run a mutation, you first call `useUserRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userRegistrationMutation, { data, loading, error }] = useUserRegistrationMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useUserRegistrationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UserRegistrationMutation, UserRegistrationMutationVariables>) {
        return ApolloReactHooks.useMutation<UserRegistrationMutation, UserRegistrationMutationVariables>(UserRegistrationDocument, baseOptions);
      }
export type UserRegistrationMutationHookResult = ReturnType<typeof useUserRegistrationMutation>;
export type UserRegistrationMutationResult = ApolloReactCommon.MutationResult<UserRegistrationMutation>;
export type UserRegistrationMutationOptions = ApolloReactCommon.BaseMutationOptions<UserRegistrationMutation, UserRegistrationMutationVariables>;